webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__ = __webpack_require__(8);






var helpers = {};

helpers.getItemInitials = function (item) {
  if (!item) return;
  if (item.name) var text = item.name;
  if (item.title) var text = item.title;
  if (item.displayName) var text = item.displayName;
  if (item.email) var text = item.email.substring(0, item.email.indexOf("@"));

  if (!text) return;
  text = text.toLowerCase().replace("'", '').replace('"', '').replace('(', '').replace(')', '').replace('/', '').replace('+', '').replace('/', '').replace('&', '').replace('-', '').replace('  ', ' ');

  if (text.length == 1) return text;
  if (text.length == 2) return text;
  var parts = text.split(' ');
  var parts2 = text.split('-');
  var parts2 = text.split('&');
  if (parts2.length > parts.length) parts = parts2;
  if (parts.length == 1) return parts[0][0];
  return parts[0][0] + parts[1][0];
};

helpers.roundToDecs = function (input, decs) {
  return +(Math.round(input + 'e+' + decs) + 'e-' + decs);
};

helpers.getItemColor = function (item) {
  return this.getColorByString(this.getItemInitials(item));
};

helpers.getColorByString = function (str) {
  if (!str) return '#777';
  str = str + str + str + str + str + str + str + str + str + str + str + str + str + str + str;
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  var colour = '#';
  for (var i = 0; i < 3; i++) {
    var value = hash >> i * 8 & 0xFF;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
};

helpers.getProjectBudgetTotal = function (project) {
  if (project.fixed_price) return parseFloat(project.fixed_price);
  var hour_rate = 790;
  if (project.hour_rate) hour_rate = project.hour_rate;

  var spec = this.getProjectAcceptedSpec(project['.key']);
  if (spec) {
    if (spec.status == 'accepted') {
      return this.getSpecTotalBudget(spec);
    }
  }

  return 0;
};

helpers.translateProjectStatus = function (status) {
  if (!globals.projectStatuses[status]) return status;
  if (!globals.projectStatuses[status].title) return status;
  return globals.projectStatuses[status].title;
};

helpers.getProjectAcceptedSpec = function (project_key) {
  var list = this.$store.state.firebase.specs;
  for (var spec_key in list) {
    if (spec_key == '.key') continue;
    var spec = list[spec_key];
    spec['.key'] = spec_key;
    if (spec.archived) continue;
    if (spec.project_key == project_key) return spec;
  }
};

helpers.getSpecTotalHours = function (spec) {
  var total_hrs = 0;
  for (var i in spec.taskcats) {
    var taskcat = spec.taskcats[i];
    for (var i in taskcat.tasks) {
      var task = taskcat.tasks[i];
      if (task.optional == false) continue;
      total_hrs += parseFloat(task.hours);
    }
  }
  return total_hrs;
}, helpers.getSpecTotalBudget = function (spec) {
  return this.getSpecTotalHours(spec) * spec.hour_rate;
}, helpers.getProjectHoursEstimate = function (project) {
  if (!project || !project['.key']) return 0;
  var total_hrs = 0;
  var list = this.$store.state.firebase.tasks;
  for (var task_key in list) {
    var task = list[task_key];
    if (task.archived) continue;
    if (task.project_key != project['.key']) continue;
    var hrs = parseFloat(task.hours_estimate);
    if (!isNaN(hrs)) total_hrs += hrs;
  }
  return total_hrs;
};

helpers.getProjectDonePct = function (project) {
  if (!project || !project['.key']) return 0;
  if (project.done_pct) return project.done_pct;
  var all_weight = 0;
  var done_weight = 0;
  var list = this.$store.state.firebase.tasks;
  for (var task_key in list) {
    var task = list[task_key];
    if (task.archived) continue;
    if (task.project_key != project['.key']) continue;
    if (!task.hours_estimate) var hrs = 0;
    if (task.hours_estimate) var hrs = parseFloat(task.hours_estimate);
    all_weight += hrs;
    if (task.done) done_weight += hrs;
  }
  if (all_weight == done_weight && done_weight == 0) return 0;
  if (all_weight == done_weight && done_weight > 0) return 100;
  return parseInt(done_weight / all_weight * 100);
};

helpers.getMyUserKeyByUID = function (uid) {
  if (!this.users) return;
  var list = this.$store.state.firebase.users;
  for (var user_key in list) {
    var user = list[user_key];
    if (this.users[i].uid == uid) return this.users[i]['.key'];
  }
};

helpers.triggerIconSignal = function (icon) {
  eventBus.$emit('triggerIconSignal', icon);
};

function nanToZero(input) {
  if (isNaN(input)) return 0;
  return input;
}

Number.prototype.formatMoney = function (c, d, t) {
  var n = this,
      c = isNaN(c = Math.abs(c)) ? 2 : c,
      d = d == undefined ? "." : d,
      t = t == undefined ? "," : t,
      s = n < 0 ? "-" : "",
      i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
      j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

helpers.outputMoney = function (input, decimals, format) {
  if (!decimals) decimals = 0;
  if (!format) format = 'a';
  input = parseFloat(input);
  input = nanToZero(input);
  var output = input.formatMoney(decimals, ',', '.');
  if (format == 'a') return output;
  if (format == 'b') return '' + output + ' kr.';
  if (format == 'c') return 'DKK ' + output + '';
  if (format == 'd') return output + ',-';
  if (format == 'e') return output;
};

helpers.getClientProjects = function (client_key, filters) {
  var output = [];
  var list = this.$store.state.firebase.projects;
  for (var project_key in list) {
    if (project_key == '.key') continue;
    var project = list[project_key];
    project['.key'] = project_key;

    if (filters) {
      if (filters.only_active && project.status != 'active') continue;
      if (filters.only_finished && project.status != 'finished') continue;
      if (filters.not_archived && project.archived) continue;
    }

    if (project.client_key == client_key) output.push(project);
  }
  return output;
};

helpers.clientTotalEarning = function (client_key) {
  var projects = this.getClientProjects(client_key);
  var total = 0;
  for (var i = 0; i < projects.length; i++) {
    var project = projects[i];
    if (project.archived) continue;
    total += this.getProjectBudgetTotal(project);
  }
  return this.outputMoney(total, 'a');
};

helpers.readTimebookedHours = function (input) {
  var hrs = 0;
  var list = this.$store.state.firebase.timebookings;
  if (!list) return hrs;
  for (var timebookings_key in list) {
    var timebooking = list[timebookings_key];

    if (input.timeframe == 'today') {
      if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(timebooking.date).isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()(), 'seconds')) continue;
      if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(timebooking.date).isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()(), 'seconds')) continue;
    }

    if (input.user_key && timebooking.user_key != input.user_key) continue;
    if (input.project_key && timebooking.project_key != input.project_key) continue;
    if (input.client_key && timebooking.client_key != input.client_key) continue;
    if (input.task_key && timebooking.task_key != input.task_key) continue;
    hrs += timebooking.hours;
  }
  return hrs;
};

helpers.readTimeloggedHours = function (input) {
  var hrs = 0;

  var list = this.$store.state.firebase.timelogs;
  if (!list) return hrs;

  if (input.timeframe == 'today') {
    var now_timestamp_from = __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf('day').unix();
    var now_timestamp_to = __WEBPACK_IMPORTED_MODULE_1_moment___default()().endOf('day').unix();
  }

  for (var timelog_key in list) {
    if (timelog_key == '.key') continue;

    var timelog = list[timelog_key];
    timelog['.key'] = timelog_key;

    if (!timelog.date_timestamp) {
      console.log('timelog: converting time format (helpers)');
      var timestamp = __WEBPACK_IMPORTED_MODULE_1_moment___default()(timelog.date).unix();
      this.$set(this.$store.state.firebase.timelogs[timelog_key], 'date_timestamp', timestamp);

      helpers.log('no timestamp set for timelog - setting it now');

      var timelog = this.$store.state.firebase.timelogs[timelog_key];
      timelog['.key'] = timelog_key;
    }

    if (input.user_key && timelog.user_key != input.user_key) continue;
    if (input.project_key && timelog.project_key != input.project_key) continue;
    if (input.client_key && timelog.client_key != input.client_key) continue;
    if (input.task_key && timelog.task_key != input.task_key) continue;

    if (input.timeframe == 'today') {
      if (timelog.date_timestamp < now_timestamp_from) continue;
      if (timelog.date_timestamp > now_timestamp_to) continue;
    }

    hrs += timelog.hours;
  }
  return hrs;
};

helpers.getLastTimelogs = function (number) {
  var output = [];

  var list = this.$store.state.firebase.timelogs;
  if (!list) return output;

  var newestTimelogs = _.cloneDeep(list);

  if (!newestTimelogs) return;

  console.log(newestTimelogs);

  newestTimelogs.sort(function (a, b) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(b.date).unix() > __WEBPACK_IMPORTED_MODULE_1_moment___default()(a.date).unix();
  });

  return newestTimelogs.slice(0, number);
};

helpers.getFilteredTimebookings = function (filters) {
  var items = [];

  if (!this.timebookings) return items;
  for (var i = 0; i < this.timebookings.length; i++) {
    var timebooking = this.timebookings[i];
    if (timebooking.archived) continue;
    if (filters.user_key != undefined && filters.user_key != 'undefined') {
      if (filters.user_key != timebooking.user_key) continue;
    }
    if (filters.project_key != undefined && filters.project_key != 'undefined') {
      if (filters.project_key != timebooking.project_key) continue;
    }
    if (filters.client_key != undefined && filters.client_key != 'undefined') {
      var timelog_client = this.getClientByProjectKey(timebooking.project_key);
      if (!timelog_client) continue;

      if (filters.client_key != timelog_client['.key']) continue;
    }

    if (filters.date_from && __WEBPACK_IMPORTED_MODULE_1_moment___default()(timebooking.date).isBefore(filters.date_from, 'seconds')) continue;
    if (filters.date_to && __WEBPACK_IMPORTED_MODULE_1_moment___default()(timebooking.date).isAfter(filters.date_to, 'seconds')) continue;

    items.push(timebooking);
  }

  items.sort(function (a, b) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(b.date) - __WEBPACK_IMPORTED_MODULE_1_moment___default()(a.date);
  });

  return items;
};

helpers.delete_timelog = function (timelog) {
  var sure = confirm('Er du sikker?');
  if (!sure) return;
  var id = timelog['.key'];
  __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["a" /* default */].ref('timelogs').child(id).remove();
  eventBus.$emit('toast', { text: 'Timelog deleted' });
};

helpers.getClientKeyFromTimelog = function (timelog) {
  var project = this.$store.state.firebase.projects[timelog.project_key];
  if (!project) return;
  return project.client_key;
};

helpers.getClientFromTimelog = function (timelog) {
  var client_key = this.getClientKeyFromTimelog(timelog);
  return this.$store.state.firebase.clients[client_key];
};

helpers.translateWorktype = function (worktype) {
  if (!worktype || worktype == 'undefined') return 'Andet';
  for (var i = 0; i < globals.worktypes.length; i++) {
    if (worktype == globals.worktypes[i].value) return globals.worktypes[i].title;
  }
  return worktype;
};

helpers.getProject = function (key) {
  var project = {};
  if (!this.$store.state.firebase.projects) return project;
  if (this.$store.state.firebase.projects[key]) project = this.$store.state.firebase.projects[key];
  return project;
};

helpers.getClient = function (project_key) {
  var client = {};
  var project = this.getProject(project_key);
  if (project['client_key'] && this.$store.state.firebase.clients[project['client_key']]) {
    client = this.$store.state.firebase.clients[project['client_key']];
    client['.key'] = project['client_key'];
  }
  return client;
};

helpers.getClientByProjectKey = function (project_key) {
  var project = this.$store.state.firebase.projects[project_key];

  if (!project) return;
  var client = this.$store.state.firebase.clients[project.client_key];
  if (!client) return;
  return client;
};

helpers.getProjectEconomyFigures = function (year, month, project_key) {

  if (month == undefined) month = this.activeMonth;
  if (year == undefined) year = this.activeYear;
  var output = {
    budgetted: 0,
    invoiced: 0,
    paid: 0
  };
  var list = this.$store.state.firebase.payments;
  for (var payment_key in list) {
    var payment = list[payment_key];
    if (project_key && payment.project_key != project_key) continue;
    if (!__WEBPACK_IMPORTED_MODULE_1_moment___default()(payment.due_date).isSame(year + '-' + month + '-15')) continue;
    output.budgetted += parseFloat(payment.amount_dkk_ex_vat);
    if (payment.invoiced) output.invoiced += parseFloat(payment.amount_dkk_ex_vat);
    if (payment.paid) output.paid += parseFloat(payment.amount_dkk_ex_vat);
  }
  return output;
};

helpers.fixFirebaseKey = function (obj) {
  obj.key = obj['.key'];
  delete obj['.key'];
  return obj;
};

helpers.keyedObjectToArray = function (keyedObject) {
  var outputArray = [];
  for (var key in keyedObject) {
    if (key == '.key') continue;
    var entry = keyedObject[key];
    entry.mutated_by_keyedObjectToArray = true;
    entry.key = key;
    entry['.key'] = key;
    outputArray.push(entry);
  }
  return outputArray;
};

helpers.getUserbyUID = function (uid) {

  var output = {};
  if (!uid) return output;

  var list = this.$store.state.firebase.users;
  if (!list) return output;

  for (var user_key in list) {
    var this_user = list[user_key];
    if (this_user == 'users') continue;
    this_user['.key'] = user_key;
    if (this_user.uid == uid) output = this_user;
  }
  return output;
};

helpers.stringPad = function (str, length, padChar) {
  while (str.length < length) {
    str = padChar + str;
  }return str;
};

helpers.colorNameGetHex = function (colorname) {
  var colors = { 'aliceblue': '#f0f8ff', 'antiquewhite': '#faebd7', 'aqua': '#00ffff', 'aquamarine': '#7fffd4', 'azure': '#f0ffff', 'beige': '#f5f5dc', 'bisque': '#ffe4c4', 'black': '#000000', 'blanchedalmond': '#ffebcd', 'blue': '#0000ff', 'blueviolet': '#8a2be2', 'brown': '#a52a2a', 'burlywood': '#deb887', 'cadetblue': '#5f9ea0', 'chartreuse': '#7fff00', 'chocolate': '#d2691e', 'coral': '#ff7f50', 'cornflowerblue': '#6495ed', 'cornsilk': '#fff8dc', 'crimson': '#dc143c', 'cyan': '#00ffff', 'darkblue': '#00008b', 'darkcyan': '#008b8b', 'darkgoldenrod': '#b8860b', 'darkgray': '#a9a9a9', 'darkgreen': '#006400', 'darkkhaki': '#bdb76b', 'darkmagenta': '#8b008b', 'darkolivegreen': '#556b2f', 'darkorange': '#ff8c00', 'darkorchid': '#9932cc', 'darkred': '#8b0000', 'darksalmon': '#e9967a', 'darkseagreen': '#8fbc8f', 'darkslateblue': '#483d8b', 'darkslategray': '#2f4f4f', 'darkturquoise': '#00ced1', 'darkviolet': '#9400d3', 'deeppink': '#ff1493', 'deepskyblue': '#00bfff', 'dimgray': '#696969', 'dodgerblue': '#1e90ff', 'firebrick': '#b22222', 'floralwhite': '#fffaf0', 'forestgreen': '#228b22', 'fuchsia': '#ff00ff', 'gainsboro': '#dcdcdc', 'ghostwhite': '#f8f8ff', 'gold': '#ffd700', 'goldenrod': '#daa520', 'gray': '#808080', 'green': '#008000', 'greenyellow': '#adff2f', 'honeydew': '#f0fff0', 'hotpink': '#ff69b4', 'indianred ': '#cd5c5c', 'indigo': '#4b0082', 'ivory': '#fffff0', 'khaki': '#f0e68c', 'lavender': '#e6e6fa', 'lavenderblush': '#fff0f5', 'lawngreen': '#7cfc00', 'lemonchiffon': '#fffacd', 'lightblue': '#add8e6', 'lightcoral': '#f08080', 'lightcyan': '#e0ffff', 'lightgoldenrodyellow': '#fafad2', 'lightgrey': '#d3d3d3', 'lightgreen': '#90ee90', 'lightpink': '#ffb6c1', 'lightsalmon': '#ffa07a', 'lightseagreen': '#20b2aa', 'lightskyblue': '#87cefa', 'lightslategray': '#778899', 'lightsteelblue': '#b0c4de', 'lightyellow': '#ffffe0', 'lime': '#00ff00', 'limegreen': '#32cd32', 'linen': '#faf0e6', 'magenta': '#ff00ff', 'maroon': '#800000', 'mediumaquamarine': '#66cdaa', 'mediumblue': '#0000cd', 'mediumorchid': '#ba55d3', 'mediumpurple': '#9370d8', 'mediumseagreen': '#3cb371', 'mediumslateblue': '#7b68ee', 'mediumspringgreen': '#00fa9a', 'mediumturquoise': '#48d1cc', 'mediumvioletred': '#c71585', 'midnightblue': '#191970', 'mintcream': '#f5fffa', 'mistyrose': '#ffe4e1', 'moccasin': '#ffe4b5', 'navajowhite': '#ffdead', 'navy': '#000080', 'oldlace': '#fdf5e6', 'olive': '#808000', 'olivedrab': '#6b8e23', 'orange': '#ffa500', 'orangered': '#ff4500', 'orchid': '#da70d6', 'palegoldenrod': '#eee8aa', 'palegreen': '#98fb98', 'paleturquoise': '#afeeee', 'palevioletred': '#d87093', 'papayawhip': '#ffefd5', 'peachpuff': '#ffdab9', 'peru': '#cd853f', 'pink': '#ffc0cb', 'plum': '#dda0dd', 'powderblue': '#b0e0e6', 'purple': '#800080', 'rebeccapurple': '#663399', 'red': '#ff0000', 'rosybrown': '#bc8f8f', 'royalblue': '#4169e1', 'saddlebrown': '#8b4513', 'salmon': '#fa8072', 'sandybrown': '#f4a460', 'seagreen': '#2e8b57', 'seashell': '#fff5ee', 'sienna': '#a0522d', 'silver': '#c0c0c0', 'skyblue': '#87ceeb', 'slateblue': '#6a5acd', 'slategray': '#708090', 'snow': '#fffafa', 'springgreen': '#00ff7f', 'steelblue': '#4682b4', 'tan': '#d2b48c', 'teal': '#008080', 'thistle': '#d8bfd8', 'tomato': '#ff6347', 'turquoise': '#40e0d0', 'violet': '#ee82ee', 'wheat': '#f5deb3', 'white': '#ffffff', 'whitesmoke': '#f5f5f5', 'yellow': '#ffff00', 'yellowgreen': '#9acd32' };
  if (typeof colors[colorname.toLowerCase()] != 'undefined') return colors[colorname.toLowerCase()];
  return false;
};

helpers.idealTextColor = function (bgColor) {
  if (bgColor == 'black') return '#ffffff';
  if (bgColor == 'white') return '#000000';
  if (bgColor == 'grey') return '#000000';
  var hexColor = this.colorNameGetHex(bgColor);
  if (hexColor) bgColor = hexColor;
  var nThreshold = 105;
  var components = this.getRGBComponents(bgColor);
  var bgDelta = components.R * 0.299 + components.G * 0.587 + components.B * 0.114;

  return 255 - bgDelta < nThreshold ? "#000000" : "#ffffff";
};

helpers.getRGBComponents = function (color) {

  var r = color.substring(1, 3);
  var g = color.substring(3, 5);
  var b = color.substring(5, 7);

  return {
    R: parseInt(r, 16),
    G: parseInt(g, 16),
    B: parseInt(b, 16)
  };
};

helpers.img_loaded = function (imgurl, callback) {
  var img = new Image();
  img.addEventListener('load', function () {
    if (callback) callback();
  });
  img.src = imgurl;
};

helpers.moment_enumerateDaysBetweenDates = function (startDate, endDate) {
  var dates = [];

  var currDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(startDate).startOf('day');
  var lastDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(endDate).startOf('day');

  while (currDate.add(1, 'days').diff(lastDate) <= 0) {
    dates.push(currDate.clone());
  }

  return dates;
};

helpers.log = function (input) {

  if (!window['$kia']) return;

  if ((typeof input === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(input)) != 'object') {
    console.warn('%c  Kia  %c  ' + input + '  ', 'background: #333; color: #fff; border-radius: 4px 0 0 4px;', 'background: #DDD; color: #000; border-radius: 0 4px 4px 0;');
  }

  if ((typeof input === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(input)) == 'object') {
    var label = 'KIA LOGGING ITEM:';
    console.group(label);

    console.warn(input);
    console.groupEnd(label);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (helpers);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_js__ = __webpack_require__(3);


var _methods;





var mixins = {};

mixins.db = {
  computed: {
    my_user: function my_user() {
      return this.$store.getters['users/my_user'];
    },
    my_user_key: function my_user_key() {
      return this.my_user.key || this.my_user['.key'];
    },
    is_admin: function is_admin() {
      return this.$store.getters['users/my_user'] && this.$store.getters['users/my_user'].admin;
    },
    show_beta_content: function show_beta_content() {
      return this.$store.state.show_beta_content;
    },
    economy_access: function economy_access() {
      return this.is_admin;
    }
  }
};

mixins.generic = {

  computed: {
    show_beta_content: function show_beta_content() {
      return this.$store.state.show_beta_content;
    },
    show_debug_data_boxes: function show_debug_data_boxes() {
      return this.$store.state.show_debug_data_boxes;
    },
    base_url: function base_url() {
      return this.$store.getters.base_url;
    },
    api_url: function api_url() {
      return this.$store.getters.api_url;
    },
    my_user: function my_user() {
      return this.$store.getters['users/my_user'];
    },
    my_user_key: function my_user_key() {
      return this.$store.getters['users/my_user_key'];
    }
  },

  methods: (_methods = {
    is_user: function is_user(initials) {
      return this.my_user.email == initials + '@milk-studio.dk';
    },
    triggerIconSignal: function triggerIconSignal(symbol) {
      eventBus.$emit('triggerIconSignal', symbol);
    },
    openURLNewWindow: function openURLNewWindow(url) {
      window.open(url, '_blank');
    },
    alert: function alert(input) {
      eventBus.$emit('msg', input);
    },
    msg: function msg(input) {
      eventBus.$emit('msg', input);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'alert', function alert(input) {
    eventBus.$emit('alert', input);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'toast', function toast(input) {
    eventBus.$emit('toast', input);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'openTimelogger', function openTimelogger(input) {
    eventBus.$emit('openTimelogger', input);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'set_small_spinner', function set_small_spinner(visible) {
    this.$store.commit('set_small_spinner', visible);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'set_big_spinner', function set_big_spinner(visible) {
    this.$store.commit('set_big_spinner', visible);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'goto', function goto(to) {
    this.$router.push(to);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getAll', function getAll(type, key) {
    return this.$store.getters.getAll(type, key);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getOne', function getOne(type, key) {
    return this.$store.getters.getOne(type, key);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getComments', function getComments(keytype, key) {
    return this.$store.getters['comments/byKey'](keytype, key);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getCommentsCount', function getCommentsCount(keytype, key) {
    var c = this.getComments(keytype, key);
    if (!c) return 0;
    return c.length;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'closeTimeloggerBasic', function closeTimeloggerBasic() {
    this.$store.commit('set__timeloggerBasic_active', false);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'openTimeloggerBasic', function openTimeloggerBasic(input) {
    if (input) this.$store.commit('set__timeloggerBasic_timelog', input);
    this.$store.commit('set__timeloggerBasic_active', true);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'fdb_push', function fdb_push(table, entry) {
    return __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["a" /* default */].ref(table).push(entry);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'item_has_tag', function item_has_tag(item, tag) {
    if (!item) return false;
    if (!item.tags) return false;
    if (!item.tags.toLowerCase) return false;
    if (item.tags.toLowerCase().indexOf(tag.toLowerCase()) === -1) return false;
    return true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'toggleTagAndSave', function toggleTagAndSave(itemtype, item, tag) {
    if (!item) return;

    var item_key = item.key || item['.key'];

    if (!item_key) return;

    var has_tag = this.item_has_tag(item, tag);

    if (!has_tag) item.tags += ' ' + tag;

    if (has_tag) {
      var tags = item.tags || '';
      tags = tags.split(' ');
      tags = tags.filter(function (entry) {
        return entry && entry.toLowerCase() !== tag.toLowerCase();
      });
      item.tags = tags.join(' ');
    }

    __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["a" /* default */].ref(itemtype).child(item_key).update({ tags: item.tags });
    this.triggerIconSignal();
  }), _methods),

  log: function log(input) {
    if (this.$store.state.env !== 'local') return;
    __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].log(input);
  }
};

mixins.something = {};

/* harmony default export */ __webpack_exports__["a"] = (mixins);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(596),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(592),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(580),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(523);




var firebaseConfig = {
	apiKey: "AIzaSyC8m7xdpoBmRNugOtvmZPzzJHVIqv4Rhyg",
	authDomain: "kira-wpaix.firebaseapp.com",
	databaseURL: "https://kira-wpaix.firebaseio.com",
	storageBucket: "kira-wpaix.appspot.com"
};

var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(firebaseConfig);
var fdb = firebaseApp.database();

/* harmony default export */ __webpack_exports__["a"] = (fdb);

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(579),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);




var user = {
  displayName: undefined,
  email: undefined,
  emailVerified: false,
  photoURL: undefined,
  uid: undefined,
  authenticated: undefined
};

var login = function login(id, pass) {
  __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(id, pass);
};

var init = function init() {

  __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInAnonymously().catch(function (error) {
    var errorCode = error.code;
    var errorMessage = error.message;
  });

  __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().onAuthStateChanged(function (theUser) {

    globals.authentication_checked = true;
    eventBus.$emit('onAuthChecked');
    var user = {};

    globals.firebase_connected = true;

    if (theUser) {
      user.displayName = theUser.displayName;
      user.email = theUser.email;
      user.emailVerified = theUser.emailVerified;
      user.photoURL = theUser.photoURL;
      user.uid = theUser.uid;
      user.authenticated = true;

      eventBus.$emit('onAuthLogin', user);
    } else {
      user.displayName = undefined;
      user.email = undefined;
      user.emailVerified = false;
      user.photoURL = undefined;
      user.uid = undefined;
      user.authenticated = false;
      eventBus.$emit('onAuthLogout');
    }

    globals.user = user;
  }, function (error) {});
};

var getUser = function getUser() {
  return user;
};

var logout = function logout() {
  __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
    window.location.reload();
  }, function (error) {
    window.location.reload();
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({ init: init, getUser: getUser, logout: logout, login: login });

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(615),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(578),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(622),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/checkmark': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M461.6 109.6l-54.9-43.3c-1.7-1.4-3.8-2.4-6.2-2.4-2.4 0-4.6 1-6.3 2.5L194.5 323s-78.5-75.5-80.7-77.7c-2.2-2.2-5.1-5.9-9.5-5.9s-6.4 3.1-8.7 5.4c-1.7 1.8-29.7 31.2-43.5 45.8-.8.9-1.3 1.4-2 2.1-1.2 1.7-2 3.6-2 5.7 0 2.2.8 4 2 5.7l2.8 2.6s139.3 133.8 141.6 136.1c2.3 2.3 5.1 5.2 9.2 5.2 4 0 7.3-4.3 9.2-6.2l249.1-320c1.2-1.7 2-3.6 2-5.8 0-2.5-1-4.6-2.4-6.4z"/>'
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var globals = {
	version: 1.4,
	count: 23,
	database_loaded: false,
	authentication_checked: false,
	user: undefined,
	userData: undefined,
	db: {},
	show_beta_content: false,
	skin: 2,
	small_spinner: false,
	big_spinner: false,
	db_loaded: { users: undefined },
	off_canvas_menu_active: false,
	url: 'https://kia.milk-studio.dk/'
};

globals.skins = {
	skin1: {
		bgfadecolor1: 'red',
		bgfadecolor2: 'blue'
	},
	skin2: {
		bgfadecolor1: 'purple',
		bgfadecolor2: 'yellow'
	}
};

globals.projectStatuses = {
	draft: { title: 'Skitse' },

	active: { title: 'Aktiv' },
	finished: { title: 'Afsluttet' },
	aborted: { title: 'Aflyst' }
};

globals.projects = {
	status_filter: 'active',
	search_filter: undefined
};

globals.clients = {
	search_filter: undefined
};

globals.worktypes = [{ value: 'meeting', title: 'Møde/dialog' }, { value: 'specs_offer', title: 'Kravspec/tilbud' }, { value: 'project_management', title: 'Projektstyring' }, { value: 'client_dialog', title: 'Kundedialog', legacy: true }, { value: 'graphic_design', title: 'Grafisk design' }, { value: 'development', title: 'Udvikling' }, { value: 'motiongraphics', title: 'Motion graphics' }, { value: 'content', title: 'Content' }, { value: 'testing', title: 'Testing' }, { value: 'maintenance', title: 'Drift/support' }, { value: 'other', title: 'Andet' }];

globals.timelogger = {
	visible: false,
	addList: [],
	emptyListItem: { project_key: undefined, hours: 0, task_key: undefined, worktype: undefined, title: undefined, date: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'), billable: true }
};

globals.specs = {
	status_filter: 'all',
	search_filter: undefined
};

globals.spec = {
	changes: undefined,
	taskcats: undefined
};

globals.pieChartColors = ['#9FFFCB', '#004E64', '#00A5CF', '#7AE582', '#CDCDCD', '#214E34', '#E4959E', '#CB9CF2', '#9E7B9B', '#F35B04', '#7678ED'];

globals.modal_timeline_project_popup = {
	active: false,
	project: undefined
};

globals.modal_timelog_edit = {
	active: false,
	timelog: undefined
};

globals.modal_economypost_edit = {
	active: false,
	economypost: undefined
};

globals.specelements = {

	newsletter_signup: {
		title: 'Nyhedsbrev signup',
		hours: 3
	},

	search_function: {
		title: 'Søgefunktion',
		hours: 5
	},

	analytics: {
		title: 'Analytics',
		no_pairing: ['analytics2'],
		hours: 2
	},

	analytics2: {
		title: 'Udvidet Analytics',
		no_pairing: ['analytics'],
		hours: 5
	},

	subpages1: {
		title: '1-5 unikke undersider',
		no_pairing: ['subpages2', 'subpages3', 'subpages4'],
		hours: 3
	},

	subpages2: {
		title: '6-10 unikke undersider',
		no_pairing: ['subpages1', 'subpages3', 'subpages4'],
		hours: 5
	},

	subpages3: {
		title: '11-20 unikke undersider',
		no_pairing: ['subpages1', 'subpages2', 'subpages4'],
		hours: 7
	},

	subpages4: {
		title: '20-40 unikke undersider',
		no_pairing: ['subpages1', 'subpages2', 'subpages3'],
		hours: 10
	},

	clientsize1: {
		title: 'Nystartet virksomhed',
		no_pairing: ['clientsize2', 'clientsize3', 'clientsize4'],
		hours: 3
	},

	clientsize2: {
		title: 'Mindre virksomhed',
		no_pairing: ['clientsize1', 'clientsize3', 'clientsize4'],
		hours: 5
	},

	clientsize3: {
		title: 'Mellem størrelse virksomhed',
		no_pairing: ['clientsize1', 'clientsize2', 'clientsize4'],
		hours: 8
	},

	clientsize4: {
		title: 'Stor virksomhed',
		no_pairing: ['clientsize1', 'clientsize2', 'clientsize3'],
		hours: 15
	},

	iosapp: {
		title: 'iOs Native App',
		hours: 30
	},

	cookiewarning: {
		title: 'Cookie advarsel',
		hours: 3
	},

	terms_text: {
		title: 'Terms tekst-side + popup',
		hours: 2
	},

	correction1: {
		title: '1 retterunde',
		no_pairing: ['correction2'],
		hours: 20
	},

	correction2: {
		title: '2 retterunder',
		no_pairing: ['correction1'],
		hours: 40
	},

	testing1: {
		title: 'Testing S',
		no_pairing: ['testing2'],
		hours: 40
	},

	testing2: {
		title: 'Testing M',
		no_pairing: ['testing1'],
		hours: 40
	}

};

window.globals = globals;
/* harmony default export */ __webpack_exports__["a"] = (globals);

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(589),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_dist_logger__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_firebase_js__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_users_js__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_timelogs_js__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_projects_js__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_clients_js__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_economyposts_js__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_specs_js__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_comments_js__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_js__ = __webpack_require__(3);








var axios = __webpack_require__(350).default;




__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);











var logger = __WEBPACK_IMPORTED_MODULE_8_vuex_dist_logger___default()({
  collapsed: false, filter: function filter(mutation, stateBefore, stateAfter) {
    return mutation.type !== "aBlacklistedMutation";
  },
  transformer: function transformer(state) {
    return state.subTree;
  },
  mutationTransformer: function mutationTransformer(mutation) {
    return mutation.type;
  },

  logger: console
});

var store = new __WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */].Store({
  strict: false,
  modules: {
    firebase: __WEBPACK_IMPORTED_MODULE_9__modules_firebase_js__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_10__modules_users_js__["a" /* default */],
    timelogs: __WEBPACK_IMPORTED_MODULE_11__modules_timelogs_js__["a" /* default */],
    specs: __WEBPACK_IMPORTED_MODULE_15__modules_specs_js__["a" /* default */],
    economyposts: __WEBPACK_IMPORTED_MODULE_14__modules_economyposts_js__["a" /* default */],
    projects: __WEBPACK_IMPORTED_MODULE_12__modules_projects_js__["a" /* default */],
    clients: __WEBPACK_IMPORTED_MODULE_13__modules_clients_js__["a" /* default */],
    comments: __WEBPACK_IMPORTED_MODULE_16__modules_comments_js__["a" /* default */]
  },
  state: {

    env: undefined,

    firebase_load_pct: 0,
    firebase_synced_and_ready: false,

    show_beta_content: false,
    show_debug_data_boxes: false,

    bgfadeimg_tags: 'milk',

    count: 0,

    small_spinner: false,
    big_spinner: false,

    worktypes: [{ key: 'meeting', title: 'Møde/dialog' }, { key: 'specs_offer', title: 'Kravspec/tilbud' }, { key: 'project_management', title: 'Projektstyring' }, { key: 'client_dialog', title: 'Kundedialog', legacy: true }, { key: 'graphic_design', title: 'Grafisk design' }, { key: 'development', title: 'Udvikling' }, { key: 'motiongraphics', title: 'Motion graphics' }, { key: 'content', title: 'Content' }, { key: 'testing', title: 'Testing' }, { key: 'maintenance', title: 'Drift/support' }, { key: 'other', title: 'Andet' }],

    timeloggerBasic: {
      active: false,
      timelog: {
        hours: undefined,
        worktype: undefined,
        billable: true,
        note: undefined,
        project_key: undefined
      }
    },

    specLineRobot: {
      active: false
    },

    context_bg: {
      bgcolor: undefined,
      bgimg: undefined
    },

    dinero_fetched: undefined

  },
  getters: {
    base_url: function base_url(state, getters) {
      if (state.env === 'local') return 'http://localhost:3000/';
      if (state.env === 'live') return 'https://kia.milk-studio.dk/';
    },
    api_url: function api_url(state, getters) {
      if (state.env === 'local') return getters.base_url + 'api/';
      if (state.env === 'live') return getters.base_url + 'api/';
    },
    projectsCount: function projectsCount(state, getters) {
      var output = 0;
      for (var key in state.firebase.projects) {
        var project = state.firebase.projects[key];
        output++;
      }
      return output;
    },
    something: function something(state, getters) {
      return 123;
    },


    somethingElse: function somethingElse(state, getters) {
      return state.count + 1;
    },

    getAll: function getAll(state, getters) {
      return function (type) {
        var output = [];
        if (!state.firebase[type]) return output;

        for (var key in state.firebase[type]) {
          if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(state.firebase[type][key]) !== 'object') continue;
          output.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.firebase[type][key], { _key: key, '.key': key, key: key }));
        }

        return output;
      };
    },

    getOne: function getOne(state, getters) {
      return function (type, key) {
        if (!state.firebase[type + 's']) return;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.firebase[type + 's'][key], { _key: key, '.key': key, key: key });
      };
    },

    getAll2: function getAll2(state, getters) {
      return function (type) {
        if (!getters.firebase_arrays[type]) return [];
        return getters.firebase_arrays[type];
      };
    },

    getOne2: function getOne2(state, getters) {
      return function (type, key) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(getters.getAll(type + 's')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;
            if (item.key === key || item['.key'] === key) return item;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      };
    },

    get_dinero_invoices: function get_dinero_invoices(state, getters) {
      return function (input) {

        var output = [];

        if (!state.dinero_fetched) return output;
        if (!state.dinero_fetched.invoices) return output;

        if (!input) input = {};

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(state.dinero_fetched.invoices), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var invoice = _step2.value;


            if (input.client_cvr !== undefined && invoice.client_cvr != input.client_cvr) continue;
            if (input.status !== undefined && invoice.status !== input.status) continue;
            if (input.invoice_no !== undefined && invoice.invoice_no !== input.invoice_no) continue;

            output.push(invoice);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return output;
      };
    },

    get_dinero_invoices_total: function get_dinero_invoices_total(state, getters) {
      return function (input) {
        var invoices = getters.get_dinero_invoices(input);
        var total = 0;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(invoices), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var inv = _step3.value;
            total += inv.total_ex_vat_dkk;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return total;
      };
    }

  },
  mutations: {
    set_env: function set_env(state, x) {
      state.env = x;
    },
    set_firebase_load_pct: function set_firebase_load_pct(state, x) {
      state.firebase_load_pct = x;
    },
    set_context_bgcolor: function set_context_bgcolor(state, x) {
      state.context_bg.bgcolor = x;
    },
    set_context_bgimg: function set_context_bgimg(state, x) {
      state.context_bg.bgimg = x;
    },
    set_dinero_fetched: function set_dinero_fetched(state, x) {
      state.dinero_fetched = x;
    },
    set_small_spinner: function set_small_spinner(state, x) {
      state.small_spinner = x;
    },
    set_big_spinner: function set_big_spinner(state, x) {
      state.big_spinner = x;
    },
    firebase_synced_and_ready: function firebase_synced_and_ready(state) {
      state.firebase_synced_and_ready = true;
    },
    increment: function increment(state) {
      state.count++;
    },
    toggle_show_beta_content: function toggle_show_beta_content(state, input) {
      if (input == undefined) input = !state.show_beta_content;
      state.show_beta_content = input;
    },
    toggle_show_debug_data_boxes: function toggle_show_debug_data_boxes(state, input) {
      if (input == undefined) input = !state.show_debug_data_boxes;
      state.show_debug_data_boxes = input;
    },
    transferTimelogsFromProjectToProjevy: function transferTimelogsFromProjectToProjevy(state, input) {
      console.log(input);
    },
    set__bgfadeimg_tags: function set__bgfadeimg_tags(state, x) {
      state.bgfadeimg_tags = x;
    },
    set__timeloggerBasic_active: function set__timeloggerBasic_active(state, x) {
      state.timeloggerBasic.active = x;
    },
    set__timeloggerBasic_timelog: function set__timeloggerBasic_timelog(state, x) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.timeloggerBasic.timelog, x);
    },
    set__specLineRobot_active: function set__specLineRobot_active(state, x) {
      state.specLineRobot.active = x;
    }
  },
  actions: {
    load_context_bgimg: function load_context_bgimg(_ref, url) {
      var commit = _ref.commit;

      var img = new Image();
      img.addEventListener('load', function () {
        commit('set_context_bgimg', url);
      });
      img.src = url;
    },
    dinero_fetch: function dinero_fetch(_ref2, version) {
      var commit = _ref2.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        axios.get('https://kia.milk-studio.dk/api/dinero_fetch/' + version).then(function (response) {
          commit('set_dinero_fetched', response.data);
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  } });

if (false) {
  module.hot.accept(['./modules/users', './modules/timelogs', './modules/specs', './modules/economyposts', './modules/projects', './modules/clients', './modules/comments'], function () {
    store.hotUpdate({
      modules: {
        users: require('./modules/users').default,
        timelogs: require('./modules/timelogs').default,
        specs: require('./modules/specs').default,
        economyposts: require('./modules/economyposts').default,
        projects: require('./modules/projects').default,
        clients: require('./modules/clients').default,
        comments: require('./modules/comments').default
      }
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/briefcase': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18.5 5H14V3.5c0-.827-.673-1.5-1.5-1.5h-5C6.673 2 6 2.673 6 3.5V5H1.5C.673 5 0 5.673 0 6.5v11c0 .827.673 1.5 1.5 1.5h17c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5zM7 3.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V5H7V3.5zM1.5 6h17a.5.5 0 0 1 .5.5V14h-2v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v.5H6v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v.5H1V6.5a.5.5 0 0 1 .5-.5zM16 14v1h-1v-1h1zM5 14v1H4v-1h1zm13.5 4h-17a.5.5 0 0 1-.5-.5V15h2v.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V15h8v.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V15h2v2.5a.5.5 0 0 1-.5.5z"/>'
  }
});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'logo': {
    width: 16,
    height: 16,
    viewBox: '0 0 941.8 324.5',
    data: '<path pid="0" d="M70 315H11.6V97.1h58v12.2c20-11.6 37.2-17.4 51.4-17.4 23.5 0 41.7 6.8 54.5 20.5 26.7-13.6 51.1-20.5 73.2-20.5 28.8 0 48.7 8.4 59.9 25.1 11.2 16.7 16.8 43.4 16.8 80v118H267V198.6c0-18.6-2-32.3-6.1-41.2-4.1-8.9-12.2-13.3-24.4-13.3-9.3 0-20.6 2-34 6.1l-6.5 2.2c1.2 21.8 1.7 38.4 1.7 49.7V315h-58.4V203c0-21.5-1.9-36.7-5.7-45.5-3.8-8.9-12.1-13.3-24.8-13.3-11.3 0-22.5 2-33.6 6.1L70 152v163zM392.5 315V97.1h58.4V315h-58.4zM518.5 315V9.9h58.4V315h-58.4zM702.9 315h-58.4V9.9h58.4v173.5l22.2-3.9 43.2-82.4h65.4L777 200.4 836.7 315h-65.8l-44-85-24 3.9V315zM930.2 60.6c0 15.9-12.9 28.8-28.8 28.8s-28.8-12.9-28.8-28.8c0-22.5 28.8-51.2 28.8-51.2s28.8 28.7 28.8 51.2z"/>'
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var themes = {};

themes.white = {

  primary: '#333', primary_text: '#FFF',
  secondary: '#DDD', secondary_text: '#333',
  tertiary: '#777', tertiary_text: '#333',

  success: '#789C7D', success_text: '#fff',
  warning: '#EED471', warning_text: '#000',
  danger: '#DE7D73', danger_text: '#fff',

  body_bgcolor: '#EEE',
  body_textcolor: '#333',

  leftbar_bgcolor: '#fff',
  leftbar_textcolor: '#333',
  leftbar_iconcolor: '#333',

  box_bgcolor: '#fff',
  box_textcolor: '#333',

  box_header_bgcolor: '#FFF',
  box_header_textcolor: '#333',

  input_bgcolor: '#EEE',
  input_textcolor: '#333',

  table_stripe_color: '#EEEE',

  filterbtn_textcolor: '#333',
  filterbtn_linecolor: '#777'

};

themes.cream = {

  primary: '#333', primary_text: '#FFF',
  secondary: '#DDD', secondary_text: '#333',
  tertiary: '#777', tertiary_text: '#333',

  success: '#789C7D', success_text: '#fff',
  warning: '#EED471', warning_text: '#000',
  danger: '#DE7D73', danger_text: '#fff',

  body_bgcolor: '#BEAEA1',
  body_textcolor: '#333',

  leftbar_bgcolor: '#DED7D0',
  leftbar_textcolor: '#333',
  leftbar_iconcolor: '#333',

  box_bgcolor: '#F7F5F3',
  box_textcolor: '#333',

  box_header_bgcolor: '#EFEBE8',
  box_header_textcolor: '#333',

  input_bgcolor: '#E6E1DC',
  input_textcolor: '#333',

  table_stripe_color: '#EFEBE8',

  filterbtn_textcolor: '#333',
  filterbtn_linecolor: '#777'

};

themes.dark = {

  primary: '#fff', primary_text: '#333',
  secondary: '#333', secondary_text: '#fff',
  tertiary: '#777', tertiary_text: '#fff',

  success: '#789C7D', success_text: '#fff',
  warning: '#EED471', warning_text: '#000',
  danger: '#DE7D73', danger_text: '#fff',

  body_bgcolor: '#222',
  body_textcolor: '#fff',

  leftbar_bgcolor: '#333',
  leftbar_textcolor: '#fff',
  leftbar_iconcolor: '#CCC',

  box_bgcolor: '#333',
  box_textcolor: '#fff',

  box_header_bgcolor: '#111',
  box_header_textcolor: '#fff',

  input_bgcolor: '#222',
  input_textcolor: '#fff',

  table_stripe_color: '#222',

  filterbtn_textcolor: '#fff',
  filterbtn_linecolor: '#777'

};

/* harmony default export */ __webpack_exports__["a"] = (themes);

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(614),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(598),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(613),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(595),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/chevron-right': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M298.3 256L131.1 81.9c-4.2-4.3-4.1-11.4.2-15.8l29.9-30.6c4.3-4.4 11.3-4.5 15.5-.2L380.9 248c2.2 2.2 3.2 5.2 3 8.1.1 3-.9 5.9-3 8.1L176.7 476.8c-4.2 4.3-11.2 4.2-15.5-.2L131.3 446c-4.3-4.4-4.4-11.5-.2-15.8L298.3 256z"/>'
  }
});

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-calendar-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" class="st0" d="M80 112v64h352v-64"/><path pid="1" d="M352 96V64h-16v32H176V64h-16v32H64v352h384V96h-96zm80 336H80V192h352v240zm0-256H80v-64h80v32h16v-32h160v32h16v-32h80v64z"/>'
  }
});

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-list-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M432 80v352H80V80h352m16-16H64v384h384V64z"/><path pid="1" d="M192 152h192v16H192zM192 248h192v16H192zM192 344h192v16H192z"/><circle pid="2" cx="144" cy="160" r="16"/><circle pid="3" cx="144" cy="256" r="16"/><circle pid="4" cx="144" cy="352" r="16"/>'
  }
});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-play': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M128 96v320l256-160L128 96z"/>'
  }
});

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-timer-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M236.6 271.6c4.6 5.7 11.5 9.4 19.4 9.4 13.8 0 25-11.2 25-25 0-7.3-3.2-13.8-8.2-18.4-.6-.7-1.3-1.5-2.2-2.2 0 0-117.7-87.5-120.3-85.2-2.6 2.3 85.3 120.2 85.3 120.2.2.4.7.8 1 1.2z"/><path pid="1" d="M256.2 48h-.2v112h16V65.3c97.8 8.3 175.3 90.5 175.3 190.5 0 105.5-85.7 191.4-191.2 191.4-105.5 0-191.3-85.8-191.3-191.3 0-52.8 21.5-100.6 56.1-135.2L109 108.9C71.3 146.6 48 198.6 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S371 48 256.2 48z"/>'
  }
});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/trash': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M15.5 2H12v-.5c0-.827-.673-1.5-1.5-1.5h-2C7.673 0 7 .673 7 1.5V2H3.5C2.673 2 2 2.673 2 3.5v1c0 .652.418 1.208 1 1.414V18.5c0 .827.673 1.5 1.5 1.5h10c.827 0 1.5-.673 1.5-1.5V5.914c.582-.206 1-.762 1-1.414v-1c0-.827-.673-1.5-1.5-1.5zM8 1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V2H8v-.5zM14.5 19h-10a.5.5 0 0 1-.5-.5V6h11v12.5a.5.5 0 0 1-.5.5zM16 4.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v1z"/><path pid="1" d="M12.5 7a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 1 0v-10a.5.5 0 0 0-.5-.5zM9.5 7a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 1 0v-10a.5.5 0 0 0-.5-.5zM6.5 7a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 1 0v-10a.5.5 0 0 0-.5-.5z"/>'
  }
});

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(616),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(586),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(602),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */,
/* 288 */,
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({
  fallback: function fallback(value, _fallback) {
    if (value === undefined) return _fallback;
    if (value === null) return _fallback;
    return value;
  },

  fallback2: function fallback2(value, fallback) {
    if (value === undefined) return fallback;
    if (value === null) return fallback;
    if (value === 0) return fallback;
    return value;
  },

  uppercase: function uppercase(value) {
    return value.toUpperCase();
  },

  int: function int(value) {
    return parseInt(value);
  },

  float: function float(value) {
    return parseFloat(value);
  },

  string: function string(value) {
    return '' + value + '';
  },

  decimals: function decimals(value, _decimals) {
    if (value === undefined) return value;
    if (!value.toFixed) return value;
    return parseFloat(value.toFixed(_decimals));
  },

  double: function double(value) {
    return value * 2;
  },

  round: function round(value) {
    return Math.round(value);
  },

  date: function date(value, format) {
    if (!value) return '?';
    return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(value).format(format);
  },

  money: function money(value, decimals) {
    return __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* default */].outputMoney(value, decimals);
  },

  thousandSep: function thousandSep(value) {
    return Math.round(value);
  },

  boolstr: function boolstr(value, str) {
    if (value) return str[0];
    if (!value) return str[1];
  },

  weekday1dk: function weekday1dk(value) {
    return value.replace('Mon', 'M').replace('Tue', 'T').replace('Wed', 'O').replace('Thu', 'T').replace('Fri', 'F').replace('Sat', 'L').replace('Sun', 'S').replace('Mo', 'M').replace('Tu', 'T').replace('We', 'O').replace('Th', 'T').replace('Fr', 'F').replace('Sa', 'L').replace('Su', 'S');
  },

  cut: function cut(value, length) {
    if (!value) return value;
    if (value.length > length) return value.slice(0, length) + '...';
    return value;
  },

  milkinitials: function milkinitials(value) {
    return value.replace('@milk-studio.dk', '').toUpperCase();
  },

  tr_payment_model: function tr_payment_model(value) {
    if (value === 'fixed_price') return 'Fast pris';
    if (value === 'time_expense') return 'Timepris';
  },

  tr_project_status: function tr_project_status(value) {
    if (value === 'active') return 'Aktiv';
    if (value === 'draft') return 'Skitse';
    if (value === 'finished') return 'Afsluttet';
    if (value === 'aborted') return 'Aflyst';
  }

});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Projects_vue__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Projects_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Projects_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Projects_timeline_vue__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Projects_timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Projects_timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Project_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Project_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Project_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Clients_vue__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Clients_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Clients_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Client_vue__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Client_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Client_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Economy_vue__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Economy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Economy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Users_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Users_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Users_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Kitchensink_vue__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Kitchensink_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Kitchensink_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Timelogs_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Timelogs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_Timelogs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Mysettings_vue__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Mysettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_Mysettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_ThemeMachine_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_ThemeMachine_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_ThemeMachine_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Reports_vue__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Reports_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_Reports_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Specs_vue__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Specs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_Specs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Spec_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Spec_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_Spec_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Report_invoicability_vue__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Report_invoicability_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_Report_invoicability_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Report_missing_input_vue__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Report_missing_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_Report_missing_input_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_ReportMissingPayments_vue__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_ReportMissingPayments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_ReportMissingPayments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_ReportClientEarning_vue__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_ReportClientEarning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_ReportClientEarning_vue__);

























var routes = [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default.a }, { path: '/projects', component: __WEBPACK_IMPORTED_MODULE_3__views_Projects_vue___default.a }, { path: '/clients', component: __WEBPACK_IMPORTED_MODULE_6__views_Clients_vue___default.a }, { path: '/client/:id', component: __WEBPACK_IMPORTED_MODULE_7__views_Client_vue___default.a, name: 'client' }, { path: '/project/:id', component: __WEBPACK_IMPORTED_MODULE_5__views_Project_vue___default.a, name: 'project' }, { path: '/specs', component: __WEBPACK_IMPORTED_MODULE_15__views_Specs_vue___default.a }, { path: '/spec/:id', component: __WEBPACK_IMPORTED_MODULE_16__views_Spec_vue___default.a, props: { fdbs: this.fdbs } }, { path: '/kitchensink', component: __WEBPACK_IMPORTED_MODULE_10__views_Kitchensink_vue___default.a }, { path: '/economy', component: __WEBPACK_IMPORTED_MODULE_8__views_Economy_vue___default.a }, { path: '/timeline', component: __WEBPACK_IMPORTED_MODULE_4__views_Projects_timeline_vue___default.a }, { path: '/users', component: __WEBPACK_IMPORTED_MODULE_9__views_Users_vue___default.a }, { path: '/my-settings', component: __WEBPACK_IMPORTED_MODULE_12__views_Mysettings_vue___default.a }, { path: '/tema-editor', component: __WEBPACK_IMPORTED_MODULE_13__views_ThemeMachine_vue___default.a }, { path: '/reports', component: __WEBPACK_IMPORTED_MODULE_14__views_Reports_vue___default.a }, { path: '/report-invoicability', component: __WEBPACK_IMPORTED_MODULE_17__views_Report_invoicability_vue___default.a }, { path: '/reports/missing-input', component: __WEBPACK_IMPORTED_MODULE_18__views_Report_missing_input_vue___default.a }, { path: '/reports/missing-payments', component: __WEBPACK_IMPORTED_MODULE_19__views_ReportMissingPayments_vue___default.a }, { path: '/reports/client-earning', component: __WEBPACK_IMPORTED_MODULE_20__views_ReportClientEarning_vue___default.a }, { path: '/timelogs', component: __WEBPACK_IMPORTED_MODULE_11__views_Timelogs_vue___default.a }, { path: '/timelogs/:user/:client/:project/:from_date/:to_date', component: __WEBPACK_IMPORTED_MODULE_11__views_Timelogs_vue___default.a }];

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes,
  mode: 'hash',
  base: '/'
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(68);

/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */],
  install: function install(Vue, options) {
    Vue.prototype.$store = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */];
  }
});

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(604),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'fontawesome/git': {
    width: 1792,
    height: 1792,
    viewBox: '0 0 1792 1792',
    data: '<path pid="0" d="M595 1514q0-100-165-100-158 0-158 104 0 101 172 101 151 0 151-105zm-59-755q0-61-30-102t-89-41q-124 0-124 145 0 135 124 135 119 0 119-137zm269-324v202q-36 12-79 22 16 43 16 84 0 127-73 216.5T472 1072q-40 8-59.5 27t-19.5 58q0 31 22.5 51.5t58 32 78.5 22 86 25.5 78.5 37.5 58 64T797 1488q0 304-363 304-69 0-130-12.5t-116-41-87.5-82T68 1529q0-165 182-225v-4q-67-41-67-126 0-109 63-137v-4q-72-24-119.5-108.5T79 759q0-139 95-231.5T409 435q96 0 178 47 98 0 218-47zm318 881H901q4-45 4-134V573q0-94-4-128h222q-4 33-4 124v613q0 89 4 134zm601-222v196q-71 39-174 39-62 0-107-20t-70-50-39.5-78-18.5-92-4-103V635h2v-4q-7 0-19-1t-18-1q-21 0-59 6V445h96v-76q0-54-6-89h227q-6 41-6 165h171v190q-15 0-43.5-2t-42.5-2h-85v365q0 131 87 131 61 0 109-33zm-576-947q0 58-39 101.5t-96 43.5q-58 0-98-43.5T875 147q0-59 39.5-103T1013 0q58 0 96.5 44.5T1148 147z"/>'
  }
});

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'fontawesome/trello': {
    width: 1792,
    height: 1792,
    viewBox: '0 0 1792 1792',
    data: '<path pid="0" d="M832 1344V320q0-14-9-23t-23-9H320q-14 0-23 9t-9 23v1024q0 14 9 23t23 9h480q14 0 23-9t9-23zm672-384V320q0-14-9-23t-23-9H992q-14 0-23 9t-9 23v640q0 14 9 23t23 9h480q14 0 23-9t9-23zm160-768v1408q0 26-19 45t-45 19H192q-26 0-45-19t-19-45V192q0-26 19-45t45-19h1408q26 0 45 19t19 45z"/>'
  }
});

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/android-arrow-forward': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M85 277.375h259.704L225.002 397.077 256 427l171-171L256 85l-29.922 29.924 118.626 119.701H85v42.75z"/>'
  }
});

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/android-close': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"/>'
  }
});

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/android-favorite-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M349.6 64c-36.4 0-70.718 16.742-93.6 43.947C233.117 80.742 198.8 64 162.4 64 97.918 64 48 114.221 48 179.095c0 79.516 70.718 143.348 177.836 241.694L256 448l30.164-27.211C393.281 322.442 464 258.61 464 179.095 464 114.221 414.082 64 349.6 64zm-80.764 329.257l-4.219 3.873-8.617 7.773-8.616-7.772-4.214-3.869c-50.418-46.282-93.961-86.254-122.746-121.994C92.467 236.555 80 208.128 80 179.095c0-22.865 8.422-43.931 23.715-59.316C118.957 104.445 139.798 96 162.4 96c26.134 0 51.97 12.167 69.11 32.545L256 157.661l24.489-29.116C297.63 108.167 323.465 96 349.6 96c22.603 0 43.443 8.445 58.686 23.778C423.578 135.164 432 156.229 432 179.095c0 29.033-12.467 57.459-40.422 92.171-28.784 35.74-72.325 75.709-122.742 121.991z"/>'
  }
});

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/android-folder-open': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M437.334 144H256.006l-42.668-48H74.666C51.197 96 32 115.198 32 138.667v234.666C32 396.802 51.197 416 74.666 416h362.668C460.803 416 480 396.802 480 373.333V186.667C480 163.198 460.803 144 437.334 144zM448 373.333c0 5.782-4.885 10.667-10.666 10.667H74.666C68.884 384 64 379.115 64 373.333V176h373.334c5.781 0 10.666 4.885 10.666 10.667v186.666z"/>'
  }
});

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/android-options': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M32 384h272v32H32zM400 384h80v32h-80zM384 447.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z"/><g><path pid="1" d="M32 240h80v32H32zM208 240h272v32H208zM192 303.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z"/></g><g><path pid="2" d="M32 96h272v32H32zM400 96h80v32h-80zM384 159.5c0 17.949-14.327 32.5-32 32.5-17.673 0-32-14.551-32-32.5v-95c0-17.949 14.327-32.5 32-32.5 17.673 0 32 14.551 32 32.5v95z"/></g>'
  }
});

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/android-time': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" fill-opacity=".9" d="M256 43C137.789 43 43 138.851 43 256s94.789 213 213 213 213-95.851 213-213S373.149 43 256 43zm0 383.4c-93.718 0-170.4-76.683-170.4-170.4S162.282 85.6 256 85.6 426.4 162.282 426.4 256 349.718 426.4 256 426.4z"/><path pid="1" fill-opacity=".9" d="M266.65 149.5H234.7v127.8l111.825 67.093 15.975-26.625-95.85-56.444z"/>'
  }
});

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/chevron-left': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M213.7 256L380.9 81.9c4.2-4.3 4.1-11.4-.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-.2L131.1 247.9c-2.2 2.2-3.2 5.2-3 8.1-.1 3 .9 5.9 3 8.1l204.2 212.7c4.2 4.3 11.2 4.2 15.5-.2l29.9-30.6c4.3-4.4 4.4-11.5.2-15.8L213.7 256z"/>'
  }
});

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/gear-a': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M411.1 256c0-23.9 14.8-42.8 36.9-55.8-4-13.3-9.3-26.2-15.8-38.2-24.9 6.5-45-3.2-62-20.2-16.9-16.9-22.1-37.1-15.6-62-12-6.5-24.8-11.8-38.2-15.8-13 22.2-36.4 36.9-60.4 36.9-23.9 0-47.4-14.7-60.4-36.9-13.4 4-26.2 9.3-38.2 15.8 6.5 24.9 1.3 45-15.6 62-16.9 16.9-37.1 26.7-61.9 20.2-6.6 12-11.9 24.8-15.9 38.2 22.2 13 37 31.9 37 55.8s-14.8 47.4-37 60.4c4 13.4 9.3 26.2 15.8 38.2 24.9-6.5 45-1.3 61.9 15.6 17 16.9 22.1 37.1 15.6 62 12.1 6.5 24.8 11.8 38.2 15.8 13-22.2 36.5-36.9 60.4-36.9s47.4 14.7 60.4 36.9c13.4-4 26.2-9.3 38.2-15.8-6.5-24.9-1.3-45 15.6-62 16.9-16.9 37.1-26.7 62-20.2 6.5-12.1 11.8-24.9 15.8-38.2-22.1-13-36.8-31.9-36.8-55.8zM256 354.3c-54.2 0-98.3-44-98.3-98.3s44-98.3 98.3-98.3 98.3 44 98.3 98.3-44 98.3-98.3 98.3z"/>'
  }
});

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/gear-b': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M448 294.4v-76.8h-42.8c-3.4-14.4-8.9-28-16.1-40.5l29.8-29.7-54.3-54.3-29.1 29.1c-12.6-7.7-26.4-13.5-41.1-17.3V64h-76.8v40.9c-14.7 3.8-28.5 9.7-41.1 17.3l-29.1-29.1-54.3 54.3 29.8 29.7c-7.2 12.5-12.6 26.1-16.1 40.5H64v76.8h44.1c3.8 13.7 9.5 26.6 16.7 38.6l-31.7 31.7 54.3 54.3 32.3-32.3c11.7 6.8 24.5 11.9 37.9 15.4v46h76.8v-46c13.5-3.5 26.2-8.6 37.9-15.4l32.3 32.3 54.3-54.3-31.6-31.7c7.2-11.9 12.9-24.8 16.7-38.6h44zm-192 15.4c-29.7 0-53.7-24.1-53.7-53.8s24-53.8 53.7-53.8 53.8 24.1 53.8 53.8-24.1 53.8-53.8 53.8z"/>'
  }
});

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-checkmark-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M340.1 177.3L215.3 303l-47.2-47.2-17.8 17.8 56 56c2.5 2.5 5.9 4.5 8.9 4.5s6.3-2 8.8-4.4l133.7-134.4-17.6-18z"/><path pid="1" d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 398.7c-105.1 0-190.7-85.5-190.7-190.7 0-105.1 85.5-190.7 190.7-190.7 105.1 0 190.7 85.5 190.7 190.7 0 105.1-85.6 190.7-190.7 190.7z"/>'
  }
});

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-clock-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 398.7c-105.1 0-190.7-85.5-190.7-190.7 0-105.1 85.5-190.7 190.7-190.7 105.1 0 190.7 85.5 190.7 190.7 0 105.1-85.6 190.7-190.7 190.7z"/><path pid="1" d="M256 256h-96v17.3h113.3V128H256z"/>'
  }
});

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-minus-empty': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M384 265H128v-17h256v17z"/>'
  }
});

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-play-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M144 124.9L353.8 256 144 387.1V124.9M128 96v320l256-160L128 96z"/>'
  }
});

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-plus-empty': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M384 265H264v119h-17V265H128v-17h119V128h17v120h120v17z"/>'
  }
});

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'ionicons/ios-trash-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M400 113.3h-80v-20c0-16.2-13.1-29.3-29.3-29.3h-69.5C205.1 64 192 77.1 192 93.3v20h-80V128h21.1l23.6 290.7c0 16.2 13.1 29.3 29.3 29.3h141c16.2 0 29.3-13.1 29.3-29.3L379.6 128H400v-14.7zm-193.4-20c0-8.1 6.6-14.7 14.6-14.7h69.5c8.1 0 14.6 6.6 14.6 14.7v20h-98.7v-20zm135 324.6v.8c0 8.1-6.6 14.7-14.6 14.7H186c-8.1 0-14.6-6.6-14.6-14.7v-.8L147.7 128h217.2l-23.3 289.9z"/><path pid="1" d="M249 160h14v241h-14zM320 160h-14.6l-10.7 241h14.6zM206.5 160H192l10.7 241h14.6z"/>'
  }
});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/calendar-full': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18.5 2H16v-.5a.5.5 0 0 0-1 0V2H5v-.5a.5.5 0 0 0-1 0V2H1.5C.673 2 0 2.673 0 3.5v14c0 .827.673 1.5 1.5 1.5h17c.827 0 1.5-.673 1.5-1.5v-14c0-.827-.673-1.5-1.5-1.5zm-17 1H4v1.5a.5.5 0 0 0 1 0V3h10v1.5a.5.5 0 0 0 1 0V3h2.5a.5.5 0 0 1 .5.5V6H1V3.5a.5.5 0 0 1 .5-.5zm17 15h-17a.5.5 0 0 1-.5-.5V7h18v10.5a.5.5 0 0 1-.5.5z"/><path pid="1" d="M7.5 10h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM10.5 10h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM13.5 10h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM16.5 10h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM4.5 12h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM7.5 12h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM10.5 12h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM13.5 12h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM16.5 12h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM4.5 14h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM7.5 14h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM10.5 14h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM13.5 14h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM16.5 14h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM4.5 16h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM7.5 16h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM10.5 16h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM13.5 16h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1zM16.5 16h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1z"/>'
  }
});

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/chart-bars': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M17.5 20h-16C.673 20 0 19.327 0 18.5v-16C0 1.673.673 1 1.5 1h16c.827 0 1.5.673 1.5 1.5v16c0 .827-.673 1.5-1.5 1.5zM1.5 2a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-16a.5.5 0 0 0-.5-.5h-16z"/><path pid="1" d="M6.5 17h-2a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5zM5 16h1V8H5v8zM10.5 17h-2a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5zM9 16h1V5H9v11zM14.5 17h-2a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5zM13 16h1v-4h-1v4z"/>'
  }
});

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/cross': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10.707 10.5l5.646-5.646a.5.5 0 0 0-.707-.707L10 9.793 4.354 4.147a.5.5 0 0 0-.707.707L9.293 10.5l-5.646 5.646a.5.5 0 0 0 .708.707l5.646-5.646 5.646 5.646a.498.498 0 0 0 .708 0 .5.5 0 0 0 0-.707L10.709 10.5z"/>'
  }
});

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/hand': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M17 4c-.364 0-.706.098-1 .269V3a2.002 2.002 0 0 0-3.113-1.661C12.613.56 11.871 0 11 0S9.386.56 9.113 1.339A2.002 2.002 0 0 0 6 3v7.373L4.654 8.04a1.947 1.947 0 0 0-1.199-.953 1.866 1.866 0 0 0-1.462.202c-.907.544-1.253 1.774-.77 2.742.03.061.668 1.368 2.66 5.35.938 1.875 1.967 3.216 3.059 3.984.857.603 1.449.634 1.559.634h5c.851 0 1.642-.277 2.352-.822.667-.513 1.246-1.255 1.72-2.204.934-1.868 1.428-4.452 1.428-7.474v-3.5c0-1.103-.897-2-2-2zm1 5.5c0 2.867-.457 5.296-1.322 7.026C16.114 17.654 15.104 19 13.5 19H8.51c-.039-.003-.46-.05-1.095-.525-.633-.474-1.605-1.472-2.638-3.54-2.027-4.054-2.65-5.331-2.656-5.343l-.002-.004c-.251-.503-.073-1.162.389-1.439a.876.876 0 0 1 .685-.095.956.956 0 0 1 .587.472l.006.01 1.561 2.705c.319.583.678.828 1.067.729.39-.099.587-.489.587-1.157V3c0-.551.449-1 1-1s1 .449 1 1v6.5a.5.5 0 0 0 1 0V2c0-.551.449-1 1-1s1 .449 1 1v7.5a.5.5 0 0 0 1 0V3c0-.551.449-1 1-1s1 .449 1 1v7.5a.5.5 0 0 0 1 0V6c0-.551.449-1 1-1s1 .449 1 1v3.5z"/>'
  }
});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/heart': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M9.5 19a.5.5 0 0 1-.243-.063c-.094-.052-2.326-1.301-4.592-3.347-1.341-1.21-2.411-2.448-3.183-3.68C.498 10.339 0 8.771 0 7.25A5.256 5.256 0 0 1 5.25 2c.98 0 2.021.367 2.931 1.034.532.39.985.86 1.319 1.359a5.522 5.522 0 0 1 1.319-1.359C11.729 2.367 12.77 2 13.75 2A5.256 5.256 0 0 1 19 7.25c0 1.521-.499 3.089-1.482 4.66-.771 1.232-1.842 2.47-3.182 3.68-2.266 2.046-4.498 3.295-4.592 3.347a.5.5 0 0 1-.243.063zM5.25 3A4.255 4.255 0 0 0 1 7.25c0 3.04 2.35 5.802 4.321 7.585A27.738 27.738 0 0 0 9.5 17.922a27.738 27.738 0 0 0 4.179-3.087C15.65 13.053 18 10.29 18 7.25A4.255 4.255 0 0 0 13.75 3c-1.703 0-3.357 1.401-3.776 2.658a.5.5 0 0 1-.948 0C8.607 4.401 6.953 3 5.25 3z"/>'
  }
});

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/home': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M19.871 12.165l-8.829-9.758A1.392 1.392 0 0 0 10 1.937c-.397 0-.767.167-1.042.47L.129 12.165a.5.5 0 0 0 .741.67l2.129-2.353V18.5c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-8.018l2.129 2.353a.499.499 0 1 0 .741-.671zM12 19H8v-4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V19zm4-.5a.5.5 0 0 1-.5.5H13v-4.5c0-.827-.673-1.5-1.5-1.5h-3c-.827 0-1.5.673-1.5 1.5V19H4.5a.5.5 0 0 1-.5-.5V9.377l5.7-6.3c.082-.091.189-.141.3-.141s.218.05.3.141l5.7 6.3V18.5z"/>'
  }
});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/hourglass': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M16 3.5V3c0-.392-.241-.733-.717-1.014-.344-.203-.821-.382-1.419-.531-1.172-.293-2.722-.454-4.364-.454s-3.192.161-4.364.454c-.598.149-1.075.328-1.419.531C3.241 2.267 3 2.608 3 3v.5a6.513 6.513 0 0 0 4 6.002v1.997a6.513 6.513 0 0 0-4 6.002v.5c0 .392.241.733.717 1.014.344.203.821.382 1.419.531C6.308 19.839 7.858 20 9.5 20s3.192-.161 4.364-.454c.598-.149 1.075-.328 1.419-.531.476-.281.717-.623.717-1.014v-.5a6.513 6.513 0 0 0-4-6.002V9.502A6.513 6.513 0 0 0 16 3.5zM5.612 2.369C6.678 2.131 8.059 2 9.5 2s2.823.131 3.888.369c1.15.257 1.498.534 1.589.631-.091.097-.439.374-1.589.631C12.322 3.869 10.941 4 9.5 4s-2.823-.131-3.888-.369C4.462 3.374 4.114 3.097 4.023 3c.091-.097.439-.374 1.589-.631zm5.721 9.944A5.51 5.51 0 0 1 15 17.5v.473c-.042.057-.324.37-1.612.657-1.066.238-2.447.369-3.888.369s-2.823-.131-3.888-.369c-1.287-.288-1.57-.6-1.612-.657V17.5a5.509 5.509 0 0 1 3.667-5.187.5.5 0 0 0 .333-.471V9.159a.5.5 0 0 0-.333-.471 5.513 5.513 0 0 1-3.624-4.506c.3.135.666.257 1.093.364C6.308 4.839 7.858 5 9.5 5s3.192-.161 4.364-.454a6.548 6.548 0 0 0 1.093-.364 5.511 5.511 0 0 1-3.624 4.506.5.5 0 0 0-.333.471v2.683a.5.5 0 0 0 .333.471z"/><path pid="1" d="M13.667 16.529C11.405 15.73 10 13.803 10 11.5V8.475a4.955 4.955 0 0 0 1.723-.495.5.5 0 0 0-.445-.895c-.555.276-1.153.416-1.778.416s-1.223-.14-1.778-.416a.5.5 0 0 0-.445.895A4.928 4.928 0 0 0 9 8.475V11.5c0 2.302-1.405 4.229-3.667 5.029a.499.499 0 0 0 .058.959c.982.22 2.477.512 4.109.512s3.127-.292 4.109-.512a.5.5 0 0 0 .058-.959zM9.5 17c-.877 0-1.701-.087-2.437-.205a6.43 6.43 0 0 0 1.711-1.575c.293-.391.536-.812.726-1.254.19.442.433.863.726 1.254a6.432 6.432 0 0 0 1.711 1.575c-.736.117-1.56.205-2.437.205z"/>'
  }
});

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/list': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M19.5 16h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1zM19.5 11h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1zM19.5 6h-15a.5.5 0 0 1 0-1h15a.5.5 0 0 1 0 1zM1.5 7C.673 7 0 6.327 0 5.5S.673 4 1.5 4 3 4.673 3 5.5 2.327 7 1.5 7zm0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM1.5 12C.673 12 0 11.327 0 10.5S.673 9 1.5 9 3 9.673 3 10.5 2.327 12 1.5 12zm0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM1.5 17C.673 17 0 16.327 0 15.5S.673 14 1.5 14s1.5.673 1.5 1.5S2.327 17 1.5 17zm0-2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"/>'
  }
});

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/magic-wand': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M11.5 7a.5.5 0 0 1-.5-.5C11 5.122 9.878 4 8.5 4a.5.5 0 0 1 0-1C9.878 3 11 1.878 11 .5a.5.5 0 0 1 1 0C12 1.878 13.122 3 14.5 3a.5.5 0 0 1 0 1A2.503 2.503 0 0 0 12 6.5a.5.5 0 0 1-.5.5zm-1.199-3.5c.49.296.903.708 1.199 1.199.296-.49.708-.903 1.199-1.199A3.536 3.536 0 0 1 11.5 2.301c-.296.49-.708.903-1.199 1.199zM1.5 10c-.276 0-.5-.224-.5-.5S.776 9 .5 9a.5.5 0 0 1 0-1c.276 0 .5-.224.5-.5a.5.5 0 0 1 1 0c0 .276.224.5.5.5a.5.5 0 0 1 0 1c-.276 0-.5.224-.5.5s-.224.5-.5.5zM18.147 15.939L7.561 5.353c-.283-.283-.659-.438-1.061-.438s-.778.156-1.061.438l-.586.586c-.283.283-.438.659-.438 1.061s.156.778.438 1.061l10.586 10.586c.283.283.659.438 1.061.438s.778-.156 1.061-.438l.586-.586c.283-.283.438-.659.438-1.061s-.156-.778-.438-1.061zM5.561 6.646l.586-.586c.094-.094.219-.145.354-.145s.26.052.354.145l1.439 1.439-1.293 1.293-1.439-1.439a.5.5 0 0 1 0-.707zm11.878 10.708l-.586.586c-.094.094-.219.145-.353.145s-.26-.052-.353-.145L7.708 9.501l1.293-1.293 8.439 8.439a.5.5 0 0 1 0 .707zM3.5 5a.5.5 0 0 1-.5-.5C3 3.673 2.327 3 1.5 3a.5.5 0 0 1 0-1C2.327 2 3 1.327 3 .5a.5.5 0 0 1 1 0C4 1.327 4.673 2 5.5 2a.5.5 0 0 1 0 1C4.673 3 4 3.673 4 4.5a.5.5 0 0 1-.5.5zm-.502-2.5c.19.143.359.312.502.502a2.54 2.54 0 0 1 .502-.502 2.54 2.54 0 0 1-.502-.502 2.54 2.54 0 0 1-.502.502zM3.5 15a.5.5 0 0 1-.5-.5c0-.827-.673-1.5-1.5-1.5a.5.5 0 0 1 0-1c.827 0 1.5-.673 1.5-1.5a.5.5 0 0 1 1 0c0 .827.673 1.5 1.5 1.5a.5.5 0 0 1 0 1c-.827 0-1.5.673-1.5 1.5a.5.5 0 0 1-.5.5zm-.502-2.5c.19.143.359.312.502.502a2.54 2.54 0 0 1 .502-.502 2.54 2.54 0 0 1-.502-.502 2.54 2.54 0 0 1-.502.502z"/>'
  }
});

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/pencil': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M19.104.896C18.542.334 17.795.025 17 .025s-1.542.309-2.104.871l-12.75 12.75a.496.496 0 0 0-.116.183l-2 5.5a.5.5 0 0 0 .641.64l5.5-2a.51.51 0 0 0 .183-.116l12.75-12.75c.562-.562.871-1.309.871-2.104s-.309-1.542-.871-2.104zM5.725 17.068l-4.389 1.596 1.596-4.389L14 3.207 16.793 6 5.725 17.068zM18.396 4.396l-.896.896-2.793-2.793.896-.896c.373-.373.869-.578 1.396-.578s1.023.205 1.396.578.578.869.578 1.396-.205 1.023-.578 1.396z"/>'
  }
});

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/pie-chart': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M8.5 20c-2.27 0-4.405-.884-6.01-2.49S0 13.77 0 11.5c0-2.27.884-4.405 2.49-6.01S6.23 3 8.5 3a.5.5 0 0 1 .5.5V11h7.5a.5.5 0 0 1 .5.5c0 2.27-.884 4.405-2.49 6.01S10.77 20 8.5 20zM8 4.016c-3.903.258-7 3.516-7 7.484C1 15.636 4.364 19 8.5 19c3.967 0 7.225-3.097 7.484-7H8.5a.5.5 0 0 1-.5-.5V4.016z"/><path pid="1" d="M18.5 10h-8a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5c2.27 0 4.405.884 6.01 2.49S19 7.23 19 9.5a.5.5 0 0 1-.5.5zM11 9h6.984A7.513 7.513 0 0 0 11 2.016V9z"/>'
  }
});

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/rocket': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M13.5 9C12.122 9 11 7.878 11 6.5S12.122 4 13.5 4 16 5.122 16 6.5 14.878 9 13.5 9zm0-4c-.827 0-1.5.673-1.5 1.5S12.673 8 13.5 8 15 7.327 15 6.5 14.327 5 13.5 5zM.5 20a.499.499 0 0 1-.47-.67c1.539-4.231 3.157-6.377 4.808-6.377.545 0 1.054.234 1.515.694.728.728.754 1.453.648 1.933-.334 1.508-2.464 2.985-6.33 4.391a.51.51 0 0 1-.171.03zm4.339-6.048c-.495 0-1.078.434-1.685 1.255-.597.807-1.197 1.957-1.788 3.427 1.335-.537 2.408-1.082 3.199-1.625 1.067-.733 1.383-1.3 1.46-1.646s-.047-.677-.379-1.009c-.27-.27-.534-.401-.808-.401z"/><path pid="1" d="M19.5 0c-2.595 0-4.907.44-6.874 1.308-1.621.716-3.009 1.72-4.126 2.986-.208.236-.401.475-.58.715-.862.057-1.744.4-2.624 1.02-.745.524-1.493 1.25-2.225 2.157-1.23 1.524-1.986 3.027-2.018 3.09a.5.5 0 0 0 .8.578c.005-.005.483-.475 1.298-.936.672-.38 1.708-.827 2.961-.906.317.811 1.224 1.781 1.659 2.216s1.405 1.342 2.216 1.659c-.079 1.253-.526 2.289-.906 2.961-.462.816-.931 1.293-.935 1.297a.501.501 0 0 0 .577.801c.063-.032 1.566-.788 3.09-2.018.907-.732 1.633-1.48 2.157-2.225.62-.881.962-1.762 1.02-2.624.239-.178.478-.371.715-.58 1.266-1.117 2.27-2.505 2.986-4.126.868-1.966 1.308-4.279 1.308-6.874v-.5h-.5zM3.107 9.808c.953-1.383 2.41-3.098 4.052-3.637-.649 1.137-.985 2.181-1.106 2.843a7.784 7.784 0 0 0-2.946.794zm7.086 7.082a7.761 7.761 0 0 0 .793-2.944c.661-.121 1.706-.457 2.842-1.105-.54 1.639-2.254 3.096-3.636 4.049zm4.851-6.14C12.964 12.585 10.81 13 10.5 13c-.002 0-.207-.004-.759-.393-.385-.271-.834-.657-1.262-1.085s-.814-.877-1.085-1.262c-.389-.552-.393-.757-.393-.759 0-.31.415-2.464 2.25-4.544 2.196-2.488 5.557-3.849 9.744-3.95-.101 4.187-1.461 7.548-3.95 9.744z"/>'
  }
});

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/store': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18 9.5v-1a.499.499 0 0 0-.053-.224l-2-4A.5.5 0 0 0 15.5 4h-12a.5.5 0 0 0-.447.276l-2 4A.496.496 0 0 0 1 8.5v1c0 .816.393 1.542 1 1.999V18h-.5a.5.5 0 0 0 0 1h16a.5.5 0 0 0 0-1H17v-6.501c.607-.457 1-1.182 1-1.999zM11.5 11c-.827 0-1.5-.673-1.5-1.5V9h3v.5c0 .827-.673 1.5-1.5 1.5zM2 9.5V9h3v.5c0 .827-.673 1.5-1.5 1.5S2 10.327 2 9.5zM9 5v3H6.14l.75-3H9zm3.11 0l.75 3H10V5h2.11zM6 9h3v.5c0 .827-.673 1.5-1.5 1.5S6 10.327 6 9.5V9zm8 0h3v.5c0 .827-.673 1.5-1.5 1.5S14 10.327 14 9.5V9zm2.691-1H13.89l-.75-3h2.051l1.5 3zM3.809 5H5.86l-.75 3H2.309l1.5-3zM3 11.95a2.501 2.501 0 0 0 2.5-.952 2.497 2.497 0 0 0 4 0c.361.48.89.827 1.5.951v6.05H3v-6.05zM16 18h-4v-6.05a2.504 2.504 0 0 0 1.5-.951 2.497 2.497 0 0 0 2.5.952v6.05z"/><path pid="1" d="M14 14.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4.5 15a.5.5 0 0 1-.354-.853l1-1a.5.5 0 0 1 .707.707l-1 1a.498.498 0 0 1-.354.146zM5.5 17a.5.5 0 0 1-.354-.853l3-3a.5.5 0 0 1 .707.707l-3 3a.498.498 0 0 1-.354.146zM8.5 17a.5.5 0 0 1-.354-.853l1-1a.5.5 0 0 1 .707.707l-1 1a.498.498 0 0 1-.354.146z"/>'
  }
});

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/thumbs-up': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18.916 11.208c.443-.511.695-1.355.695-2.159 0-.531-.115-.996-.333-1.345A1.46 1.46 0 0 0 18 7h-2.618c1.425-2.591 1.785-4.543 1.07-5.807C15.953.312 15.039 0 14.407 0a.5.5 0 0 0-.495.433c-.179 1.319-1.188 2.893-2.768 4.318a15.544 15.544 0 0 1-5.286 3.11 1.502 1.502 0 0 0-1.356-.86h-3c-.827 0-1.5.673-1.5 1.5v9c0 .827.673 1.5 1.5 1.5h3c.634 0 1.176-.395 1.396-.952 1.961.246 2.699.64 3.414 1.022.895.478 1.739.93 4.503.93.72 0 1.398-.188 1.91-.529.5-.333.82-.801.926-1.343.399-.162.753-.536 1.024-1.092.264-.541.435-1.232.435-1.761 0-.099-.006-.19-.017-.274.253-.186.48-.473.667-.851a4.32 4.32 0 0 0 .432-1.826c0-.424-.079-.777-.234-1.051l-.039-.065zM4.5 18h-3a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5zm13.839-7.726c-.151.304-.304.414-.37.414a.5.5 0 0 0 0 1c.042 0 .072 0 .117.078.066.117.104.32.104.558 0 .445-.126.974-.328 1.382-.198.399-.399.544-.487.544a.5.5 0 0 0-.269.922c.031.317-.117 1.165-.501 1.718-.145.209-.298.329-.418.329a.5.5 0 0 0-.5.5c0 .88-.972 1.281-1.875 1.281-2.513 0-3.217-.376-4.032-.812-.762-.407-1.618-.865-3.781-1.134V8.867a16.545 16.545 0 0 0 5.812-3.373c1.593-1.436 2.639-2.988 2.994-4.426.272.087.579.271.776.618.334.59.584 2.096-1.493 5.557a.5.5 0 0 0 .429.758H18c.199 0 .327.07.43.234.117.187.181.477.181.815 0 .424-.102.882-.272 1.225z"/>'
  }
});

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/user': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M9.5 11C6.467 11 4 8.533 4 5.5S6.467 0 9.5 0 15 2.467 15 5.5 12.533 11 9.5 11zm0-10C7.019 1 5 3.019 5 5.5S7.019 10 9.5 10 14 7.981 14 5.5 11.981 1 9.5 1zM17.5 20h-16C.673 20 0 19.327 0 18.5c0-.068.014-1.685 1.225-3.3.705-.94 1.67-1.687 2.869-2.219C5.558 12.33 7.377 12 9.5 12s3.942.33 5.406.981c1.199.533 2.164 1.279 2.869 2.219C18.986 16.815 19 18.432 19 18.5c0 .827-.673 1.5-1.5 1.5zm-8-7c-3.487 0-6.06.953-7.441 2.756C1.024 17.107 1.001 18.488 1 18.502a.5.5 0 0 0 .5.498h16a.5.5 0 0 0 .5-.5c0-.012-.023-1.393-1.059-2.744C15.559 13.953 12.986 13 9.5 13z"/>'
  }
});

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var icon = __webpack_require__(2);
icon.register({
  'linearicons/users': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18.5 18h-11c-.827 0-1.5-.673-1.5-1.5 0-.048.011-1.19.924-2.315.525-.646 1.241-1.158 2.128-1.522 1.071-.44 2.4-.662 3.948-.662s2.876.223 3.948.662c.887.364 1.603.876 2.128 1.522.914 1.125.924 2.267.924 2.315 0 .827-.673 1.5-1.5 1.5zM7 16.503a.5.5 0 0 0 .5.497h11a.5.5 0 0 0 .5-.497c-.001-.035-.032-.895-.739-1.734-.974-1.157-2.793-1.768-5.261-1.768s-4.287.612-5.261 1.768c-.707.84-.738 1.699-.739 1.734zM13 11c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-7c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM4.5 18h-3C.673 18 0 17.327 0 16.5c0-.037.008-.927.663-1.8.378-.505.894-.904 1.533-1.188.764-.34 1.708-.512 2.805-.512.179 0 .356.005.527.014a.5.5 0 0 1-.053.999 9.1 9.1 0 0 0-.473-.012c-3.894 0-3.997 2.379-4 2.503a.5.5 0 0 0 .5.497h3a.5.5 0 0 1 0 1zM5 12c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"/>'
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_js__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_storePlugin__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuefire__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_ripple_directive__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_charts__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_toasted__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetrend__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_svgicon__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_svgicon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_svgicon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_dragula__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_dragula___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_dragula__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filters__ = __webpack_require__(289);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__store_storePlugin__["a" /* default */]);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('ripple', __WEBPACK_IMPORTED_MODULE_7_vue_ripple_directive__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_charts___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_dragula___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_toasted___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vuetrend__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_svgicon___default.a, {
  tagName: 'svgicon'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('multiselect', __WEBPACK_IMPORTED_MODULE_13_vue_multiselect___default.a);


for (var name in __WEBPACK_IMPORTED_MODULE_14__filters__["a" /* default */]) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter(name, __WEBPACK_IMPORTED_MODULE_14__filters__["a" /* default */][name]);
}
window.eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

window.app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_1__router_js__["a" /* default */],

  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue___default.a);
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

/* harmony default export */ __webpack_exports__["a"] = ({

    namespaced: true,

    state: {},

    getters: {

        getAll: function getAll(state, getters, rootState, rootGetters) {
            return rootGetters.getAll('clients');
            if (!rootGetters.firebase_arrays.clients) return [];
            return rootGetters.firebase_arrays.clients;
        },

        getOne: function getOne(state, getters, rootState, rootGetters) {
            return function (key) {
                return rootGetters.getOne('client', key);
            };
        },

        getClient: function getClient(state, getters, rootState, rootGetters) {
            return function (client_key) {
                return rootGetters.getOne('client', client_key);
                if (!client_key) return;
                if (!rootState.firebase) return;
                if (!rootState.firebase.clients) return;
                var c = rootState.firebase.clients[client_key];
                return c;
            };
        },

        getClientByProjectKey: function getClientByProjectKey(state, getters, rootState, rootGetters) {
            return function (project_key) {
                var p = rootGetters['projects/getProject'](project_key);
                if (!p || !p.client_key) return;
                return getters.getClient(p.client_key);
            };
        },

        get_client_projects: function get_client_projects(state, getters, rootState, rootGetters) {
            return function (client_key) {
                var projects = rootGetters['projects/getFiltered']({
                    client_key: client_key
                });
                return projects;
            };
        },

        get_total_earning: function get_total_earning(state, getters, rootState, rootGetters) {
            return function (client) {

                var total = 0;
                var client_key = client.key || client['.key'];
                var projects = getters.get_client_projects(client_key);

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var project = _step.value;
                        rootGetters['projects/get_payable_amount'](project);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return total;
            };
        }

    } });

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({

    namespaced: true,

    state: {},

    getters: {

        byKey: function byKey(state, getters, rootState, rootGetters) {
            return function (search_keytype, search_key) {
                var items = rootState.firebase.comments;
                var output = [];
                for (var key in items) {
                    var item = items[key];
                    if (item.keytype != search_keytype) continue;
                    if (item.key != search_key) continue;
                    if (item.archived) continue;
                    item['.key'] = key;
                    item.user = rootGetters['users/getOne'](item.user_key);
                    item.created_human = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.created, 'YYYY-MM-DD').format('DD/MM/YY HH:mm');
                    item.created_human2 = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.created, 'YYYY-MM-DD').fromNow();
                    output.push(item);
                }
                return output;
            };
        }

    }

});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




/* harmony default export */ __webpack_exports__["a"] = ({

    namespaced: true,

    state: {

        calculate_hypothetic_posts: false

    },

    getters: {

        getAll: function getAll(state, getters, rootState, rootGetters) {
            return rootGetters.getAll('economyposts');
            if (!rootGetters.firebase_arrays.economyposts) return [];
            return rootGetters.firebase_arrays.economyposts;
        },

        getOne: function getOne(state, getters, rootState, rootGetters) {
            return function (key) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(getters.getAll), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;
                        if (item.key === key) return item;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
        },

        getFiltered: function getFiltered(state, getters, rootState, rootGetters) {
            return function (filters, economyposts) {

                var output = [];

                if (!filters) filters = {};
                if (!filters['place_posts_by']) filters.place_posts_by = 'invoice_date';

                if (!economyposts) economyposts = getters.getAll;

                if (!economyposts) return output;

                for (var i = 0; i < economyposts.length; i++) {

                    var _economypost = economyposts[i];

                    if (_economypost.archived && !filters.include_archived) continue;

                    if (filters.client_key != undefined && filters.client_key != 'undefined') {
                        if (filters.client_key != _economypost.client_key) continue;
                    }

                    if (filters.project_key != undefined && filters.project_key != 'undefined') {
                        if (filters.project_key != _economypost.project_key) continue;
                    }

                    if (filters.project_keys != undefined) {
                        if (filters.project_keys.indexOf(_economypost.project_key) === -1) continue;
                    }

                    if (filters.income_only && !_economypost.amount_dkk_ex_vat > 0) continue;
                    if (filters.expense_only && !_economypost.amount_dkk_ex_vat < 0) continue;

                    if (filters.paid !== undefined) {
                        if (filters.paid === true && !_economypost.paid) continue;
                        if (filters.paid === false && _economypost.paid) continue;
                    }

                    if (filters.invoiced !== undefined) {
                        if (filters.invoiced === true && !_economypost.invoiced) continue;
                        if (filters.invoiced === false && _economypost.invoiced) continue;
                    }

                    if (filters.hypothetic !== undefined) {
                        if (filters.hypothetic === true && !_economypost.hypothetic) continue;
                        if (filters.hypothetic === false && _economypost.hypothetic) continue;
                    }

                    if (filters.date_from_timestamp || filters.date_to_timestamp) {
                        if (!_economypost.date_timestamp) economyposts[i].date_timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_economypost[filters.place_posts_by], 'YYYY-MM-DD').unix();
                        var _economypost = economyposts[i];
                        if (_economypost.date_timestamp < filters.date_from_timestamp) continue;
                        if (_economypost.date_timestamp > filters.date_to_timestamp) continue;
                    }

                    _economypost.year_no = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_economypost[filters.place_posts_by], 'YYYY-MM-DD').format('YYYY');
                    _economypost.month_no = parseInt(__WEBPACK_IMPORTED_MODULE_2_moment___default()(_economypost[filters.place_posts_by], 'YYYY-MM-DD').format('M'));

                    output.push(_economypost);
                }

                output.sort(function (a, b) {
                    return b.amount_dkk_ex_vat - a.amount_dkk_ex_vat;
                });

                return output;
            };
        },

        getTotals: function getTotals(state, getters, rootState, rootGetters) {
            return function (economyposts) {
                var totals = {
                    income_total: 0,
                    expense_total: 0,
                    total: 0
                };

                for (var i = 0; i < economyposts.length; i++) {
                    var post = economyposts[i];
                    var val = parseInt(post.amount_dkk_ex_vat);

                    if (post.hypothetic && !state.calculate_hypothetic_posts) continue;
                    if (val > 0) totals.income_total += val;
                    if (val < 0) totals.expense_total += val;
                    totals.total += val;
                }
                return totals;
            };
        },

        getFilteredAndTotals: function getFilteredAndTotals(state, getters, rootState, rootGetters) {
            return function (filters) {
                var economyposts = getters.getFiltered(filters);
                var totals = getters.getTotals(economyposts);
                return {
                    posts: economyposts,
                    totals: totals
                };
            };
        }

    },

    mutations: {
        toggle_calculate_hypothetic_posts: function toggle_calculate_hypothetic_posts(state) {
            var val = !state.calculate_hypothetic_posts;
            state.calculate_hypothetic_posts = val;
        }
    }

});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuexfire__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = ({

    state: {

        users: null,
        clients: null,
        projects: null,
        specs: null,
        economyposts: null,
        timelogs: null,
        timebookings: null,
        tasks: null,
        tasklists: null,
        comments: null

    },

    getters: {},

    mutations: __WEBPACK_IMPORTED_MODULE_0_vuexfire__["firebaseMutations"],

    actions: {

        setVuexFireRef: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuexfire__["firebaseAction"])(function (_ref, input) {
            var bindFirebaseRef = _ref.bindFirebaseRef;

            bindFirebaseRef(input.key, input.ref);
        })

    } });

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



/* harmony default export */ __webpack_exports__["a"] = ({

    namespaced: true,

    state: {

        fdb: {
            projects: [],
            _projects: null }

    },

    getters: {
        getAll: function getAll(state, getters, rootState, rootGetters) {
            return rootGetters.getAll('projects');
            if (!rootGetters.firebase_arrays.projects) return [];
            return rootGetters.firebase_arrays.projects;
        },

        getOne: function getOne(state, getters, rootState, rootGetters) {
            return function (key) {
                return rootGetters.getOne('project', key);
            };
        },

        getProject: function getProject(state, getters, rootState, rootGetters) {
            return function (project_key) {
                return rootGetters.getOne('project', project_key);
                if (!rootState.firebase.projects) return;
                var p = rootState.firebase.projects[project_key];
                return p;
            };
        },

        getFiltered: function getFiltered(state, getters, rootState, rootGetters) {
            return function (filters) {

                var output = [];
                if (!filters) filters = {};
                var projects = getters.getAll;

                for (var i = 0; i < projects.length; i++) {

                    var project = projects[i];

                    if (project.archived && !filters.include_archived) continue;

                    if (filters.client_key != undefined && filters.client_key != 'undefined') {
                        if (filters.client_key != project.client_key) continue;
                    }

                    if (filters.project_key != undefined && filters.project_key != 'undefined') {
                        if (filters.project_key != project.project_key) continue;
                    }

                    if (filters.tag_in != undefined) {
                        if (!project.tags) continue;
                        if (project.tags.toLowerCase().indexOf(filters.tag_in.toLowerCase()) === -1) continue;
                    }

                    if (filters.tag_not_in != undefined) {
                        if (!project.tags || project.tags.toLowerCase().indexOf(filters.tag_not_in.toLowerCase()) !== -1) continue;
                    }

                    if (filters.project_keys != undefined) {
                        if (filters.project_keys.indexOf(project.project_key) === -1) continue;
                    }

                    if (filters.status != undefined && filters.status !== project.status) continue;
                    if (filters.status_not != undefined && filters.status_not === project.status) continue;

                    output.push(project);
                }

                return output;
            };
        },

        projects_without_budget: function projects_without_budget(state, getters, rootState, rootGetters) {

            return rootGetters.getAll('projects').filter(function (project) {
                if (!project.fixed_price) return false;
                return true;
            });

            var output = [];
            var list = rootState.firebase.projects;
            for (var key in list) {
                if (key == '.key') continue;
                var project = list[key];
                if (project.archived) continue;

                if (project.fixed_price) continue;
                output.push(project);
            }
            return output;
        },
        projects_without_timeline: function projects_without_timeline(state, getters, rootState, rootGetters) {
            var output = [];

            var list = rootGetters.getAll('projects');
            for (var key in list) {
                if (key == '.key') continue;
                var project = list[key];
                if (project.archived) continue;
                if (project.start_date && project.end_date) continue;
                output.push(project);
            }
            return output;
        },
        active_projects_beyond_end_date: function active_projects_beyond_end_date(state, getters, rootState, rootGetters) {
            var output = [];

            var list = rootGetters.getAll('projects');
            var now_date_timestamp = __WEBPACK_IMPORTED_MODULE_0_moment___default()().unix();
            for (var key in list) {
                if (key == '.key') continue;
                var project = list[key];
                if (project.archived) continue;
                if (project.status != 'active') continue;
                if (!project.end_date) continue;
                var end_date_timestamp = __WEBPACK_IMPORTED_MODULE_0_moment___default()(project.end_date, 'YYYY-MM-DD').unix();
                if (now_date_timestamp < end_date_timestamp) continue;
                output.push(project);
            }
            return output;
        },
        most_profitable: function most_profitable(state, getters, rootState, rootGetters) {
            var output = [];

            var list = rootGetters.getAll('projects');
            for (var key in list) {
                if (key == '.key') continue;
                var project = list[key];
                if (project.archived) continue;

                project.budget = getters.getBudget(project);

                if (!project.budget) continue;

                project.hours_logged = rootGetters['timelogs/get_cached'].project[key];

                project.hour_earning = project.budget / project.hours_logged;

                output.push(project);
            }
            return output;
        },


        getBudget: function getBudget(state, getters, rootState, rootGetters) {
            return function (project) {

                if (typeof project === 'string') project = getters.getProject(project);
                if (!project) return;
                var project_key = project.key || project['.key'];

                if (project.fixed_price) return parseFloat(project.fixed_price);

                var spec = rootGetters['specs/getByProjectKey'](project_key);
                if (spec) return rootGetters['specs/getTotal'](spec);

                var hour_rate = getters.get_hour_rate(project);

                if (project.estimated_hrs && hour_rate) return project.estimated_hrs * hour_rate;

                return 0;
            };
        },

        get_billable_hours: function get_billable_hours(state, getters, rootState, rootGetters) {
            return function (project) {
                var project_key = project.key || project['.key'];

                var project_timelogs = rootGetters['timelogs/get_cached'].project[project_key];
                var billable_timelogs = project_timelogs.filter(function (t) {
                    return t.billable === true;
                });
                var billable_timelogs_total_hours = rootGetters['timelogs/getTotalHours'](billable_timelogs);
                return billable_timelogs_total_hours;
            };
        },

        get_billable_hours_amount: function get_billable_hours_amount(state, getters, rootState, rootGetters) {
            return function (project) {
                var hour_rate = getters.get_hour_rate(project);
                var billable_timelogs_total_hours = getters.get_billable_hours(project);
                return billable_timelogs_total_hours * hour_rate;
            };
        },

        get_payable_amount: function get_payable_amount(state, getters, rootState, rootGetters) {
            return function (project) {
                if (project.status === 'draft') return 0;
                if (project.status === 'aborted') return 0;
                if (project.payment_model == 'fixed_price') return getters.getBudget(project);

                if (project.payment_model == 'time_expense') return getters.get_billable_hours_amount(project);

                return 0;
            };
        },

        get_hour_rate: function get_hour_rate(state, getters, rootState, rootGetters) {
            return function (project) {

                if (project.hour_rate) return project.hour_rate;
                if (!project.client && !project.client_key) return;
                var client = project.client || rootGetters['clients/getClient'](project.client_key);
                if (client && client.hour_rate) return client.hour_rate;
            };
        },

        get_budgetted_hours: function get_budgetted_hours(state, getters, rootState, rootGetters) {
            return function (project) {
                if (!project) return 0;

                var project_key = project.key || project['.key'];


                if (project.estimated_hrs) return project.estimated_hrs;

                var spec = rootGetters['specs/getByProjectKey'](project_key);
                if (spec) return rootGetters['specs/getHours'](spec);

                var hour_rate = getters.get_hour_rate(project);

                if (hour_rate && project.fixed_price) return parseFloat(project.fixed_price / hour_rate);

                return 0;
            };
        },

        get_budgetted_hours_spent_pct: function get_budgetted_hours_spent_pct(state, getters, rootState, rootGetters) {
            return function (project, timelogs) {
                var hrs = getters.get_budgetted_hours(project);
                var project_key = project.key || project['.key'];

                timelogs = timelogs || rootGetters['timelogs/get_cached'].project[project_key];

                var spent_hrs = rootGetters['timelogs/getTotalHours'](timelogs);

                if (!hrs || !spent_hrs) return 0;

                var pct = spent_hrs / hrs * 100;
                if (isNaN(pct) || !isFinite(pct)) pct = 0;
                pct = parseInt(pct);
                return pct;
            };
        },

        get_invoiced_dkk: function get_invoiced_dkk(state, getters, rootState, rootGetters) {
            return function (project) {
                var economyposts = rootGetters['economyposts/getFiltered']({
                    project_key: project.key,
                    hypothetic: false,
                    income_only: true,
                    invoiced: true
                });
                var totals = rootGetters['economyposts/getTotals'](economyposts);
                return totals.income_total;
            };
        },

        get_invoiced_and_paid_dkk: function get_invoiced_and_paid_dkk(state, getters, rootState, rootGetters) {
            return function (project) {
                var economyposts = rootGetters['economyposts/getFiltered']({
                    project_key: project.key,
                    hypothetic: false,
                    income_only: true,
                    invoiced: true,
                    paid: true
                });
                var totals = rootGetters['economyposts/getTotals'](economyposts);
                return totals.income_total;
            };
        },

        is_fully_invoiced: function is_fully_invoiced(state, getters, rootState, rootGetters) {
            return function (project) {
                var amount_payable = getters.getBudget(project);
                var invoiced_dkk = getters.get_invoiced_dkk(project);
                return invoiced_dkk >= amount_payable;
            };
        },

        is_fully_invoiced_and_paid: function is_fully_invoiced_and_paid(state, getters, rootState, rootGetters) {
            return function (project) {
                var amount_payable = getters.getBudget(project);
                var invoiced_and_paid_dkk = getters.get_invoiced_and_paid_dkk(project);
                return invoiced_and_paid_dkk >= amount_payable;
            };
        }

    } });

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({

    namespaced: true,

    state: {

        statuses: {
            draft: { title: 'Skitse' },
            sent: { title: 'Afsendt' },
            accepted: { title: 'Accepteret' },
            archived: { title: 'Arkiverede' }
        },

        types: {
            estimates: {
                title: 'Tilbud/timepris'
            },
            fixed_prices: {
                title: 'Tilbud/fastpris'
            }
        }

    },

    getters: {
        getAll: function getAll(state, getters, rootState, rootGetters) {
            return rootGetters.getAll('specs');
            if (!rootGetters.firebase_arrays.specs) return [];
            return rootGetters.firebase_arrays.specs;
        },

        getOne: function getOne(state, getters, rootState, rootGetters) {
            return function (key) {
                return rootGetters.getOne('spec', key);
            };
        },

        getByProjectKey: function getByProjectKey(state, getters, rootState, rootGetters) {
            return function (key) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(getters.getAll), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;
                        if (item.project_key === key) return item;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
        },

        getProjectAcceptedSpec: function getProjectAcceptedSpec(state, getters, rootState, rootGetters) {
            return function (project_key) {
                var list = rootState.firebase.specs;
                for (var spec_key in list) {
                    if (spec_key == '.key') continue;
                    var spec = list[spec_key];
                    spec['.key'] = spec_key;
                    if (spec.archived) continue;
                    if (spec.project_key == project_key) return spec;
                }
            };
        },

        getHours: function getHours(state, getters, rootState, rootGetters) {
            return function (spec) {
                var total_hrs = 0;

                for (var i in spec.taskcats) {
                    var taskcat = spec.taskcats[i];

                    for (var i in taskcat.tasks) {
                        var task = taskcat.tasks[i];
                        if (task.optional == false) continue;
                        total_hrs += parseFloat(task.hours);
                    }
                }
                return total_hrs;
            };
        },

        getTotal: function getTotal(state, getters, rootState, rootGetters) {
            return function (spec) {
                var project = rootGetters['projects/getOne'](spec.project_key);
                var hour_rate = project.hour_rate;
                return getters.getHours(spec) * hour_rate;
            };
        }

    } });

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({

  namespaced: true,

  state: {},

  getters: {

    getAll: function getAll(state, getters, rootState, rootGetters) {
      return rootGetters.getAll('timelogs');
      if (!rootGetters.firebase_arrays.timelogs) return [];
      return rootGetters.firebase_arrays.timelogs;
    },

    getOne: function getOne(state, getters, rootState, rootGetters) {
      return function (key) {
        return rootGetters.getOne('timelog', key);
      };
    },

    timelogs_timestamped: function timelogs_timestamped(state, getters, rootState, rootGetters) {},


    getTotalHours: function getTotalHours(state, getters, rootState, rootGetters) {
      return function (timelogs) {
        var hrs = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(timelogs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var timelog = _step.value;
            hrs += parseFloat(timelog.hours);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return hrs;
      };
    },

    getFiltered: function getFiltered(state, getters, rootState, rootGetters) {
      return function (filters, timelogs) {

        var output = [];

        if (!timelogs) timelogs = getters.getAll;

        if (!timelogs) return output;

        if (!filters) filters = {};

        for (var i = 0; i < timelogs.length; i++) {

          var _timelog = timelogs[i];

          if (_timelog.archived && !filters.include_archived) continue;

          if (filters.user_key != undefined && filters.user_key != 'undefined') {
            if (filters.user_key != _timelog.user_key) continue;
          }

          if (filters.project_key !== undefined && filters.project_key !== _timelog.project_key) continue;

          if (filters.project_keys != undefined) {
            if (filters.project_keys.indexOf(_timelog.project_key) === -1) continue;
          }

          if (filters.client_key != undefined && filters.client_key != 'undefined') {
            var timelog_client = rootGetters['clients/getClientByProjectKey'](_timelog.project_key);
            if (!timelog_client) continue;
            if (filters.client_key != timelog_client['.key']) continue;
          }

          if (filters.date_from_timestamp || filters.date_to_timestamp) {
            if (!_timelog.date_timestamp) console.log('timelog: converting time format');
            if (!_timelog.date_timestamp) timelogs[i].date_timestamp = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_timelog.date, 'YYYY-MM-DD').unix();
            var _timelog = timelogs[i];
            if (_timelog.date_timestamp < filters.date_from_timestamp) continue;
            if (_timelog.date_timestamp > filters.date_to_timestamp) continue;
          }

          if (filters.only_billable === true && _timelog.billable !== true) continue;

          output.push(_timelog);
        }

        if (!filters.no_sorting) output = getters.sort_newest(output);

        __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* default */].log('Ran timelogs filtering: ' + timelogs.length + ' items');

        return output;
      };
    },

    sort_newest: function sort_newest(state, getters, rootState, rootGetters) {
      return function (timelogs) {
        return timelogs.sort(function (a, b) {
          return b.date_timestamp - a.date_timestamp;
        });
      };
    },

    get_cached: function get_cached(state, getters, rootState, rootGetters) {
      __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* default */].log('organizing and caching timelogs');
      var output = {
        client: {},
        project: {},
        user: {}
      };

      var clients = rootGetters['clients/getAll'];
      var projects = rootGetters['projects/getAll'];
      var users = rootGetters['users/getAll'];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var project = _step2.value;
          output.project[project.key] = [];
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(users), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var user = _step3.value;
          output.user[user.key] = [];
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(clients), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var client = _step4.value;
          output.client[client.key] = [];
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(rootGetters.getAll('timelogs')), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var timelog = _step5.value;
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _project = _step7.value;
              if (timelog.project_key === _project.key) output.project[_project.key].push(timelog);
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(users), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var _user = _step8.value;
              if (timelog.user_key === _user.key) output.user[_user.key].push(timelog);
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(clients), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _client = _step6.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var _project2 = _step9.value;

              if (_project2.client_key === _client.key) {
                output.client[_client.key] = output.client[_client.key].concat(output.project[_project2.key]);
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return output;
    },
    my_timelogs: function my_timelogs(state, getters, rootState, rootGetters) {
      return getters.get_cached.user[rootGetters['users/my_user_key']];
    },
    my_timelogs_this_week: function my_timelogs_this_week(state, getters, rootState, rootGetters) {
      var timelogs = getters.getFiltered({
        date_from_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(7, 'day').startOf('day').unix(),
        date_to_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(0, 'day').endOf('day').unix()
      }, getters.my_timelogs);
      return timelogs;
    },
    my_timelogs_today: function my_timelogs_today(state, getters, rootState, rootGetters) {
      var timelogs = getters.getFiltered({
        date_from_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(0, 'day').startOf('day').unix(),
        date_to_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(0, 'day').endOf('day').unix()
      }, getters.my_timelogs_this_week);
      return timelogs;
    },
    my_timelogs_yesterday: function my_timelogs_yesterday(state, getters, rootState, rootGetters) {
      var timelogs = getters.getFiltered({
        date_from_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'days').startOf('day').unix(),
        date_to_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(-1, 'days').endOf('day').unix()
      }, getters.my_timelogs_this_week);
      return timelogs;
    },
    my_timelogs_today_hrs: function my_timelogs_today_hrs(state, getters, rootState, rootGetters) {
      return getters.getTotalHours(getters.my_timelogs_today);
    },
    my_timelogs_this_week_hrs: function my_timelogs_this_week_hrs(state, getters, rootState, rootGetters) {
      return getters.getTotalHours(getters.my_timelogs_this_week);
    },
    my_timelogs_yesterday_hrs: function my_timelogs_yesterday_hrs(state, getters, rootState, rootGetters) {
      return getters.getTotalHours(getters.my_timelogs_yesterday);
    }
  },

  mutations: {} });

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({

    namespaced: true,

    state: {

        logged_in_user: undefined

    },

    getters: {

        getAll: function getAll(state, getters, rootState, rootGetters) {
            return rootGetters.getAll('users');
        },
        getOne: function getOne(state, getters, rootState, rootGetters) {
            return function (key) {
                return rootGetters.getOne('user', key);
            };
        },

        my_user: function my_user(state, getters, rootState, rootGetters) {
            var users = getters.getAll.filter(function (user) {
                return user.uid == state.logged_in_user.uid;
            });
            if (!users) return;
            return users[0];
        },
        my_user_key: function my_user_key(state, getters, rootState, rootGetters) {
            if (!getters.my_user) return;return getters.my_user.key;
        },


        get_initials: function get_initials(state, getters, rootState, rootGetters) {
            return function (user) {
                return user.email.replace('@milk-studio.dk', '');
            };
        },

        my_initials: function my_initials(state, getters, rootState, rootGetters) {
            return getters.get_initials(getters.my_user);
        }
    },

    mutations: {
        set_logged_in_user: function set_logged_in_user(state, input) {
            state.logged_in_user = input;
        }
    } });

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_store_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Login__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Timelogger__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Timelogger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Timelogger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TimeloggerBasic__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TimeloggerBasic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_TimeloggerBasic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SpecLineRobot__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SpecLineRobot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SpecLineRobot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Modal__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Leftnavbar__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Leftnavbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_Leftnavbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ImgLoaded__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ImgLoaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_ImgLoaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_modal_timeline_project_popup__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_modal_timeline_project_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_modal_timeline_project_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_modal_timelog_edit__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_modal_timelog_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_modal_timelog_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_modal_economypost_edit__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_modal_economypost_edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_modal_economypost_edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_generated_svg_icons_ionicons_android_favorite_outline__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_generated_svg_icons_ionicons_android_favorite_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_generated_svg_icons_ionicons_android_favorite_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_generated_svg_icons_ionicons_checkmark__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_generated_svg_icons_ionicons_checkmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_generated_svg_icons_ionicons_checkmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_generated_svg_icons_linearicons_thumbs_up__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_generated_svg_icons_linearicons_thumbs_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_generated_svg_icons_linearicons_thumbs_up__);


























var user = __WEBPACK_IMPORTED_MODULE_6__auth_js__["a" /* default */].getUser();

var initApp = function initApp() {

  __WEBPACK_IMPORTED_MODULE_6__auth_js__["a" /* default */].init();

  if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function () {}, false);
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Leftnavbar: __WEBPACK_IMPORTED_MODULE_13__views_Leftnavbar___default.a, Box: __WEBPACK_IMPORTED_MODULE_14__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_15__components_Btn___default.a, Login: __WEBPACK_IMPORTED_MODULE_8__views_Login___default.a, Timelogger: __WEBPACK_IMPORTED_MODULE_9__views_Timelogger___default.a, modalTimelineProjectPopup: __WEBPACK_IMPORTED_MODULE_17__views_modal_timeline_project_popup___default.a,
    modalTimelogEdit: __WEBPACK_IMPORTED_MODULE_18__views_modal_timelog_edit___default.a, modalEconomypostEdit: __WEBPACK_IMPORTED_MODULE_19__views_modal_economypost_edit___default.a, TimeloggerBasic: __WEBPACK_IMPORTED_MODULE_10__components_TimeloggerBasic___default.a, Modal: __WEBPACK_IMPORTED_MODULE_12__components_Modal___default.a, ImgLoaded: __WEBPACK_IMPORTED_MODULE_16__components_ImgLoaded___default.a,
    SpecLineRobot: __WEBPACK_IMPORTED_MODULE_11__components_SpecLineRobot___default.a
  },
  data: function data() {
    return {
      globals: __WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */],
      auth: __WEBPACK_IMPORTED_MODULE_6__auth_js__["a" /* default */],
      firebase_entities: ['clients', 'users', 'projects', 'tasks', 'tasklists', 'timelogs', 'payments', 'comments'],
      firebasesEntitiesRead: 0,
      iconSignal: undefined
    };
  },

  computed: {
    firebase_synced_and_ready: function firebase_synced_and_ready() {
      return this.$store.state.firebase_synced_and_ready;
    },
    firebase_load_pct: function firebase_load_pct() {
      return this.$store.state.firebase_load_pct;
    },
    user: function user() {
      return this.$store.getters['users/my_user'];
    },
    userAuthenticated: function userAuthenticated() {
      if (!this.user) return false;return this.user.authenticated;
    },
    contextbg_css: function contextbg_css() {
      var css = {};
      css.backgroundColor = this.$store.state.context_bg.bgcolor;
      return css;
    },
    contextbgimg_css: function contextbgimg_css() {
      var css = {};

      return css;
    },
    loadingtextman_text: function loadingtextman_text() {
      var texts = ["Admiring Dan's tattoos...", "Preparing for long day computing William's input...", "Cleaning Milk-studio.dk from tonights hacking attempts...", "Ccalculating mathematical perfection of Anders' eyebrows...", "Blocking PET from Milk Gmail account...", "Installing russian spyware onto Milk Studio Macbooks...", "Calculating days since last Milk insta story...", "Calculating days until next Milk Studio case...", "Calculating days until Adidas contacts Milk Studio for a campaign solution...", "Calculating economy on Milkonomy sheet...", "Analyzing Trello board: 'Mælkopteren'...", "12 errors found analyzing Milk Dinero account...", "Low work effort calculated for user an@milk-studio.dk...", "Low work effort calculated for user db@milk-studio.dk...", "Low work effort calculated for user wp@milk-studio.dk...", "Old system detected, please call our Indian hotline for upgrade instructions...", "Unsafe system detected, please call our Indian hotline for upgrade instructions...", 'Cleaning up KS bloatet codebase...', "Reticulating splines...", "Generating witty dialog...", "Swapping time and space...", "Spinning violently around the y-axis...", "Tokenizing real life...", "Bending the spoon...", "Filtering morale...", "Don't think of purple hippos...", "We need a new fuse...", "Have a good day.", "Upgrading Windows, your PC will restart several times. Sit back and relax.", "640K ought to be enough for anybody", "The architects are still drafting", "The bits are breeding", "We're building the buildings as fast as we can", "Would you prefer chicken, steak, or tofu?", "(Pay no attention to the man behind the curtain)", "...and enjoy the elevator music...", "Please wait while the little elves draw your map", "Don't worry - a few bits tried to escape, but we caught them", "Would you like fries with that?", "Checking the gravitational constant in your locale...", "Go ahead -- hold your breath!", "...at least you're not on hold...", "Hum something loud while others stare", "You're not in Kansas any more", "The server is powered by a lemon and two electrodes.", "Please wait while a larger software vendor in Seattle takes over the world", "We're testing your patience", "As if you had any other choice", "Follow the white rabbit", "Why don't you order a sandwich?", "While the satellite moves into position", "keep calm and npm install", "The bits are flowing slowly today", "Dig on the 'X' for buried treasure... ARRR!", "It's still faster than you could draw it", "The last time I tried this the monkey didn't survive. Let's hope it works better this time.", "I should have had a V8 this morning.", "My other loading screen is much faster.", "Testing on Timmy... We're going to need another Timmy.", "Reconfoobling energymotron...", "(Insert quarter)", "Are we there yet?", "Have you lost weight?", "Just count to 10", "Why so serious?", "It's not you. It's me.", "Counting backwards from Infinity", "Don't panic...", "Embiggening Prototypes", "Do not run! We are your friends!", "Do you come here often?", "Warning: Don't set yourself on fire.", "We're making you a cookie.", "Creating time-loop inversion field", "Spinning the wheel of fortune...", "Loading the enchanted bunny...", "Computing chance of success", "I'm sorry Dave, I can't do that.", "Looking for exact change", "All your web browser are belong to us", "All I really need is a kilobit.", "I feel like im supposed to be loading something. . .", "What do you call 8 Hobbits? A Hobbyte.", "Should have used a compiled language...", "Is this Windows?", "Adjusting flux capacitor...", "Please wait until the sloth starts moving.", "Don't break your screen yet!", "I swear it's almost done.", "Let's take a mindfulness minute...", "Unicorns are at the end of this road, I promise.", "Listening for the sound of one hand clapping...", "Keeping all the 1's and removing all the 0's...", "Putting the icing on the cake. The cake is not a lie...", "Cleaning off the cobwebs...", "Making sure all the i's have dots...", "We are not liable for any broken screens as a result of waiting.", "We need more dilithium crystals", "Where did all the internets go", "Connecting Neurotoxin Storage Tank...", "Granting wishes...", "Time flies when you’re having fun.", "Get some coffee and come back in ten minutes..", "Spinning the hamster…", "99 bottles of beer on the wall..", "Stay awhile and listen..", "Be careful not to step in the git-gui", "You shall not pass! yet..", "Load it and they will come", "Convincing AI not to turn evil..", "There is no spoon. Because we are not done loading it", "Your left thumb points to the right and your right thumb points to the left.", "How did you get here?", "Wait, do you smell something burning?", "Computing the secret to life, the universe, and everything.", "When nothing is going right, go left!!...", "I love my job only when I'm on vacation...", "i'm not lazy, I'm just relaxed!!", "Never steal. The government hates competition....", "Why are they called apartments if they are all stuck together?", "Life is Short – Talk Fast!!!!", "Optimism – is a lack of information.....", "Save water and shower together", "Whenever I find the key to success, someone changes the lock.", "Sometimes I think war is God’s way of teaching us geography.", "I’ve got problem for your solution…..", "Where there’s a will, there’s a relative.", "User: the word computer professionals use when they mean !!idiot!!", "Adults are just kids with money.", "I think I am, therefore, I am. I think.", "A kiss is like a fight, with mouths.", "You don’t pay taxes—they take taxes.", "Coffee, Chocolate, Men. The richer the better!", "I am free of all prejudices. I hate everyone equally.", "git happens", "May the forks be with you", "A commit a day keeps the mobs away", "This is not a joke, it's a commit.", "Constructing additional pylons...", "Roping some seaturtles...", "Locating Jebediah Kerman...", "We are not liable for any broken screens as a result of waiting.", "Hello IT, have you tried turning it off and on again?", "If you type Google into Google you can break the internet", "Well, this is embarrassing.", "What is the airspeed velocity of an unladen swallow?", "Hello, IT... Have you tried forcing an unexpected reboot?", "They just toss us away like yesterday's jam.", "They're fairly regular, the beatings, yes. I'd say we're on a bi-weekly beating.", "The Elders of the Internet would never stand for it.", "Space is invisible mind dust, and stars are but wishes.", "Didn't know paint dried so quickly.", "Everything sounds the same", "I'm going to walk the dog", "I didn't choose the engineering life. The engineering life chose me.", "Dividing by zero...", "Spawn more Overlord!", "If I’m not back in five minutes, just wait longer.", "Some days, you just can’t get rid of a bug!", "We’re going to need a bigger boat.", "Chuck Norris never git push. The repo pulls before.", "Web developers do it with <style>", "I need to git pull --my-life-together", "Java developers never RIP. They just get Garbage Collected.", "Cracking military-grade encryption...", "Simulating traveling salesman...", "Proving P=NP...", "Entangling superstrings...", "Twiddling thumbs...", "Searching for plot device...", "Trying to sort in O(n)...", "Laughing at your pictures-i mean, loading...", "Sending data to NS-i mean, our servers.", "Looking for sense of humour, please hold on.", "Please wait while the intern refills his coffee.", "A different error message? Finally, some progress!", "Hold on while we wrap up our git together...sorry", "Please hold on as we reheat our coffee", "Kindly hold on as we convert this bug to a feature...", "Kindly hold on as our intern quits vim...", "Winter is coming...", "Installing dependencies", "Switching to the latest JS framework...", "Distracted by cat gifs", "Finding someone to hold my beer", "BRB, working on my side project", "@todo Insert witty loading message", "Let's hope it's worth the wait", "Aw, snap! Not..", "Ordering 1s and 0s...", "Updating dependencies...", "Whatever you do, don't look behind you...", "Please wait... Consulting the manual...", "It is dark. You're likely to be eaten by a grue.", "Loading funny message...", "It's 10:00pm. Do you know where your children are?", "Waiting Daenerys say all her titles...", "Feel free to spin in your chair", "What the what?", "format C: ...", "Forget you saw that password I just typed into the IM ...", "What's under there?", "Your computer has a virus, its name is Windows!", "Go ahead, hold your breath and do an ironman plank till loading complete", "Bored of slow loading spinner, buy more RAM!", "Help, I'm trapped in a loader!", "What is the difference btwn a hippo and a zippo? One is really heavy, the other is a little lighter", "Please wait, while we purge the Decepticons for you. Yes, You can thanks us later!", "Chuck Norris once urinated in a semi truck's gas tank as a joke....that truck is now known as Optimus Prime.", "Chuck Norris doesn’t wear a watch. HE decides what time it is.", "Mining some bitcoins...", "Downloading more RAM..", "Updating to Windows Vista...", "Deleting System32 folder", "Hiding all ;'s in your code", "Alt-F4 speeds things up.", "Initializing the initializer...", "When was the last time you dusted around here?", "Optimizing the optimizer...", "Last call for the data bus! All aboard!", "Running swag sticker detection...", "When nothing is going right, go left!", "Never let a computer know you're in a hurry.", "A computer will do what you tell it to do, but that may be much different from what you had in mind.", "Some things man was never meant to know. For everything else, there's Google.", "Unix is user-friendly. It's just very selective about who its friends are.", "Shovelling coal into the server", "Pushing pixels...", "How about this weather, eh?", "Building a wall...", "Everything in this universe is either a potato or not a potato", "The severity of your issue is always lower than you expected.", "Updating Updater...", "Downloading Downloader...", "Debugging Debugger...", "Reading Terms and Conditions for you.", "Digested cookies being baked again.", "Live long and prosper.", "There is no cow level, but there's a goat one!", "Deleting all your hidden porn...", "Running with scissors...", "Definitely not a virus...", "You may call me Steve.", "All you had to do is to commit the damn funnies, CJ!", "You seem like a nice person...", "Coffee at my place, tommorow at 10A.M. - don't be late!", "Work, work...", "Patience! This is difficult, you know...", "Discovering new ways of making you wait...", "Your time is very important to us. Please wait while we ignore you...", "Time flies like an arrow; fruit flies like a banana", "Two men walked into a bar; the third ducked...", "Sooooo... Have you seen my vacation photos yet?", "Sorry we are busy catching em' all, we're done soon", "TODO: Insert elevator music", "Still faster than Windows update", "Composer hack: Waiting for reqs to be fetched is less frustrating if you add -vvv to your command.", "Obfuscating quantum entaglement"];
      var text = texts[parseInt(Math.random() * texts.length)];
      return text;
    }
  },
  methods: {

    getMyUserKeyByUID: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].getMyUserKeyByUID,

    talk: function talk() {
      alert('app talkin at yu');
    },
    alert: function (_alert) {
      function alert(_x) {
        return _alert.apply(this, arguments);
      }

      alert.toString = function () {
        return _alert.toString();
      };

      return alert;
    }(function (msg) {
      alert(msg);
    }),
    msg: function msg(_msg) {
      this.alert(_msg);
    },
    toast: function toast(input) {
      if (typeof input === 'string') input = { text: input };
      if (!input.position) input.position = 'bottom-right';
      if (!input.duration) input.duration = '4000';
      this.$toasted.show(input.text, input);
    },
    toggleOffCanvasMenuActive: function toggleOffCanvasMenuActive() {
      __WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */].off_canvas_menu_active = !__WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */].off_canvas_menu_active;
    },
    onDatabaseLoaded: function onDatabaseLoaded() {
      this.log('onDatabaseLoaded');
      this.loadUserData();
    },
    onAuthChecked: function onAuthChecked() {
      this.log('onAuthChecked');
    },
    onAuthLogin: function onAuthLogin(userData) {
      this.log('onAuthLogin');

      this.startFirebaseSync();

      this.$store.commit('users/set_logged_in_user', userData);
    },
    onAuthLogout: function onAuthLogout() {
      this.log('onAuthLogout');
    },
    onUpdateLoginStatus: function onUpdateLoginStatus(loggedIn) {
      this.log('onUpdateLoginStatus');
      if (loggedIn) {
        this.log('loggedIn');
      }
      if (!loggedIn) {
        this.log('not loggedIn');
        __WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */].user = undefined;
      }
    },
    loadUserData: function loadUserData() {

      this.log('loadUserData');

      var user_key = undefined;for (var key in this.$store.state.firebase.users) {
        if (this.$store.state.firebase.users[key].uid == __WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */].user.uid) user_key = key;
      }
      var userData = this.$store.state.firebase.users[user_key];
      if (!userData) return;


      __WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */].user.first_name = userData.first_name;


      if (this.$store.state.my_user.email == "wp@milk-studio.dk") {
        __WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */].show_beta_content = true;this.$store.commit('toggle_show_beta_content', true);
      }
    },
    triggerIconSignal: function triggerIconSignal(icon) {
      this.iconSignal = icon;
      var _this = this;
      setTimeout(function () {
        _this.iconSignal = false;
      }, 1300);
    },
    spec_create_new: function spec_create_new() {
      var new_entry = __WEBPACK_IMPORTED_MODULE_5__firebase_config_js__["a" /* default */].ref('specs').push({
        name: 'Unavngivent',
        type: 'fixed_prices',

        hour_rate: 790,
        status: 'draft',
        created: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        taskcats: [],
        notes: '',
        showLineTotals: true,
        showCatTotals: true
      });
      var new_entry_key = new_entry.getKey();
      this.$router.push('spec/' + new_entry_key);
    },
    startFirebaseSync: function startFirebaseSync() {

      var _this = this;

      var firebaseItems = ['clients', 'projects', 'economyposts', 'timelogs', 'timebookings', 'users', 'tasks', 'tasklists', 'specs', 'comments'];
      var firebaseItems_loaded = [];

      for (var i = 0; i < firebaseItems.length; i++) {
        var key = firebaseItems[i];
        var ref = __WEBPACK_IMPORTED_MODULE_5__firebase_config_js__["a" /* default */].ref(key);

        ref.once('value', function (data) {
          firebaseItems_loaded.push(1);

          _this.$store.commit('set_firebase_load_pct', parseInt(firebaseItems_loaded.length / firebaseItems.length * 100));
          if (firebaseItems_loaded.length == firebaseItems.length) {
            _this.$store.commit('firebase_synced_and_ready');
          }
        });

        this.$store.dispatch('setVuexFireRef', { key: key, ref: ref });
      }
    },
    apply_ui_theme: function apply_ui_theme(input) {

      var theme_key = input.theme_key;
      var theme = input.theme;

      if (theme_key != 'custom') {
        theme = __WEBPACK_IMPORTED_MODULE_4__themes_js__["a" /* default */][theme_key];
        if (!theme) return;
        localStorage.removeItem('user_theme_custom');
      }

      if (theme_key == 'custom') {
        if (!theme) theme = JSON.parse(localStorage.getItem('user_theme_custom'));
        localStorage.setItem('user_theme_custom', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(theme));
      }

      localStorage.setItem('user_theme_key', theme_key);

      for (var key in theme) {
        var val = theme[key];
        document.documentElement.style.setProperty('--' + key, val);
      }
    },
    set_context_bg: function set_context_bg(input) {
      if (!input) input = {};
      var bgcolor = input.bgcolor || 'transparent';
      var bgimg_url = input.bgimg || 'https://source.unsplash.com/1200x600/?pineapple';

      var el = document.querySelector('.context-bg');
      var el_img = document.querySelector('.context-bg .img');

      el.style.backgroundColor = bgcolor;

      el.classList.add('img-off');

      el_img.src = null;

      setTimeout(function () {}, 300);

      if (!bgimg_url) el.style.backgroundImage = null;
      el.style.backgroundImage = 'url(' + bgimg_url + ')';
    },
    log: function log(input) {
      if (this.$store.state.env !== 'local') return;
      __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].log(input);
    }
  }, created: function created() {

    var _this = this;
    eventBus.$on('loadUserData', function () {
      _this.loadUserData();
    });
    eventBus.$on('toast', function (input) {
      _this.toast(input);
    });
    eventBus.$on('msg', function (input) {
      _this.msg(input);
    });
    eventBus.$on('alert', function (input) {
      _this.alert(input);
    });
    eventBus.$on('apply_ui_theme', function (input) {
      _this.apply_ui_theme(input);
    });
    eventBus.$on('onUpdateLoginStatus', function (loggedIn) {
      _this.onUpdateLoginStatus(loggedIn);
    });

    eventBus.$on('onAuthChecked', function () {
      _this.onAuthChecked();
    });
    eventBus.$on('onAuthLogin', function (input) {
      _this.onAuthLogin(input);
    });
    eventBus.$on('onAuthLogout', function () {
      _this.onAuthLogout();
    });
    eventBus.$on('triggerIconSignal', function (icon) {
      _this.triggerIconSignal(icon);
    });

    eventBus.$on('spec_create_new', function () {
      _this.spec_create_new();
    });

    var user_theme_key = localStorage.getItem('user_theme_key') || 'white';
    this.apply_ui_theme({ theme_key: user_theme_key });

    document.documentElement.classList.add('skin1');

    initApp();

    this.startFirebaseSync();

    var env = 'live';
    if (window.location.href.indexOf('localhost:') > 0) env = 'local';
    if (window.location.href.indexOf('.test') > 0) env = 'local';

    __WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */].env = env;
    this.$store.commit('set_env', env);

    if (env === 'local') {
      window.$store = _this.$store;
      window.$kia = _this;
      __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].log('Welcome to the Kia - We are in DEV mode, enjoy!');
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_md5__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'avatar',
  props: ['input', 'text'],
  computed: {
    initials: function initials() {
      if (this.text) return this.text;
      return __WEBPACK_IMPORTED_MODULE_0__helpers_js__["a" /* default */].getItemInitials(this.input);
    },
    bg_color: function bg_color() {
      if (this.input && this.input.color) return this.input.color;
      if (this.text) return __WEBPACK_IMPORTED_MODULE_0__helpers_js__["a" /* default */].getColorByString(this.text);
      return __WEBPACK_IMPORTED_MODULE_0__helpers_js__["a" /* default */].getColorByString(this.initials);
    },
    gravatarUrl: function gravatarUrl() {
      if (!this.input) return;
      if (!this.input.email) return;
      var email = this.input.email;
      var baseurl = 'https://www.gravatar.com/avatar/';
      var md5_email = __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(email);
      var size = '?s=' + 150;
      return baseurl + md5_email + size;
    },
    css: function css() {
      var css = {};
      css['background-color'] = this.bg_color;
      css['color'] = 'white';
      if (this.gravatarUrl) css['background-image'] = 'url(' + this.gravatarUrl + ')';
      return css;
    }
  },
  methods: {}
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generated_svg_icons_ionicons_chevron_right__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_generated_svg_icons_ionicons_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_generated_svg_icons_ionicons_chevron_right__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Btn: __WEBPACK_IMPORTED_MODULE_0__components_Btn___default.a },
  props: ['label', 'open', 'header-toggle', 'cls'],
  data: function data() {
    return {
      is_open: undefined
    };
  },
  computed: {
    box_cls: function box_cls() {
      var output = '';
      if (this.cls) output += this.cls;

      return output;
    }
  },
  methods: {
    toggleOpen: function toggleOpen() {
      if (this._events['toggledOpen']) {
        this.$emit('toggledOpen', !this.is_open);
      } else {
        if (this.is_open === undefined) this.is_open = true;
        this.is_open = !this.is_open;
      }
    },
    headerToggleOpen: function headerToggleOpen() {
      if (this._props.headerToggle != undefined) this.toggleOpen();
    },
    togglerToggleOpen: function togglerToggleOpen() {
      if (this._props.headerToggle == undefined) this.toggleOpen();
    }
  },
  created: function created() {
    if (this.open) this.is_open = this.open;
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    color: String,
    disabled: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    iconR: { default: false },
    iconL: { default: false }
  },
  data: function data() {
    return {
      ripple: {
        top: 0,
        left: 0,
        size: 150,
        active: false
      }
    };
  },

  computed: {
    cls: function cls() {
      var output = '';
      if (this.disabled == true) output += 'disabled ';
      if (this.large == true) output += 'btn-large ';
      if (this.small == true) output += 'btn-small ';
      if (this.full == true) output += 'block ';
      if (this.block == true) output += 'block ';
      if (this.color) output += 'color-' + this._props.color;
      if (this.ripple.active) output += ' rippling ';
      if (this.iconL || this.iconR) output += ' has-icon ';
      if (this.iconL) output += ' has-icon-l ';
      if (this.iconR) output += ' has-icon-r ';
      return output;
    }
  },
  methods: {
    doRipple: function doRipple(e) {
      if (this.ripple.active) return;
      this.ripple.top = e.offsetY;
      this.ripple.left = e.offsetX;
      this.ripple.active = true;
      var _this = this;
      setTimeout(function () {
        _this.ripple.active = false;
      }, 400);
    },
    rippleStyle: function rippleStyle() {
      return {
        height: this.ripple.size + 'px',
        width: this.ripple.size + 'px',
        top: this.ripple.top + 'px',
        left: this.ripple.left + 'px',
        marginLeft: -(this.ripple.size / 2) + 'px',
        marginTop: -(this.ripple.size / 2) + 'px'
      };
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Avatar__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Avatar: __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].generic],
  props: {
    keytype: { type: String },
    keyis: { type: String },
    classes: { type: String }
  },
  data: function data() {
    return {
      creatingComment: false,
      editing_comment_i: undefined,
      editing_comment_text: undefined
    };
  },

  computed: {
    cls: function cls() {
      var c = '';
      if (this.$props.classes) c += ' ' + this.$props.classes + ' ';
      return c;
    },
    comments: function comments() {

      var items = this.$store.getters['comments/byKey'](this.keytype, this.keyis);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          item.can_edit = item.user_key === this.my_user_key;
          item.can_delete = this.is_admin || item.user_key === this.my_user_key;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      items = items.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(b.created, 'YYYY-MM-DD').unix() - __WEBPACK_IMPORTED_MODULE_3_moment___default()(a.created, 'YYYY-MM-DD').unix();
      });

      return items;
    },
    users: function users() {
      return this.$store.state.firebase.users;
    }
  },
  methods: {
    nl2br: function nl2br(input) {
      var output = input.replace(/(?:\r\n|\r|\n)/g, '<br>');
      return output;
    },
    cancelCreateComment: function cancelCreateComment() {
      this.$refs.newcommenttext.value = undefined;
      this.creatingComment = false;
    },
    createComment: function createComment() {

      if (!this.creatingComment) {
        this.creatingComment = true;
        var _this = this;
        setTimeout(function () {
          _this.$refs.newcommenttext.focus();
        }, 0);
        return true;
      }

      var d = {
        keytype: this.keytype,
        key: this.keyis,
        text: this.$refs.newcommenttext.value,
        user_key: this.my_user['.key'],
        user_uid: this.my_user.uid,
        created: __WEBPACK_IMPORTED_MODULE_3_moment___default()().toISOString()
      };

      __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('comments').push(d);

      this.creatingComment = false;
      this.$refs.newcommenttext.value = undefined;
      eventBus.$emit('triggerIconSignal', 'thumbsup');
    },
    archiveComment: function archiveComment(c) {
      var sure = confirm('Are you sure?');
      if (!sure) return;
      __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('comments').child(c['.key']).update({ archived: true });
      eventBus.$emit('triggerIconSignal', 'thumbsup');
    },
    setEditingComment: function setEditingComment(c, c_i) {
      this.editing_comment_i = c_i;
      this.editing_comment_text = c.text;
      setTimeout(function () {
        document.querySelector('.edit-comment textarea').focus();
      }, 0);
    },
    saveEditedComment: function saveEditedComment() {
      var c = this.comments[this.editing_comment_i];
      var data = {
        text: this.editing_comment_text,
        edited: true
      };
      __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('comments').child(c['.key']).update(data);
      this.editing_comment_i = undefined;
      eventBus.$emit('triggerIconSignal', 'thumbsup');
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'datatable',
  props: ['items'],
  data: function data() {
    return {
      filterstring: ''
    };
  },

  methods: {
    getItemsLength: function getItemsLength() {
      return this.items.length;
    }
  },
  components: {}
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['invoices'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].generic],
  computed: {
    total: function total() {
      var total = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.invoices), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var i = _step.value;
          total += i.total_ex_vat_dkk;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return total;
    }
  },
  methods: {
    hasMatchingEconomyPost: function hasMatchingEconomyPost(invoice) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {

        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.getAll('economyposts')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var post = _step2.value;

          if (post.invoice_no != invoice.invoice_no) continue;
          if (post.amount_dkk_ex_vat != invoice.total_ex_vat_dkk) continue;
          if (post.invoice_date != invoice.date) continue;
          return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    copyInvoiceToEconomyPost: function copyInvoiceToEconomyPost(invoice) {
      alert('Denne feature er på vej, mvh William. Estimat er 1 times arbejde.');
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Btn__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Avatar: __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default.a, Btn: __WEBPACK_IMPORTED_MODULE_5__components_Btn___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].generic],
  props: {
    posts: { type: Array },
    totals: { type: Object },
    fields: { type: String, default: 'client,project,invoice_no,invoice_date,invoiced,paid,amount' }
  },
  data: function data() {
    return {};
  },

  computed: {
    economyposts: function economyposts() {
      return this.$store.state.firebase.economyposts;
    },
    clients: function clients() {
      return this.$store.state.firebase.clients;
    },
    projects: function projects() {
      return this.$store.state.firebase.projects;
    },
    colcount: function colcount() {
      return this.fields_list.length;
    },
    fields_list: function fields_list() {
      return this.fields.split(',');
    }
  },
  methods: {
    show_field: function show_field(key) {
      return this.fields && this.fields.indexOf(key) !== -1;
    },


    outputMoney: __WEBPACK_IMPORTED_MODULE_0__helpers_js__["a" /* default */].outputMoney,

    economypostTitle: function economypostTitle(economypost) {
      var t = '-';
      if (economypost.title && economypost.title.length) t = economypost.title;
      if (economypost.project_key) t = this.$store.state.firebase.projects[economypost.project_key].name;
      if (economypost.hypothetic) t = 'Hypotetisk: ' + t;
      return t;
    },
    negaPosi_cls: function negaPosi_cls(input) {
      var cls = '';
      if (input > 0) cls += ' posi ';
      if (input < 0) cls += ' nega ';
      return cls;
    },
    openEconomypost: function openEconomypost(economypost) {
      globals.modal_economypost_edit.economypost = economypost;
      globals.modal_economypost_edit.active = true;
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['active'],
  data: function data() {
    return {
      ripple: {
        top: 0,
        left: 0,
        size: 150,
        active: false
      }
    };
  },

  computed: {
    classes: function classes() {
      var output = '';
      if (this.active) output += ' active ';
      if (this.ripple.active) output += ' rippling ';
      return output;
    }
  },
  methods: {
    doRipple: function doRipple(e) {
      if (this.ripple.active) return;
      this.ripple.top = e.offsetY;
      this.ripple.left = e.offsetX;
      this.ripple.active = true;
      var _this = this;
      setTimeout(function () {
        _this.ripple.active = false;
      }, 400);
    },
    rippleStyle: function rippleStyle() {
      return {
        height: this.ripple.size + 'px',
        width: this.ripple.size + 'px',
        top: this.ripple.top + 'px',
        left: this.ripple.left + 'px',
        marginLeft: -(this.ripple.size / 2) + 'px',
        marginTop: -(this.ripple.size / 2) + 'px'
      };
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fullcalendar_core__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fullcalendar_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fullcalendar_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fullcalendar_daygrid__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fullcalendar_daygrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fullcalendar_daygrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_timegrid__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_timegrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fullcalendar_timegrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_list__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fullcalendar_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_timeline__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fullcalendar_timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_defaultsdeep__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_defaultsdeep__);











/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    data: function data() {
        return {

            calendar: undefined,

            defaultConfig: {
                locale: 'da',
                firstDay: 1,
                aspectRatio: 2,
                timeFormat: 'H(:mm)',
                timeZone: 'UTC',


                header: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay, listMonth,listWeek,listDay, timelineCustom'
                },
                views: {

                    dayGridMonth: { buttonText: 'Grid: Month' },
                    timeGridWeek: { buttonText: 'Week' },
                    timeGridDay: { buttonText: 'Day' },

                    listMonth: { buttonText: 'List: Month' },
                    listWeek: { buttonText: 'Week' },
                    listDay: { buttonText: 'Day' },

                    timelineCustom: {
                        type: 'timeline',
                        duration: { days: 90 },
                        buttonText: 'Timeline',
                        dateFormat: 'H(:mm)',
                        slotLabelFormat: [{ month: 'short', year: 'numeric' }, { day: 'numeric' }, { week: 'short' }, { weekday: 'narrow' }]

                    }

                },

                plugins: [__WEBPACK_IMPORTED_MODULE_1__fullcalendar_daygrid___default.a, __WEBPACK_IMPORTED_MODULE_2__fullcalendar_timegrid___default.a, __WEBPACK_IMPORTED_MODULE_3__fullcalendar_list___default.a, __WEBPACK_IMPORTED_MODULE_4__fullcalendar_timeline___default.a],
                eventRender: function eventRender(data) {
                    if (data.event.extendedProps && data.event.extendedProps.booking && data.event.extendedProps.booking.type) {
                        var type = data.event.extendedProps.booking.type.colorcode;
                        data.el.classList.add('booking-type-' + type);
                    }
                }
            }

        };
    },


    computed: {},

    methods: {},

    watch: {},

    mounted: function mounted() {

        var el = this.$refs.calendar;
        var config = __WEBPACK_IMPORTED_MODULE_5_lodash_defaultsdeep___default()(this.config, this.defaultConfig);
        this.calendar = new __WEBPACK_IMPORTED_MODULE_0__fullcalendar_core__["Calendar"](el, config);
        this.calendar.render();
    },
    beforeDestroy: function beforeDestroy() {

        this.calendar.destroy();
    }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['src'],
  data: function data() {
    return {
      loaded: false
    };
  },

  computed: {},

  created: function created() {

    var _this = this;
    var img = new Image();
    img.onload = function () {
      _this.loaded = true;
    };
    img.src = this.src;
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inputfield',
  props: {
    label: { type: String },
    icon: { type: String },
    type: { type: String },
    suffix: { type: String },
    padded: { type: Boolean, default: false },
    classes: { type: String }
  },
  data: function data() {
    return {};
  },

  computed: {
    cls: function cls() {
      var c = '';
      if (this.$props.classes) c += ' ' + this.$props.classes + ' ';
      if (this.$props.padded) c += ' padded ';
      if (!this.$props.label) c += ' no-label ';
      return c;
    }
  },
  components: {}
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: { type: String, default: function _default() {
                return 'Tasks';
            }
        }
    },

    data: function data() {
        return {

            tasklists: [{ title: 'Todo' }, { title: 'Doing' }, { title: 'Done' }],

            tasks: []

        };
    },


    computed: {
        columns_cls: function columns_cls() {
            var cls = {};
            cls['count-' + this.tasklists.length] = true;
            return cls;
        }
    },

    mounted: function mounted() {
        this.tasks = [];
    },


    methods: {
        addTask: function addTask(tasklist_i) {
            this.tasks.push({
                col_index: tasklist_i,
                text: 'New task'
            });
        },
        removeTask: function removeTask(task_i) {
            this.tasks.splice(task_i, 1);
        },
        removeColumn: function removeColumn(tasklist_i) {
            this.tasklists.splice(tasklist_i, 1);
        },
        addColumn: function addColumn(tasklist_i) {
            this.tasklists.push({
                title: 'New column'
            });
        }
    },

    beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_masonry_layout__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_masonry_layout__);


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['color', 'disabled'],
  data: function data() {
    return {
      config: {
        itemSelector: '.masonry-grid-item',
        columnWidth: 140
      },
      $masonrygrid: undefined
    };
  },

  computed: {},
  methods: {
    reLayout: function reLayout() {
      console.log(this.$masonrygrid);
      this.$masonrygrid.masonry('layout');
    }
  },
  mounted: function mounted() {
    this.$masonrygrid = new __WEBPACK_IMPORTED_MODULE_0_masonry_layout___default.a(this.$refs.masonrygrid, this.config);
    var _this = this;
    setInterval(function () {}, 1000);
  },
  created: function created() {
    var _this = this;
    eventBus.$on('masonry_relayout', function () {
      _this.reLayout();
    });
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['pct', 'color', 'bgcolor'],
  computed: {
    getBgColor: function getBgColor() {
      if (this._props.bgcolor) return this._props.bgcolor;
      return 'rgba(0,0,0,.1)';
    },
    getColor: function getColor() {
      if (this._props.color) return this._props.color;
      return 'rgba(0,0,0,1)';
    }
  },
  methods: {
    getValue: function getValue() {
      return (100 - this.pct) * 2.5122;
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['pct', 'bgcolor', 'color'],
  computed: {
    getBgColor: function getBgColor() {
      if (this._props.bgcolor) return this._props.bgcolor;
      return 'rgba(0,0,0,.15)';
    },
    getColor: function getColor() {
      if (this._props.color) return this._props.color;
      return 'rgba(0,0,0,1)';
    }
  },
  methods: {
    bgStyle: function bgStyle() {
      return {
        'background-color': this.getBgColor
      };
    },
    fgStyle: function fgStyle() {
      return {
        width: this.pct + '%',
        'background-color': this.getColor
      };
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: ['visible', 'no-dimmer-close', 'cls'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].generic],
  data: function data() {
    return {};
  },
  computed: {},
  methods: {
    dimmerClose: function dimmerClose() {
      if (this.noDimmerClose) return;
      this.$emit('close');
    },
    killerClose: function killerClose() {
      this.$emit('close');
    }
  },
  created: function created() {}
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['items', 'perpage', 'page'],
  methods: {
    setPage: function setPage(index) {
      this.$emit('updated', index);
    },
    prevPage: function prevPage() {
      this.$emit('updated', this._props.page - 1);
    },
    nextPage: function nextPage() {
      this.$emit('updated', this._props.page + 1);
    },
    getItemsLength: function getItemsLength(items) {
      if ((typeof items === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(items)) === 'object') items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(items).map(function (k) {
        return items[k];
      });
      return items.length;
    },
    getPerPage: function getPerPage() {
      if (!this._props.perpage) return 10;
      return parseInt(this._props.perpage);
    },
    getNumberPages: function getNumberPages() {
      var perpage = this.getItemsLength(this.items) / this.getPerPage();
      perpage = parseInt(perpage);
      if (perpage < 1) perpage = 1;
      return perpage;
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Btn__);




/* harmony default export */ __webpack_exports__["default"] = ({
	props: [],
	mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].generic],
	components: {
		Btn: __WEBPACK_IMPORTED_MODULE_1__components_Btn___default.a
	},
	data: function data() {
		return {

			sug_index: undefined,

			preview: undefined,

			suggestions: [{
				title: 'Workshop',
				entries: [{ title: 'Opstartsworkshop', line: { title: 'Opstartsworkshop', text: 'Der forberedes til og og faciliteres workshop hvor løsningens udformning afklares i detaljegrad.', hours: 8 } }]
			}, {
				title: 'CMS',
				entries: [{ title: 'WordPress CMS', line: { title: 'WordPress CMS', text: 'Der installeres og opsættes WordPress CMS system som gør det nemt og hurtigt at styre løsningens indhold i form af tekst og billeder.', hours: 10 } }, { title: 'Headless WordPress', line: { title: 'WordPress CMS', text: 'Der installeres og opsættes WordPress CMS system som gør det nemt og hurtigt at styre løsningens indhold i form af tekst og billeder. Indhold transporteres fra CMS til selve løsningen via tilpasset REST API.', hours: 16 } }, { title: 'Custom CMS/admin', line: { title: 'Custom CMS', text: 'Der udvikles CMS/admin panel hvorfra indhold kan styres.', hours: 24 } }]
			}, {
				title: 'Testing',
				entries: [{ title: 'Enkel device testing', line: { title: 'Enkel device testing', text: 'Løsningen testes på de mest udbredte devices, heriblandt desktop, tablet og mobil i nye modeller og med nyeste software/browser.', hours: 10 } }, { title: 'Udvidet device testing', line: { title: 'Enkel device testing', text: 'Løsningen testes på de mest udbredte devices, heriblandt desktop, tablet og mobil i nye modeller og med nyeste software/browser.', hours: 16 } }]
			}, {
				title: 'Webshop',
				entries: [{ title: 'Enkel Shopify', line: { title: 'Webshop', text: 'Der opsættes e-commerce løsning i Shopify med afsæt i afstemt theme. Valgte theme definerer layout samt tekniske og designmæssige muligheder. Design tilpasses ved styring af typografi og farver.', hours: 14 } }, { title: 'Enkel WooCommerce', line: { title: 'Webshop', text: 'Der opsættes custom Woocommerce webshop med skræddersyet theme kodet fra bunden.', hours: 68 } }]
			}, {
				title: 'Projektstyring',
				entries: [{ title: 'Budget projektstyring', line: { title: 'Projektstyring', text: 'Projektstyring, dialog og afsluttende overleveringsmøde', hours: 6 } }, { title: 'Mellem projektstyring', line: { title: 'Projektstyring', text: 'Projektstyring, dialog, midtvejsmøde og afsluttende overleveringsmøde', hours: 12 } }, { title: 'Stor projektstyring', line: { title: 'Projektstyring', text: 'Projektstyring, dialog, midtvejsmøde og afsluttende overleveringsmøde', hours: 20 } }]
			}, {
				title: 'Rettelser',
				entries: [{ title: 'Mikro', line: { title: 'Rettelser', text: 'Rettelser foretages i samlet retterunde', hours: 6 } }, { title: 'Makro', line: { title: 'Rettelser', text: 'Rettelser foretages i samlet retterunde', hours: 12 } }]
			}]

		};
	},
	computed: {},
	methods: {
		selectEntry: function selectEntry(entry) {

			eventBus.$emit('specLineRobot_onSelectEntry', entry.line);

			this.toast('Tilføjet...');
		}
	}, created: function created() {},
	mounted: function mounted() {},
	destroyed: function destroyed() {}
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Specsheet__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Specsheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Specsheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generated_svg_icons_ionicons_ios_trash_outline__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generated_svg_icons_ionicons_ios_trash_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_generated_svg_icons_ionicons_ios_trash_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generated_svg_icons_ionicons_checkmark__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generated_svg_icons_ionicons_checkmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_generated_svg_icons_ionicons_checkmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generated_svg_icons_ionicons_android_close__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generated_svg_icons_ionicons_android_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_generated_svg_icons_ionicons_android_close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_ionicons_ios_minus_empty__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_ionicons_ios_minus_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_ionicons_ios_minus_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generated_svg_icons_logo__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generated_svg_icons_logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_generated_svg_icons_logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuedraggable__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_autosize__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_autosize__);




















/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['localspec'],
	mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */].generic],
	components: {
		Box: __WEBPACK_IMPORTED_MODULE_4__components_Box___default.a,
		Btn: __WEBPACK_IMPORTED_MODULE_5__components_Btn___default.a,
		Avatar: __WEBPACK_IMPORTED_MODULE_13__components_Avatar___default.a,
		Inputfield: __WEBPACK_IMPORTED_MODULE_7__components_Inputfield___default.a,
		draggable: __WEBPACK_IMPORTED_MODULE_15_vuedraggable___default.a,
		Specsheet: __WEBPACK_IMPORTED_MODULE_6__components_Specsheet___default.a
	},
	data: function data() {
		return {
			spec: undefined,
			specLineRobot_insertAtTaskcatIndex: undefined
		};
	},
	computed: {
		client: function client() {
			return this.$store.getters['clients/getOne'](this.project.client_key);
		},
		project: function project() {
			return this.$store.getters['projects/getOne'](this.spec.project_key);
		},
		hour_rate: function hour_rate() {
			return this.$store.getters['projects/get_hour_rate'](this.project);
		},
		total: function total() {
			return this.$store.getters['specs/getTotal'](this.spec);
		},
		total_hours: function total_hours() {
			return this.$store.getters['specs/getHours'](this.spec);
		},
		pretitle: function pretitle() {
			var t = '';

			t += 'Prisoverslag';
			if (this.spec.date) t += ' &mdash; ' + this.spec.date;
			return t;
		},
		title: function title() {
			var t = '';
			t += this.client.name + ': ' + this.project.name;

			return t;
		},
		legaltext1: function legaltext1() {
			var t;

			if (this.project.payment_model == 'fixed_price') {}
			if (this.project.payment_model == 'time_expense') {}

			return t;
		},
		legaltext2: function legaltext2() {
			return;
			return 'I Milk Studio arbejder vi både med faste priser og almindelig timepris.<br>' + '&mdash; Fordelen ved faste priser er at du ved præcis hvad en given løsning kommer til at koste.<br>' + '&mdash; Timepris er typisk langt billigere for dig, idet det effektive arbejde kan påbegyndes nærmest direkte uden der skal bruges tid på budget, tilbud og andet overhead.';
		},
		legaltext_below: function legaltext_below() {
			if (this.project.payment_model == 'fixed_price') return 'Priser angivet ovenfor er faste priser.';
			if (this.project.payment_model == 'time_expense') return 'Der afregnes på timebasis ' + this.project.hour_rate + ' kr. med udgangspunkt i ovenstående estimater.';
		},
		notes_text: function notes_text() {
			var t;
			if (this.project.payment_model == 'fixed_price') {
				t = 'Prisoverslag er beregnet ud fra gældende timepris på ' + this.hour_rate + ' kr. ekskl. moms. ';
			}
			if (this.project.payment_model == 'time_expense') {
				t = 'Prisoverslag er beregnet ud fra gældende timepris på ' + this.hour_rate + ' kr. ekskl. moms. ';
				'Ved opgaveafslutning afregnes opgaven efter forbrugt arbejdstid. Kunden har krav på opgørelse for arbejdstid såfremt en sådan ønskes. ' + 'Milk Studio forpligter sig til at advisere kunden i tilfælde af at arbejdets omfang overstiger ovenstående estimater i væsentligt omfang. ' + 'Kunden fra til enhver tid ret til at bede Milk Studio afslutte opgaven hvorefter der vil blive afregnet ud fra opbrugt arbejdstid.<br>';
			}

			t += 'Alle priser angivet ovenfor er angivet ekskl. moms. ';
			t += 'Fakturering er som udgangspunkt 50% ved opstart og 50% ved opgavens afslutning.';
			t += '<br>Vi gør opmærksom på vores generelle forretningsbetingelser som kan ses på https://milk-studio.dk/forretningsbetingelser.pdf';

			return t;
		},
		specView_cls: function specView_cls() {
			var cls = {};
			cls['spec-type-' + this.project.payment_model] = true;
			return cls;
		}
	},
	methods: {

		getProjectAcceptedSpec: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectAcceptedSpec,

		toggleSpecSetting: function toggleSpecSetting(key) {
			if (this.spec[key] == undefined) this.$set(this.spec, key, false);
			this.spec[key] = !this.spec[key];
		},
		task_drag_start: function task_drag_start(e) {},
		task_drag_end: function task_drag_end(e) {},
		task_drag_remove: function task_drag_remove(e) {
			console.log('remove: ' + e.oldIndex + ' > ' + e.newIndex);
		},
		task_drag_add: function task_drag_add(e) {
			console.log(e);
			console.log('add: ' + e.oldIndex + ' > ' + e.newIndex);
			this.autoSizeTextAreasDelayed();
		},
		updateTaskTitle: function updateTaskTitle(taskcat_i, task_i) {
			var el = this.$refs['taskTitle' + taskcat_i + '-' + task_i][0];
			var val = el.textContent;
			this.$set(this.spec.taskcats[taskcat_i].tasks[task_i], 'title', val);
		},
		updateTaskText: function updateTaskText(taskcat_i, task_i) {
			var el = this.$refs['taskText' + taskcat_i + '-' + task_i][0];
			var val = el.textContent;
			this.$set(this.spec.taskcats[taskcat_i].tasks[task_i], 'text', val);
		},
		triggerSpecLineRobot: function triggerSpecLineRobot(taskcat_i) {
			this.specLineRobot_insertAtTaskcatIndex = taskcat_i;
			this.$store.commit('set__specLineRobot_active', true);
		},
		specLineRobot_onSelectEntry: function specLineRobot_onSelectEntry(task) {

			if (!this.spec.taskcats.length) {
				this.addTaskcat();
			}

			var taskcat_index = this.specLineRobot_insertAtTaskcatIndex;

			if (taskcat_index == undefined) taskcat_index = this.spec.taskcats.length - 1;

			if (!this.spec.taskcats[taskcat_index].tasks) {
				this.$set(this.spec.taskcats[taskcat_index], 'tasks', []);
			}
			this.spec.taskcats[taskcat_index].tasks.push(task);

			this.specLineRobot_insertAtTaskcatIndex = undefined;
			this.spec.showDescriptions = true;

			this.autoSizeTextAreasDelayed();
		},


		outputMoney: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].outputMoney,

		change: function change(key, e) {
			var val = e.target.value;
			this.changes[key] = val;
		},
		goto: function goto(url) {
			this.$router.push(url);
		},
		hasExistingAcceptedSpec: function hasExistingAcceptedSpec(data) {
			if (data.status != 'accepted') return false;
			if (!data.project_key) return false;
			var existing_accepted_spec = this.getProjectAcceptedSpec(data.project_key);
			if (!existing_accepted_spec) return false;
			if (existing_accepted_spec['.key'] == data['.key']) return false;
			return true;
		},
		save: function save() {

			globals.big_spinner = true;
			var id = this.$route.params.id;
			var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.spec));

			if (this.hasExistingAcceptedSpec(data)) {
				eventBus.$emit('toast', {
					text: '<br>Der er allerede accepteret spec for denne opgave.<br><br>Du kan ikke gemme flere accepterede specs på samme opgave.<br><br>'
				});
				return false;
			}

			delete data['.key'];

			__WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('specs').child(id).update(data);

			eventBus.$emit('toast', {
				text: 'Saved'
			});
			globals.big_spinner = false;
			eventBus.$emit('triggerIconSignal', 'thumbsup');
		},
		archiveSpec: function archiveSpec() {
			var confirmed = confirm('Sikker?');
			if (!confirmed) return;
			var key = this.$route.params.id;

			__WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('specs').child(key).update({
				archived: true
			});
			this.$router.replace('/specs');
			eventBus.$emit('toast', {
				text: 'Spec arkiveret'
			});
		},
		getCatTotalHours: function getCatTotalHours(taskcat) {
			var total_hrs = 0;
			for (var i in taskcat.tasks) {
				var task = taskcat.tasks[i];
				if (task.optional == false) continue;
				total_hrs += parseFloat(task.hours);
			}
			return total_hrs;
		},
		getCatTotalBudget: function getCatTotalBudget(taskcat) {
			var hrs = this.getCatTotalHours(taskcat);
			return hrs * this.hour_rate;
		},
		addTask: function addTask(taskcat_index) {
			if (!this.spec.taskcats.length) {
				this.addTaskcat();
			}
			var task = { title: '', text: '', hours: 0, optional: undefined };

			if (taskcat_index == undefined) taskcat_index = this.spec.taskcats.length - 1;

			if (!this.spec.taskcats[taskcat_index].tasks) {
				this.$set(this.spec.taskcats[taskcat_index], 'tasks', []);
			}
			this.spec.taskcats[taskcat_index].tasks.push(task);
		},
		addTaskcat: function addTaskcat(taskcat_i) {

			var task = { title: '', text: '', hours: 0, optional: undefined };
			var taskcat = { title: 'Opgaver', tasks: [task] };
			if (!this.spec.taskcats) {
				this.$set(this.spec, 'taskcats', []);
			}
			if (taskcat_i === undefined) {
				this.spec.taskcats.push(taskcat);
			}
			if (taskcat_i !== undefined) {
				this.spec.taskcats.splice(taskcat_i + 1, 0, taskcat);
			}

			this.toast('Kategori tilføjet');
		},
		specElementInSpec: function specElementInSpec(specelement_key) {
			if (!this.spec.specelements) return false;
			if (!this.spec.specelements[specelement_key]) return false;
			if (!this.spec.specelements[specelement_key].active) return false;
			return true;
		},
		toggleSpecElementInSpec: function toggleSpecElementInSpec(specelement_key) {
			var inAlready = this.specElementInSpec(specelement_key);
			if (!this.spec.specelements[specelement_key]) {
				this.$set(this.spec.specelements, specelement_key, { active: undefined });
			}

			this.spec.specelements[specelement_key].active = !inAlready;

			if (!inAlready) {
				var specelement = globals.specelements[specelement_key];
				if (specelement['no_pairing']) {
					for (var i = 0; i < specelement.no_pairing.length; i++) {
						var pair_element_key = specelement.no_pairing[i];
						if (this.specElementInSpec(pair_element_key)) {
							this.spec.specelements[pair_element_key].active = false;
						}
					}
				}
			}
		},
		taskClasses: function taskClasses(task) {
			var cls = {};
			if (task.optional == undefined) cls['optional-undefined'] = true;
			if (task.optional == false) cls['optional-false'] = true;
			if (this.spec.showDescriptions && task.text && task.text.length) cls['has-text'] = true;
			return cls;
		},
		toggleTaskOptional: function toggleTaskOptional(task) {
			switch (task.optional) {
				case undefined:
					this.$set(task, 'optional', true);
					break;
				case true:
					this.$set(task, 'optional', false);
					break;
				case false:
					this.$set(task, 'optional', undefined);
					break;
			}
		},
		array_move: function array_move(arr, old_index, new_index) {
			if (new_index >= arr.length) {
				var k = new_index - arr.length + 1;
				while (k--) {
					arr.push(undefined);
				}
			}
			arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
			return arr;
		},
		taskCatMoveUp: function taskCatMoveUp(taskcat, taskcat_i) {
			var taskcat_new_i = taskcat_i;
			taskcat_new_i -= 1;
			this.array_move(this.spec.taskcats, taskcat_i, taskcat_new_i);
			this.autoSizeTextAreasDelayed();
		},
		taskCatMoveDown: function taskCatMoveDown(taskcat, taskcat_i) {
			var taskcat_new_i = taskcat_i;
			taskcat_new_i += 1;
			this.array_move(this.spec.taskcats, taskcat_i, taskcat_new_i);
			this.autoSizeTextAreasDelayed();
		},
		taskcatDelete: function taskcatDelete(taskcat, taskcat_i) {
			var sure = confirm('Vil du slette alle rækkerne i dette afsnit?');
			if (!sure) return;
			this.spec.taskcats.splice(taskcat_i, 1);
			this.autoSizeTextAreasDelayed();
			this.toast('Kategori slettet');
		},
		taskDelete: function taskDelete(task, task_i, taskcat, taskcat_i) {
			var sure = confirm('Vil du slette denne række?');
			if (!sure) return;
			this.spec.taskcats[taskcat_i].tasks.splice(task_i, 1);
			this.autoSizeTextAreasDelayed();
			this.toast('Række slettet');
		},
		toggleShowDescriptions: function toggleShowDescriptions() {
			if (this.spec.showDescriptions == undefined) this.$set(this.spec, 'showDescriptions', false);
			this.$set(this.spec, 'showDescriptions', !this.spec.showDescriptions);
			var _this = this;
			setTimeout(function () {
				_this.autoSizeTextAreas2();
			}, 0);
		},
		autoSizeTextArea: function autoSizeTextArea(taskcat_i, task_i) {
			var el = this.$refs['taskTitle' + taskcat_i + '-' + task_i][0];
			__WEBPACK_IMPORTED_MODULE_16_autosize___default()(el);
		},
		autoSizeTextArea2: function autoSizeTextArea2(taskcat_i, task_i) {
			var el = this.$refs['taskText' + taskcat_i + '-' + task_i][0];
			__WEBPACK_IMPORTED_MODULE_16_autosize___default()(el);
		},
		autoSizeTextAreas: function autoSizeTextAreas() {
			var textareas = document.querySelectorAll('textarea.input-task-title');
			__WEBPACK_IMPORTED_MODULE_16_autosize___default()(textareas);
		},
		autoSizeTextAreas2: function autoSizeTextAreas2() {
			var textareas = document.querySelectorAll('textarea.input-task-text');
			__WEBPACK_IMPORTED_MODULE_16_autosize___default()(textareas);
		},
		autoSizeTextAreasDelayed: function autoSizeTextAreasDelayed() {
			var _this = this;
			setTimeout(function () {
				_this.autoSizeTextAreas();
				_this.autoSizeTextAreas2();
				_this.autoSizeTextAreaNotes();
			}, 0);
		},
		autoSizeTextAreaNotes: function autoSizeTextAreaNotes() {
			var el = this.$refs['notesTextArea'];
			if (!el) return;
			__WEBPACK_IMPORTED_MODULE_16_autosize___default()(el);
		},
		downloadPDF: function downloadPDF() {
			alert('Tryk CMD+P for at prnte/gemme PDF. :)');
		},
		cloneSpec: function cloneSpec() {
			var key = prompt('URL på projekt du ønsker at kopiere fra');
			if (!key) return;

			key = key.replace('https://kia.milk-studio.dk/#/project/', '');

			var project = this.$store.getters['projects/getOne'](key);
			var spec = this.$store.getters['specs/getByProjectKey'](key);
			if (!spec) {
				this.toast('Spec ikke fundet ...');
				return;
			}

			__WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('specs').child(this.spec.key || this.spec['.key']).update({ taskcats: spec.taskcats });
			this.toast('Opgavespecifikation kopieret fra ' + project.name + '...');
		}
	}, created: function created() {

		var _this = this;

		document.body.classList.add('has-spec-sheet');

		eventBus.$on('specLineRobot_onSelectEntry', function (entry) {
			_this.specLineRobot_onSelectEntry(entry);
		});
	},
	mounted: function mounted() {

		this.spec = this.localspec;

		if (this.spec.type == 'fixed_prices') if (this.spec.type == 'estimates') this.autoSizeTextAreas();
		this.autoSizeTextAreas2();
		this.autoSizeTextAreaNotes();
	},
	destroyed: function destroyed() {

		document.body.classList.remove('has-spec-sheet');
	}
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        label: { required: true },
        prefix: { default: '' },
        suffix: { default: '' }
    },
    data: function data() {
        return {
            isActive: false
        };
    },
    computed: {
        header: function header() {
            return this.prefix + this.label + this.suffix;
        }
    }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TabBox',
  props: ['label', 'icon']
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tab-Boxes',
  props: ['tabs']
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['active-tab', 'look'],
    data: function data() {
        return {
            tabs: []
        };
    },
    computed: {},
    created: function created() {
        this.tabs = this.$children;
    },
    mounted: function mounted() {},


    methods: {
        findTab: function findTab(hash) {
            return this.tabs.find(function (tab) {
                return tab.hash === hash;
            });
        },
        selectTab: function selectTab(index) {

            var i = 0;
            this.tabs.forEach(function (tab) {
                tab.isActive = i == index;
                i++;
            });

            this.$emit('changed', { tab: selectedTab });

            return;
            var selectedTab = this.findTab(selectedTabHash);

            if (!selectedTab) {
                return;
            }

            this.tabs.forEach(function (tab) {
                tab.isActive = tab.hash === selectedTab.hash;
            });

            this.$emit('changed', { tab: selectedTab });

            this.activeTabHash = selectedTab.hash;
        }
    }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    tags: { tags: String, itemtype: String, itemkey: String }
  },
  data: function data() {
    return {};
  },

  computed: {
    tags_list: function tags_list() {
      var tags = this.tags.split(' ');
      return tags;
    }
  },
  components: {}
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globals_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Box__);







/* harmony default export */ __webpack_exports__["default"] = ({
	components: { Box: __WEBPACK_IMPORTED_MODULE_3__components_Box___default.a },

	props: ['title', 'entries', 'days-back', 'days-ahead', 'show-sidebar', 'sidebar-width'],

	data: function data() {
		return {

			globals: __WEBPACK_IMPORTED_MODULE_1__globals_js__["a" /* default */],

			grid_highlight_weeks: true,

			show_dates: false,
			show_weeks: true,

			expandedRows: [],
			days_back: 7,
			days_ahead: 180,
			dayInitials: ['', 's', 'm', 't', 'o', 't', 'f', 'l', 's'],
			monthTitles: ['', 'januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'],
			field_width: 15,

			show_view_options: false
		};
	},

	computed: {
		show_sidebar: function show_sidebar() {
			if (this.$props.showSidebar == undefined) return false;
			if (this.$props.showSidebar == true) return true;
			return false;
		},
		sidebar_width: function sidebar_width() {
			if (this.$props.sidebarWidth == undefined) return 120;
			return this.$props.sidebarWidth;
		},
		now: function now() {
			return __WEBPACK_IMPORTED_MODULE_2_moment___default()();
		},
		timeline_dates: function timeline_dates() {
			var output = [];
			var datespan = this.days_ahead + this.days_back + 1;
			for (var i = 0; i < datespan; i++) {
				var offset = i - this.days_back;
				var momente = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(offset, 'days');
				var d = parseInt(momente.format('D'));
				var m = parseInt(momente.format('MM'));
				var y = parseInt(momente.format('YYYY'));
				var dn = parseInt(momente.format('d')) + 1;
				var w = parseInt(momente.format('W'));
				var entry = { d: d, m: m, y: y, dn: dn, w: w };
				if (i == this.days_back) entry.today = true;
				output.push(entry);
			}
			return output;
		},
		timeline_months: function timeline_months() {
			var output = [];
			for (var i = 0; i < this.timeline_dates.length; i++) {
				var date = this.timeline_dates[i];
				var lastOutputItem = output[output.length - 1];
				if (lastOutputItem && lastOutputItem.m == date.m) {
					output[output.length - 1].days_count++;
				} else {
					output.push({
						m: date.m,
						y: date.y,
						days_count: 1
					});
				}
			}
			return output;
		},
		timeline_weeks: function timeline_weeks() {
			var output = [];
			for (var i = 0; i < this.timeline_dates.length; i++) {
				var date = this.timeline_dates[i];
				var lastOutputItem = output[output.length - 1];
				if (lastOutputItem && lastOutputItem.w == date.w) {
					output[output.length - 1].days_count++;
				} else {
					output.push({
						w: date.w,
						days_count: 1
					});
				}
			}
			return output;
		},
		timeline_content_container_css: function timeline_content_container_css() {
			var css = {};
			css.width = 'calc(100% - ' + this.sidebar_width + 'px)';
			if (!this.show_sidebar) css.width = '100%';
			return css;
		},
		timeline_content_css: function timeline_content_css() {
			return {
				width: (this.days_ahead + 1 + this.days_back) * this.field_width + 'px'
			};
		},
		field_css: function field_css() {
			return {
				width: this.field_width + 'px'
			};
		}
	},

	methods: {
		isRowExpanded: function isRowExpanded(row_i) {
			if (this.expandedRows[row_i] && this.expandedRows[row_i] == true) return true;
			return false;
		},
		toggleRowExpanded: function toggleRowExpanded(row_i, boolean) {
			if (boolean === undefined) boolean = !this.isRowExpanded(row_i);
			this.$set(this.expandedRows, row_i, boolean);
		},
		month_field_css: function month_field_css(m) {
			return {
				width: this.field_width * m.days_count + 'px'
			};
		},
		field_classes: function field_classes(d) {
			var cls = {};
			if (d.today) cls.today = true;
			cls['day' + parseInt(d.dn)] = true;
			return cls;
		},
		entry_marker_css: function entry_marker_css(entry) {

			var bgcolor = '#333';if (entry.color) bgcolor = entry.color;
			var textcolor = 'white';

			var firstdate = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(this.days_back, 'days');

			var start_days_diff = __WEBPACK_IMPORTED_MODULE_2_moment___default()(entry.date_from, 'YYYY-MM-DD').diff(firstdate, 'days');
			var end_days_diff = __WEBPACK_IMPORTED_MODULE_2_moment___default()(entry.date_to, 'YYYY-MM-DD').diff(firstdate, 'days');

			var l = start_days_diff + 1;
			var w = end_days_diff - l + 1 + 1;

			return {
				left: l * this.field_width + 'px',
				width: w * this.field_width + 'px',
				'background-color': bgcolor,
				'color': textcolor
			};
		},
		entry_marker_classes: function entry_marker_classes(entry) {
			var c = {};
			c.l = true;
			return c;
		},
		entry_marker_title_css: function entry_marker_title_css(entry) {
			return {};
			if (!entry.color) return;
			var bgColor = entry.color;
			return {
				'background-color': bgColor
			};
		},
		entry_marker_end_css: function entry_marker_end_css(side, entry) {},
		timeline_entry_marker_end: function timeline_entry_marker_end(side, data) {
			return {};
			var bgColor = data.color;
			var css = {
				'border-color': bgColor + ' transparent transparent transparent'
			};
			if (side == 'l') {
				css['border-width'] = '10px 10px 0 0';
				css['border-color'] = bgColor + ' transparent transparent transparent';
			}
			if (side == 'r') {
				css['border-width'] = '0 10px 10px 0';
				css['border-color'] = 'transparent ' + bgColor + ' transparent transparent';
			}
			return css;
		},
		triggerEntryPopup: function triggerEntryPopup(project) {
			__WEBPACK_IMPORTED_MODULE_1__globals_js__["a" /* default */].modal_timeline_project_popup.project = project;
			__WEBPACK_IMPORTED_MODULE_1__globals_js__["a" /* default */].modal_timeline_project_popup.active = true;
		},
		entry_marker_donebar_css: function entry_marker_donebar_css(entry) {
			var done_pct = entry.done_pct;
			return { 'width': done_pct + '%' };
		},
		onZoomUpdateViewSettings: function onZoomUpdateViewSettings() {
			var z = this.field_width;
			this.grid_highlight_weeks = z < 30;
			this.show_dates = z >= 30;
		},
		zoomIn: function zoomIn() {
			this.field_width += 5;
			this.onZoomUpdateViewSettings();
		},
		zoomOut: function zoomOut() {
			if (this.field_width > 10) this.field_width -= 5;
			this.onZoomUpdateViewSettings();
		},
		updateDaysBack: function updateDaysBack() {
			var value = this.$refs.daysBackInput.value;
			this.days_back = value;
		},
		updateDaysAhead: function updateDaysAhead() {
			var value = this.$refs.daysAheadInput.value;
			this.days_ahead = value;
		},
		onEntryClick: function onEntryClick(entry) {
			this.$emit('entry-click', entry);
		},
		onEntrySidebarClick: function onEntrySidebarClick(entry) {
			this.$emit('sidebar-entry-click', entry);
		}
	}, created: function created() {

		if (this.$props.daysBack != undefined) this.days_back = parseInt(this.$props.daysBack);
		if (this.$props.daysAhead != undefined) this.days_ahead = parseInt(this.$props.daysAhead);

		if (this.$props.showDates != undefined) this.show_dates = this.$props.showDates;
		if (this.$props.showWeeks != undefined) this.show_weeks = this.$props.showWeeks;

		this.onZoomUpdateViewSettings();
	}
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Inputfield__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Box: __WEBPACK_IMPORTED_MODULE_5__components_Box___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_7__components_Inputfield___default.a, Btn: __WEBPACK_IMPORTED_MODULE_6__components_Btn___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */].generic],
  data: function data() {
    return {

      timelog: {
        hours: undefined,
        title: undefined,
        project_key: undefined,
        billable: undefined,
        worktype: undefined
      }

    };
  },
  computed: {
    worktypes: function worktypes() {
      return this.$store.state.worktypes;
    },
    project: function project() {
      return this.getOne('project', this.timelog.project_key);
    },
    ready: function ready() {
      if (!this.timelog.project_key) return false;
      if (!this.timelog.hours) return false;
      if (!this.timelog.worktype) return false;
      if (!this.timelog.title) return false;
      if (!this.timelog.title.length) return false;
      return true;
    }
  },
  methods: {
    multiSelectGetOption: function multiSelectGetOption(options, key) {
      if (!options) return;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;
          if (option.key == key) return option.key;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    worktypeOnMultiSelect: function worktypeOnMultiSelect(item) {
      this.timelog.worktype = item.key;
    },
    create: function create() {

      this.timelog.user_key = this.$store.getters['users/my_user']['.key'];
      this.timelog.date = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD');
      this.timelog.created = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD hh:mm:SS');
      this.timelog.date_timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()().unix(), this.timelog.created_timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()().unix(), this.fdb_push('timelogs', this.timelog);

      this.$store.commit('set__timeloggerBasic_active', false);
      this.triggerIconSignal('heart');

      this.$toasted.show(this.timelog.hours + ' timer tracket...', {
        position: 'bottom-right',
        duration: '2000'
      });
    }
  },
  created: function created() {

    this.timelog = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.timeloggerBasic.timelog));
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      return _this.$refs.hoursinput.focus();
    });
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Avatar__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Avatar: __WEBPACK_IMPORTED_MODULE_5__components_Avatar___default.a },
  props: ['timelogs'],

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */].generic],

  data: function data() {
    return {

      separate_dates: false

    };
  },

  computed: {
    timelogs_dataloaded: function timelogs_dataloaded() {

      var timelogs = this.timelogs;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(timelogs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timelog = _step.value;

          if (!timelog.project && timelog.project_key) timelog.project = this.getOne('project', timelog.project_key);
          if (!timelog.client && timelog.client_key) timelog.client = this.getOne('client', timelog.client_key);
          if (!timelog.user && timelog.user_key) timelog.user = this.getOne('user', timelog.user_key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return timelogs;
    }
  },

  methods: {

    delete_timelog: __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* default */].delete_timelog,
    translateWorktype: __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* default */].translateWorktype,

    timelogListDateSpacerBoolean: function timelogListDateSpacerBoolean(filteredTimelogs, i) {
      if (i == 0) return false;
      var timelog = filteredTimelogs[i];
      var timelog_prev = filteredTimelogs[i - 1];
      return timelog.date != timelog_prev.date;
    },
    editTimelog: function editTimelog(timelog) {
      __WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */].modal_timelog_edit.timelog = timelog;
      __WEBPACK_IMPORTED_MODULE_2__globals_js__["a" /* default */].modal_timelog_edit.active = true;
    },
    gotoClient: function gotoClient(input) {
      var a = 'client/',
          b;
      if (typeof input == 'string') b = input;
      if (typeof input != 'string') b = input['.key'];
      this.$router.push(a + b);
    },
    getUserInitials: function getUserInitials(key) {
      var user = this.getUser(key);return user.email.replace('@milk-studio.dk', '');
    },
    nicedate: function nicedate(date, format) {
      if (!format) format = 'YYYY-MM-DD';
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date, 'YYYY-MM-DD').format(format);
    }
  },

  created: function created() {}
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Filterbtn__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Filterbtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Filterbtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Comments__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Comments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_EconomyPosts__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_EconomyPosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_EconomyPosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DineroInvoices__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DineroInvoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_DineroInvoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__firebase_config_js__ = __webpack_require__(8);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'client',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_3__mixins_js__["a" /* default */].generic],
  components: { Box: __WEBPACK_IMPORTED_MODULE_4__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_5__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_11__components_Avatar___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_6__components_Inputfield___default.a, Filterbtn: __WEBPACK_IMPORTED_MODULE_7__components_Filterbtn___default.a, Comments: __WEBPACK_IMPORTED_MODULE_8__components_Comments___default.a, EconomyPosts: __WEBPACK_IMPORTED_MODULE_9__components_EconomyPosts___default.a, DineroInvoices: __WEBPACK_IMPORTED_MODULE_10__components_DineroInvoices___default.a },
  data: function data() {
    return {
      globals: this.$parent.globals,
      changes: {},
      client_id: this.$route.params.id,
      showing: 'projects_active'
    };
  },
  computed: {
    client_key: function client_key() {
      return this.$route.params.id;
    },
    client: function client() {
      return this.getOne('client', this.client_key);
    },
    clientProjects: function clientProjects() {
      var output = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.getAll('projects')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var project = _step.value;


          if (project.client_key != this.client_id) continue;
          if (project.archived) continue;

          project.status_translated = __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].translateProjectStatus(project.status);

          project.timelogs = this.$store.getters['timelogs/get_cached'].project[project._key];
          project.timelogs_total_hours = this.$store.getters['timelogs/getTotalHours'](project.timelogs);
          project.budget = this.$store.getters['projects/getBudget'](project);
          project.budgetted_hours_spent_pct = this.$store.getters['projects/get_budgetted_hours_spent_pct'](project, project.timelogs);

          output.push(project);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return output;
    },
    clientActiveProjects: function clientActiveProjects() {
      return this.clientProjects.filter(function (project) {
        return project.status == 'active';
      });
    },
    clientFinishedProjects: function clientFinishedProjects() {
      return this.clientProjects.filter(function (project) {
        return project.status == 'finished';
      });
    },
    economyposts: function economyposts() {
      var client_posts = this.$store.getters['economyposts/getFiltered']({
        client_key: this.client.key
      });

      var project_keys = this.clientProjects.map(function (a) {
        return a.key;
      });
      var project_posts = this.$store.getters['economyposts/getFiltered']({
        project_keys: project_keys
      });

      var economyposts = client_posts.concat(project_posts);
      var totals = this.$store.getters['economyposts/getTotals'](economyposts);

      return { posts: economyposts, totals: totals };
    },
    client_timelogs: function client_timelogs() {
      return this.$store.getters['timelogs/get_cached'].client[this.client_key];
    },
    client_timelog_totals: function client_timelog_totals() {
      return this.$store.getters['timelogs/getTotalHours'](this.client_timelogs);
    },
    client_total_earning: function client_total_earning() {
      return this.$store.getters['clients/get_total_earning'](this.client.key);
    },
    clientColor: function clientColor() {
      if (this.client.color) return this.client.color;
      var initials = __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getItemInitials(this.client);
      return __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getColorByString(initials);
    },
    header_cls: function header_cls() {
      return {
        'background-color': this.clientColor,
        'color': 'white'
      };
    },
    client_dinero_invoices: function client_dinero_invoices() {
      if (!this.client.cvr) return [];
      return this.$store.getters.get_dinero_invoices({ client_cvr: this.client.cvr });
    },
    client_dinero_invoiced_total: function client_dinero_invoiced_total() {
      if (!this.client.cvr) return [];
      return this.$store.getters.get_dinero_invoices_total({ client_cvr: this.client.cvr });
    }
  },
  methods: {

    getProjectBudgetTotal: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectBudgetTotal,
    getProjectHoursEstimate: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectHoursEstimate,
    outputMoney: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].outputMoney,
    getProjectAcceptedSpec: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectAcceptedSpec,
    clientTotalEarning: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].clientTotalEarning,
    getClientProjects: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getClientProjects,

    setShowing: function setShowing(input) {
      this.showing = input;
    },
    openTimelogger: function openTimelogger(input) {
      eventBus.$emit('openTimelogger', input);
    },
    createNewClientProject: function createNewClientProject(input) {
      var p = {
        name: 'Ny opgave',
        client_key: this.$route.params.id,
        payment_model: 'fixed_price',
        created: __WEBPACK_IMPORTED_MODULE_1_moment___default()().unix()
      };

      if (input) {
        if (input.status) p.status = input.status;
      }

      if (!p.hour_rate && this.client.hour_rate) p.hour_rate = this.client.hour_rate;

      if (this.client.color) p.color = this.client.color;

      __WEBPACK_IMPORTED_MODULE_12__firebase_config_js__["a" /* default */].ref('projects').push(p);
    },
    change: function change(key, e) {
      var val = e.target.value;
      this.changes[key] = val;
    },
    goto: function goto(url) {
      this.$router.push(url);
    },
    submitChanges: function submitChanges() {
      var id = this.$route.params.id;
      var data = this.changes;
      __WEBPACK_IMPORTED_MODULE_12__firebase_config_js__["a" /* default */].ref('clients').child(id).update(data);
      eventBus.$emit('toast', { text: 'Saved' });
      this.$forceUpdate();
    },
    incrementGlobalCount: function incrementGlobalCount() {
      window.globals.count++;
    },
    archiveClient: function archiveClient() {

      if (this.clientProjects.length) {
        this.toast('Du kan ikke arkivere en kunde med tilknyttede projekter. Start med at flytte eller arkivere projekterne først.');
        return;
      }

      var confirmed = confirm('Sikker?');
      if (!confirmed) return;
      var confirmed2 = confirm('Helt sikker?');
      if (!confirmed2) return;

      var key = this.$route.params.id;
      __WEBPACK_IMPORTED_MODULE_12__firebase_config_js__["a" /* default */].ref('clients').child(key).update({ archived: true });
      this.$router.replace('/clients');
    },
    dinero_fetch_invoices: function dinero_fetch_invoices() {
      this.set_small_spinner(1);
      var _this = this;
      this.$store.dispatch('dinero_fetch', 'latest').then(function (response) {
        _this.toast('Dinero data indlæst!');
        _this.set_small_spinner(0);
      }).catch(function (error) {
        _this.toast('Fejl, kunne ikke indlæse fra Dinero...');
        _this.set_small_spinner(0);
      });
    }
  }, created: function created() {},
  mounted: function mounted() {
    this.$store.commit('set_context_bgcolor', this.clientColor);
    if (this.client.bgimg_tags) this.$store.dispatch('load_context_bgimg', 'https://source.unsplash.com/1200x600/?' + this.client.bgimg_tags + '');
  },
  destroyed: function destroyed() {

    this.$store.commit('set_context_bgcolor', null);
    this.$store.commit('set_context_bgimg', null);
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__firebase_config_js__ = __webpack_require__(8);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clients',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].generic],
  data: function data() {
    return {
      globals: this.$parent.globals
    };
  },
  computed: {
    search_filter: function search_filter() {
      return globals.clients.search_filter;
    },
    filteredClients: function filteredClients() {
      var output = [];
      var clients = this.$store.getters['clients/getAll'];
      if (!clients) return output;

      var filterString = this.search_filter;
      if (!filterString || filterString == undefined || filterString == '') filterString = undefined;
      if (filterString) filterString = filterString.toLowerCase();

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(clients), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var client = _step.value;


          if (client.archived) continue;

          if (filterString) {
            var filter_match = client.name && client.name.toLowerCase().indexOf(filterString) >= 0;
            if (!filter_match) continue;
          }

          client.active_projects_count = this.getClientProjects(client.key, { only_active: true, not_archived: true }).length;
          client.finished_projects_count = this.getClientProjects(client.key, { only_finished: true, not_archived: true }).length;

          output.push(client);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      output = output.sort(function (a, b) {
        return b.active_projects_count * 1000 + b.finished_projects_count - (a.active_projects_count * 1000 + a.finished_projects_count);
      });

      return output;
    }
  },
  methods: {

    getProjectBudgetTotal: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].getProjectBudgetTotal,
    getProjectHoursEstimate: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].getProjectHoursEstimate,
    outputMoney: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].outputMoney,
    clientTotalEarning: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].clientTotalEarning,
    getClientProjects: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].getClientProjects,
    getProjectAcceptedSpec: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].getProjectAcceptedSpec,

    getObjSize: function getObjSize(obj) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).length;
    },
    gotoClient: function gotoClient(client) {
      this.$router.push('client/' + client['.key']);
    },
    search_filter_updated: function search_filter_updated() {
      globals.clients.search_filter = this.$refs.search_filter.value;
    },
    incrementGlobalCount: function incrementGlobalCount() {
      window.globals.count++;
    },
    createNewClient: function createNewClient() {
      var new_entry = __WEBPACK_IMPORTED_MODULE_9__firebase_config_js__["a" /* default */].ref('clients').push({
        name: 'Ny kunde',
        created: __WEBPACK_IMPORTED_MODULE_2_moment___default()().unix()
      });
      var new_entry_key = new_entry.getKey();
      this.$router.push('client/' + new_entry_key);
    }
  },
  components: { Box: __WEBPACK_IMPORTED_MODULE_5__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_6__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_7__components_Avatar___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_8__components_Inputfield___default.a }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Filterbtn__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Filterbtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Filterbtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Minipctbar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Minipctbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Minipctbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Minidonut__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Minidonut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Minidonut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_EconomyPosts__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_EconomyPosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_EconomyPosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_chartist__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_v_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_v_chartist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_generated_svg_icons_ionicons_chevron_left__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_generated_svg_icons_ionicons_chevron_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_generated_svg_icons_ionicons_chevron_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_generated_svg_icons_ionicons_chevron_right__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_generated_svg_icons_ionicons_chevron_right___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_generated_svg_icons_ionicons_chevron_right__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_generated_svg_icons_ionicons_gear_a__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_generated_svg_icons_ionicons_gear_a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_generated_svg_icons_ionicons_gear_a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_generated_svg_icons_ionicons_checkmark__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_generated_svg_icons_ionicons_checkmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_generated_svg_icons_ionicons_checkmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_peity__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_peity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_peity__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Box: __WEBPACK_IMPORTED_MODULE_6__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_7__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_9__components_Avatar___default.a, Minipctbar: __WEBPACK_IMPORTED_MODULE_11__components_Minipctbar___default.a, Minidonut: __WEBPACK_IMPORTED_MODULE_12__components_Minidonut___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_8__components_Inputfield___default.a, 'vue-chartist': __WEBPACK_IMPORTED_MODULE_14_v_chartist___default.a, Peity: __WEBPACK_IMPORTED_MODULE_19_vue_peity___default.a, Filterbtn: __WEBPACK_IMPORTED_MODULE_10__components_Filterbtn___default.a, EconomyPosts: __WEBPACK_IMPORTED_MODULE_13__components_EconomyPosts___default.a },
  name: 'economy',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].generic],
  data: function data() {
    return {
      globals: this.$parent.globals,

      tabs: [{ key: 'main', label: 'Overblik' }, { key: 'keyfigs', label: 'Nøgletal' }, { key: 'missing', label: 'Til afklaring' }, { key: 'vat', label: 'Moms' }],
      tab_key_active: 'main',

      month_offset: 0,
      accounting_month_offset: 6,

      place_posts_by: 'invoice_date',

      keyFiguresExpanded: true,
      clientEarningsExpanded: false,

      missingInvoiceExpanded: true,
      missingPaymentExpanded: true,
      vatViewExpanded: true,

      activeEconomypostKey: undefined,
      activeEconomypost: undefined,
      user: __WEBPACK_IMPORTED_MODULE_4__auth_js__["a" /* default */].getUser(),
      monthNames: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'],

      chartist_data: {
        labels: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'],
        series: [[1050, 10, 2, 3, 3, 2, 1, 4, 5, 5, 2, 1]]
      },
      chartist_options: {
        fullWidth: true,
        chartPadding: {
          right: 140
        }
      },

      pieChartColors: ['#9FFFCB', '#004E64', '#00A5CF', '#7AE582', '#CDCDCD', '#214E34', '#E4959E', '#CB9CF2', '#9E7B9B', '#F35B04', '#7678ED'],

      client_earnings_date_from: undefined,
      client_earnings_date_to: undefined

    };
  },
  computed: {
    calculate_hypothetic_posts: function calculate_hypothetic_posts() {
      return this.$store.state.economyposts.calculate_hypothetic_posts;
    },
    now: function now() {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(this.month_offset, 'month');
    },
    activeMonthNumber: function activeMonthNumber() {
      return parseInt(this.now.format('M'));
    },
    activeMonthPosts: function activeMonthPosts() {
      return this.getFilteredAndTotals({
        date_from_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now, 'YYYY-MM-DD').startOf('month').unix(),
        date_to_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now, 'YYYY-MM-DD').endOf('month').unix()
      });
    },
    activeYearPosts: function activeYearPosts() {
      var output = [];

      for (var i = 1; i <= 12; i++) {
        var monthNumber = i;

        var month_moment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now).month(monthNumber - 1).add(this.accounting_month_offset, 'months');

        if (this.activeMonthNumber - 1 < this.accounting_month_offset) {
          month_moment.add(-1, 'year');
        }

        var data = this.getFilteredAndTotals({
          place_posts_by: this.place_posts_by,
          date_from_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()(month_moment).startOf('month').unix(),
          date_to_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()(month_moment).endOf('month').unix()
        });
        data.title = month_moment.format('MMM YYYY');
        data.month = month_moment.format('M');
        data.year = month_moment.format('Y');
        output.push(data);
      }
      return output;
    },
    activeYearTotals: function activeYearTotals() {

      var output = {
        q1: { income: 0, expense: 0, total: 0 },
        q2: { income: 0, expense: 0, total: 0 },
        q3: { income: 0, expense: 0, total: 0 },
        q4: { income: 0, expense: 0, total: 0 },
        year: { income: 0, expense: 0, total: 0 }
      };

      for (var i = 0; i < this.activeYearPosts.length; i++) {
        var m = this.activeYearPosts[i];
        var qno = Math.ceil((i + 1) / 12 * 4);
        output['q' + qno].income += m.totals.income_total;output['q' + qno].expense += m.totals.expense_total;output['q' + qno].total += m.totals.total;
        output.year.income += m.totals.income_total;output.year.expense += m.totals.expense_total;output.year.total += m.totals.total;
      }

      return output;
    },
    yearTitle: function yearTitle() {

      if (this.accounting_month_offset > 0) {
        if (this.now.month() + 1 > this.accounting_month_offset) {
          return this.now.format('YYYY') + '-' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now).add(1, 'year').format('YYYY');
        } else {
          return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now).add(-1, 'year').format('YYYY') + '-' + this.now.format('YYYY');
        }
      }

      return this.now.format('YYYY');
    },
    economyposts: function economyposts() {
      return this.$store.state.firebase.economyposts;
    },
    clients: function clients() {
      return this.$store.state.firebase.clients;
    },
    projects: function projects() {
      return this.$store.state.firebase.projects;
    },
    clientsEconomyList: function clientsEconomyList() {
      var client_earnings = {};
      var total_amount = 0;
      var output = [];

      if (this.client_earnings_date_from && this.client_earnings_date_to) {
        var datestamp_from = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.client_earnings_date_from).unix();
        var datestamp_to = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.client_earnings_date_to).unix();
      }

      var economyposts = this.$store.state.firebase.economyposts;

      if (!economyposts) return output;

      for (var key in economyposts) {
        if (key == '.key') continue;

        var economypost = economyposts[key];
        if (!economypost.date_invoiced) continue;
        if (economypost.archived) continue;
        var project = this.$store.state.firebase.projects[economypost.project_key];
        if (!project) continue;

        if (datestamp_from && datestamp_to) {
          economypost.date_timestamp = __WEBPACK_IMPORTED_MODULE_3_moment___default()(economypost.date_invoiced).unix();
          if (economypost.date_timestamp < datestamp_from) continue;
          if (economypost.date_timestamp > datestamp_to) continue;
        }

        var client = this.$store.state.firebase.clients[project.client_key];
        if (!client_earnings[project.client_key]) client_earnings[project.client_key] = 0;
        client_earnings[project.client_key] += parseFloat(economypost.amount_dkk_ex_vat);
        total_amount += parseFloat(economypost.amount_dkk_ex_vat);
      }

      for (var x in client_earnings) {
        output.push({
          client_key: x,
          earning: client_earnings[x],
          pct: (client_earnings[x] / total_amount * 100).toFixed(2)
        });
      }

      output.sort(function (a, b) {
        return a.earning < b.earning;
      });

      return output;
    },
    clientsEconomyListPieData: function clientsEconomyListPieData() {
      var output = [];
      for (var i = 0; i < this.clientsEconomyList.length; i++) {
        var entry = this.clientsEconomyList[i];
        output.push(entry.earning);
      }
      return output.toString();
    },
    chart1: function chart1() {
      var chart = {
        columns: [{
          'type': 'string',
          'label': 'Year'
        }, {
          'type': 'number',
          'label': 'Sales'
        }, {
          'type': 'number',
          'label': 'Expenses'
        }],
        rows: [['2004', 1000, 400], ['2005', 1170, 460], ['2006', 660, 1120], ['2007', 1030, 540]],
        options: {
          title: 'Company Performance',
          hAxis: {
            title: 'Year',
            minValue: '2004',
            maxValue: '2007'
          },
          vAxis: {
            title: '',
            minValue: 300,
            maxValue: 1200
          },
          width: 900,
          height: 500,
          curveType: 'function'
        }
      };
      return chart;
    },
    needing_invoices: function needing_invoices() {
      return this.getFilteredAndTotals({
        invoiced: false,
        hypothetic: false
      });
    },
    needing_payment: function needing_payment() {
      return this.getFilteredAndTotals({
        paid: false,
        hypothetic: false
      });
    }
  },
  methods: {

    outputMoney: __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].outputMoney,
    stringPad: __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].stringPad,
    getProject: __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].getProject,

    monthName: function monthName(no) {
      var vals = ['', 'januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
      if (!vals[no]) return no;
      return vals[no];
    },
    flipBoolean: function flipBoolean(key) {
      this[key] = !this[key];
    },
    activeMonth: function activeMonth(state, getters, rootState, rootGetters) {
      return getters.getFilteredAndTotals({ place_posts_by: this.place_posts_by });
    },
    activeAccountingYear: function activeAccountingYear(state, getters, rootState, rootGetters) {
      return getters.getFilteredAndTotals({});
    },
    getFilteredAndTotals: function getFilteredAndTotals(filters) {
      return this.$store.getters['economyposts/getFilteredAndTotals'](filters);
    },
    gotoNextYear: function gotoNextYear() {
      this.month_offset += 12;
    },
    gotoPrevYear: function gotoPrevYear() {
      this.month_offset -= 12;
    },
    gotoNextMonth: function gotoNextMonth() {
      this.month_offset += 1;
    },
    gotoPrevMonth: function gotoPrevMonth() {
      this.month_offset -= 1;
    },
    gotoMonthByOffset: function gotoMonthByOffset(offset) {
      this.month_offset -= offset;
    },
    gotoMonthYear: function gotoMonthYear(month, year) {
      var targetDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().month(month - 1).year(year);
      var diff = targetDate.diff(this.now, 'days');
      diff = Math.round(diff / 30);
      this.month_offset += diff;
    },
    openEconomypost: function openEconomypost(economypost) {
      globals.modal_economypost_edit.economypost = economypost;
      globals.modal_economypost_edit.active = true;
    },
    createNewEconomypost: function createNewEconomypost() {
      var new_economypost = {
        created: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now).format('YYYY-MM-DD hh:mm:SS'),

        amount_dkk_ex_vat: 0,
        invoice_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now).format('YYYY-MM-DD'),
        payment_due_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now).format('YYYY-MM-DD')
      };
      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('economyposts').push(new_economypost);
      eventBus.$emit('toast', { text: 'Økonomipost oprettet' });
    },
    economypostTitle: function economypostTitle(economypost) {
      var t = 'Ny økonomipost';
      if (economypost.title && economypost.title.length) t = economypost.title;
      if (economypost.project_key) t = this.$store.state.firebase.projects[economypost.project_key].name;
      if (economypost.hypothetic) t = 'Hypotetisk: ' + t;
      return t;
    },
    isPostInMonth: function isPostInMonth(post, month) {
      var a = __WEBPACK_IMPORTED_MODULE_3_moment___default()(post.invoice_date, 'YYYY-MM-DD');
      var b = __WEBPACK_IMPORTED_MODULE_3_moment___default()().year(month.year).month(month.month - 1);
      console.log(a.format('YYYY-MM-DD'));
      console.log(b.format('YYYY-MM-DD'));
      return a.isSame(b, 'month');
    },
    clickMonthLabel: function clickMonthLabel(monthno, activeMonthNo) {
      console.log(monthno);
      console.log(activeMonthNo);
      var offsetAddition = monthno - activeMonthNo;

      console.log(offsetAddition);


      return;
      if (monthno < this.accounting_month_offset) {}
      this.activeMonth = monthno;
    },
    negaPosi_cls: function negaPosi_cls(input) {
      var cls = '';
      if (input > 0) cls += ' posi ';
      if (input < 0) cls += ' nega ';
      return cls;
    },
    toggle_calculate_hypothetic_posts: function toggle_calculate_hypothetic_posts() {
      this.$store.commit('economyposts/toggle_calculate_hypothetic_posts');
    }
  }, created: function created() {

    if (!this.is_admin) this.goto('/');
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generated_svg_icons_ionicons_android_time__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generated_svg_icons_ionicons_android_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_generated_svg_icons_ionicons_android_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generated_svg_icons_ionicons_android_arrow_forward__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generated_svg_icons_ionicons_android_arrow_forward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_generated_svg_icons_ionicons_android_arrow_forward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Masonry__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Masonry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Masonry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Comments__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Comments__);
















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'home',
	mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].generic],
	globals: window.globals,
	components: { Box: __WEBPACK_IMPORTED_MODULE_8__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_9__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_10__components_Avatar___default.a, Masonry: __WEBPACK_IMPORTED_MODULE_11__components_Masonry___default.a, Comments: __WEBPACK_IMPORTED_MODULE_12__components_Comments___default.a },
	data: function data() {
		return {
			user: globals.user,
			globals: globals,

			ripple1: {
				color: 'red'
			}

		};
	},

	computed: {
		my_timelogs: function my_timelogs() {
			return this.$store.getters['timelogs/my_timelogs'];
		},
		my_timelogs_this_week: function my_timelogs_this_week() {
			return this.$store.getters['timelogs/my_timelogs_this_week'];
		},
		my_timelogs_today: function my_timelogs_today() {
			return this.$store.getters['timelogs/my_timelogs_today'];
		},
		my_timelogs_yesterday: function my_timelogs_yesterday() {
			return this.$store.getters['timelogs/my_timelogs_yesterday'];
		},
		my_timelogs_today_hrs: function my_timelogs_today_hrs() {
			return this.$store.getters['timelogs/my_timelogs_today_hrs'];
		},
		my_timelogs_yesterday_hrs: function my_timelogs_yesterday_hrs() {
			return this.$store.getters['timelogs/my_timelogs_yesterday_hrs'];
		},
		my_timelogs_this_week_hrs: function my_timelogs_this_week_hrs() {
			return this.$store.getters['timelogs/my_timelogs_this_week_hrs'];
		},
		weekTimelogs_timespan: function weekTimelogs_timespan() {

			var dates = __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].moment_enumerateDaysBetweenDates(__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(6, 'days'), __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days'));
			var output = [];

			for (var i = 0; i < dates.length; i++) {
				var date = dates[i];

				var filters = {
					date_from_timestamp: date.clone().add(-1, 'days').unix(),
					date_to_timestamp: date.clone().add(-1, 'days').unix(),
					no_sorting: true
				};

				var logs = this.$store.getters['timelogs/getFiltered'](filters, this.my_timelogs_this_week);
				var hours = this.$store.getters['timelogs/getTotalHours'](logs);

				output.push({
					date: date.utc(),
					hours_logged: hours,
					title: date.format('D/M'),
					dayno: date.day()
				});
			}

			return output;
		},
		weekTimelogs_timespan_maxhours: function weekTimelogs_timespan_maxhours() {
			var o = 0;
			for (var i = 0; i < this.weekTimelogs_timespan.length; i++) {
				var d = this.weekTimelogs_timespan[i];
				if (parseFloat(d.hours_logged) > o) o = parseFloat(d.hours_logged);
			}
			return o;
		},
		my_timelogs_today_invoicable_earning: function my_timelogs_today_invoicable_earning() {
			var dkk = 0;
			if (!this.myTimelogsToday) return dkk;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.myTimelogsToday), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var timelog = _step.value;

					if (timelog.billable !== true) continue;
					var project = this.getOne('project', timelog.project_key);
					if (!project) continue;
					if (project.payment_model != 'time_expense') continue;
					dkk += project.hour_rate * timelog.hours;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return dkk;
		},
		allActiveProjects: function allActiveProjects() {
			var projects = this.$store.getters['projects/getFiltered']({
				status: 'active'
			});
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var project = _step2.value;

					project.client = this.$store.getters['clients/getOne'](project.client_key) || { name: 'Ukendt' };
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return projects;
		},
		myActiveProjects: function myActiveProjects() {
			var my_initials = this.$store.getters['users/get_initials'](this.my_user);
			var projects = this.$store.getters['projects/getFiltered']({
				tag_in: my_initials,
				status_not: 'finished'
			});
			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var project = _step3.value;

					project.client = this.$store.getters['clients/getOne'](project.client_key) || { name: 'Ukendt' };
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return projects;
		},
		projects_invoice_ready: function projects_invoice_ready() {
			var projects = this.$store.getters['projects/getFiltered']({
				tag_in: 'fakturaklar',
				status_not: 'finished'
			});
			projects = projects.filter(function (e) {
				return e.status != 'draft';
			});
			projects = projects.filter(function (e) {
				return e.status != 'aborted';
			});
			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var project = _step4.value;

					project.client = this.$store.getters['clients/getOne'](project.client_key) || { name: 'Ukendt' };
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			return projects;
		},
		projects_money_owed: function projects_money_owed() {
			var projects = this.$store.getters['projects/getFiltered']({
				status_not: 'finished'
			});
			projects = projects.filter(function (e) {
				return e.status != 'draft';
			});
			projects = projects.filter(function (e) {
				return e.status != 'aborted';
			});
			var output = [];
			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var project = _step5.value;

					var payable_amount = this.$store.getters['projects/get_payable_amount'](project);
					project.client = this.$store.getters['clients/getOne'](project.client_key) || { name: 'Ukendt' };
					if (!payable_amount) continue;
					project.payable_amount = payable_amount;
					project.invoice_ready = (project.tags || '').toLowerCase().indexOf('fakturaklar') !== -1;
					output.push(project);
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			output = output.filter(function (e) {
				return !e.invoice_ready;
			});
			return output;
		}
	},
	methods: {

		translateWorktype: __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].translateWorktype,

		delete_timelog: __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].delete_timelog,
		getClientFromTimelog: function getClientFromTimelog(timelog) {
			var p = this.getOne('project', timelog.project_key);
			var c = this.getOne('client', p.client_key);
			return c;
		},
		barHeight: function barHeight(a, b) {
			var css = {};

			if (a == undefined || isNaN(a)) a = 0;
			if (b == undefined || isNaN(b)) b = 0;

			var pct = parseInt(a / b * 100);

			if (pct < 0) pct = 0;
			if (pct > 100) pct = 100;

			css.height = pct + '%';
			return css;
		},
		gravatarurl: function gravatarurl(email, radius) {
			var baseurl = 'https://www.gravatar.com/avatar/';
			var md5_email = __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(email);
			var size = '?s=' + radius;
			return baseurl + md5_email + size;
		},
		editTimelog: function editTimelog(timelog) {
			globals.modal_timelog_edit.timelog = timelog;
			globals.modal_timelog_edit.active = true;
		},

		triggerIconSignal: __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].triggerIconSignal

	},

	mounted: function mounted() {},
	created: function created() {

		eventBus.$emit('set_bgfade_img', 'white');
	}
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabBoxes__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabBoxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TabBoxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TabBox__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TabBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_TabBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Filterbtn__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Filterbtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Filterbtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Minipctbar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Minipctbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Minipctbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Minidonut__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Minidonut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Minidonut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Tabs__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Tab__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Tab__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'kitchensink',
  components: { Box: __WEBPACK_IMPORTED_MODULE_0__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_3__components_Btn___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_4__components_Inputfield___default.a, TabBox: __WEBPACK_IMPORTED_MODULE_2__components_TabBox___default.a, TabBoxes: __WEBPACK_IMPORTED_MODULE_1__components_TabBoxes___default.a, Filterbtn: __WEBPACK_IMPORTED_MODULE_5__components_Filterbtn___default.a, Tabs: __WEBPACK_IMPORTED_MODULE_8__components_Tabs___default.a, Tab: __WEBPACK_IMPORTED_MODULE_9__components_Tab___default.a, Minipctbar: __WEBPACK_IMPORTED_MODULE_6__components_Minipctbar___default.a, Minidonut: __WEBPACK_IMPORTED_MODULE_7__components_Minidonut___default.a },
  data: function data() {
    return {
      globals: this.$parent.globals,
      filter_areas: ['boxes', 'tabs', 'buttons', 'interactions', 'inputs', 'tables', 'whatever'],
      filter_area: 'boxes',
      colors: '#666',
      var1: 'something',
      boxOpenStatus1: true, boxOpenStatus2: true, boxOpenStatus3: true,
      boxOpenStatus_a1: true, boxOpenStatus_a2: false, boxOpenStatus_a3: false,
      tabs1_activeIndex: 2,
      tabs2_activeIndex: 1,
      checkboxey12: true,
      dummy_switchval: true
    };
  },
  methods: {
    triggerToast: function triggerToast() {
      this.$toasted.show('hello billo', {
        position: 'bottom-right',
        duration: '4000'
      });
    },
    flipBoolean: function flipBoolean(key) {
      this[key] = !this[key];
    },
    setOnlyOneTrue: function setOnlyOneTrue(target_index, target_array) {
      if (this[target_array[target_index]] == true) {
        this[target_array[target_index]] = false;
      } else {
        for (var i in target_array) {
          this[target_array[i]] = i == target_index;
        }
      }
    }
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generated_svg_icons_linearicons_home__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_generated_svg_icons_linearicons_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_generated_svg_icons_linearicons_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generated_svg_icons_linearicons_hourglass__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generated_svg_icons_linearicons_hourglass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_generated_svg_icons_linearicons_hourglass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generated_svg_icons_linearicons_briefcase__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generated_svg_icons_linearicons_briefcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_generated_svg_icons_linearicons_briefcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generated_svg_icons_linearicons_chart_bars__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generated_svg_icons_linearicons_chart_bars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_generated_svg_icons_linearicons_chart_bars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generated_svg_icons_linearicons_rocket__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generated_svg_icons_linearicons_rocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_generated_svg_icons_linearicons_rocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generated_svg_icons_linearicons_user__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generated_svg_icons_linearicons_user___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_generated_svg_icons_linearicons_user__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generated_svg_icons_linearicons_users__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generated_svg_icons_linearicons_users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_generated_svg_icons_linearicons_users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generated_svg_icons_linearicons_magic_wand__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generated_svg_icons_linearicons_magic_wand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_generated_svg_icons_linearicons_magic_wand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_linearicons_pie_chart__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_linearicons_pie_chart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_linearicons_pie_chart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generated_svg_icons_linearicons_heart__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generated_svg_icons_linearicons_heart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_generated_svg_icons_linearicons_heart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generated_svg_icons_linearicons_list__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generated_svg_icons_linearicons_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_generated_svg_icons_linearicons_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_generated_svg_icons_linearicons_hand__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_generated_svg_icons_linearicons_hand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_generated_svg_icons_linearicons_hand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_generated_svg_icons_linearicons_store__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_generated_svg_icons_linearicons_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_generated_svg_icons_linearicons_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_generated_svg_icons_linearicons_calendar_full__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_generated_svg_icons_linearicons_calendar_full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_generated_svg_icons_linearicons_calendar_full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_generated_svg_icons_ionicons_ios_clock_outline__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_generated_svg_icons_ionicons_ios_clock_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_generated_svg_icons_ionicons_ios_clock_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_generated_svg_icons_ionicons_ios_calendar_outline__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_generated_svg_icons_ionicons_ios_calendar_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_generated_svg_icons_ionicons_ios_calendar_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_generated_svg_icons_logo__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_generated_svg_icons_logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_generated_svg_icons_logo__);

























/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'leftnavbar',
	components: { Avatar: __WEBPACK_IMPORTED_MODULE_1__components_Avatar___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].generic],
	data: function data() {
		return {
			app: window.globalAppData,
			spinner: false,
			bigSpinner: false,
			globals: globals
		};
	},

	computed: {},
	methods: {
		setView: function setView(viewName) {
			globals.off_canvas_menu_active = false;
			this.$router.push(viewName);
		},
		isProject: function isProject() {
			var firstBit = this.$route.path.split('/')[1];
			return firstBit == 'projects' || firstBit == 'project';
		},
		isClient: function isClient() {
			var firstBit = this.$route.path.split('/')[1];
			return firstBit == 'clients' || firstBit == 'client';
		},
		isEconomy: function isEconomy() {
			var firstBit = this.$route.path.split('/')[1];
			return firstBit == 'economy';
		},
		isTimelogs: function isTimelogs() {
			var firstBit = this.$route.path.split('/')[1];
			return firstBit == 'timelogs';
		},
		isTimelogger: function isTimelogger() {
			return globals.timelogger.visible;
		},
		incrementGlobalCount: function incrementGlobalCount() {
			globals.count++;
		},
		logOut: function logOut() {
			var sure = confirm('Ønsker du at logge ud?');
			if (!sure) return;
			__WEBPACK_IMPORTED_MODULE_0__auth_js__["a" /* default */].logout();
		},
		openTimelogger: function openTimelogger() {
			eventBus.$emit('openTimelogger');
		}
	} });

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Btn__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      globals: this.$parent.globals,
      forgotPassMode: false,
      login_pwd: undefined,
      login_user: undefined,
      password_reset_email: undefined
    };
  },
  methods: {
    doLogin: function doLogin() {
      __WEBPACK_IMPORTED_MODULE_1__auth_js__["a" /* default */].login(this.login_user, this.login_pwd);
    },
    forgotPass: function forgotPass() {}
  },
  components: { Box: __WEBPACK_IMPORTED_MODULE_2__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_3__components_Btn___default.a }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themes_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Avatar__);











/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      globals: this.$parent.globals,
      themes: __WEBPACK_IMPORTED_MODULE_3__themes_js__["a" /* default */],
      debug_output: undefined
    };
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].generic],
  computed: {
    projectsMissingAClient: function projectsMissingAClient() {
      var projects = this.$store.getters['projects/getAll'];
      var output = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var project = _step.value;

          if (!project.client_key) {
            output.push(project);
            continue;
          }
          var c = this.$store.getters['clients/getOne'](project.client_key);
          if (!c) output.push(project);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return output;
    }
  },
  methods: {
    toggle_show_beta_content: function toggle_show_beta_content() {
      this.$store.commit('toggle_show_beta_content');
    },
    toggle_show_debug_data_boxes: function toggle_show_debug_data_boxes() {
      this.$store.commit('toggle_show_debug_data_boxes');
    },
    apply_ui_theme: function apply_ui_theme(theme_key) {
      eventBus.$emit('apply_ui_theme', { theme_key: theme_key });
    },
    dbmigrate_215346: function dbmigrate_215346() {
      console.log('--> DB Migration: all projects with status not finished/active were set to draft');
      var items = this.$store.getters['projects/getAll'];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.status === 'finished') continue;
          if (item.status === 'active') continue;
          console.log(item.name + ' --- ' + item.status);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    dbmigrate_21sdfsdf46: function dbmigrate_21sdfsdf46() {
      console.log('--> DB Migration: all projects with payment_model undefined were set to fixed_price');
      var items = this.$store.getters['projects/getAll'];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          if (item.payment_model === 'fixed_price') continue;
          if (item.payment_model === 'time_expense') continue;
          __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["a" /* default */].ref('projects').child(item.key || item['.key']).update({ payment_model: 'fixed_price' });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    dbmigrate_2sfgd6: function dbmigrate_2sfgd6() {
      var _this = this;

      console.log('--> DB Migration: archive all projects without a valid client');
      var items = this.$store.getters['projects/getAll'];

      items = items.filter(function (item) {
        var client = _this.$store.getters['clients/getOne'](item.client_key);
        if (!client) return false;
        return true;
      });

      this.debug_output = items;
      return;

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          console.log(item.name + ' --- ' + item.status);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    dbmigrate_2esffwqfd: function dbmigrate_2esffwqfd() {
      console.log('--> DB Migration: change all timelogs from stringdate to unix');
      var i = 0;

      var fdb_updates = {};

      var items = this.getAll('timelogs').filter(function (e) {
        return e.created && !e.created_timestamp;
      });

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(items), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          var key = item.key || item._key || item['.key'];
          if (!key) continue;

          if (item.date && !item.date_timestamp) {}

          if (item.created && !item.created_timestamp) {
            fdb_updates['timelogs/' + key + '/created_timestamp'] = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.created, 'YYYY-MM-DD hh:mm:SS').unix();
          }

          i++;
          if (i > 100000) {
            console.log('max processed');
            break;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      console.log(fdb_updates);
    },
    dbmigrate: function dbmigrate() {}
  }, created: function created() {
    this.dbmigrate();
  },


  components: { Box: __WEBPACK_IMPORTED_MODULE_6__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_7__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_8__components_Avatar___default.a }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Filterbtn__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Filterbtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Filterbtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Minipctbar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Minipctbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Minipctbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Minidonut__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Minidonut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Minidonut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Masonry__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Masonry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Masonry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Specsheet__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Specsheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Specsheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_TimelogsList__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_TimelogsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_TimelogsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Timeline__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_FullCalendar__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_FullCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_FullCalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Comments__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Comments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Kanban__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Kanban___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Kanban__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_EconomyPosts__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_EconomyPosts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_EconomyPosts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_TagsPreview__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_TagsPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_TagsPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_generated_svg_icons_logo__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_generated_svg_icons_logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_generated_svg_icons_logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_generated_svg_icons_linearicons_briefcase__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_generated_svg_icons_linearicons_briefcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_generated_svg_icons_linearicons_briefcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_generated_svg_icons_ionicons_gear_b__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_generated_svg_icons_ionicons_gear_b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_generated_svg_icons_ionicons_gear_b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_generated_svg_icons_fontawesome_trello__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_generated_svg_icons_fontawesome_trello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_generated_svg_icons_fontawesome_trello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_generated_svg_icons_fontawesome_git__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_generated_svg_icons_fontawesome_git___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_generated_svg_icons_fontawesome_git__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_generated_svg_icons_ionicons_android_folder_open__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_generated_svg_icons_ionicons_android_folder_open___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_generated_svg_icons_ionicons_android_folder_open__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_generated_svg_icons_ionicons_ios_list_outline__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_generated_svg_icons_ionicons_ios_list_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_generated_svg_icons_ionicons_ios_list_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_generated_svg_icons_ionicons_android_options__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_generated_svg_icons_ionicons_android_options___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_generated_svg_icons_ionicons_android_options__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_generated_svg_icons_ionicons_ios_timer_outline__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_generated_svg_icons_ionicons_ios_timer_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_generated_svg_icons_ionicons_ios_timer_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_generated_svg_icons_ionicons_ios_checkmark_outline__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_generated_svg_icons_ionicons_ios_checkmark_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_generated_svg_icons_ionicons_ios_checkmark_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_generated_svg_icons_ionicons_ios_calendar_outline__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_generated_svg_icons_ionicons_ios_calendar_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_generated_svg_icons_ionicons_ios_calendar_outline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_generated_svg_icons_ionicons_ios_play_outline__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_generated_svg_icons_ionicons_ios_play_outline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_generated_svg_icons_ionicons_ios_play_outline__);







































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].generic],
  components: { Box: __WEBPACK_IMPORTED_MODULE_4__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_5__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_7__components_Avatar___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_6__components_Inputfield___default.a, Minipctbar: __WEBPACK_IMPORTED_MODULE_9__components_Minipctbar___default.a, Minidonut: __WEBPACK_IMPORTED_MODULE_10__components_Minidonut___default.a, Filterbtn: __WEBPACK_IMPORTED_MODULE_8__components_Filterbtn___default.a, Masonry: __WEBPACK_IMPORTED_MODULE_11__components_Masonry___default.a, Timeline: __WEBPACK_IMPORTED_MODULE_14__components_Timeline___default.a, FullCalendar: __WEBPACK_IMPORTED_MODULE_15__components_FullCalendar___default.a, Comments: __WEBPACK_IMPORTED_MODULE_16__components_Comments___default.a, Kanban: __WEBPACK_IMPORTED_MODULE_17__components_Kanban___default.a, EconomyPosts: __WEBPACK_IMPORTED_MODULE_18__components_EconomyPosts___default.a, Specsheet: __WEBPACK_IMPORTED_MODULE_12__components_Specsheet___default.a, TagsPreview: __WEBPACK_IMPORTED_MODULE_19__components_TagsPreview___default.a, TimelogsList: __WEBPACK_IMPORTED_MODULE_13__components_TimelogsList___default.a },
  data: function data() {
    return {
      globals: this.$parent.globals,

      activeTasklistKey: undefined,
      activeTaskKey: undefined,
      showing: 'home',
      changes: {},
      colOne: ['hey', 'der', 'dig'],
      colTwo: ['ey', 'ho', 'yo']
    };
  },
  computed: {
    project_key: function project_key() {
      return this.$route.params.id;
    },
    project: function project() {
      return this.getOne('project', this.project_key);
    },
    clients: function clients() {
      return this.getAll('clients');
    },
    clients_not_archived: function clients_not_archived() {
      return this.clients.filter(function (e) {
        return !e.archived;
      });
    },
    projectColor: function projectColor() {
      if (this.project.color) return this.project.color;

      var initials = __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getItemInitials(this.project);
      var color = __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getColorByString(initials);
      return color;
    },
    activeTask: function activeTask() {
      if (!this.activeTaskKey || !this.$store.state.firebase.tasks[this.activeTaskKey]) return undefined;
      var task = this.$store.state.firebase.tasks[this.activeTaskKey];
      task['.key'] = this.activeTaskKey;
      return task;
    },
    activeTasklist: function activeTasklist() {
      if (!this.activeTasklistKey || !this.$store.state.firebase.tasklists[this.activeTasklistKey]) return undefined;
      var tasklist = this.$store.state.firebase.tasklists[this.activeTasklistKey];
      tasklist['.key'] = this.activeTasklistKey;
      return tasklist;
    },
    project_tasks: function project_tasks() {
      var project = this.project;
      return this.tasks.filter(function (task) {
        return task.project_key == project['.key'];
      });
    },
    projectTasklists: function projectTasklists() {
      var tasklists = [];
      var list = this.$store.state.firebase.tasklists;
      for (var tasklist_key in list) {
        if (tasklist_key == '.key') continue;
        var tasklist = list[tasklist_key];
        tasklist['.key'] = tasklist_key;
        if (tasklist.project_key != this.project['.key']) continue;
        if (tasklist.archived) continue;
        tasklists.push(tasklist);
      }
      return tasklists;
    },
    hoursBooked: function hoursBooked() {
      var bookings = this.getFilteredTimebookings({
        project_key: this.project_key
      });
      var hrs = 0;
      for (var i = 0; i < bookings.length; i++) {
        var booking = bookings[i];
        hrs += booking.hours;
      }
      return hrs;
    },
    client: function client() {
      return this.$store.getters['clients/getOne'](this.project.client_key);
    },
    spec: function spec() {
      return this.$store.getters['specs/getByProjectKey'](this.project_key);
    },
    project_billable_hours_amount: function project_billable_hours_amount() {
      return this.$store.getters['projects/get_billable_hours_amount'](this.project);
    },
    project_budget: function project_budget() {
      return this.$store.getters['projects/getBudget'](this.project);
    },
    project_budgetted_hours: function project_budgetted_hours() {
      return this.$store.getters['projects/get_budgetted_hours'](this.project);
    },
    project_timelogs: function project_timelogs() {
      return this.$store.getters['timelogs/get_cached'].project[this.project_key];
    },
    project_timelogs_total_hours: function project_timelogs_total_hours() {
      return this.$store.getters['timelogs/getTotalHours'](this.project_timelogs);
    },
    project_budgetted_hours_spent_pct: function project_budgetted_hours_spent_pct() {
      return this.$store.getters['projects/get_budgetted_hours_spent_pct'](this.project, this.project_timelogs);
    },
    project_payable_amount: function project_payable_amount() {
      return this.$store.getters['projects/get_payable_amount'](this.project);
    },
    project_billable_hours: function project_billable_hours() {
      return this.$store.getters['projects/get_billable_hours'](this.project);
    },
    project_hour_rate: function project_hour_rate() {
      return this.$store.getters['projects/get_hour_rate'](this.project);
    },
    hoursTrackedMultipliedByProjectRate: function hoursTrackedMultipliedByProjectRate() {
      var hour_rate = this.project_hour_rate;
      var hours_tracked = this.project_timelogs_total_hours;
      if (!hour_rate || !hours_tracked) return 0;
      return hour_rate * hours_tracked;
    },
    calendarConfig: function calendarConfig() {
      return {
        editable: true
      };
    },
    economyposts: function economyposts() {
      return this.$store.getters['economyposts/getFilteredAndTotals']({ project_key: this.project_key });
    },
    get_invoiced_dkk: function get_invoiced_dkk() {
      return this.$store.getters['projects/get_invoiced_dkk'](this.project);
    },
    get_invoiced_and_paid_dkk: function get_invoiced_and_paid_dkk() {
      return this.$store.getters['projects/get_invoiced_and_paid_dkk'](this.project);
    },
    is_fully_invoiced: function is_fully_invoiced() {
      return this.$store.getters['projects/is_fully_invoiced'](this.project);
    },
    is_fully_invoiced_and_paid: function is_fully_invoiced_and_paid() {
      return this.$store.getters['projects/is_fully_invoiced_and_paid'](this.project);
    },
    header_css: function header_css() {
      var color = this.projectColor;
      return {
        backgroundColor: color,
        color: 'white'
      };
    }
  },
  methods: {

    getProjectDonePct: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectDonePct,
    getProjectHoursEstimate: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectHoursEstimate,
    getFilteredTimebookings: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getFilteredTimebookings,
    getProjectBudgetTotal: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectBudgetTotal,
    getProjectAcceptedSpec: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectAcceptedSpec,
    getSpecTotalHours: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getSpecTotalHours,
    getSpecTotalBudget: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getSpecTotalBudget,
    outputMoney: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].outputMoney,
    getColorByString: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getColorByString,
    getItemInitials: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getItemInitials,

    onTaskDrop: function onTaskDrop(e) {
      console.log(e);
      console.log(e.target);
    },

    change: function change(key, e) {
      var val = e.target.value;
      this.changes[key] = val;
    },
    submitChanges: function submitChanges() {
      var id = this.$route.params.id;
      var data = this.changes;

      if (!this.project.client_key) {
        eventBus.$emit('toast', { text: 'OBS: Du mangler at vælge kunde...' });
        return false;
      }

      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('projects').child(id).update(data);
      eventBus.$emit('toast', { text: 'Saved' });
    },
    incrementGlobalCount: function incrementGlobalCount() {
      window.globals.count++;
    },
    setShowing: function setShowing(input) {
      this.showing = input;
    },
    addTaskList: function addTaskList() {
      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('tasklists').push({
        name: 'Ny opgaveliste',
        project_key: this.project['.key']
      });
    },
    openTaskPopup: function openTaskPopup(task) {
      this.activeTaskKey = task['.key'];
    },
    closeTaskPopup: function closeTaskPopup() {
      this.activeTaskKey = undefined;
    },
    openTasklistPopup: function openTasklistPopup(tasklist) {
      this.activeTasklistKey = tasklist['.key'];
    },
    closeTasklistPopup: function closeTasklistPopup() {
      this.activeTasklistKey = undefined;
    },
    updateActiveTask: function updateActiveTask(fields) {
      var data = {};
      for (var i in fields) {
        var key = fields[i];
        data[key] = this.activeTask[key];
      }
      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('tasks').child(this.activeTaskKey).update(data);
    },
    updateActiveTasklist: function updateActiveTasklist(fields) {
      var data = {};
      for (var i in fields) {
        var key = fields[i];
        data[key] = this.activeTasklist[key];
      }
      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('tasklists').child(this.activeTasklistKey).update(data);
    },
    archiveTask: function archiveTask() {
      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('tasks').child(this.activeTaskKey).update({ archived: true });
      this.closeTaskPopup();
    },
    archiveTasklist: function archiveTasklist() {
      var confirmed = confirm('Sikker? Dette vil også arkivere alle opgaver på denne liste');
      if (!confirmed) return;
      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('tasklists').child(this.activeTasklistKey).update({ archived: true });
      this.archiveTasksBelongingToTasklist(this.activeTasklistKey);
      this.closeTasklistPopup();
    },
    archiveTasksBelongingToTasklist: function archiveTasksBelongingToTasklist(tasklist_key) {
      for (var i in this.tasks) {
        var task = this.tasks[i];
        if (task.tasklist_key == tasklist_key) {
          __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('tasks').child(task['.key']).update({ archived: true });
        }
      }
    },
    addTask: function addTask(tasklist) {
      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('tasks').push({
        title: 'ny task',
        done: false,
        tasklist_key: tasklist['.key'],
        project_key: this.project['.key'],
        hours_estimate: 1
      });
    },
    flipTaskDone: function flipTaskDone(task) {
      var key = task['.key'];
      var data = { done: task.done };
      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('tasks').child(key).update(data);
    },
    archiveProject: function archiveProject() {
      var confirmed = confirm('Sikker?');
      if (!confirmed) return;
      var confirmed2 = confirm('Helt sikker?');
      if (!confirmed2) return;
      __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('projects').child(this.project['.key']).update({ archived: true });
      this.$router.replace('/client/' + this.client.key);
    },
    animationDelay: function animationDelay(i) {
      var stagger = 100;
      var delay = i * stagger;
      return { 'animation-delay': delay + 'ms' };
    },
    createSpec: function createSpec() {

      if (!this.project.hour_rate) {
        this.msg('Du mangler at angive timepris for projektet...');
        return;
      }

      if (!this.project.payment_model) {
        this.msg('Du mangler at angive betalingsmodel for projektet...');
        return;
      }

      var entry = {
        type: 'fixed_prices',
        project_key: this.project.key,
        hour_rate: this.project.hour_rate,
        status: 'draft',
        created: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        taskcats: [{ title: 'Ny kategori', tasks: [] }],
        notes: '',
        showLineTotals: false,
        showCatTotals: false
      };
      if (this.project.payment_model && this.project.payment_model == 'time_expense') entry.type = 'estimates';
      if (this.project.payment_model) entry.payment_model = this.project.payment_model;
      var new_entry = __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('specs').push(entry);
      var new_entry_key = new_entry.getKey();
    },
    gotoSpec: function gotoSpec() {

      if (!this.spec && this.project.specsheetUrl) {
        if (globals.user.admin) {
          this.openURLNewWindow(this.project.specsheetUrl);
        } else {
          this.toast('Beklager - du har ikke adgang til dette...');
        }
      }

      if (!this.spec) {
        this.toast('Kravsspec mangler...');
      }
      if (this.spec) {
        this.$router.push('/spec/' + this.spec['.key']);
      }
    },
    createNewEconomypost: function createNewEconomypost() {
      var new_economypost = {
        project_key: this.project['.key'],
        created: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now).format('YYYY-MM-DD hh:mm:SS'),

        amount_dkk_ex_vat: 0,
        invoice_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now, 'YYYY-MM-DD').format('YYYY-MM-DD'),
        payment_due_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.now, 'YYYY-MM-DD').format('YYYY-MM-DD')
      };
      var new_entry = __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('economyposts').push(new_economypost);
      var new_entry_key = new_entry.getKey();

      var new_economypost = this.$store.getters['economyposts/getOne'](new_entry_key);

      console.log('new_entry_key: ' + new_entry_key, new_economypost);

      eventBus.$emit('toast', { text: 'Økonomipost oprettet' });

      globals.modal_economypost_edit.economypost = new_economypost;
      globals.modal_economypost_edit.active = true;
    }
  }, created: function created() {

    if (!this.project.hour_rate) this.toast('OBS: Der mangler angivet timepris...');
    if (!this.project.payment_model) this.toast('OBS: Der mangler angivet betalingsmodel...');
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('set_context_bgcolor', this.projectColor);

    if (this.client.bgimg_tags) {
      this.$store.commit('set_context_bgimg', null);
      var url = 'https://source.unsplash.com/1200x600/?' + this.client.bgimg_tags + '';
      __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].img_loaded(url, function () {
        setTimeout(function () {
          _this.$store.commit('set_context_bgimg', url);
        }, 300);
      });
    }
  },
  destroyed: function destroyed() {

    this.$store.commit('set_context_bgcolor', null);
    this.$store.commit('set_context_bgimg', null);
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Datatable__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Minipctbar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Minipctbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Minipctbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Minidonut__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Minidonut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Minidonut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generated_svg_icons_ionicons_ios_play__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generated_svg_icons_ionicons_ios_play___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_generated_svg_icons_ionicons_ios_play__);
















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'projects',
	mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].generic],
	data: function data() {
		return {
			globals: this.$parent.globals,
			projects_currentpage: 1,
			projects_perpage: 25
		};
	},
	computed: {
		status_filter: function status_filter() {
			return globals.projects.status_filter;
		},
		search_filter: function search_filter() {
			return globals.projects.search_filter;
		},
		filteredItems: function filteredItems() {

			var output = [];

			var projects = this.$store.getters['projects/getAll'];
			if (!projects) return output;

			var filterString = this.search_filter;
			if (!filterString || filterString == undefined || filterString == '') filterString = undefined;
			if (filterString) filterString = filterString.toLowerCase();

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var project = _step.value;


					if (project.archived) continue;

					if (this.status_filter != 'all') {
						if (project.status != this.status_filter) continue;
					}

					var client = this.$store.getters['clients/getClientByProjectKey'](project.key);

					project.budgetted_hours = this.$store.getters['projects/get_budgetted_hours'](project);
					project.budget = this.$store.getters['projects/getBudget'](project);

					if (filterString) {
						var match1 = project.name && project.name.toLowerCase().indexOf(filterString) >= 0;
						var match2 = client && client.name && client.name.toLowerCase().indexOf(filterString) >= 0;
						if (!match1 && !match2) continue;
					}

					output.push(project);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return output;
		}
	},
	methods: {

		getProjectDonePct: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectDonePct,
		getProjectHoursEstimate: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectHoursEstimate,
		getProjectBudgetTotal: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectBudgetTotal,
		getProjectAcceptedSpec: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getProjectAcceptedSpec,
		getSpecTotalHours: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getSpecTotalHours,
		getSpecTotalBudget: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].getSpecTotalBudget,
		outputMoney: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].outputMoney,

		gotoProject: function gotoProject(project) {
			this.$router.push('project/' + project['.key']);
		},
		gotoClient: function gotoClient(project) {
			this.$router.push('client/' + project.client_key);
		},
		getProjectStatus: function getProjectStatus(project) {
			if (!project.status) return;
			if (!this.globals.projectStatuses) return;
			if (!this.globals.projectStatuses[project.status]) return;
			if (!this.globals.projectStatuses[project.status].title) return;
			return this.globals.projectStatuses[project.status].title;
		},
		getProjectClient: function getProjectClient(project) {
			var client = { name: undefined };

			if (project.client_key && this.$store.state.firebase.clients && this.$store.state.firebase.clients[project.client_key]) client = this.$store.state.firebase.clients[project.client_key];
			return client;
		},
		search_filter_updated: function search_filter_updated() {
			globals.projects.search_filter = this.$refs.search_filter.value;
			globals.projects.status_filter = 'all';
			this.projects_currentpage = 1;
		},
		status_filter_updated: function status_filter_updated() {
			globals.projects.status_filter = this.$refs.status_filter.value;
			this.projects_currentpage = 1;
		},
		createNewProject: function createNewProject() {
			var new_entry = __WEBPACK_IMPORTED_MODULE_3__firebase_config_js__["a" /* default */].ref('projects').push({
				name: 'Ny opgave',
				hour_rate: 800
			});
			var new_entry_key = new_entry.getKey();
			this.$router.push('project/' + new_entry_key);
		},
		openTimelogger: function openTimelogger(input) {
			eventBus.$emit('openTimelogger', input);
		}
	},
	components: { Box: __WEBPACK_IMPORTED_MODULE_5__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_6__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_9__components_Avatar___default.a, Datatable: __WEBPACK_IMPORTED_MODULE_8__components_Datatable___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_7__components_Pagination___default.a, Minipctbar: __WEBPACK_IMPORTED_MODULE_10__components_Minipctbar___default.a, Minidonut: __WEBPACK_IMPORTED_MODULE_11__components_Minidonut___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_12__components_Inputfield___default.a }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Timeline__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Timeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FullCalendar__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FullCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_FullCalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Inputfield__);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects_timeline',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].generic],
  components: {
    Box: __WEBPACK_IMPORTED_MODULE_5__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_6__components_Btn___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_9__components_Inputfield___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_7__components_Timeline___default.a,
    FullCalendar: __WEBPACK_IMPORTED_MODULE_8__components_FullCalendar___default.a
  },
  data: function data() {
    return {
      globals: this.$parent.globals,
      user: __WEBPACK_IMPORTED_MODULE_2__auth_js__["a" /* default */].getUser(),
      projects_currentpage: 1,
      projects_perpage: 25,
      show_view_options: false,
      show_dates: false,
      show_weeks: true,
      sidebarWidth: 120,
      show_sidebar: false,
      grid_highlight_weeks: true,
      projects_filter: undefined,
      dayInitials: ['', 's', 'm', 't', 'o', 't', 'f', 'l', 's'],
      monthTitles: ['', 'januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'],
      timeline: {
        field_width: 15,
        days_back: 7,
        days_ahead: 180
      },
      expandedRows: []
    };
  },

  computed: {
    calendarConfig: function calendarConfig() {
      return {
        editable: true,
        events: this.calendarEvents,
        eventClick: this.calendarEventClicked

      };
    },
    calendarEvents: function calendarEvents() {

      var events = [];
      return events;

      var bookings = this.$store.state.db.bookings;
      for (var i = 0; i < bookings.length; i++) {
        var booking = bookings[i];
        var model = this.getModelById(booking.model_id);
        var client = this.getClientById(booking.client_id);
        if (!model) continue;
        if (!client) continue;
        events.push({
          title: model.name + ' ' + client.name + ' ' + booking.type.title,

          start: booking.datetime_start,
          end: booking.datetime_end,
          booking: booking

        });
      }

      return events;
    },
    workers: function workers() {
      var output = [];

      var list = this.$store.state.firebase.users;
      if (!list) return entries;

      for (var user_key in list) {
        if (user_key == '.key') continue;
        user['.key'] = user_key;
        if (user.first_name == 'Mikkel') continue;
        user.initials = user.email.substr(0, user.email.indexOf('@'));
        output.push(user);
      }

      return output;
    },
    timeline_row_entries: function timeline_row_entries() {
      var entries = [];

      var list = this.$store.state.firebase.projects;
      if (!list) return entries;

      var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()();

      for (var project_key in list) {
        if (project_key == '.key') continue;
        var project = list[project_key];

        project['.key'] = project_key;

        if (project.status == 'finished') continue;
        if (project.archived) continue;
        if (!project.start_date) continue;
        if (!project.end_date) continue;

        project.days_back = __WEBPACK_IMPORTED_MODULE_3_moment___default()(project.start_date).diff(now, 'days');
        project.days_ahead = __WEBPACK_IMPORTED_MODULE_3_moment___default()(project.end_date).diff(now, 'days');

        if (project.days_ahead < -this.timeline.days_back) continue;
        if (project.days_back > this.timeline.days_ahead) continue;

        var entry = {
          date_from: project.start_date,
          date_to: __WEBPACK_IMPORTED_MODULE_3_moment___default()(project.end_date).subtract(0, 'day').format('YYYY-MM-DD'),
          project: project,
          title: project.name,
          color: project.color,
          done_pct: project.done_pct,
          expanded: false
        };

        entries.push(entry);
      }

      entries.sort(function (a, b) {
        var aed = __WEBPACK_IMPORTED_MODULE_3_moment___default()(a.date_to).unix();
        var bed = __WEBPACK_IMPORTED_MODULE_3_moment___default()(b.date_to).unix();
        var comp = aed > bed;
        if (comp) {
          return 1;
        } else {
          return -1;
        }
      });

      return entries;
    },
    timeline_dates: function timeline_dates() {
      var output = [];
      var datespan = this.timeline.days_ahead + this.timeline.days_back + 1;
      for (var i = 0; i < datespan; i++) {
        var offset = i - this.timeline.days_back;
        var momente = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(offset, 'days');
        var d = parseInt(momente.format('D'));
        var m = parseInt(momente.format('MM'));
        var y = parseInt(momente.format('YY'));
        var dn = parseInt(momente.format('d')) + 1;
        var w = parseInt(momente.format('W'));
        var entry = { d: d, m: m, y: y, dn: dn, w: w };
        if (i == this.timeline.days_back) entry.today = true;
        output.push(entry);
      }
      return output;
    },
    timeline_months: function timeline_months() {
      var output = [];
      for (var i = 0; i < this.timeline_dates.length; i++) {
        var date = this.timeline_dates[i];
        var lastOutputItem = output[output.length - 1];
        if (lastOutputItem && lastOutputItem.m == date.m) {
          output[output.length - 1].days_count++;
        } else {
          output.push({
            m: date.m,
            days_count: 1
          });
        }
      }
      return output;
    },
    timeline_weeks: function timeline_weeks() {
      var output = [];
      for (var i = 0; i < this.timeline_dates.length; i++) {
        var date = this.timeline_dates[i];
        var lastOutputItem = output[output.length - 1];
        if (lastOutputItem && lastOutputItem.w == date.w) {
          output[output.length - 1].days_count++;
        } else {
          output.push({
            w: date.w,
            days_count: 1
          });
        }
      }
      return output;
    },
    timeline_content_container_css: function timeline_content_container_css() {
      var css = {};
      css.width = 'calc(100% - ' + this.sidebarWidth + 'px)';
      if (!this.show_sidebar) css.width = '100%';
      return css;
    },
    timeline_content_css: function timeline_content_css() {
      return {
        width: (this.timeline.days_ahead + 1 + this.timeline.days_back) * this.timeline.field_width + 'px'
      };
    },
    timeline_field_style_css: function timeline_field_style_css() {
      return {
        width: this.timeline.field_width + 'px'
      };
    }
  },
  methods: {
    isRowExpanded: function isRowExpanded(row_i) {
      console.log;
      if (this.expandedRows[row_i] && this.expandedRows[row_i] == true) return true;
      return false;
    },
    toggleRowExpanded: function toggleRowExpanded(row_i, boolean) {
      if (boolean === undefined) boolean = !this.isRowExpanded(row_i);
      this.$set(this.expandedRows, row_i, boolean);
    },
    timeline_get_month_days_count: function timeline_get_month_days_count(m) {
      var count = 0;
      for (var i = 0; i < this.timeline_dates.length; i++) {
        if (this.timeline_dates[i].m == m) count++;
      }return count;
    },
    timeline_month_field_css: function timeline_month_field_css(m) {
      return {
        width: this.timeline.field_width * m.days_count + 'px'
      };
    },
    timeline_week_field_css: function timeline_week_field_css(m) {
      return {
        width: this.timeline.field_width * w.days_count + 'px'
      };
    },
    timeline_field_classes: function timeline_field_classes(d) {
      var classes = {};
      if (d.today) classes.today = true;
      classes['day' + parseInt(d.dn)] = true;
      return classes;
    },
    timeline_entry_marker_css: function timeline_entry_marker_css(data) {
      var bgColor = data.color;
      var textColor = this.idealTextColor(bgColor);
      return {
        left: data.l * this.timeline.field_width + 'px',
        width: data.w * this.timeline.field_width + 'px',
        'background-color': bgColor,
        'color': textColor
      };
    },
    timeline_entry_marker_classes: function timeline_entry_marker_classes(entry) {
      var c = {};
      c.l = true;
      return c;
    },
    timeline_entry_marker_end: function timeline_entry_marker_end(side, data) {
      return {};
      var bgColor = data.color;
      var css = {
        'border-color': bgColor + ' transparent transparent transparent'
      };
      if (side == 'l') {
        css['border-width'] = '10px 10px 0 0';
        css['border-color'] = bgColor + ' transparent transparent transparent';
      }
      if (side == 'r') {
        css['border-width'] = '0 10px 10px 0';
        css['border-color'] = 'transparent ' + bgColor + ' transparent transparent';
      }
      return css;
    },
    onEntryclick: function onEntryclick(entry) {
      globals.modal_timeline_project_popup.project = entry.project;
      globals.modal_timeline_project_popup.active = true;
    },
    timeline_entry_marker_title: function timeline_entry_marker_title(data) {
      return {};
      var bgColor = data.color;
      return {
        'background-color': bgColor
      };
    },
    timeline_entry_marker_done_pct: function timeline_entry_marker_done_pct(data) {
      var done_pct = data.done_pct;
      return { 'width': done_pct + '%' };
    },
    timeline_entry_marker_project: function timeline_entry_marker_project(project, timeline) {
      var output = {};
      var todayIndex = this.timeline.days_back;

      var start_days_diff = __WEBPACK_IMPORTED_MODULE_3_moment___default()(project.start_date).diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(), 'days');
      var end_days_diff = __WEBPACK_IMPORTED_MODULE_3_moment___default()(project.end_date).diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(), 'days') + 1;

      start_days_diff += todayIndex;
      end_days_diff += todayIndex;

      var maxwidth = this.timeline.days_ahead + 1 + this.timeline.days_back - start_days_diff;

      output.w = 0;
      output.l = start_days_diff;
      if (output.l < 0) {
        output.w = output.l;
        output.l = 0;
      }
      output.w += end_days_diff - start_days_diff;
      if (output.w > maxwidth) output.w = maxwidth;

      output.color = project.color;
      if (!output.color && project.client_key) output.color = this.$store.state.firebase.clients[project.client_key].color;
      if (!output.color) output.color = '#333';

      output.done_pct = this.getProjectDonePct(project);

      return output;
    },
    show_worker_booking_indicator: function show_worker_booking_indicator(date, date_i, project) {
      if (date.today) return false;
      if (date_i < this.timeline.days_back) return false;
      if (date_i - this.timeline.days_back > project.days_ahead) return false;
      if (date_i - this.timeline.days_back < project.days_back) return false;
      return true;
    },
    get_date_worker_timebooking: function get_date_worker_timebooking(d, i, project, user) {
      var date = '20' + d.y + '-' + this.strpad(d.m, 2) + '-' + this.strpad(d.d, 2);
      for (var i = 0; i < this.timebookings.length; i++) {
        var timebooking = this.timebookings[i];
        if (timebooking.project_key != project['.key']) continue;
        if (timebooking.user_key != user['.key']) continue;
        if (timebooking.date != date) continue;
        return timebooking;
      }
    },
    get_date_worker_timebooking_value: function get_date_worker_timebooking_value(d, i, project, user) {
      var existing_timebooking = this.get_date_worker_timebooking(d, i, project, user);
      if (!existing_timebooking) return 0;
      return existing_timebooking.hours;
    },
    update_worker_booking: function update_worker_booking(e, d, i, project_i, project, user, user_i) {
      var ref = 'jh2g3' + project_i + user_i + i;
      var val = this.$refs[ref][0].value;
      val = parseFloat(val);
      if (val < 0) val = 0;
      if (val > 24) val = 24;

      var existing_booking = this.get_date_worker_timebooking(d, i, project, user);
      if (existing_booking) {
        if (val == 0) {}
        if (val > 0) {}
        var update = {
          hours: val,
          modified: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD hh:mm:SS')
        };
        __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('timebookings').child(existing_booking['.key']).update(update);
        eventBus.$emit('toast', { text: 'Booking updated: ' + val + ' hours booked' });
      }
      if (!existing_booking) {
        if (val == 0) return;
        var entry = {
          project_key: project['.key'],
          user_key: user['.key'],
          hours: val,
          date: '20' + d.y + '-' + this.strpad(d.m, 2) + '-' + this.strpad(d.d, 2),
          created: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD hh:mm:SS')
        };
        __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('timebookings').push(entry);
        eventBus.$emit('toast', { text: val + ' hours booked' });
      }
    },
    strpad: function strpad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },


    getProjectDonePct: __WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* default */].getProjectDonePct,
    getProjectHoursEstimate: __WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* default */].getProjectHoursEstimate,
    getProjectBudgetTotal: __WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* default */].getProjectBudgetTotal,
    outputMoney: __WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* default */].outputMoney,

    colorNameGetHex: __WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* default */].colorNameGetHex,
    idealTextColor: __WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* default */].idealTextColor,
    getRGBComponents: __WEBPACK_IMPORTED_MODULE_4__helpers_js__["a" /* default */].getRGBComponents,

    gotoProject: function gotoProject(project) {
      this.$router.push('project/' + project['.key']);
    },
    gotoClient: function gotoClient(project) {
      this.$router.push('client/' + project.client_key);
    },
    getprojectStatus: function getprojectStatus(project) {
      if (!project.status) return;
      if (!this.globals.projectStatuses) return;
      if (!this.globals.projectStatuses[project.status]) return;
      if (!this.globals.projectStatuses[project.status].title) return;
      return this.globals.projectStatuses[project.status].title;
    },
    getProjectClient: function getProjectClient(project) {
      var client = { name: undefined };

      if (project.client_key && this.$store.state.firebase.clients && this.$store.state.firebase.clients[project.client_key]) client = this.$store.state.firebase.clients[project.client_key];
      return client;
    },
    getFilteredItems: function getFilteredItems(items, filterString) {

      if (!filterString || filterString == undefined || filterString == '') return items;

      filterString = filterString.toLowerCase();

      items = items.filter(function (item) {
        var bool = false;
        for (var k in item) {
          var v = item[k];

          if (v.archived) return false;

          if (v.toLowerCase().indexOf(filterString) >= 0) bool = true;
        }
        return bool;
      });
      return items;
    },
    projects_filter_updated: function projects_filter_updated() {
      this.projects_currentpage = 1;
    },
    getPaginatedItems: function getPaginatedItems(items) {

      var start = this.projects_perpage * (this.projects_currentpage - 1);
      var end = this.projects_perpage * this.projects_currentpage;

      items = items.slice(start, end);

      return items;
    },
    calendarEventClicked: function calendarEventClicked(info) {

      alert(123);
      return;

      var booking_id = info.event.extendedProps.booking.id;

      this.goto('/booking/' + booking_id);
    }
  } });

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Avatar__);








/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'clients',
	mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].generic],
	components: { Box: __WEBPACK_IMPORTED_MODULE_3__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_4__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_5__components_Avatar___default.a },
	data: function data() {
		return {};
	},
	computed: {
		clients: function clients() {

			var clients = this.getAll('clients');
			clients = clients.filter(function (c) {
				return !c.archived;
			});

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {

				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(clients), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var client = _step.value;

					client.earning_dkk = this.$store.getters['clients/get_total_earning'](client);
					client.invoiced_dkk = 0;
					if (client.cvr) client.invoiced_dkk += this.$store.getters.get_dinero_invoices_total({ client_cvr: client.cvr });
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			clients.sort(function (a, b) {
				return b.invoiced_dkk - a.invoiced_dkk;
			});

			return clients;
		},
		totalInvoiced: function totalInvoiced() {
			var total = 0;
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.clients), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var client = _step2.value;
					total += client.invoiced_dkk;
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return total;
		}
	},
	methods: {}

});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Avatar__);








/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].generic],
	components: { Box: __WEBPACK_IMPORTED_MODULE_3__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_4__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_5__components_Avatar___default.a },
	data: function data() {
		return {};
	},
	computed: {
		projects_money_owed: function projects_money_owed() {

			var projects = this.getAll('projects');


			var output = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(projects), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var project = _step.value;

					project.client = this.$store.getters['clients/getOne'](project.client_key) || { name: 'Ukendt' };

					project.payable_amount = this.$store.getters['projects/get_payable_amount'](project);
					project.invoiced_and_paid = this.$store.getters['projects/get_invoiced_and_paid_dkk'](project);
					project.payable_remaining = project.payable_amount - project.invoiced_and_paid;

					project.invoice_ready = (project.tags || '').toLowerCase().indexOf('fakturaklar') !== -1;
					output.push(project);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			output = output.sort(function (a, b) {
				return b.payable_remaining - a.payable_remaining;
			});

			return output;
		}
	},
	methods: {}
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Avatar__);







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'clients',
	mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].generic],
	data: function data() {
		return {
			globals: this.$parent.globals
		};
	},
	computed: {
		allBudgetsTotal: function allBudgetsTotal() {
			var output = 0;
			var list = this.$store.state.firebase.projects;
			if (!list) return output;
			for (var project_key in list) {
				if (project_key == '.key') continue;
				var project = list[project_key];
				output += this.getProjectBudgetTotal(project);
			}
			return output;
		},
		byUsers: function byUsers() {
			var output = [];

			var list = this.$store.state.firebase.users;
			if (!list) return output;

			for (var user_key in list) {

				if (user_key == '.key') continue;
				var user = list[user_key];

				user.billable_kr = 0;

				for (var project_key in this.$store.state.firebase.projects) {

					if (project_key == '.key') continue;
					var project = this.$store.state.firebase.projects[project_key];

					var projectTimeloggedHours_by_user = this.readTimeloggedHours({ project_key: project['.key'], user_key: user['.key'] });
					var projectTimeloggedHours_total = this.readTimeloggedHours({ project_key: project['.key'] });

					var userTimeShare = projectTimeloggedHours_by_user / projectTimeloggedHours_total;
					if (isNaN(userTimeShare)) userTimeShare = 0;

					var projectBudget = this.getProjectBudgetTotal(project);

					var userBudgetShare = projectBudget * userTimeShare;

					user.billable_kr += userBudgetShare;
				}

				user.billable_pct = user.billable_kr / this.allBudgetsTotal * 100;
				user.billable_pct = parseFloat(user.billable_pct).toFixed(0);

				output.push(user);
			}
			return output;
		}
	},
	methods: {

		readTimeloggedHours: __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* default */].readTimeloggedHours,
		getProjectBudgetTotal: __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* default */].getProjectBudgetTotal,
		getProjectHoursEstimate: __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* default */].getProjectHoursEstimate,
		getProjectAcceptedSpec: __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* default */].getProjectAcceptedSpec,
		outputMoney: __WEBPACK_IMPORTED_MODULE_1__helpers_js__["a" /* default */].outputMoney,

		goto: function goto(location) {
			this.$router.push(location);
		}
	},
	components: { Box: __WEBPACK_IMPORTED_MODULE_2__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_3__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default.a }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Avatar__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clients',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].generic],
  components: { Box: __WEBPACK_IMPORTED_MODULE_2__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_3__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default.a },
  data: function data() {
    return {};
  },
  computed: {
    active_projects_beyond_end_date: function active_projects_beyond_end_date() {
      return this.$store.getters['projects/active_projects_beyond_end_date'];
    },
    projects_without_timeline: function projects_without_timeline() {
      return this.$store.getters['projects/projects_without_timeline'];
    },
    projects_without_budget: function projects_without_budget() {
      return this.$store.getters['projects/projects_without_budget'];
    },
    myUser: function myUser() {
      return this.$store.getters['users/my_user'];
    }
  },
  methods: {}
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Avatar__);







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].generic],
  data: function data() {
    return {};
  },
  computed: {},
  methods: {
    goto: function goto(location) {
      this.$router.push(location);
    }
  }, created: function created() {

    if (!this.is_admin) this.goto('/');
  },


  components: { Box: __WEBPACK_IMPORTED_MODULE_2__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_3__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_4__components_Avatar___default.a }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Specsheet__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Specsheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Specsheet__);











/* harmony default export */ __webpack_exports__["default"] = ({
	components: { Box: __WEBPACK_IMPORTED_MODULE_5__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_6__components_Btn___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_7__components_Inputfield___default.a, Specsheet: __WEBPACK_IMPORTED_MODULE_8__components_Specsheet___default.a },
	mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].generic],
	data: function data() {
		return {
			globals: this.$parent.globals
		};
	},
	computed: {
		spec_key: function spec_key() {
			return this.$route.params.id;
		},
		spec: function spec() {
			return this.$store.getters['specs/getOne'](this.spec_key);
		},
		all_projects: function all_projects() {
			var p = this.$store.getters['projects/getAll'];
			p = p.sort(function (a, b) {
				if (a.name < b.name) {
					return -1;
				}
				if (a.name > b.name) {
					return 1;
				}
				return 0;
			});
			return p;
		}
	},
	methods: {
		deleteSpec: function deleteSpec() {
			if (!confirm('Sikker?')) return;
			if (!confirm('Helt sikker?')) return;
			__WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('specs').child(this.spec.key).update({ archived: true });
			this.goto('/specs');
			this.toast('Opgavespecifikation slettet...');
		},
		save: function save() {

			globals.big_spinner = true;
			var id = this.$route.params.id;
			var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.spec));

			delete data['.key'];

			__WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('specs').child(id).update(data);

			eventBus.$emit('toast', {
				text: 'Saved'
			});
			globals.big_spinner = false;
			eventBus.$emit('triggerIconSignal', 'thumbsup');
		}
	},

	created: function created() {

		if (!this.is_admin) this.goto('/');
	}
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Datatable__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Minipctbar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Minipctbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Minipctbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Minidonut__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Minidonut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Minidonut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_ionicons_ios_play__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_ionicons_ios_play___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_ionicons_ios_play__);















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'specs',
	mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].generic],
	data: function data() {
		return {
			globals: this.$parent.globals,
			specs_currentpage: 1,
			specs_perpage: 25,
			specs_filter: undefined
		};
	},
	computed: {
		status_filter: function status_filter() {
			return globals.specs.status_filter;
		},
		search_filter: function search_filter() {
			return globals.specs.search_filter;
		},
		filteredItems: function filteredItems() {

			var output = [];

			var items = this.$store.state.firebase.specs;
			if (!items) return output;
			var filterString = this.search_filter;

			if (!filterString || filterString == undefined || filterString == '') filterString = undefined;
			if (filterString) filterString = filterString.toLowerCase();

			for (var spec_key in items) {

				var spec = items[spec_key];
				if (spec == 'specs') continue;

				spec['.key'] = spec_key;

				if (this.status_filter != 'archived' && spec.archived) continue;

				if (this.status_filter == 'archived') {
					if (!spec['archived'] || spec.archived != true) continue;
				}

				if (this.status_filter != 'all') {
					if (spec.status != this.status_filter) continue;
				}

				var project = this.$store.state.firebase.projects[spec.project_key];
				if (project) {
					var client = this.$store.state.firebase.clients[project.client_key];
				}

				if (filterString) {
					var match1 = spec.title.toLowerCase().indexOf(filterString) >= 0;
					if (project) var match2 = project.name.toLowerCase().indexOf(filterString) >= 0;
					if (client) var match3 = client.name.toLowerCase().indexOf(filterString) >= 0;
					if (!project && !match1) continue;
					if (!client && !(match1 || match2)) continue;
					if (!(match1 || match2 || match3)) continue;
				}

				output.push(spec);
			}

			return output;
		},
		clients: function clients() {
			return this.$store.state.firebase.clients;
		},
		projects: function projects() {
			return this.$store.state.firebase.projects;
		}
	},
	methods: {

		outputMoney: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].outputMoney,
		readTimeloggedHours: __WEBPACK_IMPORTED_MODULE_2__helpers_js__["a" /* default */].readTimeloggedHours,

		search_filter_updated: function search_filter_updated() {
			globals.specs.search_filter = this.$refs.search_filter.value;
			globals.specs.status_filter = 'all';
		},
		status_filter_updated: function status_filter_updated() {
			globals.specs.status_filter = this.$refs.status_filter.value;
		},
		gotoSpec: function gotoSpec(spec) {
			this.$router.push('spec/' + spec['.key']);
		},
		goto: function goto(url) {
			this.$router.push(url);
		},
		getSpecStatus: function getSpecStatus(spec) {
			if (!spec.status) return;
			if (!this.$store.state.specs.statuses) return;
			if (!this.$store.state.specs.statuses[spec.status]) return;
			if (!this.$store.state.specs.statuses[spec.status].title) return;
			return this.$store.state.specs.statuses[spec.status].title;
		},
		getSpecType: function getSpecType(spec) {
			if (!spec.status) return;
			if (!this.$store.state.specs.types) return;
			if (!this.$store.state.specs.types[spec.type]) return;
			if (!this.$store.state.specs.types[spec.type].title) return;
			return this.$store.state.specs.types[spec.type].title;
		},
		getProject: function getProject(spec) {
			if (!spec['project_key']) return;
			var project = this.$store.state.firebase.projects[spec.project_key];
			if (project) return project;
		},
		getClient: function getClient(spec) {
			var project = this.getProject(spec);
			if (!project) return;
			var client = this.$store.state.firebase.clients[project.client_key];
			if (client) return client;
		},
		getSpecClient: function getSpecClient(spec) {
			return;
			var client = {
				name: undefined
			};

			if (spec.client_key && this.$store.state.firebase.clients && this.$store.state.firebase.clients[spec.client_key]) client = this.$store.state.firebase.clients[spec.client_key];
			return client;
		},
		getFilteredItems: function getFilteredItems(items, filterString) {

			if (!filterString || filterString == undefined || filterString == '') return items;

			filterString = filterString.toLowerCase();

			items = items.filter(function (item) {
				var bool = false;
				for (var k in item) {
					var v = item[k];

					if (v.archived) return false;

					if (v.toLowerCase().indexOf(filterString) >= 0) bool = true;
				}
				return bool;
			});

			items = items.sort(function (a, b) {
				return b.project_key > a.project_key;
			});

			return items;
		},
		specs_filter_updated: function specs_filter_updated() {
			this.specs_currentpage = 1;
		},
		getPaginatedItems: function getPaginatedItems(items) {

			var start = this.specs_perpage * (this.specs_currentpage - 1);
			var end = this.specs_perpage * this.specs_currentpage;

			items = items.slice(start, end);

			return items;
		},
		listspecs: function listspecs() {
			var items = [];

			for (var i in this.specs) {
				var spec = this.specs[i];
				if (spec.archived) continue;
				items.push(spec);
			}

			return items;
		},
		paginationUpdate: function paginationUpdate(page) {
			this.specs_currentpage = page;
		},
		incrementGlobalCount: function incrementGlobalCount() {
			window.globals.count++;
		},
		createNewSpec: function createNewSpec() {
			eventBus.$emit('spec_create_new');
		},
		specGetBudget: function specGetBudget(spec) {
			var total_hrs = 0;
			for (var i in spec.taskcats) {
				var taskcat = spec.taskcats[i];
				for (var i in taskcat.tasks) {
					var task = taskcat.tasks[i];
					if (task.optional == false) continue;
					total_hrs += parseFloat(task.hours);
				}
			}
			return spec.hour_rate * total_hrs;
		}
	}, created: function created() {

		if (!this.is_admin) this.goto('/');
	},


	components: { Box: __WEBPACK_IMPORTED_MODULE_3__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_4__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_7__components_Avatar___default.a, Datatable: __WEBPACK_IMPORTED_MODULE_6__components_Datatable___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_5__components_Pagination___default.a, Minipctbar: __WEBPACK_IMPORTED_MODULE_8__components_Minipctbar___default.a, Minidonut: __WEBPACK_IMPORTED_MODULE_9__components_Minidonut___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_10__components_Inputfield___default.a }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Filterbtn__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Filterbtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Filterbtn__);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      globals: this.$parent.globals,
      themes: __WEBPACK_IMPORTED_MODULE_1__themes_js__["a" /* default */],

      edited_theme: {}

    };
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].generic],
  components: { Box: __WEBPACK_IMPORTED_MODULE_4__components_Box___default.a, Btn: __WEBPACK_IMPORTED_MODULE_5__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_6__components_Avatar___default.a, Filterbtn: __WEBPACK_IMPORTED_MODULE_7__components_Filterbtn___default.a },
  computed: {
    active_theme_key: function active_theme_key() {
      return localStorage.getItem('user_theme_key');
    },
    active_theme: function active_theme() {
      if (!this.active_theme_key) return;
      if (!this.themes) return;
      if (this.active_theme_key == 'custom') {
        return JSON.parse(localStorage.getItem('user_theme_custom'));
      }
      return this.themes[this.active_theme_key];
    }
  },
  methods: {
    updateTheme: function updateTheme(key, e) {

      var val = e.target.value;
      this.edited_theme[key] = val;

      eventBus.$emit('apply_ui_theme', { theme_key: 'custom', theme: this.edited_theme });
    }
  }, mounted: function mounted() {

    this.edited_theme = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.active_theme));
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generated_svg_icons_linearicons_trash__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generated_svg_icons_linearicons_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_generated_svg_icons_linearicons_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_linearicons_cross__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_linearicons_cross___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_generated_svg_icons_linearicons_cross__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generated_svg_icons_ionicons_checkmark__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generated_svg_icons_ionicons_checkmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_generated_svg_icons_ionicons_checkmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generated_svg_icons_ionicons_ios_plus_empty__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generated_svg_icons_ionicons_ios_plus_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_generated_svg_icons_ionicons_ios_plus_empty__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Box: __WEBPACK_IMPORTED_MODULE_7__components_Box___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_9__components_Inputfield___default.a, Btn: __WEBPACK_IMPORTED_MODULE_8__components_Btn___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_5__mixins_js__["a" /* default */].generic],
  name: 'timelogger',
  data: function data() {
    return {
      globals: this.$parent.globals,
      user: globals.user
    };
  },
  computed: {
    worktypes: function worktypes() {
      var output = [];
      for (var i = 0; i < globals.worktypes.length; i++) {
        var worktype = globals.worktypes[i];
        if (worktype.legacy) continue;
        output.push(worktype);
      }
      return output;
    },
    addList: function addList() {
      return globals.timelogger.addList;
    },
    projectSelectOptions: function projectSelectOptions() {
      var output = [];
      for (var project_key in this.$store.state.firebase.projects) {
        var project = this.$store.state.firebase.projects[project_key];
        var client = this.$store.state.firebase.clients[project.client_key];
        var label = project.name;
        if (client) label = project.name + ' - ' + client.name;

        if (!project.status || project.status == 'finished') continue;

        if (!project_key) continue;
        if (project_key == '.key') continue;
        output.push({
          value: project_key,
          label: label
        });
      }

      return output;
    }
  },
  methods: {
    somethingToSubmit: function somethingToSubmit() {
      var totals = this.getAddListTotalHoursCount();
      if (totals == undefined) return false;
      if (totals == 0) return false;
      return true;
    },
    multiSelectOnSelect: function multiSelectOnSelect(instance, e, entry) {
      if (instance == 'project') this.$set(entry, 'project_key', e.value);
      if (instance == 'worktype') this.$set(entry, 'worktype', e.value);
    },
    multiSelectGetOption: function multiSelectGetOption(options, key, val) {
      if (!options) return;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;
          if (option[key] == val) return option;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },


    getUserbyUID: __WEBPACK_IMPORTED_MODULE_6__helpers_js__["a" /* default */].getUserbyUID,
    triggerIconSignal: __WEBPACK_IMPORTED_MODULE_6__helpers_js__["a" /* default */].triggerIconSignal,
    getLastTimelogs: __WEBPACK_IMPORTED_MODULE_6__helpers_js__["a" /* default */].getLastTimelogs,

    createNewTimelogs: function createNewTimelogs() {

      var my_user_key = this.getUserbyUID(globals.user.uid)['.key'];
      if (!my_user_key) return;

      for (var i = 0; i < this.addList.length; i++) {
        var entry = this.addList[i];
        if (!this.lineIsReady(i)) continue;
        var new_timelog = {
          project_key: entry.project_key,

          worktype: entry.worktype,
          hours: entry.hours,
          date: entry.date,
          date_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()(entry.date, 'YYYY-MM-DD').unix(),
          billable: entry.billable,
          created: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD hh:mm:SS'),
          created_timestamp: __WEBPACK_IMPORTED_MODULE_3_moment___default()().unix(),
          user_key: my_user_key
        };
        if (entry.title) new_timelog.title = entry.title;
        __WEBPACK_IMPORTED_MODULE_2__firebase_config_js__["a" /* default */].ref('timelogs').push(new_timelog);
        entry.inserted = true;
      }

      for (var i = 0; i < this.addList.length; i++) {
        var entry = this.addList[i];
        if (entry.inserted) this.stripEntry();
      }

      this.closeTimelogger();
      this.triggerIconSignal('heart');
    },
    getAddListTotalHoursCount: function getAddListTotalHoursCount() {
      var count = 0;
      for (var i = 0; i < this.addList.length; i++) {
        var entry = this.addList[i];
        if (!this.lineIsReady(i)) continue;
        count += entry.hours;
      }
      return count;
    },
    addEmptyRow: function addEmptyRow() {
      globals.timelogger.addList.push({
        project_key: undefined,
        hours: 0,
        billable: true,
        date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
        title: undefined
      });
    },
    stripEntry: function stripEntry(i) {
      globals.timelogger.addList.splice(i, 1);
    },
    dupeLineBelow: function dupeLineBelow(i) {
      var line = globals.timelogger.addList[i];
      var newLine = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(line));
      globals.timelogger.addList.splice(i, 0, newLine);
      this.$set(entry, 'project_key', e.value);
    },
    lineIsReady: function lineIsReady(i) {
      var row = this.addList[i];
      if (!row) return false;
      if (!row.project_key) return false;

      if (!row.worktype) return false;
      if (!row.hours) return false;
      if (!row.title) return false;
      return true;
    },


    getProject: __WEBPACK_IMPORTED_MODULE_6__helpers_js__["a" /* default */].getProject,
    getClient: __WEBPACK_IMPORTED_MODULE_6__helpers_js__["a" /* default */].getClient,

    resetLinesToDefaultState: function resetLinesToDefaultState() {},
    openTimelogger: function openTimelogger(input) {
      if (input && input['project_key']) {
        while (this.addList.length > 0) {
          globals.timelogger.addList.pop();
        }
        globals.timelogger.addList.push({
          project_key: input.project_key,
          hours: 1,
          date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
          billable: true
        });
      }
      if (!this.addList.length) eventBus.$emit('timelogger_addEmptyRow');
      globals.timelogger.visible = true;
    },
    fetchLastProjects: function fetchLastProjects() {

      var lastTimelogs = this.getLastTimelogs(6);

      for (var i = 0; i < lastTimelogs.length; i++) {
        var log = lastTimelogs[i];

        globals.timelogger.addList.push({
          project_key: log.project_key,
          billable: true,
          date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
        });
      }
    },
    closeTimelogger: function closeTimelogger() {
      globals.timelogger.visible = false;
    }
  }, created: function created() {

    var _this = this;

    eventBus.$on('timelogger_addEmptyRow', function () {
      _this.addEmptyRow();
    });

    eventBus.$on('openTimelogger', function (input) {
      _this.openTimelogger(input);
    });
    eventBus.$on('closeTimelogger', function () {
      _this.closeTimelogger();
    });
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pagination__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Minipctbar__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Minipctbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Minipctbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Minidonut__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Minidonut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Minidonut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_multiselect__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_generated_svg_icons_linearicons_trash__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_generated_svg_icons_linearicons_trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_generated_svg_icons_linearicons_trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_generated_svg_icons_linearicons_pencil__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_generated_svg_icons_linearicons_pencil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_generated_svg_icons_linearicons_pencil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_peity__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_peity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_peity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_js_file_download__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_js_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_js_file_download__);






















/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Box: __WEBPACK_IMPORTED_MODULE_7__components_Box___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_9__components_Inputfield___default.a, Btn: __WEBPACK_IMPORTED_MODULE_8__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_12__components_Avatar___default.a, Datatable: __WEBPACK_IMPORTED_MODULE_11__components_Datatable___default.a, Pagination: __WEBPACK_IMPORTED_MODULE_10__components_Pagination___default.a, Minipctbar: __WEBPACK_IMPORTED_MODULE_13__components_Minipctbar___default.a, Minidonut: __WEBPACK_IMPORTED_MODULE_14__components_Minidonut___default.a, Multiselect: __WEBPACK_IMPORTED_MODULE_15_vue_multiselect___default.a, Peity: __WEBPACK_IMPORTED_MODULE_18_vue_peity___default.a },
  name: 'timelogs',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_6__mixins_js__["a" /* default */].generic],
  data: function data() {
    return {
      globals: this.$parent.globals,
      user: __WEBPACK_IMPORTED_MODULE_4__auth_js__["a" /* default */].getUser(),
      filter_date_from: undefined,
      filter_date_to: undefined,
      filter_user_key: undefined,
      filter_project_key: undefined,
      filter_client_key: undefined,
      editing_timelog_key: undefined,
      pieChartColors: globals.pieChartColors,

      transferTimelogsModal: false,
      transferTimelogsProjectA: undefined,
      transferTimelogsProjectB: undefined,
      filter_only_billable: false,

      blockFilterUpdates: false

    };
  },
  computed: {
    all_timelogs_count: function all_timelogs_count() {
      return this.$store.getters['timelogs/getAll'].length;
    },
    filter_date_from_timestamp: function filter_date_from_timestamp() {
      if (!this.filter_date_from) return;
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_from).unix();
    },
    filter_date_to_timestamp: function filter_date_to_timestamp() {
      if (!this.filter_dateto) return;
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_dateto).unix();
    },
    users: function users() {
      return this.$store.state.firebase.users;
    },
    clients: function clients() {
      return this.$store.state.firebase.clients;
    },
    projects: function projects() {
      return this.$store.state.firebase.projects;
    },
    userSelectOptions: function userSelectOptions() {
      var options = [];
      options.push({ value: undefined, label: 'Alle' });
      var items = this.$store.state.firebase.users;
      if (!items) return options;
      for (var key in items) {
        if (key == '.key') continue;
        var user = items[key];
        user['.key'] = key;
        if (!user.first_name) continue;
        var option = { value: user['.key'], label: user.first_name };
        options.push(option);
      }
      return options;
    },
    clientSelectOptions: function clientSelectOptions() {
      var options = [];
      options.push({ value: undefined, label: 'Alle' });
      var items = this.$store.state.firebase.clients;
      if (!items) return options;
      for (var key in items) {
        if (key == '.key') continue;
        var client = items[key];
        client['.key'] = key;
        if (!client.name) continue;
        var option = { value: client['.key'], label: client.name };
        options.push(option);
      }
      return options;
    },
    projectSelectOptions: function projectSelectOptions() {
      var options = [];
      options.push({ value: undefined, label: 'Alle' });

      if (!this.$store.state.firebase.clients) return options;

      var list = this.$store.state.firebase.projects;
      for (var project_key in list) {
        if (project_key == '.key') continue;
        var project = list[project_key];
        project['.key'] = project_key;

        if (!project.name) continue;
        if (this.filter_client_key && project.client_key != this.filter_client_key) continue;
        var option = { value: project['.key'], label: project.name };
        options.push(option);
      }
      return options;
    },
    filterClientSelectOptions: function filterClientSelectOptions() {
      var output = [];
      for (var client_key in this.$store.state.firebase.clients) {
        var client = this.$store.state.firebase.clients[client_key];
        var label = client.name;

        output.push({
          value: client_key,
          label: client.name
        });
      }

      return output;
    },
    cachefiltered_timelogs: function cachefiltered_timelogs() {
      var timelogs = [];
      if (this.filter_user_key && !this.filter_client_key && !this.filter_project_key) timelogs = this.$store.getters['timelogs/get_cached'].user[this.filter_user_key];
      if (!this.filter_user_key && this.filter_client_key && !this.filter_project_key) timelogs = this.$store.getters['timelogs/get_cached'].client[this.filter_client_key];
      if (!this.filter_user_key && !this.filter_client_key && this.filter_project_key) timelogs = this.$store.getters['timelogs/get_cached'].project[this.filter_project_key];
      return timelogs;
    },
    filteredTimelogs: function filteredTimelogs() {

      var cachefiltered_timelogs = this.cachefiltered_timelogs;

      if (this.filter_user_key && !this.filter_client_key && !this.filter_project_key) var cached_timelogs = this.$store.getters['timelogs/get_cached'].user[this.filter_user_key];
      if (!this.filter_user_key && this.filter_client_key && !this.filter_project_key) var cached_timelogs = this.$store.getters['timelogs/get_cached'].client[this.filter_client_key];
      if (!this.filter_user_key && !this.filter_client_key && this.filter_project_key) var cached_timelogs = this.$store.getters['timelogs/get_cached'].project[this.filter_project_key];

      if (!cachefiltered_timelogs.length) cachefiltered_timelogs = undefined;

      var timelogs = this.$store.getters['timelogs/getFiltered']({
        user_key: this.filter_user_key,
        project_key: this.filter_project_key,
        client_key: this.filter_client_key,
        date_from_timestamp: this.filter_date_from_timestamp,
        date_to_timestamp: this.filter_date_to_timestamp,
        only_billable: this.filter_only_billable,
        no_sorting: true
      }, cachefiltered_timelogs);

      timelogs = this.$store.getters['timelogs/sort_newest'](timelogs);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(timelogs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timelog = _step.value;

          timelog.user = this.$store.getters.getOne('user', timelog.user_key);
          timelog.project = this.$store.getters.getOne('project', timelog.project_key);
          timelog.client = this.$store.getters.getOne('client', timelog.project.client_key);
          timelog.worktype_translated = this.translateWorktype(timelog.worktype);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return timelogs;
    },
    getListedTimelogStats: function getListedTimelogStats() {

      var output = {
        hours_total: 0,
        clients: {},
        projects: {},
        users: {},
        worktypes: {}
      };
      var timelogs = this.filteredTimelogs;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(timelogs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var timelog = _step2.value;

          if (timelog.hours) output.hours_total += parseFloat(timelog.hours);

          if (output.clients[timelog.client_key] == undefined) output.clients[timelog.client.key] = 0;
          output.clients[timelog.client.key] += parseFloat(timelog.hours);

          if (output.projects[timelog.project_key] == undefined) output.projects[timelog.project_key] = 0;
          output.projects[timelog.project_key] += parseFloat(timelog.hours);

          if (output.users[timelog.user_key] == undefined) output.users[timelog.user_key] = 0;

          output.users[timelog.user_key] += parseFloat(timelog.hours);

          if (output.worktypes[timelog.worktype] == undefined) output.worktypes[timelog.worktype] = 0;
          output.worktypes[timelog.worktype] += parseFloat(timelog.hours);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var temp = [];
      for (var key in output.clients) {
        temp.push({ client: this.getOne('client', key), value: output.clients[key] });
      }temp.sort(function (a, b) {
        return b.value - a.value;
      });
      output.clients = temp;

      var temp = [];
      for (var _key in output.projects) {
        temp.push({ project: this.getOne('project', _key), value: output.projects[_key] });
      }temp.sort(function (a, b) {
        return b.value - a.value;
      });
      output.projects = temp;

      var temp = [];
      for (var _key2 in output.users) {
        temp.push({ user: this.getOne('user', _key2), value: output.users[_key2] });
      }temp.sort(function (a, b) {
        return b.value - a.value;
      });
      output.users = temp;

      var temp = [];
      for (var _key3 in output.worktypes) {
        temp.push({ key: _key3, value: output.worktypes[_key3] });
      }temp.sort(function (a, b) {
        return b.value - a.value;
      });
      output.worktypes = temp;

      return output;
    },
    clientsPieData: function clientsPieData() {
      var entries = this.getListedTimelogStats.clients;
      var levels = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(entries, 'value');
      return levels.toString();
    },
    projectsPieData: function projectsPieData() {
      var entries = this.getListedTimelogStats.projects;
      var levels = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(entries, 'value');
      return levels.toString();
    },
    usersPieData: function usersPieData() {
      var entries = this.getListedTimelogStats.users;
      var levels = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(entries, 'value');
      return levels.toString();
    },
    worktypesPieData: function worktypesPieData() {
      var entries = this.getListedTimelogStats.worktypes;
      var levels = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(entries, 'value');
      return levels.toString();
    },
    timespanDates: function timespanDates() {

      if (!this.filteredTimelogs || this.filteredTimelogs.length > 500) return [];

      var dates = __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].moment_enumerateDaysBetweenDates(this.filter_date_from, __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_to).add(1, 'days'));
      var output = [];

      console.log('timespanDates');

      for (var i = 0; i < dates.length; i++) {
        var date = dates[i];

        var filters = {
          date_from_timestamp: date.clone().add(-1, 'days').unix(),
          date_to_timestamp: date.clone().add(-1, 'days').unix()
        };

        var logs = this.$store.getters['timelogs/getFiltered'](filters, this.filteredTimelogs);
        var hours = this.$store.getters['timelogs/getTotalHours'](logs);

        output.push({
          date: date.utc(),
          hours_logged: hours,
          title: date.format('D/M'),
          dayno: date.day()
        });
      }

      return output;
    },
    maxHoursLoggedInTimeSpanDates: function maxHoursLoggedInTimeSpanDates() {
      var o = 0;

      for (var i = 0; i < this.timespanDates.length; i++) {
        var d = this.timespanDates[i];
        if (parseFloat(d.hours_logged) > o) o = parseFloat(d.hours_logged);
      }

      return o;
    }
  },

  methods: {
    filter_date_from_change: function filter_date_from_change(e) {
      this.filter_date_from = e.target.value;
    },
    filter_date_to_change: function filter_date_to_change(e) {
      this.filter_date_to = e.target.value;
    },
    barHeight: function barHeight(a, b) {
      var css = {};

      if (a == undefined || isNaN(a)) a = 0;
      if (b == undefined || isNaN(b)) b = 0;

      var pct = parseInt(a / b * 100);

      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;

      css.height = pct + '%';
      return css;
    },

    translateWorktype: __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].translateWorktype,

    editTimelog: function editTimelog(timelog) {
      globals.modal_timelog_edit.timelog = timelog;
      globals.modal_timelog_edit.active = true;
    },
    multiSelectOnSelect: function multiSelectOnSelect(item_key, activeOption) {
      var value = activeOption.value;


      this.$set(this, item_key, value);
    },
    gotoClient: function gotoClient(input) {
      var a = 'client/',
          b;
      if (typeof input == 'string') b = input;
      if (typeof input != 'string') b = input['.key'];
      this.$router.push(a + b);
    },
    gotoProject: function gotoProject(input) {
      var a = 'project/',
          b;
      if (typeof input == 'string') b = input;
      if (typeof input != 'string') b = input['.key'];
      this.$router.push(a + b);
    },
    setTimeframe: function setTimeframe(timeframe) {
      var from_date, to_date;
      if (timeframe == 'today') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      }
      if (timeframe == 'this-month') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('month');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('month');
      }
      if (timeframe == 'last-7-days') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(7, 'days');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      }
      if (timeframe == 'last-14-days') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(14, 'days');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      }
      if (timeframe == 'last-30-days') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(30, 'days');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      }
      if (timeframe == 'last-90-days') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(90, 'days');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      }
      if (timeframe == 'one-day-back') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_from).subtract(1, 'days');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_to).subtract(1, 'days');
      }
      if (timeframe == 'one-day-forward') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_from).add(1, 'days');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_to).add(1, 'days');
      }
      if (timeframe == 'one-week-back') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_from).subtract(1, 'weeks');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_to).subtract(1, 'weeks');
      }
      if (timeframe == 'one-week-forward') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_from).add(1, 'weeks');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_to).add(1, 'weeks');
      }
      if (timeframe == 'one-month-back') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_from).subtract(1, 'months');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_to).subtract(1, 'months');
        if (from_date.date() == 1) to_date = to_date.endOf('month');
      }
      if (timeframe == 'one-month-forward') {
        from_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_from).add(1, 'months');
        to_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filter_date_to).add(1, 'months');
        if (from_date.date() == 1) to_date = to_date.endOf('month');
      }
      this.filter_date_from = from_date.format('YYYY-MM-DD');
      this.filter_date_to = to_date.format('YYYY-MM-DD');
    },
    nicedate: function nicedate(date, format) {
      if (!format) format = 'YYYY-MM-DD';
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format(format);
    },


    delete_timelog: __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].delete_timelog,
    roundToDecs: __WEBPACK_IMPORTED_MODULE_5__helpers_js__["a" /* default */].roundToDecs,

    openTimelogger: function openTimelogger() {
      eventBus.$emit('openTimelogger');
    },
    timelogListDateSpacerBoolean: function timelogListDateSpacerBoolean(filteredTimelogs, i) {
      if (i == 0) return false;
      var timelog = filteredTimelogs[i];
      var timelog_prev = filteredTimelogs[i - 1];
      return timelog.date != timelog_prev.date;
    },
    dateFormat: function dateFormat(date, format) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format(format);
    },
    multiSelectGetOption: function multiSelectGetOption(options, key, val) {
      if (!options) return;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(options), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var option = _step3.value;
          if (option[key] == val) return option;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    transferTimelogs: function transferTimelogs() {

      var input = {
        project_a: this.transferTimelogsProjectA,
        project_b: this.transferTimelogsProjectB
      };

      if (input.project_a == input.project_b) {
        eventBus.$emit('toast', { text: 'Vælg to forskellige opgaver...' });
        return false;
      }

      var confirmed = confirm('Dette vil øverføre ALLE tidsloggings fra ' + getOne(input.project_a).name + ' til ' + getOne(input.project_b).name + '. Dette vil IKKE kunne fortrydes. Er du sikker?');
      if (!confirmed) return;

      var updated_count = 0;

      var list = this.$store.state.firebase.timelogs;
      for (var timelog_key in list) {
        if (timelog_key == '.key') continue;
        var timelog = list[timelog_key];

        if (timelog.project_key == input.project_a) {
          __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('timelogs').child(timelog_key).update({ project_key: input.project_b });
          updated_count++;
        }
      }

      eventBus.$emit('toast', { text: updated_count + ' timelogs overført' });
    },
    exportTimelogs: function exportTimelogs() {
      var logs = this.filteredTimelogs;

      var o = 'Dato,Arbejdstimer,Navn,Tekst' + "\r\n";
      for (var i = 0; i < logs.length; i++) {
        var log = logs[i];
        var user = this.getOne('user', log.user_key);
        o += log.date + ',';
        o += log.hours + ',';
        o += user.first_name + ',';
        o += '"' + (log.title || '') + '"';
        o += "\r\n";
      }
      o += "\r\n";
      o += this.filteredTimelogs.length + ' timelogs,';
      o += this.getListedTimelogStats.hours_total + ' arbejdstimer';

      var d1 = this.dateFormat(this.filter_date_from, 'DD-MM-YY');
      var d2 = this.dateFormat(this.filter_date_to, 'DD-MM-YY');

      var filename = 'Milk Studio - Timelogs ' + d1 + ' - ' + d2 + '.csv';

      __WEBPACK_IMPORTED_MODULE_19_js_file_download___default()(o, filename);
    }
  }, created: function created() {

    this.filter_date_from = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'week').format('YYYY-MM-DD');
    this.filter_date_to = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');

    if (this.$route.params.user != 'any') this.filter_user_key = this.$route.params.user;
    if (this.$route.params.client != 'any') this.filter_client_key = this.$route.params.client;
    if (this.$route.params.project != 'any') this.filter_project_key = this.$route.params.project;
    if (this.$route.params.from_date != 'any') this.filter_from_date = this.$route.params.from_date;
    if (this.$route.params.to_date != 'any') this.filter_to_date = this.$route.params.to_date;
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Avatar__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Avatar__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Box: __WEBPACK_IMPORTED_MODULE_2__components_Box___default.a, Inputfield: __WEBPACK_IMPORTED_MODULE_4__components_Inputfield___default.a, Btn: __WEBPACK_IMPORTED_MODULE_3__components_Btn___default.a, Avatar: __WEBPACK_IMPORTED_MODULE_5__components_Avatar___default.a },
  name: 'users',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_0__mixins_js__["a" /* default */].generic],
  data: function data() {
    return {
      globals: this.$parent.globals
    };
  },
  methods: {} });

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Comments__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Comments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Box__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Btn__);











/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_2__mixins_js__["a" /* default */].generic],
	components: { Inputfield: __WEBPACK_IMPORTED_MODULE_4__components_Inputfield___default.a, Btn: __WEBPACK_IMPORTED_MODULE_7__components_Btn___default.a, Comments: __WEBPACK_IMPORTED_MODULE_5__components_Comments___default.a, Box: __WEBPACK_IMPORTED_MODULE_6__components_Box___default.a },
	data: function data() {
		return {
			app: window.globalAppData,
			globals: globals,

			closeOnDimmerClick: true
		};
	},

	computed: {
		economypost: function economypost() {
			return globals.modal_economypost_edit.economypost;
		},
		projects: function projects() {
			return this.$store.state.firebase.projects;
		},
		clients: function clients() {
			return this.$store.state.firebase.clients;
		}
	},
	methods: {

		getProjectBudgetTotal: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].getProjectBudgetTotal,
		getProjectAcceptedSpec: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].getProjectAcceptedSpec,
		outputMoney: __WEBPACK_IMPORTED_MODULE_3__helpers_js__["a" /* default */].outputMoney,

		onDimmerClick: function onDimmerClick() {
			if (this.closeOnDimmerClick) this.close();
		},
		close: function close() {
			globals.modal_economypost_edit.active = false;
		},
		save: function save() {
			var key = this.economypost['.key'];
			var economypost = this.economypost;

			var patch = {
				client_key: economypost.client_key,
				project_key: economypost.project_key,
				title: economypost.title,
				note: economypost.note,
				amount_dkk_ex_vat: economypost.amount_dkk_ex_vat,
				invoice_date: economypost.invoice_date,
				invoiced: economypost.invoiced,
				payment_due_date: economypost.payment_due_date,
				invoice_no: economypost.invoice_no,
				paid: economypost.paid,
				hypothetic: economypost.hypothetic
			};

			if (patch.project_key) patch.client_key = null;

			patch = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(patch));

			__WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('economyposts').child(key).update(patch);

			globals.modal_economypost_edit.active = false;
			globals.modal_economypost_edit.timelog = undefined;
			eventBus.$emit('toast', { text: 'Økonomipost opdateret' });
		},
		archiveEconomypost: function archiveEconomypost() {
			var confirmed = confirm('Sikker?');
			if (!confirmed) return;
			__WEBPACK_IMPORTED_MODULE_1__firebase_config_js__["a" /* default */].ref('economyposts').child(this.economypost['.key']).update({ archived: true });
			globals.modal_economypost_edit.active = false;
			globals.modal_economypost_edit.timelog = undefined;
			eventBus.$emit('toast', { text: 'Økonomipost føjet til papirkurven' });
		},
		getProject: function getProject(key) {
			return this.$store.getters['projects/getProject'];
		}
	}, mounted: function mounted() {
		var economypost = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(globals.modal_economypost_edit.economypost));
		this.$set(globals.modal_economypost_edit, 'economypost', economypost);
	}
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Inputfield__);





/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_1__mixins_js__["a" /* default */].generic],
	components: { Inputfield: __WEBPACK_IMPORTED_MODULE_2__components_Inputfield___default.a },
	data: function data() {
		return {
			app: window.globalAppData,
			globals: globals,

			closeOnDimmerClick: true
		};
	},

	computed: {
		project: function project() {
			return globals.modal_timeline_project_popup.project;
		}
	},
	methods: {
		updateProjectStatus: function updateProjectStatus(e) {
			this.project.status = e.target.value;
			this.updateProject(this.project, 'status');
		},
		updateProject: function updateProject(project, param) {
			var key = project['.key'];
			var val = this.$refs['project_' + param].value;
			var patch = {};
			patch[param] = val;
			__WEBPACK_IMPORTED_MODULE_0__firebase_config_js__["a" /* default */].ref('projects').child(key).update(patch);
			eventBus.$emit('toast', { text: 'Opdateret' });
		},
		onDimmerClick: function onDimmerClick() {
			if (this.closeOnDimmerClick) this.close();
		},
		close: function close() {
			globals.modal_timeline_project_popup.active = false;
		},
		clickGotoProject: function clickGotoProject(e) {
			e.preventDefault();
			this.close();
			var url = globals.url + '#/project/' + this.project['.key'];
			window.open(url);
			return false;
		}
	} });

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Inputfield__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Inputfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Inputfield__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Btn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Btn__);











/* harmony default export */ __webpack_exports__["default"] = ({
	mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].db, __WEBPACK_IMPORTED_MODULE_4__mixins_js__["a" /* default */].generic],
	components: { Inputfield: __WEBPACK_IMPORTED_MODULE_5__components_Inputfield___default.a, Btn: __WEBPACK_IMPORTED_MODULE_7__components_Btn___default.a, Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a },
	data: function data() {
		return {
			app: window.globalAppData,
			globals: globals,

			closeOnDimmerClick: true
		};
	},

	computed: {
		timelog: function timelog() {
			return globals.modal_timelog_edit.timelog;
		},
		projects: function projects() {
			return this.$store.state.firebase.projects;
		},
		multiselectOptions_project: function multiselectOptions_project() {
			var output = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.$store.getters['projects/getAll']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var p = _step.value;

					if (p.archived) continue;
					var c = this.$store.getters['clients/getOne'](p.client_key);
					if (!c) continue;

					output.push({ value: p.key, label: c.name + ': ' + p.name });
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return output;
		}
	},
	methods: {
		onDimmerClick: function onDimmerClick() {
			if (this.closeOnDimmerClick) this.close();
		},
		close: function close() {
			globals.modal_timelog_edit.active = false;
		},
		save: function save() {
			var key = this.timelog['.key'];
			var timelog = this.timelog;

			var patch = {
				date: timelog.date,
				hours: timelog.hours,
				project_key: timelog.project_key,
				user_key: timelog.user_key,
				worktype: timelog.worktype,
				title: timelog.title,
				billable: timelog.billable,
				date_timestamp: __WEBPACK_IMPORTED_MODULE_2_moment___default()(timelog.date, 'YYYY-MM-DD').unix()
			};

			__WEBPACK_IMPORTED_MODULE_3__firebase_config_js__["a" /* default */].ref('timelogs').child(key).update(patch);

			globals.modal_timelog_edit.active = false;
			globals.modal_timelog_edit.timelog = undefined;
			eventBus.$emit('toast', { text: 'Timelog updated' });
		},
		getClient: function getClient(project_key) {
			var client = {};
			var project = this.getProject(project_key);
			if (project['client_key'] && this.$store.state.firebase.clients[project['client_key']]) {
				client = this.$store.state.firebase.clients[project['client_key']];
				client['.key'] = project['client_key'];
			}
			return client;
		},
		getProject: function getProject(key) {
			var project = {};
			if (!this.$store.state.firebase.projects) return {};
			if (this.$store.state.firebase.projects[key]) project = this.$store.state.firebase.projects[key];
			return project;
		},
		multielectGetOption: function multielectGetOption(options, key, val) {
			if (!options) return;
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var option = _step2.value;
					if (option[key] == val) return option;
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		},
		multiselectOnSelect_selectProject: function multiselectOnSelect_selectProject(item) {
			globals.modal_timelog_edit.timelog.project_key = item.value;
		}
	}, mounted: function mounted() {
		var timelog = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(globals.modal_timelog_edit.timelog));
		this.$set(globals.modal_timelog_edit, 'timelog', timelog);
	}
});

/***/ }),
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 156,
	"./af.js": 156,
	"./ar": 163,
	"./ar-dz": 157,
	"./ar-dz.js": 157,
	"./ar-kw": 158,
	"./ar-kw.js": 158,
	"./ar-ly": 159,
	"./ar-ly.js": 159,
	"./ar-ma": 160,
	"./ar-ma.js": 160,
	"./ar-sa": 161,
	"./ar-sa.js": 161,
	"./ar-tn": 162,
	"./ar-tn.js": 162,
	"./ar.js": 163,
	"./az": 164,
	"./az.js": 164,
	"./be": 165,
	"./be.js": 165,
	"./bg": 166,
	"./bg.js": 166,
	"./bm": 167,
	"./bm.js": 167,
	"./bn": 168,
	"./bn.js": 168,
	"./bo": 169,
	"./bo.js": 169,
	"./br": 170,
	"./br.js": 170,
	"./bs": 171,
	"./bs.js": 171,
	"./ca": 172,
	"./ca.js": 172,
	"./cs": 173,
	"./cs.js": 173,
	"./cv": 174,
	"./cv.js": 174,
	"./cy": 175,
	"./cy.js": 175,
	"./da": 176,
	"./da.js": 176,
	"./de": 179,
	"./de-at": 177,
	"./de-at.js": 177,
	"./de-ch": 178,
	"./de-ch.js": 178,
	"./de.js": 179,
	"./dv": 180,
	"./dv.js": 180,
	"./el": 181,
	"./el.js": 181,
	"./en-SG": 182,
	"./en-SG.js": 182,
	"./en-au": 183,
	"./en-au.js": 183,
	"./en-ca": 184,
	"./en-ca.js": 184,
	"./en-gb": 185,
	"./en-gb.js": 185,
	"./en-ie": 186,
	"./en-ie.js": 186,
	"./en-il": 187,
	"./en-il.js": 187,
	"./en-nz": 188,
	"./en-nz.js": 188,
	"./eo": 189,
	"./eo.js": 189,
	"./es": 192,
	"./es-do": 190,
	"./es-do.js": 190,
	"./es-us": 191,
	"./es-us.js": 191,
	"./es.js": 192,
	"./et": 193,
	"./et.js": 193,
	"./eu": 194,
	"./eu.js": 194,
	"./fa": 195,
	"./fa.js": 195,
	"./fi": 196,
	"./fi.js": 196,
	"./fo": 197,
	"./fo.js": 197,
	"./fr": 200,
	"./fr-ca": 198,
	"./fr-ca.js": 198,
	"./fr-ch": 199,
	"./fr-ch.js": 199,
	"./fr.js": 200,
	"./fy": 201,
	"./fy.js": 201,
	"./ga": 202,
	"./ga.js": 202,
	"./gd": 203,
	"./gd.js": 203,
	"./gl": 204,
	"./gl.js": 204,
	"./gom-latn": 205,
	"./gom-latn.js": 205,
	"./gu": 206,
	"./gu.js": 206,
	"./he": 207,
	"./he.js": 207,
	"./hi": 208,
	"./hi.js": 208,
	"./hr": 209,
	"./hr.js": 209,
	"./hu": 210,
	"./hu.js": 210,
	"./hy-am": 211,
	"./hy-am.js": 211,
	"./id": 212,
	"./id.js": 212,
	"./is": 213,
	"./is.js": 213,
	"./it": 215,
	"./it-ch": 214,
	"./it-ch.js": 214,
	"./it.js": 215,
	"./ja": 216,
	"./ja.js": 216,
	"./jv": 217,
	"./jv.js": 217,
	"./ka": 218,
	"./ka.js": 218,
	"./kk": 219,
	"./kk.js": 219,
	"./km": 220,
	"./km.js": 220,
	"./kn": 221,
	"./kn.js": 221,
	"./ko": 222,
	"./ko.js": 222,
	"./ku": 223,
	"./ku.js": 223,
	"./ky": 224,
	"./ky.js": 224,
	"./lb": 225,
	"./lb.js": 225,
	"./lo": 226,
	"./lo.js": 226,
	"./lt": 227,
	"./lt.js": 227,
	"./lv": 228,
	"./lv.js": 228,
	"./me": 229,
	"./me.js": 229,
	"./mi": 230,
	"./mi.js": 230,
	"./mk": 231,
	"./mk.js": 231,
	"./ml": 232,
	"./ml.js": 232,
	"./mn": 233,
	"./mn.js": 233,
	"./mr": 234,
	"./mr.js": 234,
	"./ms": 236,
	"./ms-my": 235,
	"./ms-my.js": 235,
	"./ms.js": 236,
	"./mt": 237,
	"./mt.js": 237,
	"./my": 238,
	"./my.js": 238,
	"./nb": 239,
	"./nb.js": 239,
	"./ne": 240,
	"./ne.js": 240,
	"./nl": 242,
	"./nl-be": 241,
	"./nl-be.js": 241,
	"./nl.js": 242,
	"./nn": 243,
	"./nn.js": 243,
	"./pa-in": 244,
	"./pa-in.js": 244,
	"./pl": 245,
	"./pl.js": 245,
	"./pt": 247,
	"./pt-br": 246,
	"./pt-br.js": 246,
	"./pt.js": 247,
	"./ro": 248,
	"./ro.js": 248,
	"./ru": 249,
	"./ru.js": 249,
	"./sd": 250,
	"./sd.js": 250,
	"./se": 251,
	"./se.js": 251,
	"./si": 252,
	"./si.js": 252,
	"./sk": 253,
	"./sk.js": 253,
	"./sl": 254,
	"./sl.js": 254,
	"./sq": 255,
	"./sq.js": 255,
	"./sr": 257,
	"./sr-cyrl": 256,
	"./sr-cyrl.js": 256,
	"./sr.js": 257,
	"./ss": 258,
	"./ss.js": 258,
	"./sv": 259,
	"./sv.js": 259,
	"./sw": 260,
	"./sw.js": 260,
	"./ta": 261,
	"./ta.js": 261,
	"./te": 262,
	"./te.js": 262,
	"./tet": 263,
	"./tet.js": 263,
	"./tg": 264,
	"./tg.js": 264,
	"./th": 265,
	"./th.js": 265,
	"./tl-ph": 266,
	"./tl-ph.js": 266,
	"./tlh": 267,
	"./tlh.js": 267,
	"./tr": 268,
	"./tr.js": 268,
	"./tzl": 269,
	"./tzl.js": 269,
	"./tzm": 271,
	"./tzm-latn": 270,
	"./tzm-latn.js": 270,
	"./tzm.js": 271,
	"./ug-cn": 272,
	"./ug-cn.js": 272,
	"./uk": 273,
	"./uk.js": 273,
	"./ur": 274,
	"./ur.js": 274,
	"./uz": 276,
	"./uz-latn": 275,
	"./uz-latn.js": 275,
	"./uz.js": 276,
	"./vi": 277,
	"./vi.js": 277,
	"./x-pseudo": 278,
	"./x-pseudo.js": 278,
	"./yo": 279,
	"./yo.js": 279,
	"./zh-cn": 280,
	"./zh-cn.js": 280,
	"./zh-hk": 281,
	"./zh-hk.js": 281,
	"./zh-tw": 282,
	"./zh-tw.js": 282
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 529;

/***/ }),
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(603),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(619),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(577),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(582),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(607),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(594),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(515)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(587),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(585),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(626),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(593),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(601),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(623),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(609),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(620),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(599),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(618),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(605),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(624),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(625),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(583),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(608),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(581),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(628),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(611),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(576),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(590),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(612),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(584),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(591),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(621),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(627),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(610),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(617),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "view spec"
  }, [(_vm.spec) ? _c('specsheet', {
    attrs: {
      "localspec": _vm.spec
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.deleteSpec()
      }
    }
  }, [_vm._v("Slet")]), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Projekt"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spec.project_key),
      expression: "spec.project_key"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.spec, "project_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change('project_key', $event)
      }]
    }
  }, _vm._l((_vm.all_projects), function(project, key, i) {
    return _c('option', {
      domProps: {
        "value": project.key
      }
    }, [_vm._v(_vm._s(project.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), (false) ? _c('btn', {
    attrs: {
      "full": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Gem")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kanban"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "contenteditable": ""
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "settings-btn --header",
    on: {
      "click": function($event) {
        return _vm.addColumn()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "columns",
    class: _vm.columns_cls
  }, _vm._l((_vm.tasklists), function(tasklist, tasklist_i) {
    return _c('div', {
      staticClass: "column"
    }, [(_vm.tasklists.length > 1) ? _c('div', {
      staticClass: "column-header"
    }, [_c('div', {
      staticClass: "column-title",
      attrs: {
        "contenteditable": ""
      }
    }, [_vm._v(_vm._s(tasklist.title))]), _vm._v(" "), _c('div', {
      staticClass: "settings-btn --column",
      on: {
        "click": function($event) {
          return _vm.removeColumn(tasklist_i)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cards"
    }, [_vm._l((_vm.tasks), function(task, task_i) {
      return (task.col_index == tasklist_i) ? _c('div', {
        staticClass: "card"
      }, [_c('div', {
        staticClass: "card-title",
        attrs: {
          "contenteditable": ""
        }
      }, [_vm._v("Task title")]), _vm._v(" "), _c('div', {
        staticClass: "card-excerpt",
        attrs: {
          "contenteditable": ""
        }
      }, [_vm._v(_vm._s(task.text))]), _vm._v(" "), _c('div', {
        staticClass: "settings-btn --card",
        on: {
          "click": function($event) {
            return _vm.removeTask(task_i)
          }
        }
      })]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "new-card-btn",
      on: {
        "click": function($event) {
          return _vm.addTask(tasklist_i)
        }
      }
    }, [_vm._v("Add")])], 2)])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "miniprogindicator"
  }, [_c('div', {
    staticClass: "bg",
    style: (_vm.bgStyle())
  }), _c('div', {
    staticClass: "fg",
    style: (_vm.fgStyle())
  })])
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputfield",
    class: _vm.cls
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.suffix) ? _c('div', {
    staticClass: "suffix"
  }, [_vm._v(_vm._s(_vm.suffix))]) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('svgicon', {
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar",
    style: (_vm.css)
  }, [(!_vm.gravatarUrl) ? [_vm._v(_vm._s(_vm.initials))] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', [_c('table', {
    staticClass: "table-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "align-l"
  }), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Total faktureret ift. tidstracking")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.byUsers), function(user, user_i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": user
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [_vm._v(_vm._s(user.first_name))]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm.outputMoney(user.billable_kr)) + " kr.")]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(user.billable_pct) + " %")])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "align-r"
  }, [_c('b', [_vm._v(_vm._s(_vm.outputMoney(_vm.allBudgetsTotal)) + " kr.")])]), _vm._v(" "), _c('td')])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Udregning")])]), _c('p', [_vm._v("Brugerens projekter gennemgås. For hvert projekt aflæses brugerens andel af tid logget på projektet. Denne andel holdes op imod projektets samlede budget.")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Husk, at denne udregning kun tager højde for hvor mange timer brugerne har tracket, og ikke medberegner graden af effektivitet per time.")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal_generic",
    class: _vm.cls
  }, [_c('div', {
    staticClass: "modal_dimmer_generic",
    on: {
      "click": function($event) {
        return _vm.dimmerClose()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal_popup_generic"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.killerClose()
      }
    }
  }, [_vm._v("X")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view projects-timeline"
  }, [_c('box', {
    attrs: {
      "label": "New calendar"
    }
  }, [_c('full-calendar', {
    attrs: {
      "config": _vm.calendarConfig
    }
  })], 1), _vm._v(" "), _c('timeline', {
    attrs: {
      "title": "Old Timeline",
      "entries": _vm.timeline_row_entries,
      "show-sidebar": _vm.show_sidebar,
      "sidebar-width": _vm.sidebarWidth
    },
    on: {
      "entry-click": _vm.onEntryclick
    }
  }), _vm._v(" "), (_vm.globals.show_beta_content) ? [_c('br'), _c('br'), _vm._v(" "), _c('box', [_vm._v("\n    BETA: "), _c('br'), _vm._v("\n    - toggle select mellem: done bar vis procent done / time spent / projekt booked pct\n    - book input on click empty input?\n    - "), _c('br'), _vm._v("\n    - timeline skal gøres til et component som tager show_left_col true/false og :row_entries som er et object med rows og subrows, så kan det nemlig bruges på single project såvel som multiple projects skærm\n      - timebooking  from_date  to_date daily_hrs  project_key"), _c('br'), _vm._v("\n    - timelogger: if date within timebooking create default timelog suggestion"), _c('br'), _vm._v("\n    - start screen: show timebookings today "), _c('br'), _vm._v("\n    - timeline: show actual tracked hours (weight per day) on person and project total\n    - timeline show remaining daily hrs booked on person and project total\n    - timeline under project, expandable show persons\n    - timeline under project, expandable show workload hrs\n    - filter persons/all\n    ")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.timelogger.visible) ? _c('div', {
    attrs: {
      "id": "timelogger"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": function($event) {
        return _vm.closeTimelogger()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [
    [_c('table', {
      staticClass: "timelogger-entries"
    }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.globals.timelogger.addList), function(entry, i) {
      return _c('tr', {
        key: i
      }, [_c('td', [_c('div', {
        staticClass: "label"
      }, [_vm._v("Dato")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.date),
          expression: "entry.date"
        }],
        staticClass: "unstyled",
        attrs: {
          "type": "date"
        },
        domProps: {
          "value": (entry.date)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(entry, "date", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "label"
      }, [_vm._v("Timer")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: (entry.hours),
          expression: "entry.hours",
          modifiers: {
            "number": true
          }
        }],
        attrs: {
          "type": "number",
          "step": ".25",
          "min": "0.25",
          "max": "24",
          "placeholder": "Timetal"
        },
        domProps: {
          "value": (entry.hours)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(entry, "hours", _vm._n($event.target.value))
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })]), _vm._v(" "), _c('td', [(false) ? _c('div', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.project_key),
          expression: "entry.project_key"
        }],
        attrs: {
          "name": "",
          "id": ""
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(entry, "project_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "undefined"
        }
      }, [_vm._v("Vælg...")]), _vm._v(" "), _vm._l((_vm.projects), function(project, i) {
        return _c('option', {
          domProps: {
            "value": project['.key']
          }
        }, [_vm._v("\n                    " + _vm._s(project.name) + " - " + _vm._s(_vm.getClient(project['.key']).name) + "\n                  ")])
      })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "label"
      }, [_vm._v("Opgave")]), _vm._v(" "), _c('multiselect', {
        attrs: {
          "options": _vm.projectSelectOptions,
          "placeholder": "Vælg...",
          "label": "label",
          "track-by": "value",
          "select-label": "",
          "selected-label": "",
          "deselect-label": "",
          "value": _vm.multiSelectGetOption(_vm.projectSelectOptions, 'value', entry.project_key),
          "reset-after": false
        },
        on: {
          "select": function($event) {
            return _vm.multiSelectOnSelect('project', $event, entry)
          }
        }
      })], 1), _vm._v(" "), (false) ? _c('td', [(_vm.getClient(entry.project_key)) ? [_vm._v("\n                " + _vm._s(_vm.getClient(entry.project_key).name) + "\n              ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (false) ? _c('td', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.task_key),
          expression: "entry.task_key"
        }],
        attrs: {
          "name": "",
          "id": ""
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(entry, "task_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.tasks), function(task, i) {
        return (task.project_key == entry.project_key) ? _c('option', {
          domProps: {
            "value": task['.key']
          }
        }, [_vm._v(_vm._s(task.title))]) : _vm._e()
      }), 0)]) : _vm._e(), _vm._v(" "), _c('td', [(false) ? _c('div', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.worktype),
          expression: "entry.worktype"
        }],
        attrs: {
          "name": "",
          "id": ""
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(entry, "worktype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "undefined"
        }
      }, [_vm._v("Vælg...")]), _vm._v(" "), _vm._l((_vm.worktypes), function(worktype, i) {
        return _c('option', {
          domProps: {
            "value": worktype.value
          }
        }, [_vm._v(_vm._s(worktype.title))])
      })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "label"
      }, [_vm._v("Arbejdstype")]), _vm._v(" "), _c('multiselect', {
        attrs: {
          "options": _vm.worktypes,
          "placeholder": "Vælg...",
          "label": "title",
          "select-label": "",
          "selected-label": "",
          "deselect-label": "",
          "track-by": "value",
          "value": _vm.multiSelectGetOption(_vm.worktypes, 'value', entry.worktype),
          "reset-after": false
        },
        on: {
          "select": function($event) {
            return _vm.multiSelectOnSelect('worktype', $event, entry)
          }
        }
      })], 1), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "label"
      }, [_vm._v("Note")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.title),
          expression: "entry.title"
        }],
        attrs: {
          "type": "text",
          "_placeholder": ""
        },
        domProps: {
          "value": (entry.title)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(entry, "title", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "checkbox"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entry.billable),
          expression: "entry.billable"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'kj12b3kj+i'
        },
        domProps: {
          "checked": Array.isArray(entry.billable) ? _vm._i(entry.billable, null) > -1 : (entry.billable)
        },
        on: {
          "change": function($event) {
            var $$a = entry.billable,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(entry, "billable", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(entry, "billable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(entry, "billable", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": 'kj12b3kj' + i
        }
      })])]), _vm._v(" "), _c('td', [(!_vm.lineIsReady(i)) ? void 0 : _vm._e(), _vm._v(" "), (_vm.lineIsReady(i)) ? _c('span', [_c('svgicon', {
        attrs: {
          "icon": "ionicons/checkmark"
        }
      })], 1) : _vm._e()], 2), _vm._v(" "), _c('td', [_c('btn', {
        attrs: {
          "color": "secondary"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.dupeLineBelow(i)
          }
        }
      }, [_c('svgicon', {
        attrs: {
          "icon": "ionicons/ios-plus-empty"
        }
      })], 1)], 1), _vm._v(" "), _c('td', [_c('btn', {
        attrs: {
          "color": "secondary"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.stripEntry(i)
          }
        }
      }, [_c('svgicon', {
        attrs: {
          "icon": "linearicons/cross"
        }
      })], 1)], 1)])
    }), 0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "grid"
    }, [_c('div', {
      staticClass: "col m50"
    }, [_c('btn', {
      attrs: {
        "color": "secondary",
        "id": "addrowbtn"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.addEmptyRow()
        }
      }
    }, [_vm._v("\n          Tilføj linje\n        ")]), _vm._v("\n         \n        "), (false) ? _c('btn', {
      attrs: {
        "color": "primary",
        "id": "fetchfromlatestprojects"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.fetchLastProjects()
        }
      }
    }, [_vm._v("Hent fra nyeste projekter")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col m50 align-r"
    }, [_c('btn', {
      attrs: {
        "color": "primary",
        "disabled": !_vm.somethingToSubmit()
      },
      nativeOn: {
        "click": function($event) {
          return _vm.createNewTimelogs()
        }
      }
    }, [_vm._v("Log " + _vm._s(_vm.getAddListTotalHoursCount()) + " timers arbejde")])], 1)])], _vm._v(" "), _c('div', {
      staticClass: "killer",
      on: {
        "click": function($event) {
          return _vm.closeTimelogger()
        }
      }
    }, [_vm._v("X")])
  ], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Timer")]), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Arbejdstype")]), _vm._v(" "), _c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', [_vm._v("Fakturérbar")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-component",
    class: {
      'box': _vm.look == 'boxed'
    },
    attrs: {
      "data-look": _vm.look
    }
  }, [_c('div', {
    class: {
      'header': _vm.look == 'boxed'
    }
  }, [_c('div', {
    staticClass: "tab-links"
  }, _vm._l((_vm.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "tab-link",
      class: {
        'active': tab.isActive
      },
      domProps: {
        "innerHTML": _vm._s(tab.header)
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(i)
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    class: {
      'content': _vm.look == 'boxed'
    }
  }, [_c('div', {
    staticClass: "tab-area",
    attrs: {
      "data-look": _vm.look
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "masonrygrid",
    staticClass: "masonry-grid"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box tab-box"
  }, [_c('div', {
    staticClass: "header"
  }, _vm._l((_vm.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "tab-btn"
    }, [_vm._v("Tab btn: " + _vm._s(tab.label) + " " + _vm._s(i))])
  }), 0), _vm._v(" "), _vm._l((_vm.tabs), function(tab, i) {
    return [_vm._t('tab' + i + i)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view",
    attrs: {
      "id": "login"
    }
  }, [(!_vm.forgotPassMode) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_user),
      expression: "login_user"
    }],
    attrs: {
      "type": "text",
      "placeholder": "User"
    },
    domProps: {
      "value": (_vm.login_user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login_user = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_pwd),
      expression: "login_pwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.login_pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login_pwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('btn', {
    attrs: {
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.forgotPassMode = true
      }
    }
  }, [_vm._v("Glemt kodeord?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('btn', {
    attrs: {
      "color": "2",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doLogin()
      }
    }
  }, [_vm._v("Log ind")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.forgotPassMode) ? _c('box', {
    attrs: {
      "label": "Log ind"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_reset_email),
      expression: "password_reset_email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.password_reset_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_reset_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn half left",
    on: {
      "click": function($event) {
        _vm.forgotPassMode = false
      }
    }
  }, [_c('div', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Tilbage\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn a half right",
    attrs: {
      "_@click": "resetPassword"
    }
  }, [_c('div', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("\n    Nyt pass plz\n    ")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comments-area",
    class: _vm.cls
  }, [_c('div', {
    staticClass: "add-comment"
  }, [(_vm.creatingComment) ? _c('textarea', {
    ref: "newcommenttext",
    attrs: {
      "id": "",
      "cols": "30",
      "rows": "3"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.creatingComment) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.cancelCreateComment()
      }
    }
  }, [_vm._v("Annullér")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.createComment()
      }
    }
  }, [_vm._v("Tilføj")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "comments-list"
  }, _vm._l((_vm.comments), function(c, c_i) {
    return _c('div', {
      key: 'c' + c_i,
      staticClass: "comment"
    }, [_c('avatar', {
      attrs: {
        "input": c.user
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "before"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n          " + _vm._s(c.user.first_name) + " " + _vm._s(c.user.last_name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "created"
    }, [_vm._v("\n          " + _vm._s(c.created_human2) + "\n          (\n            " + _vm._s(c.created_human) + "\n            "), (c.edited) ? [_vm._v("\n              — Redigeret\n            ")] : _vm._e(), _vm._v("\n          )\n        ")], 2)]), _vm._v(" "), (_vm.editing_comment_i != c_i) ? _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(_vm.nl2br(c.text))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.editing_comment_i == c_i) ? _c('div', {
      staticClass: "edit-comment"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editing_comment_text),
        expression: "editing_comment_text"
      }],
      attrs: {
        "cols": "30",
        "rows": "3"
      },
      domProps: {
        "value": (_vm.editing_comment_text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editing_comment_text = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.editing_comment_i = undefined
        }
      }
    }, [_vm._v("Annullér")]), _vm._v(" "), _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.saveEditedComment()
        }
      }
    }, [_vm._v("Gem")])]) : _vm._e(), _vm._v(" "), (_vm.editing_comment_i != c_i) ? _c('div', {
      staticClass: "after"
    }, [(c.can_edit) ? _c('div', {
      staticClass: "edit-btn",
      on: {
        "click": function($event) {
          return _vm.setEditingComment(c, c_i)
        }
      }
    }, [_vm._v("Redigér")]) : _vm._e(), _vm._v(" "), (c.can_delete) ? _c('div', {
      staticClass: "delete-btn",
      on: {
        "click": function($event) {
          return _vm.archiveComment(c)
        }
      }
    }, [_vm._v("Slet")]) : _vm._e()]) : _vm._e()], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.filteredItems == undefined) ? _c('div', {
    staticClass: "content-preload"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.filteredItems != undefined) ? _c('div', {
    staticClass: "view specs"
  }, [_c('box', {
    attrs: {
      "label": _vm.filteredItems.length + ' specs'
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [(false) ? _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.createNewSpec()
      }
    }
  }, [_vm._v("Nyt spec")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Kunde"
    }
  }, [_c('select', {
    ref: "status_filter",
    attrs: {
      "id": "status-select"
    },
    domProps: {
      "value": _vm.status_filter
    },
    on: {
      "change": _vm.status_filter_updated
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.clients), function(client, client_key, client_i) {
    return _c('option', {
      domProps: {
        "value": client_key
      }
    }, [_vm._v(_vm._s(client.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Opgave"
    }
  }, [_c('select', {
    ref: "status_filter",
    attrs: {
      "id": "status-select"
    },
    domProps: {
      "value": _vm.status_filter
    },
    on: {
      "change": _vm.status_filter_updated
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.projects), function(project, project_key, project_i) {
    return _c('option', {
      domProps: {
        "value": project_key
      }
    }, [_vm._v(_vm._s(project.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    ref: "status_filter",
    attrs: {
      "id": "status-select"
    },
    domProps: {
      "value": _vm.status_filter
    },
    on: {
      "change": _vm.status_filter_updated
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.$store.state.specs.statuses), function(status, status_key, status_i) {
    return _c('option', {
      domProps: {
        "value": status_key
      }
    }, [_vm._v(_vm._s(status.title))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Søg"
    }
  }, [_c('input', {
    ref: "search_filter",
    attrs: {
      "type": "text",
      "placeholder": "Søg"
    },
    domProps: {
      "value": _vm.search_filter
    },
    on: {
      "keyup": _vm.search_filter_updated
    }
  })])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.filteredItems.length) ? _c('table', {
    staticClass: "table-a spec-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Spec")]), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }, [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }, [_vm._v("Kunde")]), _vm._v(" "), _c('th', {
    staticClass: "align-r hide"
  }, [_vm._v("Tidsbudget")]), _vm._v(" "), (_vm.is_admin) ? _c('th', {
    staticClass: "_align-r"
  }, [_vm._v("Budget")]) : _vm._e(), _vm._v(" "), (_vm.is_admin) ? _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Oprettet")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(spec, i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": spec
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/spec/' + spec.key
      }
    }, [(spec.title) ? [_vm._v(_vm._s(spec.title))] : _vm._e(), _vm._v(" "), (!spec.title) ? [_vm._v("Unavngiven")] : _vm._e()], 2)], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [(_vm.getProject(spec)) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + _vm.getProject(spec).key
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getProject(spec).name) + "\n\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [(_vm.getClient(spec)) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + _vm.getClient(spec).key
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getClient(spec).name) + "\n\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.is_admin) ? _c('td', {
      staticClass: "_align-r"
    }, [_vm._v("\n\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("money")(_vm.specGetBudget(spec), 0)) + " kr.\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(spec.created.split(' ')[0]) + "\n\t\t\t\t\t\t")])])
  }), 0)]) : _vm._e()], 2), _vm._v(" "), (false) ? _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewSpec()
      }
    }
  }, [_vm._v("Nyt Spec")]) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view timelog"
  }, [_c('box', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m20"
  }, [(false) ? _c('inputfield', {
    attrs: {
      "label": "Bruger"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_user_key),
      expression: "filter_user_key"
    }],
    staticClass: "select-styled",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_user_key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.users), function(user, i) {
    return _c('option', {
      domProps: {
        "value": user['.key']
      }
    }, [(user && user.first_name) ? [_vm._v(_vm._s(user.first_name))] : _vm._e()], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.userSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.userSelectOptions, 'value', _vm.filter_user_key),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('filter_user_key', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [(false) ? _c('inputfield', {
    attrs: {
      "label": "Kunde"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_client_key),
      expression: "filter_client_key"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_client_key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.clients), function(client, i) {
    return _c('option', {
      domProps: {
        "value": client['.key']
      }
    }, [_vm._v("\n              " + _vm._s(client.name) + "\n            ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.clientSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.clientSelectOptions, 'value', _vm.filter_client_key),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('filter_client_key', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [(false) ? _c('inputfield', {
    attrs: {
      "label": "Opgave"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_project_key),
      expression: "filter_project_key"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filter_project_key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.projects), function(project, i) {
    return ((!_vm.filter_client_key || _vm.filter_client_key == 'undefined') || _vm.filter_client_key == project.client_key) ? _c('option', {
      domProps: {
        "value": project['.key']
      }
    }, [_vm._v("\n              " + _vm._s(project.name) + " - (" + _vm._s(_vm.getOne('client', project.client_key).name) + ")\n            ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.projectSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.projectSelectOptions, 'value', _vm.filter_project_key),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('filter_project_key', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [_c('inputfield', {
    attrs: {
      "label": 'Fra: ' + _vm.dateFormat(_vm.filter_date_from, 'ddd DD/MM')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_date_from),
      expression: "filter_date_from"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter_date_from)
    },
    on: {
      "focus": function($event) {
        _vm.blockFilterUpdates = true
      },
      "blur": function($event) {
        _vm.blockFilterUpdates = false
      },
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.blockFilterUpdates = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_date_from = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [_c('inputfield', {
    attrs: {
      "label": 'Til: ' + _vm.dateFormat(_vm.filter_date_to, 'ddd DD/MM')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_date_to),
      expression: "filter_date_to"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter_date_to)
    },
    on: {
      "focus": function($event) {
        _vm.blockFilterUpdates = true
      },
      "blur": function($event) {
        _vm.blockFilterUpdates = false
      },
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.blockFilterUpdates = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter_date_to = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-day-back')
      }
    }
  }, [_vm._v("—")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('today')
      }
    }
  }, [_vm._v("I dag")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-day-forward')
      }
    }
  }, [_vm._v("+")]), _vm._v("\n       \n    "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-month-back')
      }
    }
  }, [_vm._v("—")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('this-month')
      }
    }
  }, [_vm._v("Indeværende måned")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-month-forward')
      }
    }
  }, [_vm._v("+")]), _vm._v("\n       \n    "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-week-back')
      }
    }
  }, [_vm._v("—")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('last-7-days')
      }
    }
  }, [_vm._v("Sidste 7 dage")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('last-14-days')
      }
    }
  }, [_vm._v("Sidste 14 dage")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('last-30-days')
      }
    }
  }, [_vm._v("Sidste 30 dage")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('last-90-days')
      }
    }
  }, [_vm._v("Sidste 90 dage")]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.setTimeframe('one-week-forward')
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_only_billable),
      expression: "filter_only_billable"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kj12b3kj"
    },
    domProps: {
      "checked": Array.isArray(_vm.filter_only_billable) ? _vm._i(_vm.filter_only_billable, null) > -1 : (_vm.filter_only_billable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filter_only_billable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.filter_only_billable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.filter_only_billable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.filter_only_billable = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kj12b3kj"
    }
  }, [_vm._v("Vis kun fakturérbare")])]), _vm._v(" "), ( false) ? _c('span', [_vm._v("cachefiltered_timelogs: " + _vm._s(_vm.cachefiltered_timelogs.length || _vm.all_timelogs_count))]) : _vm._e()], 1), _vm._v(" "), (_vm.filteredTimelogs.length) ? _c('box', {
    attrs: {
      "label": _vm.filteredTimelogs.length + ' timelogs - ' + _vm.getListedTimelogStats.hours_total.toFixed(2) + ' timer'
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m25"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 80,
        height: 80,
        'innerRadius': 0,
        'radius': 40
      },
      "data": _vm.clientsPieData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Kunder")]), _vm._v(" "), _vm._l((_vm.getListedTimelogStats.clients), function(entry, i) {
    return (parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100) > 0) ? _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), (entry.client) ? _c('span', {
      staticClass: "name"
    }, [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + entry.key
      }
    }, [_vm._v(_vm._s(entry.client.name))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100)) + "%\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value)) + " timer\n            ")])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 80,
        height: 80,
        'innerRadius': 0,
        'radius': 40
      },
      "data": _vm.projectsPieData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Opgaver")]), _vm._v(" "), _vm._l((_vm.getListedTimelogStats.projects), function(entry, i) {
    return (parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100) > 0) ? _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + entry.key
      }
    }, [_vm._v(_vm._s(entry.project.name))])], 1), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100)) + "%\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value)) + " timer\n            ")])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 80,
        height: 80,
        'innerRadius': 0,
        'radius': 40
      },
      "data": _vm.usersPieData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Brugere")]), _vm._v(" "), _vm._l((_vm.getListedTimelogStats.users), function(entry, i) {
    return _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [(entry.user) ? [_vm._v(_vm._s(entry.user.first_name || '?'))] : _vm._e()], 2), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100)) + "%\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value)) + " timer\n            ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 80,
        height: 80,
        'innerRadius': 0,
        'radius': 40
      },
      "data": _vm.worktypesPieData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Arbejdstype")]), _vm._v(" "), _vm._l((_vm.getListedTimelogStats.worktypes), function(entry, i) {
    return _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v("\n              " + _vm._s(_vm.translateWorktype(entry.key)) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value / _vm.getListedTimelogStats.hours_total * 100)) + "%\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(parseInt(entry.value)) + " timer\n            ")])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.filteredTimelogs.length) ? _c('box', [_c('div', {
    attrs: {
      "_style": "overflow-x:auto;"
    }
  }, [_c('table', {
    staticClass: "table-timespan-dates"
  }, [_c('thead', [_c('tr', _vm._l((_vm.timespanDates), function(entry) {
    return _c('th', {
      attrs: {
        "data-day": entry.dayno
      }
    }, [_c('span', {
      staticClass: "l1"
    }, [_vm._v(_vm._s(entry.date.format('ddd')))]), _vm._v(" "), _c('span', {
      staticClass: "l2"
    }, [_vm._v(_vm._s(entry.date.format('D/M')))])])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((_vm.timespanDates), function(entry) {
    return _c('td', {
      attrs: {
        "data-day": entry.dayno
      }
    }, [_c('span', {
      staticClass: "l1"
    }, [_vm._v(_vm._s(entry.hours_logged))]), _vm._v(" "), _c('span', {
      staticClass: "l2"
    }, [_vm._v("timer")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      style: (_vm.barHeight(entry.hours_logged, _vm.maxHoursLoggedInTimeSpanDates))
    })])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.filteredTimelogs.length < 100) ? _c('box', [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), (false) ? _c('th', [_vm._v("Bruger")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Note")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredTimelogs), function(timelog, i) {
    return [(_vm.timelogListDateSpacerBoolean(_vm.filteredTimelogs, i)) ? _c('tr', [_c('td', {
      staticClass: "timelog-date-spacer",
      attrs: {
        "colspan": "9"
      }
    })]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "text": _vm._f("milkinitials")(timelog.user.email)
      }
    })], 1), _vm._v(" "), (false) ? _c('td', [_c('avatar', {
      attrs: {
        "input": timelog.user
      }
    })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('td', [(timelog.user) ? [_vm._v(_vm._s(timelog.user.first_name || '?'))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm._f("weekday1dk")(_vm.nicedate(timelog.date, 'ddd D/M-YY'))) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.hours) + " t\n            ")]), _vm._v(" "), _c('td', [(timelog.project) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + timelog.project_key
      }
    }, [_vm._v(_vm._s(timelog.project.name))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (timelog.client) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + timelog.project.client_key
      }
    }, [_vm._v(_vm._s(timelog.client.name))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.worktype_translated) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.title) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.editTimelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/pencil"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.delete_timelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/trash"
      }
    })], 1)])])]
  })], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.transferTimelogsModal) ? _c('btn', {
    nativeOn: {
      "click": function($event) {
        _vm.transferTimelogsModal = true
      }
    }
  }, [_vm._v("Overfør tidslogs")]) : _vm._e(), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportTimelogs()
      }
    }
  }, [_vm._v("Eksportér tidslogs")]), _vm._v(" "), (_vm.transferTimelogsModal) ? _c('box', {
    attrs: {
      "label": "Overfør tidslogs"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('label', [_vm._v("Fra opgave:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.projectSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.projectSelectOptions, 'value', _vm.transferTimelogsProjectA),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('transferTimelogsProjectA', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('label', [_vm._v("Til opgave:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.projectSelectOptions,
      "value": _vm.multiSelectGetOption(_vm.projectSelectOptions, 'value', _vm.transferTimelogsProjectB),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiSelectOnSelect('transferTimelogsProjectB', $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.is_admin) ? _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.transferTimelogs()
      }
    }
  }, [_vm._v("Overfør tidslogs...")]) : _vm._e(), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        _vm.transferTimelogsModal = false
      }
    }
  }, [_vm._v("Luk")])], 1) : _vm._e(), _vm._v(" "), _vm._l((100), function(i) {
    return _c('br')
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: _vm.box_cls
  }, [(_vm.label) ? _c('div', {
    staticClass: "header",
    class: {
      'togglable': (_vm.headerToggle != undefined)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.headerToggleOpen()
      }
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.label) + "\n      "), (_vm.is_open == true || _vm.is_open == false) ? _c('div', {
    staticClass: "toggler",
    class: {
      open: (_vm.is_open === true)
    },
    on: {
      "click": function($event) {
        return _vm.togglerToggleOpen()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-right"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$slots['meta-r']) ? _c('div', {
    staticClass: "meta-r"
  }, [_vm._t("meta-r")], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.is_open === undefined || _vm.is_open === true) ? _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "timelogger-basic"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "_label": "Timer",
      "suffix": "timer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.timelog.hours),
      expression: "timelog.hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "hoursinput",
    staticClass: "number-btns",
    attrs: {
      "type": "number",
      "min": "0.25",
      "max": "3",
      "step": "0.25",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.timelog.hours)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.create()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.timelog, "hours", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "_label": "Arbejdstype"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timelog.worktype),
      expression: "timelog.worktype"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.timelog, "worktype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Vælg arbejdstype...")]), _vm._v(" "), _vm._l((_vm.worktypes), function(option, i) {
    return _c('option', {
      key: 'fdsf' + i,
      domProps: {
        "value": option.key
      }
    }, [_vm._v(_vm._s(option.title))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "_label": "Note"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timelog.title),
      expression: "timelog.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Hvad har du lavet?"
    },
    domProps: {
      "value": (_vm.timelog.title)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.create()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.timelog, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary",
      "full": "",
      "disabled": !_vm.ready
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.create()
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.create()
      }
    }
  }, [_vm._v("Log " + _vm._s(_vm.timelog.hours || 0) + " time(r) på " + _vm._s(_vm.project.name))])], 1)
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.label) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.spec) ? _c('div', {
    staticClass: "spec-view",
    class: _vm.specView_cls
  }, [_c('box', [_c('div', {
    staticClass: "specsheet"
  }, [_c('div', {
    staticClass: "heypart"
  }, [(0) ? _c('p', [_c('b', [_vm._v("Hey — ")]), _vm._v("\n\t\t\t\t\tVi ved godt at vores opgavespecifikationer kan være til den tørre side. \n\t\t\t\t\tDog er de ret vigtige at du alligevel bruger et øjeblik på at nærlæse, da det er vigtigt at vi er helt \n\t\t\t\t\tenige om det arbejde der skal laves og dine forventninger og krav dertil. \n\t\t\t\t\tPå den måde får vi en super tilfreds kunde, hvilket er det vigtigste for os. \n\t\t\t\t\tDet er derfor super vigtigt at dine forventninger til arbejdet og den løsning vi udfører er definerede \n\t\t\t\t\ti vores specifikation nedenfor, så der ikke senere opstår tvivl.\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (0) ? _c('p', [_vm._v("\n\t\t\t\t\tI Milk går vi meget op i at du som kunde er 100% tilfreds med din løsning.\n\t\t\t\t\tDerfor nørder vi altid opgavespecifikation — selvom det ikke er den sjoveste del."), _c('br'), _vm._v("\n\t\t\t\t\tVi beder dig her hjælpe med at sikre at dine ønsker og forventninger til opgaven, samt eventuelle detaljer, er klart beskrevet i punkterne nedenfor.\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (1) ? _c('p', [_vm._v("\n\t\t\t\t\tVi går meget op i at du som kunde bliver 100% tilfreds med din løsning, og derfor nørder vi altid opgavespecifikationen.\n\t\t\t\t\tVi beder dig hjælpe med at sikre at dine ønsker er klart beskrevet, så forventninger og detaljer bliver afstemt inden projektopstart.\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pretitle",
    domProps: {
      "innerHTML": _vm._s(_vm.pretitle)
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.legaltext1)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.legaltext2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.legaltext2)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "taskcats"
  }, _vm._l((_vm.spec.taskcats), function(taskcat, taskcat_i) {
    return _c('div', {
      key: 'asdf' + taskcat_i,
      staticClass: "taskcat"
    }, [_c('div', {
      staticClass: "row row-taskcat"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (taskcat.title),
        expression: "taskcat.title"
      }],
      staticClass: "input-taskcat-title",
      attrs: {
        "type": "text",
        "placeholder": "Kategori"
      },
      domProps: {
        "value": (taskcat.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(taskcat, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "hrs-title"
    }, [_vm._v("Arbejdstimer")])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [(false) ? _c('div', {
      staticClass: "dragger"
    }, [_vm._v("=")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "taskcat-up-down"
    }, [(taskcat_i > 0) ? _c('div', {
      staticClass: "up",
      on: {
        "click": function($event) {
          return _vm.taskCatMoveUp(taskcat, taskcat_i)
        }
      }
    }) : _vm._e(), _vm._v(" "), (taskcat_i < (_vm.spec.taskcats.length - 1)) ? _c('div', {
      staticClass: "down",
      on: {
        "click": function($event) {
          return _vm.taskCatMoveDown(taskcat, taskcat_i)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [(_vm.spec.taskcats.length > 1) ? _c('div', {
      staticClass: "taskcat-delete-btn",
      on: {
        "click": function($event) {
          return _vm.taskcatDelete(taskcat, taskcat_i)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-trash-outline"
      }
    })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "tasks"
    }, [_c('draggable', {
      attrs: {
        "options": {
          group: 'tasks',
          handle: '.dragger'
        }
      },
      on: {
        "start": _vm.task_drag_start,
        "end": _vm.task_drag_end,
        "add": _vm.task_drag_add,
        "remove": _vm.task_drag_remove
      },
      model: {
        value: (taskcat.tasks),
        callback: function($$v) {
          _vm.$set(taskcat, "tasks", $$v)
        },
        expression: "taskcat.tasks"
      }
    }, _vm._l((taskcat.tasks), function(task, task_i) {
      return _c('div', {
        key: 'task' + task_i,
        staticClass: "task",
        class: _vm.taskClasses(task)
      }, [_c('div', {
        staticClass: "row row-task"
      }, [_c('div', {
        staticClass: "col"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (task.title),
          expression: "task.title"
        }],
        ref: 'taskTitle' + taskcat_i + '-' + task_i,
        refInFor: true,
        staticClass: "input-task-title",
        attrs: {
          "rows": "1",
          "data-min-rows": "1",
          "placeholder": "Opgavelinje"
        },
        domProps: {
          "value": (task.title)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(task, "title", $event.target.value)
          }, function($event) {
            return _vm.autoSizeTextArea(taskcat_i, task_i)
          }]
        }
      }), _vm._v(" "), (_vm.spec.showDescriptions) ? _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (task.text),
          expression: "task.text"
        }],
        ref: 'taskText' + taskcat_i + '-' + task_i,
        refInFor: true,
        staticClass: "input-task-text",
        attrs: {
          "rows": "1",
          "data-min-rows": "1",
          "placeholder": "?"
        },
        domProps: {
          "value": (task.text)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(task, "text", $event.target.value)
          }, function($event) {
            return _vm.autoSizeTextArea2(taskcat_i, task_i)
          }]
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('div', {
        staticClass: "task-optional",
        on: {
          "click": function($event) {
            return _vm.toggleTaskOptional(task)
          }
        }
      }, [( true) ? [(task.optional === undefined) ? [_vm._v("—")] : _vm._e(), _vm._v(" "), (task.optional === false) ? [_vm._v("Tilvalg")] : _vm._e(), _vm._v(" "), (task.optional === true) ? [_vm._v("Tilvalg")] : _vm._e()] : _vm._e(), _vm._v(" "), ( false) ? [(task.optional === undefined) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/ios-minus-empty"
        }
      }) : _vm._e(), _vm._v(" "), (task.optional === false) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/android-close"
        }
      }) : _vm._e(), _vm._v(" "), (task.optional === true) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/checkmark"
        }
      }) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: (task.hours),
          expression: "task.hours",
          modifiers: {
            "number": true
          }
        }],
        staticClass: "input-hours",
        attrs: {
          "type": "number",
          "tabindex": 666 + (taskcat_i * 100) + task_i
        },
        domProps: {
          "value": (task.hours)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(task, "hours", _vm._n($event.target.value))
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [(_vm.spec.showLineTotals) ? _c('div', {
        staticClass: "task-budget"
      }, [_vm._v("\n   \t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.outputMoney((task.hours * _vm.hour_rate))) + "\t\t\t\t\t\t\t\t\t\t\n   \t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('div', {
        staticClass: "dragger"
      }, [_vm._v("=")])]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('div', {
        staticClass: "task-delete-btn",
        on: {
          "click": function($event) {
            return _vm.taskDelete(task, task_i, taskcat, taskcat_i)
          }
        }
      }, [_c('svgicon', {
        attrs: {
          "icon": "ionicons/ios-trash-outline"
        }
      })], 1)])])])
    }), 0)], 1), _vm._v(" "), _c('div', {
      staticClass: "subtotal"
    }, [_c('div', {
      staticClass: "row row-subtotal"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('span', {
      staticClass: "add-task-entry",
      on: {
        "click": function($event) {
          return _vm.addTask(taskcat_i)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tIndsæt række\n\t\t\t\t\t\t\t\t")]), _vm._v("   \n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "add-task-entry",
      on: {
        "click": function($event) {
          return _vm.addTaskcat(taskcat_i)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tkategori\n\t\t\t\t\t\t\t\t")]), _vm._v("   \n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "add-task-entry",
      on: {
        "click": function($event) {
          return _vm.triggerSpecLineRobot(taskcat_i)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tforslag\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }), _vm._v(" "), (_vm.spec.showCatHrs) ? _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "subtotal-hours"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getCatTotalHours(taskcat)) + "\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [(_vm.spec.showCatTotals) ? _c('div', {
      staticClass: "subtotal-budget"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.outputMoney(_vm.getCatTotalBudget(taskcat))) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }), _vm._v(" "), _c('div', {
      staticClass: "col"
    })])])])
  }), 0), _vm._v(" "), (!_vm.spec.taskcats || !_vm.spec.taskcats.length) ? _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.addTaskcat()
      }
    }
  }, [_vm._v("\n\t\t\t\tTIlføj kategori\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.spec.taskcats && _vm.spec.taskcats.length) ? _c('div', {
    staticClass: "total"
  }, [_c('div', {
    staticClass: "row row-total"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "total-title"
  }, [_vm._v("\n\t\t\t\t\t\t\tTotal ex. moms\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "total-hours"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.total_hours) + "\t\t\t\t\t\t\t\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "total-budget"
  }, [_vm._v("\t\t\t\t\t\t\t\n\t\t\t\t\t\t\tkr. " + _vm._s(_vm._f("money")(_vm.total, 2)) + "\n\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "btn add-task",
    on: {
      "click": function($event) {
        return _vm.addTask()
      }
    }
  }, [_vm._v("Tilføj række")]) : _vm._e(), _vm._v(" "), (_vm.legaltext_below) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s('<br><br>' + _vm.legaltext_below)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notes-section"
  }, [_c('h4', {}, [_vm._v("Betingelser")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.notes_text)
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spec.notes),
      expression: "spec.notes"
    }],
    ref: "notesTextArea",
    staticClass: "notes-text-input",
    class: {
      empty: (!_vm.spec.notes.length)
    },
    attrs: {
      "rows": "3",
      "data-min-rows": "1",
      "placeholder": "Særlige betingelser?"
    },
    domProps: {
      "value": (_vm.spec.notes)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.spec, "notes", $event.target.value)
      }, function($event) {
        return _vm.autoSizeTextAreaNotes()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spec-footer"
  }, [_c('div', {
    staticClass: "footer-logo"
  }, [_c('svgicon', {
    attrs: {
      "icon": "logo"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("Milk Studio ApS, Strandgade 70, 1. 1401 København K. CVR 38750224")])])])]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Visning",
      "open": false,
      "header-toggle": "",
      "cls": "print-invisible"
    }
  }, [_c('div', {
    staticClass: "cols cols-4"
  }, [_c('btn', {
    attrs: {
      "color": "secondary",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleShowDescriptions()
      }
    }
  }, [(this.spec.showDescriptions) ? [_vm._v("● Tekstbeskrivelser")] : [_vm._v("○ Tekstbeskrivelser")]], 2), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleSpecSetting('showLineTotals')
      }
    }
  }, [(_vm.spec.showLineTotals) ? [_vm._v("● Linje-totaler")] : [_vm._v("○ Linje-totaler")]], 2), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleSpecSetting('showCatHrs')
      }
    }
  }, [(_vm.spec.showCatHrs) ? [_vm._v("● Kategori-timer")] : [_vm._v("○ Kategori-timer")]], 2), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleSpecSetting('showCatTotals')
      }
    }
  }, [(_vm.spec.showCatTotals) ? [_vm._v("● Kategori-totaler")] : [_vm._v("○ Kategori-totaler")]], 2)], 1)]), _vm._v(" "), _c('box', {
    attrs: {
      "cls": "print-invisible"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Dato"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spec.date),
      expression: "spec.date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.spec.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.spec, "date", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('btn', {
    attrs: {
      "full": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cloneSpec()
      }
    }
  }, [_vm._v("Kopiér fra...")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('btn', {
    attrs: {
      "full": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downloadPDF()
      }
    }
  }, [_vm._v("Download PDF")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('btn', {
    attrs: {
      "full": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Gem")])], 1)])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn",
    class: _vm.cls,
    attrs: {
      "data-color": _vm.color
    },
    on: {
      "mousedown": function($event) {
        return _vm.doRipple($event)
      }
    }
  }, [(_vm.iconL) ? _c('span', {
    staticClass: "icon-l"
  }, [_vm._v(_vm._s(_vm.iconL))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.iconR) ? _c('span', {
    staticClass: "icon-r"
  }, [_vm._v(_vm._s(_vm.iconR))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ripple",
    style: (_vm.rippleStyle())
  })])
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', [_c('table', {
    staticClass: "table-a"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Projekt")]), _vm._v(" "), _c('th', [_vm._v("Kunde")]), _vm._v(" "), _c('th', [_vm._v("Betalingsmodel")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Til betaling")]), _vm._v(" "), _c('th', [_vm._v("Fakturering")]), _vm._v(" "), _c('th', [_vm._v("Aktiv")])]), _vm._v(" "), _vm._l((_vm.projects_money_owed), function(project, i) {
    return _c('tr', {
      key: 'asd' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + project.client.key
      }
    }, [_vm._v(_vm._s(project.client.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tr_payment_model")(project.payment_model)))]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm._f("money")(project.payable_remaining, 0)) + " kr.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("boolstr")(project.invoice_ready, ['Klar', 'Ikke klar'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tr_project_status")(project.status)))])])
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.posts) ? _c('div', [_c('table', {
    staticClass: "table-eco"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.fields_list), function(field) {
    return [(field == 'title') ? _c('th', [_vm._v("Title")]) : _vm._e(), _vm._v(" "), (field == 'client') ? _c('th', [_vm._v("Kunde")]) : _vm._e(), _vm._v(" "), (field == 'project') ? _c('th', [_vm._v("Opgave")]) : _vm._e(), _vm._v(" "), (field == 'paydate') ? _c('th', [_vm._v("Betalingsdato")]) : _vm._e(), _vm._v(" "), (field == 'invoice_no') ? _c('th', [_vm._v("Faktura #")]) : _vm._e(), _vm._v(" "), (field == 'invoice_date') ? _c('th', [_vm._v("Fakturadato")]) : _vm._e(), _vm._v(" "), (field == 'invoiced') ? _c('th', [_vm._v("Faktureret")]) : _vm._e(), _vm._v(" "), (field == 'paid') ? _c('th', [_vm._v("Betalt")]) : _vm._e(), _vm._v(" "), (field == 'amount') ? _c('th', {
      staticClass: "align-r"
    }, [_vm._v("Kr. ex. moms")]) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.posts), function(post, i) {
    return _c('tr', {
      class: _vm.negaPosi_cls(post.amount_dkk_ex_vat)
    }, [_vm._l((_vm.fields_list), function(field) {
      return [(field == 'title') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm.economypostTitle(post) || '?') + "\n            ")])]) : _vm._e(), _vm._v(" "), (field == 'project') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [(post.project_key) ? [_vm._v("\n                " + _vm._s(_vm.projects[post.project_key].name) + "\n              ")] : [_vm._v("\n                —\n              ")]], 2)]) : _vm._e(), _vm._v(" "), (field == 'client') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [(post.client_key) ? [_vm._v("\n                " + _vm._s(_vm.clients[post.client_key].name) + "\n              ")] : [_vm._v("\n                —\n              ")]], 2)]) : _vm._e(), _vm._v(" "), (field == 'invoice_date') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(post.invoice_date || '?') + "\n            ")])]) : _vm._e(), _vm._v(" "), (field == 'paydatet') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(post.payment_due_date || '?') + "\n            ")])]) : _vm._e(), _vm._v(" "), (field == 'invoice_no') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(post.invoice_no || '?') + "\n            ")])]) : _vm._e(), _vm._v(" "), (field == 'invoiced') ? _c('td', [(post.invoiced) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/checkmark"
        }
      }) : [_vm._v("—")]], 2) : _vm._e(), _vm._v(" "), (field == 'paid') ? _c('td', [(post.paid) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/checkmark"
        }
      }) : [_vm._v("—")]], 2) : _vm._e(), _vm._v(" "), (field == 'amount') ? _c('td', [_c('div', {
        staticClass: "textlink",
        on: {
          "click": function($event) {
            return _vm.openEconomypost(post)
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm._f("money")(post.amount_dkk_ex_vat, 0)) + "\n            ")])]) : _vm._e()]
    })], 2)
  }), _vm._v(" "), (_vm.totals) ? _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.colcount
    }
  })]) : _vm._e()], 2), _vm._v(" "), (_vm.totals) ? _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.colcount - 2
    }
  }), _vm._v(" "), _c('td', {}, [_vm._v("Indtægter")]), _vm._v(" "), _c('td', {
    staticClass: "align-r posi"
  }, [_vm._v("\n          " + _vm._s(_vm._f("money")(_vm.totals.income_total, 0)) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.colcount - 2
    }
  }), _vm._v(" "), _c('td', {}, [_vm._v("Udgifter")]), _vm._v(" "), _c('td', {
    staticClass: "nega"
  }, [_vm._v("\n          " + _vm._s(_vm._f("money")(_vm.totals.expense_total, 0)) + "\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.colcount
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.colcount - 2
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('td', {
    class: _vm.negaPosi_cls(_vm.totals.total)
  }, [_c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.totals.total, 0)))])])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {}, [_c('b', [_vm._v("Total")])])
}]}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "filterbtns"
  }, [_vm._l((_vm.filter_areas), function(v, i) {
    return [_c('filterbtn', {
      attrs: {
        "active": (_vm.filter_area == v)
      },
      nativeOn: {
        "click": function($event) {
          _vm.filter_area = _vm.filter_areas[i]
        }
      }
    }, [_vm._v(_vm._s(v))])]
  })], 2), _vm._v(" "), (_vm.filter_area == 'boxes') ? [_c('box', {
    attrs: {
      "label": "Basic box"
    }
  }, [_vm._v("\n      Basic box\n    ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Basic box, meta content"
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_vm._v("\n        [Meta-r]\n        "), _c('span', {
    staticClass: "textlink"
  }, [_vm._v("Link")]), _vm._v(" "), _c('span', {
    staticClass: "textlink"
  }, [_vm._v("Link")])]), _vm._v("\n      Basic box, meta content\n    ")], 2), _vm._v(" "), _c('box', {
    attrs: {
      "label": "box-ception",
      "open": _vm.boxOpenStatus1
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('boxOpenStatus1')
      }
    }
  }, [_c('box', {
    attrs: {
      "label": "box-ception",
      "open": _vm.boxOpenStatus2
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('boxOpenStatus2')
      }
    }
  }, [_c('box', {
    attrs: {
      "label": "box-ception",
      "open": _vm.boxOpenStatus3
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('boxOpenStatus3')
      }
    }
  }, [_vm._v("\n          open status handled with var and var update\n        ")])], 1)], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "open = static non-var true",
      "open": true
    }
  }, [_vm._v("\n      open = static non-var true\n    ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "open = static non-var false",
      "open": false
    }
  }, [_vm._v("\n      open = static non-var false\n    ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Full header toggle-able",
      "open": false,
      "header-toggle": ""
    }
  }, [_vm._v("\n      Lorem ipsum dolor amet si\n    ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Only one box visible at a time",
      "open": true
    }
  }, [_c('box', {
    attrs: {
      "label": "Box 1",
      "open": _vm.boxOpenStatus_a1
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.setOnlyOneTrue(0, ['boxOpenStatus_a1', 'boxOpenStatus_a2', 'boxOpenStatus_a3'])
      }
    }
  }, [_vm._v("\n        Box 1\n      ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Box 2 (full header togglable)",
      "open": _vm.boxOpenStatus_a2,
      "header-toggle": ""
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.setOnlyOneTrue(1, ['boxOpenStatus_a1', 'boxOpenStatus_a2', 'boxOpenStatus_a3'])
      }
    }
  }, [_vm._v("\n        Box 2\n      ")]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Box 3",
      "open": _vm.boxOpenStatus_a3
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.setOnlyOneTrue(2, ['boxOpenStatus_a1', 'boxOpenStatus_a2', 'boxOpenStatus_a3'])
      }
    }
  }, [_vm._v("\n        Box 3\n      ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'tabs') ? [_c('box', {
    attrs: {
      "label": "Tabs"
    }
  }, [_c('tabs', {
    attrs: {
      "active-tab": _vm.tabs1_activeIndex
    }
  }, [_c('tab', {
    attrs: {
      "label": "First tab"
    }
  }, [_vm._v("\n            This is the content of the first tab\n        ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "label": "Second tab"
    }
  }, [_vm._v("\n            This is the content of the second tab\n        ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "label": "Custom fragment"
    }
  }, [_vm._v("\n            The fragment that is appended to the url can be customized\n        ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "prefix": "X<span class='glyphicon glyphicon-star'></span>X ",
      "label": "Prefix and suffix",
      "suffix": " Y<span class='badge'>4</span>Y"
    }
  }, [_vm._v("\n            A prefix and a suffix can be added\n        ")])], 1)], 1), _vm._v(" "), _c('tabs', {
    attrs: {
      "look": "boxed",
      "active-tab": _vm.tabs1_activeIndex
    }
  }, [_c('tab', {
    attrs: {
      "label": "First tab"
    }
  }, [_vm._v("\n          This is the content of the first tab\n      ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "label": "Second tab"
    }
  }, [_c('tabs', {
    attrs: {
      "look": "boxed",
      "active-tab": _vm.tabs1_activeIndex
    }
  }, [_c('tab', {
    attrs: {
      "label": "First tab"
    }
  }, [_vm._v("\n              This is the content of the first tab\n          ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "label": "Second tab"
    }
  }, [_vm._v("\n              This is the content of the second tab\n          ")]), _vm._v(" "), _c('tab', {
    attrs: {
      "prefix": "X<span class='glyphicon glyphicon-star'></span>X ",
      "label": "Prefix and suffix",
      "suffix": " Y<span class='badge'>4</span>Y"
    }
  }, [_vm._v("\n              A prefix and a suffix can be added\n          ")])], 1)], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "prefix": "X<span class='glyphicon glyphicon-star'></span>X ",
      "label": "Prefix and suffix",
      "suffix": " Y<span class='badge'>4</span>Y"
    }
  }, [_vm._v("\n          A prefix and a suffix can be added\n      ")])], 1), _vm._v(" "), _c('TabBoxes', {
    attrs: {
      "tabs": [{
        label: 'tab1'
      }, {
        label: 'tab2'
      }]
    }
  }, [_c('template', {
    slot: "tab1"
  }, [_vm._v("Tab 1 her")]), _vm._v(" "), _c('template', {
    slot: "tab2"
  }, [_vm._v("Tab 2 her")])], 2)] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'buttons') ? [_c('btn', [_vm._v("Btn color1")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Btn primary")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("Btn secondary")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "tertiary"
    }
  }, [_vm._v("Btn tertiary")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "danger"
    }
  }, [_vm._v("Btn danger")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("Btn warning")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("Btn success")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary",
      "disabled": ""
    }
  }, [_vm._v("Btn disabled")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Large and small"
    }
  }, [_c('btn', {
    attrs: {
      "color": "primary",
      "large": ""
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Normal")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary",
      "small": ""
    }
  }, [_vm._v("Small")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "filterbtns"
  }, [_vm._l((3), function(i) {
    return [_c('filterbtn', [_vm._v("Filterbtn")])]
  }), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": "true"
    }
  }, [_vm._v("Filterbtn")])], 2), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('btn', {
    attrs: {
      "icon-r": "Y"
    }
  }, [_vm._v("Button")]), _vm._v(" "), _c('btn', {
    attrs: {
      "icon-l": "X",
      "color": "secondary"
    }
  }, [_vm._v("Button")]), _vm._v(" "), _vm._v("\"\" icon-l=\"X\" color=\"secondary\">Button")] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'interactions') ? [_c('box', {
    attrs: {
      "label": "Interactions"
    }
  }, [_c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.triggerToast()
      }
    }
  }, [_vm._v("Trigger toast")])], 1)] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'inputs') ? [_c('box', {
    attrs: {
      "label": "Checkboxes"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxey12),
      expression: "checkboxey12"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kj12b3kj"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkboxey12) ? _vm._i(_vm.checkboxey12, null) > -1 : (_vm.checkboxey12)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkboxey12,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkboxey12 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkboxey12 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkboxey12 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kj12b3kj"
    }
  }, [_vm._v("Label")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxey12),
      expression: "checkboxey12"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kjh123"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkboxey12) ? _vm._i(_vm.checkboxey12, null) > -1 : (_vm.checkboxey12)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checkboxey12,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkboxey12 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkboxey12 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkboxey12 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kjh123"
    }
  }, [_vm._v("Label")])])]), _vm._v(" "), _c('box', [_c('inputfield', {
    attrs: {
      "_label": "Timer",
      "suffix": "timer"
    }
  }, [_c('input', {
    staticClass: "number-btns",
    attrs: {
      "type": "number",
      "min": "0.25",
      "max": "3",
      "step": "0.25",
      "placeholder": "0"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Timer",
      "suffix": "xxx"
    }
  }, [_c('input', {
    staticClass: "number-btns",
    attrs: {
      "type": "number",
      "min": "0.25",
      "max": "3",
      "step": "0.25",
      "placeholder": "0"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Select box"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v("Vælg...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "a"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "b"
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "c"
    }
  }, [_vm._v("C")])]), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Med ikon",
      "icon": "linearicons/arrow-left"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Med ikon",
      "icon": "linearicons/alarm"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  })])], 1)] : _vm._e(), _vm._v(" "), (_vm.filter_area == 'whatever') ? [_c('box', [_c('minidonut', {
    attrs: {
      "pct": 22,
      "color": 'white',
      "bgcolor": 'rgba(255,255,255,.3)'
    }
  }), _vm._v(" "), _c('minipctbar', {
    attrs: {
      "pct": 52,
      "color": 'white',
      "bgcolor": 'rgba(255,255,255,.3)'
    }
  }), _vm._v(" "), _c('minidonut', {
    attrs: {
      "pct": 36
    }
  }), _vm._v(" "), _c('minipctbar', {
    attrs: {
      "pct": 73
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, _vm._l((2), function(i) {
    return _c('div', {
      staticClass: "col m50"
    }, [_c('box', {
      attrs: {
        "label": "Box"
      }
    }, [_vm._v("Box")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, _vm._l((5), function(i) {
    return _c('div', {
      staticClass: "col m20"
    }, [_c('box', {
      attrs: {
        "label": "Box"
      }
    }, [_vm._v("Box")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, _vm._l((10), function(i) {
    return _c('div', {
      staticClass: "col m10"
    }, [_c('box', {
      attrs: {
        "label": "Box"
      }
    }, [_vm._v("Box")])], 1)
  }), 0), _vm._v(" "), _c('p', [_vm._v("Global data: Appname: " + _vm._s(_vm.globals.name) + ", " + _vm._s(_vm.globals.count) + " -\n  \t\t"), _c('span', {
    on: {
      "click": function($event) {
        return _vm.incrementGlobalCount()
      }
    }
  }, [_vm._v(_vm._s(_vm.globals.count))])]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Trend charts"
    }
  }, [_c('trend', {
    attrs: {
      "data": [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
      "gradient": ['#6fa8dc', '#42b983', '#2c3e50'],
      "auto-draw": "",
      "smooth": ""
    }
  })], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Boxlabel"
    }
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.")]), _vm._v(" "), _c('btn', [_vm._v("Buttoner")])], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "label here, yo"
    }
  }, [_vm._v("\n  \t\tYo, box indhold\n  \t\t"), _c('btn', [_vm._v("Yiffy")]), _vm._v(" "), _c('btn', [_vm._v("Yallo")])], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "element-ui"
    }
  }), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Vue stuff to implement"
    }
  }, [_c('p', [_vm._v("Generic UI USE THIS !!!: https://josephuspaye.github.io/Keen-UI/#/ui-tabs")]), _vm._v(" "), _c('p', [_vm._v("Brug alt herfra, navnligt select")]), _vm._v(" "), _c('p', [_vm._v("Tooltips")]), _vm._v(" "), _c('p', [_vm._v("Alert/confirm/prompts")]), _vm._v(" "), _c('p', [_vm._v("Datatables: filter, pagination, sort, perpage")]), _vm._v(" "), _c('p', [_vm._v("https://github.com/surmon-china/vue-awesome-swiper")]), _vm._v(" "), _c('p', [_vm._v("Charts")]), _vm._v(" "), _c('p', [_vm._v("time/Date/calendarpicker")]), _vm._v(" "), _c('p', [_vm._v("Avatars")]), _vm._v(" "), _c('p', [_vm._v("Trello kanban: https://github.com/BrockReece/vue-kanban")]), _vm._v(" "), _c('p', [_vm._v("Wysiwyg")]), _vm._v(" "), _c('p', [_vm._v("Selectiz")]), _vm._v(" "), _c('p', [_vm._v("Colorpicker")])])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spec-line-robot"
  }, [_c('div', {
    staticClass: "align-c btn-rows"
  }, [_vm._l((_vm.suggestions), function(sug, sug_i) {
    return (_vm.sug_index == undefined) ? [_c('btn', {
      attrs: {
        "color": "secondary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.sug_index = sug_i
        }
      }
    }, [_vm._v(_vm._s(sug.title))]), _vm._v(" \n\t\t")] : _vm._e()
  })], 2), _vm._v(" "), (_vm.sug_index != undefined) ? [_c('div', {
    staticClass: "align-c btn-rows"
  }, [_c('btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sug_index = undefined
      }
    }
  }, [_vm._v("← Tilbage")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.suggestions[_vm.sug_index].entries), function(entry, entry_i) {
    return [_c('btn', {
      attrs: {
        "icon-r": "+"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectEntry(entry)
        },
        "mouseover": function($event) {
          _vm.preview = entry
        },
        "mouseout": function($event) {
          _vm.preview = undefined
        }
      }
    }, [_vm._v(_vm._s(entry.title))]), _vm._v(" \n\t\t\t")]
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.sug_index != undefined && _vm.preview) ? _c('div', {
    staticClass: "preview"
  }, [(_vm.preview) ? [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.preview.line.title) + " — " + _vm._s(_vm.preview.line.hours) + " timer")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.preview.line.text))])] : _vm._e()], 2) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table-a timelogs-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.timelogs_dataloaded), function(timelog, i) {
    return [(_vm.separate_dates && _vm.timelogListDateSpacerBoolean(_vm.timelogs, i)) ? _c('tr', {
      key: 'tf23' + i
    }, [_c('td', {
      staticClass: "timelog-date-spacer",
      attrs: {
        "colspan": "9"
      }
    })]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "text": _vm._f("milkinitials")(timelog.user.email)
      }
    })], 1), _vm._v(" "), (false) ? _c('td', [_c('avatar', {
      attrs: {
        "input": timelog.user
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm._f("weekday1dk")(_vm.nicedate(timelog.date, 'ddd D/M-YY'))) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.hours) + " t\n            ")]), _vm._v(" "), _c('td', [(timelog.project) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + timelog.project.key
      }
    }, [_vm._v(_vm._s(timelog.project.name))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (timelog.client) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + timelog.client.key
      }
    }, [_vm._v(_vm._s(timelog.client.name))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.translateWorktype(timelog.worktype)) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.title) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.editTimelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/pencil"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.delete_timelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/trash"
      }
    })], 1)])])]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Note")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])
}]}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('box', {
    attrs: {
      "label": _vm.title
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('span', {
    staticClass: "textlink",
    class: {
      'disabled': false
    },
    on: {
      "click": function($event) {
        return _vm.zoomIn()
      }
    }
  }, [_vm._v("Zoom in")]), _vm._v("\n\t\t\t   \n\t\t\t"), _c('span', {
    staticClass: "textlink",
    class: {
      'disabled': (_vm.field_width <= 10)
    },
    on: {
      "click": function($event) {
        return _vm.zoomOut()
      }
    }
  }, [_vm._v("Zoom out")]), _vm._v("\n\t\t\t   \n\t\t\t"), _c('span', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        _vm.show_view_options = !_vm.show_view_options
      }
    }
  }, [_vm._v("Visning")])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-container",
    class: {
      'has-sidebar': _vm.show_sidebar, 'grid-highlight-weeks': true
    }
  }, [(_vm.show_sidebar) ? _c('div', {
    staticClass: "timeline-sidebar",
    style: ({
      'width': _vm.sidebar_width + 'px'
    })
  }, [_c('div', {
    staticClass: "timeline-row months"
  }, [_c('div', {
    staticClass: "field month"
  }, [_vm._v("Måned")])]), _vm._v(" "), (_vm.show_dates) ? _c('div', {
    staticClass: "timeline-row daynames"
  }, [_c('div', {
    staticClass: "field dayname"
  }, [_vm._v("Ugedag")])]) : _vm._e(), _vm._v(" "), (_vm.show_dates) ? _c('div', {
    staticClass: "timeline-row daynumbers"
  }, [_c('div', {
    staticClass: "field daynumber"
  }, [_vm._v("Dag")])]) : _vm._e(), _vm._v(" "), (_vm.show_weeks) ? _c('div', {
    staticClass: "timeline-row weeks"
  }, [_c('div', {
    staticClass: "field week"
  }, [_vm._v("Uge")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.entries), function(entry, entry_i) {
    return [_c('div', {
      staticClass: "timeline-row"
    }, [_c('div', {
      staticClass: "field entry",
      on: {
        "click": function($event) {
          return _vm.onEntrySidebarClick(entry)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(entry.title) + "\n\t\t\t\t\t\t")])])]
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "timeline-content-container",
    style: (_vm.timeline_content_container_css)
  }, [_c('div', {
    staticClass: "timeline-content",
    style: (_vm.timeline_content_css)
  }, [_c('div', {
    staticClass: "timeline-row months"
  }, [_vm._l((_vm.timeline_months), function(d, i) {
    return [_c('div', {
      staticClass: "field month",
      style: (_vm.month_field_css(d))
    }, [_vm._v(_vm._s(_vm.monthTitles[d.m]) + " " + _vm._s(d.y))])]
  })], 2), _vm._v(" "), (_vm.show_dates) ? _c('div', {
    staticClass: "timeline-row daynames"
  }, [_vm._l((_vm.timeline_dates), function(d, i) {
    return [_c('div', {
      staticClass: "field dayname",
      class: _vm.field_classes(d),
      style: (_vm.field_css)
    }, [_vm._v(_vm._s(_vm.dayInitials[d.dn]))])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.show_dates) ? _c('div', {
    staticClass: "timeline-row daynumbers"
  }, [_vm._l((_vm.timeline_dates), function(d, i) {
    return [_c('div', {
      staticClass: "field daynumber",
      class: _vm.field_classes(d),
      style: (_vm.field_css)
    }, [_vm._v(_vm._s(d.d))])]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.show_weeks) ? _c('div', {
    staticClass: "timeline-row weeks"
  }, [_vm._l((_vm.timeline_weeks), function(d, i) {
    return [_c('div', {
      staticClass: "field week",
      style: (_vm.month_field_css(d))
    }, [_vm._v("Uge " + _vm._s(d.w))])]
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.entries), function(entry, entry_i) {
    return [_c('div', {
      staticClass: "timeline-row entry"
    }, [_vm._l((_vm.timeline_dates), function(d, i) {
      return [_c('div', {
        staticClass: "field entry jeff",
        class: _vm.field_classes(d),
        style: (_vm.field_css)
      })]
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-entry",
      class: _vm.entry_marker_classes(entry),
      style: (_vm.entry_marker_css(entry)),
      on: {
        "click": function($event) {
          return _vm.onEntryClick(entry)
        }
      }
    }, [(entry.title) ? _c('div', {
      staticClass: "title",
      style: (_vm.entry_marker_title_css(entry))
    }, [_vm._v(_vm._s(entry.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "middle"
    }), _vm._v(" "), _c('div', {
      staticClass: "end end-r",
      style: (_vm.entry_marker_end_css('r', entry))
    }), _vm._v(" "), _c('div', {
      staticClass: "end end-l",
      style: (_vm.entry_marker_end_css('l', entry))
    }), _vm._v(" "), (entry.done_pct) ? _c('div', {
      staticClass: "done-bar",
      style: (_vm.entry_marker_donebar_css(entry))
    }) : _vm._e()])], 2)]
  })], 2)])]), _vm._v(" "), (_vm.show_view_options) ? [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m10"
  }, [_c('inputfield', {
    attrs: {
      "label": "Vis Datoer"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_dates),
      expression: "show_dates"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_dates) ? _vm._i(_vm.show_dates, null) > -1 : (_vm.show_dates)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_dates,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_dates = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_dates = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_dates = $$c
        }
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m10"
  }, [_c('inputfield', {
    attrs: {
      "label": "Vis uger"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_weeks),
      expression: "show_weeks"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_weeks) ? _vm._i(_vm.show_weeks, null) > -1 : (_vm.show_weeks)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_weeks,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_weeks = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_weeks = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_weeks = $$c
        }
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [_c('inputfield', {
    attrs: {
      "label": "Highlight uger"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grid_highlight_weeks),
      expression: "grid_highlight_weeks"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.grid_highlight_weeks) ? _vm._i(_vm.grid_highlight_weeks, null) > -1 : (_vm.grid_highlight_weeks)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grid_highlight_weeks,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grid_highlight_weeks = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grid_highlight_weeks = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grid_highlight_weeks = $$c
        }
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [_c('inputfield', {
    attrs: {
      "label": "Vis sidebar"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_sidebar),
      expression: "show_sidebar"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_sidebar) ? _vm._i(_vm.show_sidebar, null) > -1 : (_vm.show_sidebar)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_sidebar,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_sidebar = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_sidebar = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_sidebar = $$c
        }
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m10"
  }, [_c('inputfield', {
    attrs: {
      "label": "Sidebar bredde"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sidebarWidth),
      expression: "sidebarWidth"
    }],
    attrs: {
      "type": "number",
      "min": "20",
      "max": "600",
      "step": "10"
    },
    domProps: {
      "value": (_vm.sidebarWidth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sidebarWidth = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m20"
  }, [(_vm.globals.show_beta_content) ? _c('select', {
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "done_pct"
    }
  }, [_vm._v("BETA: Vis opgavers færdighed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "time_spent_pct"
    }
  }, [_vm._v("BETA: Vis opgavers tidsforbrug")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "booked_pct"
    }
  }, [_vm._v("BETA: Vis opgavers tidsbooking")])]) : _vm._e()])]), _vm._v(" "), (_vm.globals.show_beta_content) ? [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Beta: Days back"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days_back),
      expression: "days_back"
    }],
    attrs: {
      "type": "number",
      "min": "20",
      "max": "600",
      "step": "10"
    },
    domProps: {
      "value": (_vm.days_back)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days_back = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Days ahead"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days_ahead),
      expression: "days_ahead"
    }],
    attrs: {
      "type": "number",
      "min": "20",
      "max": "600",
      "step": "10"
    },
    domProps: {
      "value": (_vm.days_ahead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days_ahead = $event.target.value
      }
    }
  })])], 1)])] : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table-a"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.invoices), function(invoice, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(invoice.invoice_no))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.msg(invoice.title)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("cut")(invoice.title, 25)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.status))]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm._f("money")(invoice.total_ex_vat_dkk, 2)) + " kr.")]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [(_vm.hasMatchingEconomyPost(invoice)) ? _c('span', [_vm._v("✓")]) : _c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.copyInvoiceToEconomyPost(invoice)
        }
      }
    }, [_vm._v("Kopiér")])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "align-r",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "align-r"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.total, 2)) + " kr.")])]), _vm._v(" "), _c('td')])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Faktura #")]), _vm._v(" "), _c('th', [_vm._v("Tekst")]), _vm._v(" "), _c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Ex. moms")]), _vm._v(" "), _c('th')])
}]}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'off-canvas-menu-active': _vm.globals.off_canvas_menu_active
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "context-bg",
    style: (_vm.contextbg_css)
  }, [_c('div', {
    staticClass: "img",
    style: (_vm.contextbgimg_css)
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.state.context_bg.bgimg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade"
  })])]), _vm._v(" "), (_vm.globals.authentication_checked && _vm.globals.user.authenticated == false) ? _c('login') : _vm._e(), _vm._v(" "), (_vm.globals.authentication_checked && _vm.globals.user.authenticated == true) ? [(_vm.firebase_synced_and_ready) ? _c('div', {
    attrs: {
      "id": "menubtn"
    },
    on: {
      "click": function($event) {
        return _vm.toggleOffCanvasMenuActive()
      }
    }
  }, [_c('div'), _c('div'), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.firebase_synced_and_ready) ? _c('leftnavbar') : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.globals.modal_timeline_project_popup.active) ? _c('modal-timeline-project-popup') : _vm._e(), _vm._v(" "), (_vm.firebase_synced_and_ready) ? [_c('router-view')] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), _c('timelogger'), _vm._v(" "), (_vm.globals.modal_timelog_edit.active) ? _c('modal-timelog-edit') : _vm._e(), _vm._v(" "), (_vm.globals.modal_economypost_edit.active) ? _c('modal-economypost-edit') : _vm._e(), _vm._v(" "), (_vm.$store.state.timeloggerBasic.active) ? _c('modal', {
    attrs: {
      "no-dimmer-close": "",
      "cls": 'modal-timelogger-basic closebtn-outside'
    },
    on: {
      "close": function($event) {
        return _vm.$store.commit('set__timeloggerBasic_active', false)
      }
    }
  }, [_c('timelogger-basic')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.specLineRobot.active) ? _c('modal', {
    attrs: {
      "no-dimmer-close": "",
      "cls": 'spec-line-robot closebtn-outside'
    },
    on: {
      "close": function($event) {
        return _vm.$store.commit('set__specLineRobot_active', false)
      }
    }
  }, [_c('spec-line-robot')], 1) : _vm._e(), _vm._v(" "), (_vm.globals.small_spinner || _vm.$store.state.small_spinner) ? _c('div', {
    attrs: {
      "id": "small-spinner"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.firebase_synced_and_ready && _vm.user) ? [_c('div', {
    attrs: {
      "id": "small-spinner"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app_loadbar"
    }
  }, [_c('div', {
    attrs: {
      "id": "bg"
    }
  }), _vm._v(" "), _c('div', {
    style: ({
      'width': _vm.firebase_load_pct + '%'
    }),
    attrs: {
      "id": "fill"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "loadingtextman"
    }
  }, [_vm._v(_vm._s(_vm.loadingtextman_text))])] : _vm._e(), _vm._v(" "), (_vm.globals.big_spinner || _vm.$store.state.big_spinner) ? _c('div', {
    attrs: {
      "id": "big-spinner"
    }
  }, [_c('div', {
    attrs: {
      "id": "spinner"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "done-signal",
      "_v-if": "doneSignal"
    }
  }), _vm._v(" "), (_vm.iconSignal) ? _c('div', {
    attrs: {
      "id": "icon-signal"
    }
  }, [(_vm.iconSignal == 'heart') ? _c('svgicon', {
    attrs: {
      "icon": "ionicons/android-favorite-outline"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.iconSignal == 'check') ? _c('svgicon', {
    attrs: {
      "icon": "ionicons/checkmark"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.iconSignal == 'thumbsup') ? _c('svgicon', {
    attrs: {
      "icon": "linearicons/thumbs-up"
    }
  }) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', {
    attrs: {
      "label": "Mine indstillinger"
    }
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toggle_show_beta_content
    }
  }, [(_vm.show_beta_content) ? [_vm._v("● beta-indhold")] : [_vm._v("○ beta-indhold")]], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toggle_show_debug_data_boxes
    }
  }, [(_vm.show_debug_data_boxes) ? [_vm._v("● dev debug boxes")] : [_vm._v("○ dev debug boxes")]], 2), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Skift theme")]), _vm._v(" "), _vm._l((_vm.themes), function(theme, theme_key) {
    return [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.apply_ui_theme(theme_key)
        }
      }
    }, [_vm._v(_vm._s(theme_key))]), _vm._v(" "), _c('br')]
  }), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.goto('/tema-editor')
      }
    }
  }, [_vm._v("Tema editor")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.goto('/kitchensink')
      }
    }
  }, [_vm._v("Kitchensink")])], 2), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Tips & tricks"
    }
  }, [_c('table', {
    staticClass: "table-a"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("> Tags kan defineres på projekter eller kunde, under instillinger.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> Projekter tagget 'fakturaklar' markeres klar til fakturering på hjemmeskærmen.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> Projekter tagget med ens initialer (det før @ i ens Milk mail, f.eks. 'an') vises på ens hjemmeskærm så længe de ikke er afsluttede.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> Man kan skifte theme ovenfor, eller selv definere ens egne ønskede farver.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("> Beta indhold kan vises/skjules ved klik på knappen ovenfor.")])])])])]), _vm._v(" "), (_vm.debug_output) ? _c('box', {
    attrs: {
      "label": "debug_output"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.debug_output))])]) : _vm._e(), _vm._v(" "), (_vm.is_user('wp')) ? _c('box', {
    attrs: {
      "label": "WP playground"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', {
    attrs: {
      "label": 'Min arbejdstid seneste uge: ' + _vm.my_timelogs_this_week_hrs + ' t.'
    }
  }, [_c('table', {
    staticClass: "table-timespan-dates"
  }, [_c('tr', _vm._l((_vm.weekTimelogs_timespan), function(entry, i) {
    return _c('th', {
      key: 'affds' + i,
      attrs: {
        "data-day": entry.dayno
      }
    }, [_c('span', {
      staticClass: "l1"
    }, [_vm._v(_vm._s(entry.date.format('ddd')))]), _vm._v(" "), _c('span', {
      staticClass: "l2"
    }, [_vm._v(_vm._s(entry.date.format('D/M')))])])
  }), 0), _vm._v(" "), _c('tr', _vm._l((_vm.weekTimelogs_timespan), function(entry, i) {
    return _c('td', {
      key: 'afds' + i,
      attrs: {
        "data-day": entry.dayno
      }
    }, [_c('span', {
      staticClass: "l1"
    }, [_vm._v(_vm._s(entry.hours_logged))]), _vm._v(" "), _c('span', {
      staticClass: "l2"
    }, [_vm._v("timer")]), _vm._v(" "), _c('div', {
      staticClass: "bar",
      style: (_vm.barHeight(entry.hours_logged, _vm.weekTimelogs_timespan_maxhours))
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('box', {
    attrs: {
      "label": 'Min arbejdstid i dag: ' + _vm.my_timelogs_today_hrs + ' t.'
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.openTimelogger()
      }
    }
  }, [_vm._v("Log tid")])]), _vm._v(" "), _c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Kunde")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.my_timelogs_today), function(timelog, i) {
    return _c('tr', {
      key: 'ads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": _vm.getOne('project', timelog.project_key)
      }
    })], 1), _vm._v(" "), (_vm.getOne('project', timelog.project_key)) ? _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": 'project/' + timelog.project_key
      }
    }, [_vm._v(_vm._s(_vm.getOne('project', timelog.project_key).name))])], 1) : _vm._e(), _vm._v(" "), (_vm.getClientFromTimelog(timelog)) ? _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": 'client/' + _vm.getOne('project', timelog.project_key).client_key
      }
    }, [_vm._v(_vm._s(_vm.getClientFromTimelog(timelog).name))])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.translateWorktype(timelog.worktype)) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(timelog.hours) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.editTimelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/pencil"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.delete_timelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/trash"
      }
    })], 1)])])
  })], 2), _vm._v(" "), (_vm.my_timelogs_today_invoicable_earning) ? _c('div', {
    staticClass: "align-c"
  }, [_c('br'), _vm._v("\n\t\t\t\t\tIndtjening: "), _c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.my_timelogs_today_invoicable_earning)) + " kr.")])]) : _vm._e()], 2), _vm._v(" "), (_vm.is_user('wp')) ? _c('box', [_vm._v("WP todo: Vis economy nøgletal her i minibox.")]) : _vm._e(), _vm._v(" "), _c('masonry', [_c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('clients')
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/rocket"
    }
  }), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Kunder")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('timeline')
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-calendar-outline"
    }
  }), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Timeline")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('timelogs')
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/pie-chart"
    }
  }), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Tidsforbrug")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openTimelogger()
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/pie-chart"
    }
  }), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Log arbejdstid")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('box', {
    attrs: {
      "label": "Mine aktive projekter"
    }
  }, [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.myActiveProjects), function(project, i) {
    return _c('tr', {
      key: 'fads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "title": project.client.name || 'Ingen kunde',
        "to": 'project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimeloggerBasic({
            project_key: project.key
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1)])])
  })], 2)]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Alle aktive projekter",
      "open": false,
      "header-toggle": ""
    }
  }, [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.allActiveProjects), function(project, i) {
    return _c('tr', {
      key: 'fads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "title": project.client.name || 'Ingen kunde...',
        "to": 'project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimeloggerBasic({
            project_key: project.key
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1)])])
  })], 2)]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Klar til fakturering"
    }
  }, [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.projects_invoice_ready), function(project, i) {
    return _c('tr', {
      key: 'fads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "title": project.client.name || 'Ingen kunde',
        "to": 'project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("money")(_vm.$store.getters['projects/get_payable_amount'](project), 2)) + " kr.\n\t\t\t\t\t\t")])])
  })], 2)]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Skyldige betalinger"
    }
  }, [_c('table', {
    staticClass: "table-a timelogs-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Fakturering")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Beløb")])]), _vm._v(" "), _vm._l((_vm.projects_money_owed), function(project, i) {
    return _c('tr', {
      key: 'fads' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "title": project.client.name || 'Ingen kunde',
        "to": 'project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', [(project.invoice_ready) ? _c('span', [_vm._v("Klar")]) : _c('span', [_vm._v("Ikke klar")])]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("money")(project.payable_amount, 0)) + " kr.\n\t\t\t\t\t\t")])])
  })], 2)])], 1)]), _vm._v(" "), (_vm.show_beta_content) ? _c('box', {
    attrs: {
      "label": "BETA"
    }
  }, [_c('p', [_vm._v("[Graf+liste visning over min tid denne uge fordelt på opgaver og arbejdstype]"), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "textlink",
    attrs: {
      "href": "https://trello.com/b/tAdvC4Vw/milk-studio",
      "target": "_blank"
    }
  }, [_vm._v("Link: Trello")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "textlink",
    attrs: {
      "href": "http://williampaix.com/projects/kia",
      "target": "_blank"
    }
  }, [_vm._v("Link: Kia v1")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "textlink",
    attrs: {
      "href": "https://console.firebase.google.com/u/0/project/kira-wpaix/database/data",
      "target": "_blank"
    }
  }, [_vm._v("Link: Firebase console")]), _c('br')]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.gravatarurl('william.p.paix@gmail.com', 150),
      "alt": ""
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    staticClass: "tabs-component-panel"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', [_c('table', {
    staticClass: "table-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "align-l"
  }), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }, [_vm._v("Kunde")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Indtjening")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Faktureret i Dinero")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.clients), function(client, client_i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": client
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + client['.key']
      }
    }, [_vm._v(_vm._s(client.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm._f("money")(client.earning_dkk, 2)) + " kr.")]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm._f("money")(client.invoiced_dkk, 2)) + " kr.")])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "align-r"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.totalInvoiced, 2)) + " kr.")])]), _vm._v(" "), _c('td')])], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', {
    attrs: {
      "label": '' + _vm.filteredClients.length + ' kunder'
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.createNewClient()
      }
    }
  }, [_vm._v("Ny kunde")])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m30"
  }, [_c('inputfield', {
    attrs: {
      "label": "Søg"
    }
  }, [_c('input', {
    ref: "search_filter",
    attrs: {
      "type": "text",
      "placeholder": "Søg"
    },
    domProps: {
      "value": _vm.search_filter
    },
    on: {
      "keyup": _vm.search_filter_updated
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m40"
  }), _vm._v(" "), _c('div', {
    staticClass: "col m30"
  })]), _vm._v(" "), (_vm.filteredClients.length) ? _c('table', {
    staticClass: "table-a"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }), _vm._v(" "), _c('th', {
    staticClass: "align-c"
  }, [_vm._v("Aktive opgaver")]), _vm._v(" "), _c('th', {
    staticClass: "align-c"
  }, [_vm._v("Afsluttede opgaver")]), _vm._v(" "), ( false) ? _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Samlet indtjening")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.filteredClients), function(client, i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": client
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + client['.key']
      }
    }, [_vm._v(_vm._s(client.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-c"
    }, [_vm._v("\n          " + _vm._s(client.active_projects_count) + "            \n        ")]), _vm._v(" "), _c('td', {
      staticClass: "align-c"
    }, [_vm._v("\n          " + _vm._s(client.finished_projects_count) + "\n        ")]), _vm._v(" "), ( false) ? _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n          " + _vm._s(_vm.clientTotalEarning(client['.key'])) + "\n        ")]) : _vm._e()])
  })], 2) : _vm._e()], 2), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewClient()
      }
    }
  }, [_vm._v("Opret ny kunde")]), _vm._v(" "), (_vm.show_debug_data_boxes) ? _c('box', {
    attrs: {
      "label": "Dev data"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.filteredClients))])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-timeline-project-popup"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": _vm.onDimmerClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [_c('p', {
    staticClass: "align-c"
  }, [_c('b', [_vm._v(_vm._s(_vm.project.name))])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Startdato (dd-mm-ååååå)"
    }
  }, [_c('input', {
    ref: "project_start_date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.project.start_date
    },
    on: {
      "change": function($event) {
        return _vm.updateProject(_vm.project, 'start_date')
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Afslutningsdato (dd-mm-ååååå)"
    }
  }, [_c('input', {
    ref: "project_end_date",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.project.end_date
    },
    on: {
      "change": function($event) {
        return _vm.updateProject(_vm.project, 'end_date')
      }
    }
  })])], 1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Opgave færdig %"
    }
  }, [_c('input', {
    ref: "project_done_pct",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.project.done_pct
    },
    on: {
      "change": function($event) {
        return _vm.updateProject(_vm.project, 'done_pct')
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.status),
      expression: "project.status"
    }],
    ref: "project_status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateProjectStatus]
    }
  }, _vm._l((_vm.globals.projectStatuses), function(status, key, i) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(status.title))])
  }), 0)])], 1)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn color2 block full",
    attrs: {
      "href": '#/project/' + _vm.project['.key']
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n\t\t\tGå til opgave\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("X")])])])
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/reports/missing-payments"
    }
  }, [_vm._v("Manglende betaling")]), _c('br'), _vm._v(" "), (0) ? _c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/report-invoicability"
    }
  }, [_vm._v("Fakturérbarhed")]) : _vm._e(), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/reports/missing-input"
    }
  }, [_vm._v("Manglende data")]), _c('br'), _vm._v(" "), (0) ? _c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/report-project-earnability"
    }
  }, [_vm._v("Opgave-rentabilitet")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.economy_access) ? _c('router-link', {
    staticClass: "btn color-primary",
    attrs: {
      "to": "/reports/client-earning"
    }
  }, [_vm._v("Kunde-indtjening")]) : _vm._e(), _c('br')], 1)
},staticRenderFns: []}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', {
    attrs: {
      "label": "Tema editor"
    }
  }, [_c('div', {
    staticClass: "cols cols-3"
  }, [_vm._l((_vm.edited_theme), function(v, k, i) {
    return [_c('div', {
      staticClass: "inputfield"
    }, [_c('label', [_vm._v(_vm._s(k))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": v
      },
      on: {
        "change": function($event) {
          return _vm.updateTheme(k, $event)
        }
      }
    })])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "filterbtns"
  }, [_c('filterbtn', {
    attrs: {
      "active": true
    }
  }, [_vm._v("UI example 1")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": false
    }
  }, [_vm._v("UI example 2")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": false
    }
  }, [_vm._v("UI example 3")])], 1), _vm._v(" "), _c('box', {
    attrs: {
      "label": "UI examples"
    }
  }, [_c('btn', [_vm._v("Btn color1")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "2"
    }
  }, [_vm._v("Btn color2")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "3"
    }
  }, [_vm._v("Btn color3")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "4"
    }
  }, [_vm._v("Btn color4")]), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "4",
      "disabled": ""
    }
  }, [_vm._v("Btn disabled")]), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "hay",
      "icon": "linearicons/arrow-left"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.var1),
      expression: "var1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.var1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.var1 = $event.target.value
      }
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getItemsLength(_vm.items) > _vm.perpage) ? _c('div', {
    staticClass: "pagination"
  }, [_c('div', {
    staticClass: "prev",
    class: {
      hidden: ((_vm.page) < 2)
    },
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _vm._l((_vm.getNumberPages()), function(i) {
    return _c('div', {
      staticClass: "page",
      class: {
        'active': ((_vm.page) == i)
      },
      on: {
        "click": function($event) {
          return _vm.setPage(i)
        }
      }
    }, [_vm._v(_vm._s(i))])
  }), _vm._v(" "), _c('div', {
    staticClass: "next",
    class: {
      hidden: ((_vm.page) + 1 > _vm.getNumberPages())
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_vm._v(">")])], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datatable"
  }, [_c('div', {
    staticClass: "filterer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterstring),
      expression: "filterstring"
    }],
    attrs: {
      "type": "text",
      "placeholder": "filter"
    },
    domProps: {
      "value": (_vm.filterstring)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterstring = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "donut inline",
    attrs: {
      "viewBox": "0 0 100 100"
    }
  }, [_c('circle', {
    staticClass: "bg",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "40",
      "stroke-width": "20",
      "stroke": _vm.getBgColor
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "fill",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "40",
      "stroke-width": "20",
      "stroke": _vm.getColor,
      "stroke-dasharray": "251.2",
      "stroke-dashoffset": _vm.getValue()
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "calendar"
  })
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-timelog-edit"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": _vm.onDimmerClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [(false) ? _c('inputfield', {
    attrs: {
      "label": "Opgave"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globals.modal_timelog_edit.timelog.project_key),
      expression: "globals.modal_timelog_edit.timelog.project_key"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "project_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.projects), function(project, key, i) {
    return _c('option', {
      key: 'tfs23' + i,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(project.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]) : _vm._e(), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Opgave"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.multiselectOptions_project,
      "value": _vm.multielectGetOption(_vm.multiselectOptions_project, 'value', _vm.globals.modal_timelog_edit.timelog.project_key),
      "placeholder": "Vælg...",
      "label": "label",
      "track-by": "value",
      "select-label": "",
      "selected-label": "",
      "deselect-label": "",
      "reset-after": false
    },
    on: {
      "select": function($event) {
        return _vm.multiselectOnSelect_selectProject($event)
      }
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Arbejdstype"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globals.modal_timelog_edit.timelog.worktype),
      expression: "globals.modal_timelog_edit.timelog.worktype"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "worktype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.globals.worktypes), function(worktype, i) {
    return _c('option', {
      key: 'fesfs' + i,
      domProps: {
        "value": worktype.value
      }
    }, [_vm._v(_vm._s(worktype.title))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _c('br'), _vm._v(" "), (false) ? _c('inputfield', {
    attrs: {
      "label": "Kunde",
      "classes": "disabled"
    }
  }, [(_vm.getClient(_vm.timelog.project_key)) ? _c('input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "placeholder": "Timetal"
    },
    domProps: {
      "value": _vm.getClient(_vm.timelog.project_key).name
    }
  }) : _c('input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "placeholder": "Timetal"
    },
    domProps: {
      "value": '?'
    }
  })]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timelog.billable),
      expression: "timelog.billable"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kj12b3kj"
    },
    domProps: {
      "checked": Array.isArray(_vm.timelog.billable) ? _vm._i(_vm.timelog.billable, null) > -1 : (_vm.timelog.billable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.timelog.billable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.timelog, "billable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.timelog, "billable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.timelog, "billable", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kj12b3kj"
    }
  }, [_vm._v("Fakturérbar")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Timer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.globals.modal_timelog_edit.timelog.hours),
      expression: "globals.modal_timelog_edit.timelog.hours",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "step": ".25",
      "min": "0.25",
      "max": "24",
      "placeholder": "Timetal"
    },
    domProps: {
      "value": (_vm.globals.modal_timelog_edit.timelog.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "hours", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Dato"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globals.modal_timelog_edit.timelog.date),
      expression: "globals.modal_timelog_edit.timelog.date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.globals.modal_timelog_edit.timelog.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "date", $event.target.value)
      }
    }
  })]), _c('br')], 1)]), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Kommentar"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globals.modal_timelog_edit.timelog.title),
      expression: "globals.modal_timelog_edit.timelog.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "ect. kommentar"
    },
    domProps: {
      "value": (_vm.globals.modal_timelog_edit.timelog.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.globals.modal_timelog_edit.timelog, "title", $event.target.value)
      }
    }
  })]), _c('br'), _vm._v(" "), _c('btn', {
    attrs: {
      "block": "",
      "color": "2"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Gem")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("X")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "leftnavbar"
    }
  }, [_c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "logo"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/home"
    }
  }), _vm._v("\n\t\t\tHjem\n\t\t")], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isClient()
    },
    on: {
      "click": function($event) {
        return _vm.setView('/clients')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/users"
    }
  }), _vm._v("\n\t\t\tKunder\n\t\t")], 1), _vm._v(" "), (false) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isProject()
    },
    on: {
      "click": function($event) {
        return _vm.setView('/projects')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/rocket"
    }
  }), _vm._v("\n\t\t\tOpgaver\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.show_beta_content) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/timeline'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/timeline')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-calendar-outline"
    }
  }), _vm._v("\n\t\t\tTimeline\n\t\t")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isTimelogs()
    },
    on: {
      "click": function($event) {
        return _vm.setView('/timelogs')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/pie-chart"
    }
  }), _vm._v("\n\t\t\tTidsforbrug\n\t\t")], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isTimelogger()
    },
    on: {
      "click": function($event) {
        return _vm.openTimelogger()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-clock-outline"
    }
  }), _vm._v("\n\t\t\tLog tid\n\t\t")], 1), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.isEconomy()
    },
    on: {
      "click": function($event) {
        return _vm.setView('/economy')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/briefcase"
    }
  }), _vm._v("\n\t\t\tØkonomi\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.is_user('wp') && _vm.economy_access) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/specs'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/specs')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/list"
    }
  }), _vm._v("\n\t\t\tSpecs\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.show_beta_content) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/users'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/users')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/users"
    }
  }), _vm._v("\n\t\t\tUsers\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/reports'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/reports')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/users"
    }
  }), _vm._v("\n\t\t\tRapporter\n\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.show_beta_content) ? _c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: ('rgba(0,0,0,.06)'),
      expression: "'rgba(0,0,0,.06)'"
    }],
    staticClass: "link",
    class: {
      active: _vm.$route.path == '/kitchensink'
    },
    on: {
      "click": function($event) {
        return _vm.setView('/kitchensink')
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/magic-wand"
    }
  }), _vm._v("\n\t\t\tKitchen Sink\n\t\t")], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "logged-in-area"
    }
  }, [_c('avatar', {
    attrs: {
      "input": _vm.my_user
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setView('/my-settings')
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "logoutbtn"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_vm._v("Log ud")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('img', {
    attrs: {
      "src": _vm.src,
      "alt": ""
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view economy"
  }, [_c('div', {
    staticClass: "filterbtns"
  }, _vm._l((_vm.tabs), function(tab, tab_i) {
    return _c('filterbtn', {
      key: 'tab' + tab_i,
      attrs: {
        "active": _vm.tab_key_active == tab.key
      },
      nativeOn: {
        "click": function($event) {
          _vm.tab_key_active = tab.key
        }
      }
    }, [_vm._v(_vm._s(tab.label))])
  }), 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tab_key_active == 'main') ? _c('box', {
    attrs: {
      "label": 'Overblik: ' + _vm.yearTitle
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [(true) ? [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.toggle_calculate_hypothetic_posts()
      }
    }
  }, [(_vm.calculate_hypothetic_posts) ? [_vm._v("● Hypotetiske")] : [_vm._v("○ Hypotetiske")]], 2), _vm._v("\n             \n          "), (_vm.place_posts_by == 'invoice_date') ? _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        _vm.place_posts_by = 'payment_due_date'
      }
    }
  }, [_vm._v("Regnskab")]) : _vm._e(), _vm._v(" "), (_vm.place_posts_by == 'payment_due_date') ? _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        _vm.place_posts_by = 'invoice_date'
      }
    }
  }, [_vm._v("Likviditet")]) : _vm._e(), _vm._v("\n                         \n        ")] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.gotoPrevMonth()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-left"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.gotoNextMonth()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-right"
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('table', {
    staticClass: "table-eco"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.activeYearPosts), function(month, month_i) {
    return _c('th', {
      staticClass: "monthCLickTitle",
      class: {
        active: (_vm.activeMonthNumber == (month.month))
      },
      on: {
        "click": function($event) {
          return _vm.gotoMonthYear(month.month, month.year)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.monthName(month.month))), _c('br'), _vm._v(" " + _vm._s(month.year) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', {}, [_c('td', [_vm._v("Indtægter")]), _vm._v(" "), _vm._l((12), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(_vm.activeYearPosts[i - 1].totals.income_total)
    }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearPosts[i - 1].totals.income_total)))])
  })], 2), _vm._v(" "), _c('tr', {}, [_c('td', [_vm._v("Udgifter")]), _vm._v(" "), _vm._l((12), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(_vm.activeYearPosts[i - 1].totals.expense_total)
    }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearPosts[i - 1].totals.expense_total)))])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": "13"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Total")])]), _vm._v(" "), _vm._l((12), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(_vm.activeYearPosts[i - 1].totals.total)
    }, [_c('b', [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearPosts[i - 1].totals.total)))])])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": "13"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bankbeholdning")]), _vm._v(" "), _vm._l((12), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(10)
    }, [_vm._v(_vm._s(_vm.outputMoney(10)))])
  })], 2)])])])], 2) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'main') ? _c('box', {
    attrs: {
      "label": 'Økonomiposter: ' + _vm.now.format('MMM YYYY')
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.gotoPrevMonth()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-left"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.gotoNextMonth()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/chevron-right"
    }
  })], 1)]), _vm._v(" "), _c('economy-posts', {
    attrs: {
      "posts": _vm.activeMonthPosts.posts,
      "totals": _vm.activeMonthPosts.totals
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewEconomypost()
      }
    }
  }, [_vm._v("Opret ny økonomipost")])], 2) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'keyfigs') ? _c('box', {
    attrs: {
      "label": 'Nøgletal ' + _vm.yearTitle,
      "open": _vm.keyFiguresExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('keyFiguresExpanded')
      }
    }
  }, [_c('table', {
    staticClass: "table-eco"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((4), function(i) {
    return _c('th', [_vm._v("Q" + _vm._s(i))])
  }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.yearTitle))])], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Indtægter")]), _vm._v(" "), _vm._l((4), function(i) {
    return _c('td', {
      staticClass: "posi"
    }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals['q' + i].income, 0)))])
  }), _vm._v(" "), _c('td', {
    staticClass: "posi"
  }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals.year.income, 0)))])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Udgifter")]), _vm._v(" "), _vm._l((4), function(i) {
    return _c('td', {
      staticClass: "nega"
    }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals['q' + i].expense, 0)))])
  }), _vm._v(" "), _c('td', {
    staticClass: "nega"
  }, [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals.year.expense, 0)))])], 2), _vm._v(" "), _c('tr', {
    staticClass: "spacer"
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Total")])]), _vm._v(" "), _vm._l((4), function(i) {
    return _c('td', {
      class: _vm.negaPosi_cls(_vm.activeYearTotals['q' + i].total)
    }, [_c('b', [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals['q' + i].total, 0)))])])
  }), _vm._v(" "), _c('td', {
    class: _vm.negaPosi_cls(_vm.activeYearTotals.year.total)
  }, [_c('b', [_vm._v(_vm._s(_vm.outputMoney(_vm.activeYearTotals.year.total, 0)))])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'missing') ? _c('box', {
    attrs: {
      "label": "Mangler fakturering",
      "open": _vm.missingInvoiceExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('missingInvoiceExpanded')
      }
    }
  }, [_c('p', [_vm._v("Her vises alle posteringer som mangler fakturering, så de kan behandles.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Total: " + _vm._s(_vm.outputMoney(_vm.needing_invoices.totals.total)) + " kr.")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.needing_invoices.posts), function(p) {
    return [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.openEconomypost(p)
        }
      }
    }, [_vm._v("\n        " + _vm._s(p.title || 'Unnamed') + " — " + _vm._s(_vm.outputMoney(p.amount_dkk_ex_vat)) + " kr.\n      ")]), _vm._v("   \n    ")]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'missing') ? _c('box', {
    attrs: {
      "label": "Mangler betaling",
      "open": _vm.missingPaymentExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('missingPaymentExpanded')
      }
    }
  }, [_c('p', [_vm._v("Her vises alle posteringer som mangler bettaling, så de kan behandles.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Total: " + _vm._s(_vm.outputMoney(_vm.needing_payment.totals.total)) + " kr.")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.needing_payment.posts), function(p) {
    return [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.openEconomypost(p)
        }
      }
    }, [_vm._v("\n        " + _vm._s(p.title || 'Unnamed') + " — " + _vm._s(_vm.outputMoney(p.amount_dkk_ex_vat)) + " kr.\n      ")]), _vm._v("   \n    ")]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.tab_key_active == 'vat') ? _c('box', {
    attrs: {
      "label": "Momsafregning",
      "open": _vm.vatViewExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('vatViewExpanded')
      }
    }
  }, [_c('p', [_vm._v("Her vises moms +/-/total på måneds, kvartals og halvårsbasis")])]) : _vm._e(), _vm._v(" "), (false) ? _c('box', {
    attrs: {
      "label": "Indtjening"
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink"
  }, [_vm._v("\n        —\n      ")])]), _vm._v("\n\n    " + _vm._s(_vm.chart1) + "\n\n    "), _c('vue-chart', {
    attrs: {
      "columns": [{
        type: 'string',
        label: 'year'
      }, {
        type: 'string',
        label: 'year2'
      }, {
        type: 'string',
        label: 'year3'
      }],
      "rows": [
        [200, 33, 442],
        [100, 133, 242]
      ],
      "options": {}
    }
  })], 2) : _vm._e(), _vm._v(" "), (false) ? _c('box', {
    attrs: {
      "label": 'Samlet kundeindtjening',
      "open": _vm.clientEarningsExpanded
    },
    on: {
      "toggledOpen": function($event) {
        return _vm.flipBoolean('clientEarningsExpanded')
      }
    }
  }, [_vm._v(">\n    "), _c('template', {
    slot: "meta-r"
  }, [_vm._v("\n      fra "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_earnings_date_from),
      expression: "client_earnings_date_from"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.client_earnings_date_from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_earnings_date_from = $event.target.value
      }
    }
  }), _vm._v(" til "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_earnings_date_to),
      expression: "client_earnings_date_to"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.client_earnings_date_to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client_earnings_date_to = $event.target.value
      }
    }
  }), _vm._v("\n              \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('peity', {
    attrs: {
      "type": 'pie',
      "options": {
        'fill': _vm.pieChartColors,
        width: 250,
        height: 250,
        'innerRadius': 0,
        'radius': 140
      },
      "data": _vm.clientsEconomyListPieData
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('div', {
    staticClass: "chart-minitable"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Kunder")]), _vm._v(" "), _vm._l((_vm.clientsEconomyList), function(entry, i) {
    return _c('div', {
      staticClass: "entry"
    }, [_c('span', {
      staticClass: "colorcircle",
      style: ({
        'background-color': _vm.pieChartColors[i]
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v("\n              " + _vm._s(_vm.clients[entry.client_key].name) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "pct"
    }, [_vm._v("\n              " + _vm._s(entry.pct) + " %\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "hours"
    }, [_vm._v("\n              " + _vm._s(_vm.outputMoney(entry.earning, 'a')) + " kr.\n            ")])])
  })], 2)])])], 2) : _vm._e(), _vm._v(" "), ( false) ? _c('box', {
    attrs: {
      "label": 'Chart'
    }
  }, [_c('vue-chartist', {
    attrs: {
      "data": _vm.chartist_data,
      "options": _vm.chartist_options,
      "type": "Line"
    }
  })], 1) : _vm._e(), _vm._v(" "), ( false) ? _c('box', {
    attrs: {
      "label": 'År: ' + _vm.activeYear
    }
  }, [_c('p', [_vm._v("Sparkline chart over månederne, med enten invoiced, eller også paid, eller begge.")]), _vm._v(" "), _c('table', {
    staticClass: "table-a"
  }, [_c('thead', [_c('tr', _vm._l((12), function(i) {
    return _c('th', {
      class: {
        'this-month': i == _vm.activeMonth
      }
    }, [(i == _vm.activeMonth) ? _c('span', [_vm._v(" --> ")]) : _vm._e(), _vm._v("\n            " + _vm._s(i) + "\n            "), (i == _vm.activeMonth) ? _c('span', [_vm._v(" <-- ")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((12), function(i) {
    return _c('td', {
      class: {
        'this-month': i == _vm.activeMonth
      }
    }, [_vm._v("\n            " + _vm._s(i) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.yearStats) + "\n    ")]), _vm._v(" "), _c('trend', {
    attrs: {
      "data": _vm.yearStats,
      "gradient": ['#000', '#000', '#000'],
      "auto-draw": "",
      "smooth": ""
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view users"
  }, [_c('box', {
    attrs: {
      "label": 'Brugere'
    }
  }, [_c('table', {
    staticClass: "table-a"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fornavn")]), _vm._v(" "), _c('th', [_vm._v("Administrator?")])])]), _vm._v(" "), _vm._l((_vm.users), function(user, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.first_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user))])])
  })], 2), _vm._v(" "), _c('btn', [_vm._v("Opret ny bruger")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filterbtn",
    class: _vm.classes,
    on: {
      "mousedown": function($event) {
        return _vm.doRipple($event)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "ripple",
    style: (_vm.rippleStyle())
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "project-header",
    style: (_vm.header_cls)
  }, [_c('div', {
    staticClass: "pretitle"
  }, [_vm._v("\n      Kunde\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.client.name))])]), _vm._v(" "), _c('div', {
    staticClass: "filterbtns"
  }, [_c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'projects_active'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('projects_active')
      }
    }
  }, [_vm._v("Aktive opgaver")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'projects'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('projects')
      }
    }
  }, [_vm._v("Alle opgaver")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'details'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('details')
      }
    }
  }, [_vm._v("Detaljer")]), _vm._v(" "), (_vm.economy_access) ? _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'economy'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('economy')
      }
    }
  }, [_vm._v("Økonomi")]) : _vm._e(), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'comments'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('comments')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCommentsCount('client', _vm.client['.key'])) + " kommentarer")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'settings'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('settings')
      }
    }
  }, [_vm._v("Indstillinger")])], 1), _vm._v(" "), (_vm.client && _vm.showing == 'settings') ? _c('box', [_c('inputfield', {
    attrs: {
      "label": "Navn"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.client.name
    },
    on: {
      "change": function($event) {
        return _vm.change('name', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Farve"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.client.color
    },
    on: {
      "change": function($event) {
        return _vm.change('color', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Timepris (Kan også projektdefineres)"
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.client.hour_rate
    },
    on: {
      "change": function($event) {
        return _vm.change('hour_rate', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Tags"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.tags),
      expression: "client.tags"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.tags)
    },
    on: {
      "change": function($event) {
        return _vm.change('tags', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "tags", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Background image tags (commasep eg: nature,water)"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.bgimg_tags),
      expression: "client.bgimg_tags"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.bgimg_tags)
    },
    on: {
      "change": function($event) {
        return _vm.change('bgimg_tags', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "bgimg_tags", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "CVR nummer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.cvr),
      expression: "client.cvr"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.cvr)
    },
    on: {
      "change": function($event) {
        return _vm.change('cvr', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "cvr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "2"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitChanges()
      }
    }
  }, [_vm._v("Gem")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.archiveClient()
      }
    }
  }, [_vm._v("Arkivér kunde")])], 1) : _vm._e(), _vm._v(" "), (_vm.economy_access && _vm.showing == 'economy') ? _c('box', {
    attrs: {
      "label": "Økonomiposter"
    }
  }, [_c('economy-posts', {
    attrs: {
      "posts": _vm.economyposts.posts,
      "totals": _vm.economyposts.totals,
      "fields": "title,client,project,invoice_no,invoice_date,invoiced,paid,amount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.economy_access && _vm.showing == 'economy') ? _c('box', {
    attrs: {
      "label": "Dinero faktura-oversigt"
    }
  }, [(!_vm.$store.state.dinero_fetched) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.dinero_fetch_invoices()
      }
    }
  }, [_vm._v("Indlæs Dinero fakturaer")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.dinero_fetched && _vm.client_dinero_invoices) ? _c('dinero-invoices', {
    attrs: {
      "invoices": _vm.client_dinero_invoices
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'details') ? _c('box', {
    attrs: {
      "label": "Detaljer"
    }
  }, [_c('table', {
    staticClass: "table-a"
  }, [_c('tr', [_c('td', [_vm._v("Kundens timepris")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.client.hour_rate, 2)) + " kr.")])]), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Indtjening i alt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.client_total_earning, 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Faktureret i alt (Dinero)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.client_dinero_invoiced_total, 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timer tracket i alt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("decimals")(_vm.client_timelog_totals, 2)) + " timer")])]), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Reel timepris")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.client_total_earning / _vm.client_timelog_totals, 2)) + " kr.\n          ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kunde oprettet")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.client.created, 'DD/MM-YYYY HH:MM')) + " ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showing == 'projects_active') ? _c('box', {
    attrs: {
      "label": _vm.clientActiveProjects.length + ' opgaver'
    }
  }, [_c('table', {
    staticClass: "table-a projects-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Budget")]), _vm._v(" "), _c('th', [_vm._v("Estimeret")]), _vm._v(" "), _c('th', [_vm._v("Tracket")]), _vm._v(" "), _c('th', [_vm._v("Tidsforbrug")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.clientActiveProjects), function(project, i) {
    return _c('tr', {
      key: 'fadsfd' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + project['.key']
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(_vm._f("money")(project.budget, 0), 0)) + " kr.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(project.estimated_hrs, 0)) + " T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(_vm._f("decimals")(project.timelogs_total_hours, 2), 0)) + " T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.budgetted_hours_spent_pct) + " %")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimeloggerBasic({
            project_key: project['.key']
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1)])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    staticClass: "hide",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewClientProject({
          status: 'active'
        })
      }
    }
  }, [_vm._v("Opret ny opgave")])], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'projects') ? _c('box', {
    attrs: {
      "label": _vm.clientProjects.length + ' opgaver'
    }
  }, [_c('table', {
    staticClass: "table-a projects-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Budget")]), _vm._v(" "), (false) ? _c('th', [_vm._v("Estimeret")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Tracket")]), _vm._v(" "), _c('th', [_vm._v("Tidsforbrug")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.clientProjects), function(project, i) {
    return _c('tr', {
      key: 'fadsfd' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + project['.key']
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.status_translated))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(_vm._f("money")(project.budget, 0), 0)) + " kr.")]), _vm._v(" "), (false) ? _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(project.estimated_hrs, 0)) + " T")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(_vm._f("decimals")(project.timelogs_total_hours, 2), 0)) + " T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.budgetted_hours_spent_pct) + " %")]), _vm._v(" "), _c('td', [(project.status != 'finished') ? _c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimeloggerBasic({
            project_key: project['.key']
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1) : _vm._e()])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    staticClass: "hide",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewClientProject()
      }
    }
  }, [_vm._v("Opret ny opgave")])], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'comments') ? _c('box', {
    attrs: {
      "label": 'Kommentarer'
    }
  }, [_c('comments', {
    attrs: {
      "keytype": 'client',
      "keyis": _vm.client['.key']
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show_debug_data_boxes) ? _c('box', {
    attrs: {
      "label": "client"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.client))])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.project) ? _c('div', {
    staticClass: "screen-loading"
  }, [_vm._v("\n    Loading...\n  ")]) : _vm._e(), _vm._v(" "), (_vm.project) ? _c('div', {
    staticClass: "view project"
  }, [_c('div', {
    staticClass: "project-header",
    style: (_vm.header_css)
  }, [(_vm.client) ? _c('div', {
    staticClass: "pretitle"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.goto('/client/' + _vm.client['.key'])
      }
    }
  }, [_vm._v(_vm._s(_vm.client.name))]), _vm._v("   —   \n        Opgave\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.project.name))])]), _vm._v(" "), _c('div', {
    staticClass: "filterbtns"
  }, [_c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'home'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('home')
      }
    }
  }, [_vm._v("Overblik")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'comments'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('comments')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCommentsCount('project', _vm.project['.key'])) + " kommentarer")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'spec'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('spec')
      }
    }
  }, [_vm._v("Specifikation")]), _vm._v(" "), (_vm.show_beta_content || _vm.is_user('wp')) ? _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'kanban'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('kanban')
      }
    }
  }, [_vm._v("Opgaver")]) : _vm._e(), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'timelogs'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('timelogs')
      }
    }
  }, [_vm._v("Tidstracking")]), _vm._v(" "), (_vm.economy_access) ? _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'economy'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('economy')
      }
    }
  }, [_vm._v("Økonomiposter")]) : _vm._e(), _vm._v(" "), (_vm.show_beta_content) ? _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'timeline'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('timeline')
      }
    }
  }, [_vm._v("Timeline")]) : _vm._e(), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'settings'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('settings')
      }
    }
  }, [_vm._v("Indstillinger")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'details'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('details')
      }
    }
  }, [_vm._v("Detaljer")])], 1), _vm._v(" "), (_vm.showing == 'home') ? [_c('masonry', [_c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "t"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-checkmark-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.getProjectDonePct(_vm.project)) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v("\n              " + _vm._s(_vm._f("decimals")(_vm.project_budgetted_hours, 0)) + " timer\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Estimeret")])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('/timelogs/any/any/' + _vm.project['.key'] + '/any/any')
      }
    }
  }, [_c('div', {
    staticClass: "t"
  }, [_vm._v("Tid booket")]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-calendar-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.hoursBooked) + " timer")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.goto('/timelogs/any/any/' + _vm.project['.key'] + '/any/any')
      }
    }
  }, [_c('div', {
    staticClass: "t"
  }, [_vm._v("Tid tracket")]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_vm._v("\n\t\t\t\t      " + _vm._s(_vm._f("decimals")(_vm.project_budgetted_hours_spent_pct, 0)) + "%\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm._f("decimals")(_vm.project_timelogs_total_hours, 0)) + " timer")])])]), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openTimeloggerBasic({
          project_key: _vm.project['.key']
        })
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-play-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Log arbejdstid")])])]), _vm._v(" "), (_vm.project.gitRepoUrl) ? _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openURLNewWindow(_vm.project.gitRepoUrl)
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "fontawesome/git"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Git repo")])])]) : _vm._e(), _vm._v(" "), (_vm.project.trelloUrl) ? _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openURLNewWindow(_vm.project.trelloUrl)
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "fontawesome/trello"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Trello board")])])]) : _vm._e(), _vm._v(" "), (_vm.project.timelineUrl) ? _c('div', {
    staticClass: "masonry-grid-item w1 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openURLNewWindow(_vm.project.timelineUrl)
      }
    }
  }, [_c('div', {
    staticClass: "t up"
  }, [_vm._v("Tidsplan")]), _vm._v(" "), _c('div', {
    staticClass: "m d"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/android-options"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        _vm.showing = 'spec'
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/ios-list-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [(!_vm.spec && !_vm.project.specsheetUrl) ? [_vm._v("\n                Opgavespecifikation mangler!\n              ")] : [_vm._v("\n                Opgavespecifikation/tilbud\n              ")]], 2)])]), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v("\n\t\t\t\t      " + _vm._s(_vm._f("money")(_vm.project_budget)) + " kr.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Budget ex. moms")])])]) : _vm._e(), _vm._v(" "), (_vm.project.docsUrl && _vm.globals.user.admin) ? _c('div', {
    staticClass: "masonry-grid-item w2 h2"
  }, [_c('div', {
    staticClass: "snackbox clickable",
    on: {
      "click": function($event) {
        return _vm.openURLNewWindow(_vm.project.docsUrl)
      }
    }
  }, [_c('div', {
    staticClass: "m up"
  }, [_c('svgicon', {
    attrs: {
      "icon": "ionicons/android-folder-open"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Google Drive")])])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.get_invoiced_dkk)) + " kr.")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Faktureret")])])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.get_invoiced_and_paid_dkk)) + " kr.")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Betalt")])])]) : _vm._e(), _vm._v(" "), (_vm.economy_access && _vm.project.status == 'active') ? _c('div', {
    staticClass: "masonry-grid-item w2 h1"
  }, [_c('div', {
    staticClass: "snackbox"
  }, [_c('div', {
    staticClass: "m up"
  }, [_vm._v(_vm._s(_vm._f("money")((_vm.project_payable_amount - _vm.get_invoiced_and_paid_dkk))) + " kr.")]), _vm._v(" "), _c('div', {
    staticClass: "b"
  }, [_vm._v("Resterende betaling")])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleTagAndSave('projects', _vm.project, _vm.$store.getters['users/my_initials'])
      }
    }
  }, [(_vm.item_has_tag(_vm.project, _vm.$store.getters['users/my_initials'])) ? [_vm._v("● Mine projekter")] : [_vm._v("○ Mine projekter")]], 2), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleTagAndSave('projects', _vm.project, 'fakturaklar')
      }
    }
  }, [(_vm.item_has_tag(_vm.project, 'fakturaklar')) ? [_vm._v("● Faktura-klar")] : [_vm._v("○ Faktura-klar")]], 2)], 1)] : _vm._e(), _vm._v(" "), (_vm.showing == 'timelogs') ? [_c('box', {
    attrs: {
      "label": _vm.project_timelogs_total_hours + ' timer tracket'
    }
  }, [(_vm.project_timelogs) ? _c('timelogs-list', {
    attrs: {
      "timelogs": _vm.project_timelogs
    }
  }) : _c('p', [_vm._v("Ingen tid tracket endnu...")])], 1)] : _vm._e(), _vm._v(" "), (_vm.showing == 'timeline') ? [_c('box', {
    attrs: {
      "label": "New calendar"
    }
  }, [_c('full-calendar', {
    attrs: {
      "config": _vm.calendarConfig
    }
  })], 1), _vm._v(" "), _c('timeline', {
    attrs: {
      "title": "Timeline",
      "days-back": "7",
      "days-ahead": "120",
      "entries": [{
        title: '2018-08-25 >> 2018-09-03',
        date_from: _vm.project.start_date,
        date_to: _vm.project.end_date,
        color: _vm.projectColor,
        fillpct: 75
      } ]
    }
  })] : _vm._e(), _vm._v(" "), (_vm.showing == 'settings') ? _c('box', {
    attrs: {
      "label": 'Indstillinger'
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Opgavens titel"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.name
    },
    on: {
      "change": function($event) {
        return _vm.change('name', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Kunde"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.client_key),
      expression: "project.client_key"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "client_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change('client_key', $event)
      }]
    }
  }, _vm._l((_vm.clients_not_archived), function(client, key, i) {
    return _c('option', {
      key: 'tf23' + i,
      domProps: {
        "value": client.key
      }
    }, [_vm._v(_vm._s(client.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), (_vm.economy_access) ? [_c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": 'Timepris (Kundens normale timepris: ' + (_vm.client.hour_rate || 'Udefineret') + ')'
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.project.hour_rate
    },
    on: {
      "change": function($event) {
        return _vm.change('hour_rate', $event)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.economy_access) ? [_c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Fast pris ex. moms (Gammel, brug i stedet Opgavespecifikationen)"
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.project.fixed_price
    },
    on: {
      "change": function($event) {
        return _vm.change('fixed_price', $event)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.economy_access) ? [_c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Estimerede timer (Gammel, brug i stedet Opgavespecifikationen)"
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.project.estimated_hrs
    },
    on: {
      "change": function($event) {
        return _vm.change('estimated_hrs', $event)
      }
    }
  })])] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Færdig %"
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.project.done_pct
    },
    on: {
      "change": function($event) {
        return _vm.change('done_pct', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Noter")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.notes),
      expression: "project.notes"
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.project.notes)
    },
    on: {
      "change": function($event) {
        return _vm.change('notes', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "notes", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    staticClass: "col m50"
  }, [_c('inputfield', {
    attrs: {
      "label": "Farve"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.color
    },
    on: {
      "change": function($event) {
        return _vm.change('color', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.status),
      expression: "project.status"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change('status', $event)
      }]
    }
  }, _vm._l((_vm.globals.projectStatuses), function(status, key, i) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(status.title))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Betalingsmodel"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.payment_model),
      expression: "project.payment_model"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "payment_model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change('payment_model', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "fixed_price"
    }
  }, [_vm._v("Fast pris")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "time_expense"
    }
  }, [_vm._v("Tidsafregnet")])]), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])]), _vm._v(" "), _c('br'), _vm._v(" "), (false) ? _c('tags-preview', {
    attrs: {
      "tags": _vm.project.tags,
      "itemtype": 'project',
      "itemkey": _vm.project.key
    }
  }) : _vm._e(), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Tags"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.tags),
      expression: "project.tags"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.project.tags)
    },
    on: {
      "change": function($event) {
        return _vm.change('tags', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "tags", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Startdato (dd-mm-ååååå)"
    }
  }, [_c('input', {
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.project.start_date
    },
    on: {
      "change": function($event) {
        return _vm.change('start_date', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Afslutningsdato (dd-mm-ååååå)"
    }
  }, [_c('input', {
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.project.end_date
    },
    on: {
      "change": function($event) {
        return _vm.change('end_date', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.economy_access) ? [_c('inputfield', {
    attrs: {
      "label": "Dokument mappe-link (Google Drive)"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.docsUrl
    },
    on: {
      "change": function($event) {
        return _vm.change('docsUrl', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Tidsplan dokument-link"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.timelineUrl
    },
    on: {
      "change": function($event) {
        return _vm.change('timelineUrl', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Trello board link"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.trelloUrl
    },
    on: {
      "change": function($event) {
        return _vm.change('trelloUrl', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Git repo link"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.gitRepoUrl
    },
    on: {
      "change": function($event) {
        return _vm.change('gitRepoUrl', $event)
      }
    }
  })])] : _vm._e()], 2)]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.submitChanges()
      }
    }
  }, [_vm._v("Opdatér opgave")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn color-secondary",
    on: {
      "click": function($event) {
        return _vm.archiveProject()
      }
    }
  }, [_vm._v("Arkivér opgave")])], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'economy') ? _c('box', {
    attrs: {
      "label": 'Økonomi'
    }
  }, [(false) ? _c('p', [_vm._v("Budget: " + _vm._s(_vm.outputMoney(_vm.getProjectBudgetTotal(_vm.project), 'b')))]) : _vm._e(), _vm._v(" "), _c('economy-posts', {
    attrs: {
      "posts": _vm.economyposts.posts,
      "totals": _vm.economyposts.totals,
      "fields": "invoice_no,invoice_date,invoiced,paid,amount"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewEconomypost()
      }
    }
  }, [_vm._v("Opret ny økonomipost")])], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'details') ? _c('box', {
    attrs: {
      "label": 'Andet'
    }
  }, [_c('table', {
    staticClass: "table-a"
  }, [_c('tr', [_c('td', [_vm._v("Betalingsmodel")]), _vm._v(" "), _c('td', [(_vm.project.payment_model == 'fixed_price') ? [_vm._v("Fast pris")] : _vm._e(), _vm._v(" "), (_vm.project.payment_model == 'time_expense') ? [_vm._v("Tidsafregnet")] : _vm._e(), _vm._v(" "), (!_vm.project.payment_model) ? [_vm._v("?")] : _vm._e()], 2)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Timepris")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm._f("money")(_vm.project_hour_rate, 2)) + " kr.\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Estimerede timer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project_budgetted_hours || '-') + " timer")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Arbejdstimer logget")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project_timelogs_total_hours) + " timer")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("- Heraf markeret fakturérbare")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project_billable_hours) + " timer")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Budget")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.project_budget)) + " kr.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _c('td', [_vm._v(" ")])]), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Kundens betaling")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.project_payable_amount, 2)) + " kr.")])])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("- Faktureret")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.get_invoiced_dkk, 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("- Betalt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.get_invoiced_and_paid_dkk, 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Resterende betaling")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")((_vm.project_payable_amount - _vm.get_invoiced_and_paid_dkk), 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _c('td', [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Betaling ud fra fakturérbare timer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.project_billable_hours_amount, 2)) + " kr.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Timepris * tidsforbrug")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.project_hour_rate * _vm.project_timelogs_total_hours, 2)) + " kr.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tid tracket ift. budget tidsramme")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.project_budgetted_hours_spent_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Realiseret timepris")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")((_vm.project_payable_amount / _vm.project_timelogs_total_hours), 2)) + " kr.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _c('td', [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Projekt oprettet")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.project.created, 'DD/MM-YYYY HH:MM')) + " ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showing == 'spec') ? [(_vm.spec) ? _c('specsheet', {
    attrs: {
      "localspec": _vm.spec
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.spec) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.createSpec()
      }
    }
  }, [_vm._v("Opret opgavespecifikation")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showing == 'comments') ? _c('box', {
    attrs: {
      "label": 'Kommentarer'
    }
  }, [_c('comments', {
    attrs: {
      "keytype": 'project',
      "keyis": _vm.project_key
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'kanban') ? _c('div', [_c('kanban')], 1) : _vm._e(), _vm._v(" "), (_vm.showing == '_tasks') ? _c('div', {
    attrs: {
      "id": "tasklists"
    }
  }, [_vm._l((_vm.projectTasklists), function(tasklist, i) {
    return (!tasklist.archived) ? _c('div', {
      staticClass: "tasklist"
    }, [_c('div', {
      staticClass: "tasklist-header"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(tasklist.name))]), _vm._v(" "), _c('div', {
      staticClass: "edit-btn",
      on: {
        "click": function($event) {
          return _vm.openTasklistPopup(tasklist)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/gear-b"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "dragula",
        rawName: "v-dragula",
        value: (_vm.project_tasks),
        expression: "project_tasks"
      }],
      staticClass: "tasks",
      attrs: {
        "bag": "first-bag"
      }
    }, _vm._l((_vm.project_tasks), function(task, i) {
      return (task.tasklist_key == tasklist['.key'] && !task.archived) ? _c('div', {
        key: task['.key'],
        staticClass: "task",
        on: {
          "click": function($event) {
            return _vm.openTaskPopup(task)
          }
        }
      }, [_vm._v("\n            " + _vm._s(task.title) + "\n          ")]) : _vm._e()
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "tasklist-footer"
    }, [_c('div', {
      staticClass: "add-task-btn",
      on: {
        "click": function($event) {
          return _vm.addTask(tasklist)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/home"
      }
    }), _vm._v(" Ny task\n          ")], 1)])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "add-tasklist-btn",
    on: {
      "click": function($event) {
        return _vm.addTaskList()
      }
    }
  }, [_c('svgicon', {
    attrs: {
      "icon": "linearicons/home"
    }
  }), _vm._v(" Ny liste\n      ")], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.show_debug_data_boxes) ? _c('box', {
    attrs: {
      "label": "project"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.project))])]) : _vm._e(), _vm._v(" "), (_vm.activeTasklistKey) ? _c('div', {
    attrs: {
      "id": "tasklist-overlay"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": function($event) {
        return _vm.closeTasklistPopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('inputfield', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTasklist.name),
      expression: "activeTasklist.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeTasklist.name)
    },
    on: {
      "change": function($event) {
        return _vm.updateActiveTasklist(['name'])
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeTasklist, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.archiveTasklist()
      }
    }
  }, [_vm._v("Slet tasklist")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.activeTaskKey) ? _c('div', {
    attrs: {
      "id": "task-overlay"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": function($event) {
        return _vm.closeTaskPopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('inputfield', [_c('label', [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTask.title),
      expression: "activeTask.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.activeTask.title)
    },
    on: {
      "change": function($event) {
        return _vm.updateActiveTask(['title'])
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeTask, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Text")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTask.text),
      expression: "activeTask.text"
    }],
    domProps: {
      "value": (_vm.activeTask.text)
    },
    on: {
      "change": function($event) {
        return _vm.updateActiveTask(['text'])
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeTask, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Timetal estimat")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTask.hours_estimate),
      expression: "activeTask.hours_estimate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "9999",
      "step": "0.25"
    },
    domProps: {
      "value": (_vm.activeTask.hours_estimate)
    },
    on: {
      "change": function($event) {
        return _vm.updateActiveTask(['hours_estimate'])
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeTask, "hours_estimate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Done?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeTask.done),
      expression: "activeTask.done"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.activeTask.done,
      "checked": Array.isArray(_vm.activeTask.done) ? _vm._i(_vm.activeTask.done, null) > -1 : (_vm.activeTask.done)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.activeTask.done,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.activeTask, "done", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.activeTask, "done", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.activeTask, "done", $$c)
        }
      }, function($event) {
        return _vm.flipTaskDone(_vm.activeTask)
      }]
    }
  })]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.archiveTask()
      }
    }
  }, [_vm._v("Slet opgave")])], 1)]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view projects"
  }, [(_vm.filteredItems.length || _vm.search_filter) ? _c('box', {
    attrs: {
      "label": _vm.filteredItems.length + ' opgaver'
    }
  }, [_c('template', {
    slot: "meta-r"
  }, [_c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.createNewProject()
      }
    }
  }, [_vm._v("Ny opgave")])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m30"
  }, [_c('inputfield', {
    attrs: {
      "label": "Søg"
    }
  }, [_c('input', {
    ref: "search_filter",
    attrs: {
      "type": "text",
      "placeholder": "Søg"
    },
    domProps: {
      "value": _vm.search_filter
    },
    on: {
      "keyup": _vm.search_filter_updated
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m40"
  }, [_c('inputfield', {
    attrs: {
      "label": "Status"
    }
  }, [_c('select', {
    ref: "status_filter",
    attrs: {
      "id": "status-select"
    },
    domProps: {
      "value": _vm.status_filter
    },
    on: {
      "change": _vm.status_filter_updated
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _vm._l((_vm.globals.projectStatuses), function(status, status_key, status_i) {
    return _c('option', {
      domProps: {
        "value": status_key
      }
    }, [_vm._v(_vm._s(status.title))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "select-arrow"
  }, [_vm._v("▾")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m30"
  })]), _vm._v(" "), (_vm.filteredItems.length) ? _c('table', {
    staticClass: "table-a projects-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }, [_vm._v("Kunde")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Færdig")]), _vm._v(" "), ( false) ? _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Tid logget/budget")]) : _vm._e(), _vm._v(" "), ( false) ? _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Budget kr.")]) : _vm._e(), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(project, i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.gotoProject(project)
        }
      }
    }, [_vm._v(_vm._s(project.name))])]), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.gotoClient(project)
        }
      }
    }, [_vm._v(_vm._s(_vm.getProjectClient(project).name))])]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getProjectStatus(project)) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getProjectDonePct(project)) + "%\n\t\t\t\t\t\t \n\t\t\t\t\t\t"), _c('minipctbar', {
      attrs: {
        "pct": _vm.getProjectDonePct(project)
      }
    })], 1), _vm._v(" "), ( false) ? _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(parseInt(project.timelogs_total_hours)) + " /\n\t\t\t\t\t\t" + _vm._s(parseInt(project.budgetted_hours)) + " timer\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), ( false) ? _c('td', {
      staticClass: "align-r"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.outputMoney(project.budget, 0)) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimelogger({
            project_key: project['.key']
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1)])])
  }), 0)]) : _vm._e(), _vm._v(" "), (false) ? [_c('pagination', {
    attrs: {
      "items": _vm.filteredItems,
      "perpage": _vm.projects_perpage,
      "page": _vm.projects_currentpage
    },
    on: {
      "updated": _vm.paginationUpdate
    }
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.filteredItems.length) ? _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.createNewProject()
      }
    }
  }, [_vm._v("Ny opgave")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-preview"
  }, [_vm._v("\n  " + _vm._s(_vm.tags) + "\n  " + _vm._s(_vm.itemtype) + "\n  " + _vm._s(_vm.itemkey) + "\n  " + _vm._s(_vm.tags_list) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal-economypost-edit"
    }
  }, [_c('div', {
    staticClass: "dimmer",
    on: {
      "click": _vm.onDimmerClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "cols cols-3"
  }, [_c('inputfield', [_c('label', [_vm._v("Kunde")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.client_key),
      expression: "economypost.client_key"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.economypost, "client_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ingen relevant kunde")]), _vm._v(" "), _vm._l((_vm.clients), function(client, key, i) {
    return _c('option', {
      attrs: {
        "value": ""
      },
      domProps: {
        "value": key
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(client.name) + "\t\t\t\t\t\t\n\t\t\t\t")])
  })], 2)]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Opgave")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.project_key),
      expression: "economypost.project_key"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.economypost, "project_key", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ingen relevant opgave")]), _vm._v(" "), _vm._l((_vm.projects), function(project, key, i) {
    return _c('option', {
      attrs: {
        "value": ""
      },
      domProps: {
        "value": key
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(project.name) + "\n\t\t\t\t\t"), (project.client_key && _vm.clients[project.client_key]) ? [_vm._v("\n\t\t\t\t\t- " + _vm._s(_vm.clients[project.client_key].name) + "\n\t\t\t\t\t")] : _vm._e()], 2)
  })], 2)]), _vm._v(" "), (!_vm.economypost.project_key || !_vm.economypost.project_key.length) ? _c('inputfield', [_c('label', [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.title),
      expression: "economypost.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.economypost.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "title", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Beløb eks. moms")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.economypost.amount_dkk_ex_vat),
      expression: "economypost.amount_dkk_ex_vat",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.economypost.amount_dkk_ex_vat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "amount_dkk_ex_vat", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), ( false) ? _c('p', [_vm._v("\n\t\t\t\t\tProject budget:"), _c('br'), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.outputMoney(_vm.getProjectBudgetTotal(_vm.getProject(_vm.economypost.project_key)), 'a')) + "\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Faktureringsdato")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.invoice_date),
      expression: "economypost.invoice_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.economypost.invoice_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "invoice_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Note")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.note),
      expression: "economypost.note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.economypost.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "note", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Faktura #")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.economypost.invoice_no),
      expression: "economypost.invoice_no",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.economypost.invoice_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "invoice_no", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('inputfield', [_c('label', [_vm._v("Betalingsfrist")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.payment_due_date),
      expression: "economypost.payment_due_date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.economypost.payment_due_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.economypost, "payment_due_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.invoiced),
      expression: "economypost.invoiced"
    }],
    attrs: {
      "type": "checkbox",
      "id": "kj12bfds3kj"
    },
    domProps: {
      "checked": Array.isArray(_vm.economypost.invoiced) ? _vm._i(_vm.economypost.invoiced, null) > -1 : (_vm.economypost.invoiced)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.economypost.invoiced,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.economypost, "invoiced", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.economypost, "invoiced", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.economypost, "invoiced", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kj12bfds3kj"
    }
  }, [_vm._v("Faktureret")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.paid),
      expression: "economypost.paid"
    }],
    attrs: {
      "type": "checkbox",
      "id": "fdsdf"
    },
    domProps: {
      "checked": Array.isArray(_vm.economypost.paid) ? _vm._i(_vm.economypost.paid, null) > -1 : (_vm.economypost.paid)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.economypost.paid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.economypost, "paid", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.economypost, "paid", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.economypost, "paid", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "fdsdf"
    }
  }, [_vm._v("Betalt")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.economypost.hypothetic),
      expression: "economypost.hypothetic"
    }],
    attrs: {
      "type": "checkbox",
      "id": "jn2jkhb"
    },
    domProps: {
      "checked": Array.isArray(_vm.economypost.hypothetic) ? _vm._i(_vm.economypost.hypothetic, null) > -1 : (_vm.economypost.hypothetic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.economypost.hypothetic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.economypost, "hypothetic", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.economypost, "hypothetic", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.economypost, "hypothetic", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "jn2jkhb"
    }
  }, [_vm._v("Hypotetisk")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "cols cols-3"
  }, [_c('btn', {
    attrs: {
      "block": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.archiveEconomypost()
      }
    }
  }, [_vm._v("Slet")]), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Gem")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (false) ? _c('box', {
    attrs: {
      "label": 'Kommentarer'
    }
  }, [_c('comments', {
    attrs: {
      "keytype": 'economypost',
      "keyis": _vm.economypost['.key']
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "killer",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("X")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [(_vm.myUser.email == 'wp@milk-studio.dk' || _vm.myUser.email == 'db@milk-studio.dk') ? _c('box', {
    attrs: {
      "label": _vm.projects_without_timeline.length + ' projekter uden start/slut-dato'
    }
  }, [_vm._l((_vm.projects_without_timeline), function(project, project_i) {
    return [_c('btn', {
      nativeOn: {
        "click": function($event) {
          return _vm.goto('project/' + project['.key'])
        }
      }
    }, [_vm._v(_vm._s(project.name))]), _vm._v("  \n\t\t\t")]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.myUser.email == 'wp@milk-studio.dk' || _vm.myUser.email == 'db@milk-studio.dk') ? _c('box', {
    attrs: {
      "label": _vm.projects_without_budget.length + ' Projekter uden budget'
    }
  }, [_vm._l((_vm.projects_without_budget), function(project, project_i) {
    return [_c('btn', {
      nativeOn: {
        "click": function($event) {
          return _vm.goto('project/' + project['.key'])
        }
      }
    }, [_vm._v(_vm._s(project.name))]), _vm._v("  \n\t\t\t")]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.myUser.email == 'wp@milk-studio.dk' || _vm.myUser.email == 'db@milk-studio.dk') ? _c('box', {
    attrs: {
      "label": _vm.active_projects_beyond_end_date.length + ' Afsluttede projekter?'
    }
  }, [_vm._l((_vm.active_projects_beyond_end_date), function(project, project_i) {
    return [_c('btn', {
      nativeOn: {
        "click": function($event) {
          return _vm.goto('project/' + project['.key'])
        }
      }
    }, [_vm._v(_vm._s(project.name))]), _vm._v("  \n\t\t\t")]
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })
],[400]);


// WEBPACK FOOTER //
// assets/js/app.6863da4535a173791226.js